var af = Object.defineProperty;
var sf = (e, n, t) => n in e ? af(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var we = (e, n, t) => sf(e, typeof n != "symbol" ? n + "" : n, t);
import { defineComponent as Te, computed as C, openBlock as b, createElementBlock as M, normalizeStyle as Fe, normalizeClass as ne, createCommentVNode as P, toDisplayString as ce, ref as te, shallowRef as Wt, onMounted as nt, watch as He, onUnmounted as sn, h as wt, nextTick as Xe, createBlock as fe, unref as p, useSlots as Yt, resolveDynamicComponent as ht, mergeProps as lt, withCtx as de, renderSlot as U, createTextVNode as Ue, createElementVNode as E, withModifiers as Ve, createVNode as oe, useId as Cr, watchEffect as Ut, withDirectives as mn, vModelCheckbox as rf, toValue as tt, reactive as pa, getCurrentScope as gu, onScopeDispose as Dr, shallowReadonly as Sa, useTemplateRef as Qe, createSlots as ft, renderList as Pe, normalizeProps as Mt, guardReactiveProps as Ft, mergeDefaults as yu, provide as Va, readonly as Xl, toRef as hr, Teleport as zn, Transition as vt, inject as Qn, Fragment as Se, onBeforeUpdate as lf, vShow as Fn, withKeys as It, useModel as Ds, mergeModels as ea, TransitionGroup as Sl, getCurrentInstance as Jl, hasInjectionContext as bu, toRaw as of, onUpdated as uf, onBeforeUnmount as Os, useAttrs as Ql, isVNode as rs, vModelText as cf, onDeactivated as wu, onActivated as ku, triggerRef as Tl, isRef as xu, markRaw as Ai, resolveComponent as Su, isMemoSame as df, defineAsyncComponent as ff } from "vue";
import { RouterLink as hf, useRouter as Tu, onBeforeRouteLeave as mf, useRoute as ei } from "vue-router";
import { defineStore as vf } from "pinia";
const pf = ["alt", "src"], gf = {
  key: 1,
  class: "select-none"
}, yf = /* @__PURE__ */ Te({
  __name: "VAvatar",
  props: {
    name: { default: "" },
    avatar: { default: void 0 },
    size: { default: "md" },
    customSize: { default: void 0 },
    shape: { default: "circle" },
    online: { type: Boolean, default: !1 },
    alt: { default: "User avatar" }
  },
  setup(e) {
    const n = e, t = C(() => ({
      xs: "w-6 h-6 text-xs",
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg",
      xl: "w-16 h-16 text-xl"
    })[n.size]), a = C(
      () => n.shape === "square" ? "rounded-md" : "rounded-full"
    ), s = C(() => n.customSize ? {
      width: `${n.customSize}px`,
      height: `${n.customSize}px`,
      fontSize: `${n.customSize * 0.4}px`
    } : {}), r = C(() => {
      if (!n.name) return "?";
      const o = n.name.trim().split(/\s+/);
      return o.length >= 2 ? `${o[0][0]}${o[1][0]}`.toUpperCase() : n.name.substring(0, 2).toUpperCase();
    }), l = C(() => {
      if (!n.name) return "bg-base-200 text-secondaryText";
      let o = 0;
      for (let c = 0; c < n.name.length; c++)
        o = n.name.charCodeAt(c) + ((o << 5) - o);
      const u = [
        "bg-blue-500 text-white",
        "bg-purple-500 text-white",
        "bg-pink-500 text-white",
        "bg-green-500 text-white",
        "bg-orange-500 text-white",
        "bg-primary text-white",
        "bg-indigo-500 text-white",
        "bg-cyan-500 text-white"
      ];
      return u[Math.abs(o) % u.length];
    }), i = C(() => !!n.avatar);
    return (o, u) => (b(), M("div", {
      class: ne([[t.value, a.value, !i.value && l.value], "user-avatar relative inline-flex items-center justify-center overflow-hidden flex-shrink-0 font-medium transition-all duration-200"]),
      style: Fe(s.value)
    }, [
      i.value ? (b(), M("img", {
        key: 0,
        alt: e.alt,
        src: e.avatar,
        class: "w-full h-full object-cover",
        onError: u[0] || (u[0] = (c) => c.target.style.display = "none")
      }, null, 40, pf)) : P("", !0),
      i.value ? P("", !0) : (b(), M("span", gf, ce(r.value), 1)),
      e.online ? (b(), M("span", {
        key: 2,
        class: ne([{
          "w-1.5 h-1.5": e.size === "xs",
          "w-2 h-2": e.size === "sm",
          "w-2.5 h-2.5": e.size === "md",
          "w-3 h-3": e.size === "lg",
          "w-4 h-4": e.size === "xl"
        }, "absolute bottom-0 right-0 block rounded-full bg-success ring-2 ring-base-100 transition-all"]),
        "aria-label": "Online"
      }, null, 2)) : P("", !0)
    ], 6));
  }
}), Ge = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n)
    t[a] = s;
  return t;
}, U2 = /* @__PURE__ */ Ge(yf, [["__scopeId", "data-v-985a3a1e"]]), Mu = /^[a-z0-9]+(-[a-z0-9]+)*$/, Or = (e, n, t, a = "") => {
  const s = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (s.length < 2 || s.length > 3)
      return null;
    a = s.shift().slice(1);
  }
  if (s.length > 3 || !s.length)
    return null;
  if (s.length > 1) {
    const i = s.pop(), o = s.pop(), u = {
      // Allow provider without '@': "provider:prefix:name"
      provider: s.length > 0 ? s[0] : a,
      prefix: o,
      name: i
    };
    return n && !ir(u) ? null : u;
  }
  const r = s[0], l = r.split("-");
  if (l.length > 1) {
    const i = {
      provider: a,
      prefix: l.shift(),
      name: l.join("-")
    };
    return n && !ir(i) ? null : i;
  }
  if (t && a === "") {
    const i = {
      provider: a,
      prefix: "",
      name: r
    };
    return n && !ir(i, t) ? null : i;
  }
  return null;
}, ir = (e, n) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((n && e.prefix === "" || e.prefix) && e.name) : !1, $u = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), mr = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), _r = Object.freeze({
  ...$u,
  ...mr
}), Ml = Object.freeze({
  ..._r,
  body: "",
  hidden: !1
});
function bf(e, n) {
  const t = {};
  !e.hFlip != !n.hFlip && (t.hFlip = !0), !e.vFlip != !n.vFlip && (t.vFlip = !0);
  const a = ((e.rotate || 0) + (n.rotate || 0)) % 4;
  return a && (t.rotate = a), t;
}
function Ri(e, n) {
  const t = bf(e, n);
  for (const a in Ml)
    a in mr ? a in e && !(a in t) && (t[a] = mr[a]) : a in n ? t[a] = n[a] : a in e && (t[a] = e[a]);
  return t;
}
function wf(e, n) {
  const t = e.icons, a = e.aliases || /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  function r(l) {
    if (t[l])
      return s[l] = [];
    if (!(l in s)) {
      s[l] = null;
      const i = a[l] && a[l].parent, o = i && r(i);
      o && (s[l] = [i].concat(o));
    }
    return s[l];
  }
  return Object.keys(t).concat(Object.keys(a)).forEach(r), s;
}
function kf(e, n, t) {
  const a = e.icons, s = e.aliases || /* @__PURE__ */ Object.create(null);
  let r = {};
  function l(i) {
    r = Ri(
      a[i] || s[i],
      r
    );
  }
  return l(n), t.forEach(l), Ri(e, r);
}
function Cu(e, n) {
  const t = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return t;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    n(s, null), t.push(s);
  });
  const a = wf(e);
  for (const s in a) {
    const r = a[s];
    r && (n(s, kf(e, s, r)), t.push(s));
  }
  return t;
}
const xf = {
  provider: "",
  aliases: {},
  not_found: {},
  ...$u
};
function Jr(e, n) {
  for (const t in n)
    if (t in e && typeof e[t] != typeof n[t])
      return !1;
  return !0;
}
function Du(e) {
  if (typeof e != "object" || e === null)
    return null;
  const n = e;
  if (typeof n.prefix != "string" || !e.icons || typeof e.icons != "object" || !Jr(e, xf))
    return null;
  const t = n.icons;
  for (const s in t) {
    const r = t[s];
    if (
      // Name cannot be empty
      !s || // Must have body
      typeof r.body != "string" || // Check other props
      !Jr(
        r,
        Ml
      )
    )
      return null;
  }
  const a = n.aliases || /* @__PURE__ */ Object.create(null);
  for (const s in a) {
    const r = a[s], l = r.parent;
    if (
      // Name cannot be empty
      !s || // Parent must be set and point to existing icon
      typeof l != "string" || !t[l] && !a[l] || // Check other props
      !Jr(
        r,
        Ml
      )
    )
      return null;
  }
  return n;
}
const Vi = /* @__PURE__ */ Object.create(null);
function Sf(e, n) {
  return {
    provider: e,
    prefix: n,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function Ya(e, n) {
  const t = Vi[e] || (Vi[e] = /* @__PURE__ */ Object.create(null));
  return t[n] || (t[n] = Sf(e, n));
}
function Ou(e, n) {
  return Du(n) ? Cu(n, (t, a) => {
    a ? e.icons[t] = a : e.missing.add(t);
  }) : [];
}
function Tf(e, n, t) {
  try {
    if (typeof t.body == "string")
      return e.icons[n] = { ...t }, !0;
  } catch {
  }
  return !1;
}
let Ts = !1;
function _u(e) {
  return typeof e == "boolean" && (Ts = e), Ts;
}
function Mf(e) {
  const n = typeof e == "string" ? Or(e, !0, Ts) : e;
  if (n) {
    const t = Ya(n.provider, n.prefix), a = n.name;
    return t.icons[a] || (t.missing.has(a) ? null : void 0);
  }
}
function $f(e, n) {
  const t = Or(e, !0, Ts);
  if (!t)
    return !1;
  const a = Ya(t.provider, t.prefix);
  return n ? Tf(a, t.name, n) : (a.missing.add(t.name), !0);
}
function Cf(e, n) {
  if (typeof e != "object")
    return !1;
  if (typeof n != "string" && (n = e.provider || ""), Ts && !n && !e.prefix) {
    let s = !1;
    return Du(e) && (e.prefix = "", Cu(e, (r, l) => {
      $f(r, l) && (s = !0);
    })), s;
  }
  const t = e.prefix;
  if (!ir({
    prefix: t,
    name: "a"
  }))
    return !1;
  const a = Ya(n, t);
  return !!Ou(a, e);
}
const Eu = Object.freeze({
  width: null,
  height: null
}), Iu = Object.freeze({
  // Dimensions
  ...Eu,
  // Transformations
  ...mr
}), Df = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Of = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Fi(e, n, t) {
  if (n === 1)
    return e;
  if (t = t || 100, typeof e == "number")
    return Math.ceil(e * n * t) / t;
  if (typeof e != "string")
    return e;
  const a = e.split(Df);
  if (a === null || !a.length)
    return e;
  const s = [];
  let r = a.shift(), l = Of.test(r);
  for (; ; ) {
    if (l) {
      const i = parseFloat(r);
      isNaN(i) ? s.push(r) : s.push(Math.ceil(i * n * t) / t);
    } else
      s.push(r);
    if (r = a.shift(), r === void 0)
      return s.join("");
    l = !l;
  }
}
function _f(e, n = "defs") {
  let t = "";
  const a = e.indexOf("<" + n);
  for (; a >= 0; ) {
    const s = e.indexOf(">", a), r = e.indexOf("</" + n);
    if (s === -1 || r === -1)
      break;
    const l = e.indexOf(">", r);
    if (l === -1)
      break;
    t += e.slice(s + 1, r).trim(), e = e.slice(0, a).trim() + e.slice(l + 1);
  }
  return {
    defs: t,
    content: e
  };
}
function Ef(e, n) {
  return e ? "<defs>" + e + "</defs>" + n : n;
}
function If(e, n, t) {
  const a = _f(e);
  return Ef(a.defs, n + a.content + t);
}
const Pf = (e) => e === "unset" || e === "undefined" || e === "none";
function Af(e, n) {
  const t = {
    ..._r,
    ...e
  }, a = {
    ...Iu,
    ...n
  }, s = {
    left: t.left,
    top: t.top,
    width: t.width,
    height: t.height
  };
  let r = t.body;
  [t, a].forEach((y) => {
    const k = [], m = y.hFlip, v = y.vFlip;
    let w = y.rotate;
    m ? v ? w += 2 : (k.push(
      "translate(" + (s.width + s.left).toString() + " " + (0 - s.top).toString() + ")"
    ), k.push("scale(-1 1)"), s.top = s.left = 0) : v && (k.push(
      "translate(" + (0 - s.left).toString() + " " + (s.height + s.top).toString() + ")"
    ), k.push("scale(1 -1)"), s.top = s.left = 0);
    let S;
    switch (w < 0 && (w -= Math.floor(w / 4) * 4), w = w % 4, w) {
      case 1:
        S = s.height / 2 + s.top, k.unshift(
          "rotate(90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
      case 2:
        k.unshift(
          "rotate(180 " + (s.width / 2 + s.left).toString() + " " + (s.height / 2 + s.top).toString() + ")"
        );
        break;
      case 3:
        S = s.width / 2 + s.left, k.unshift(
          "rotate(-90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
    }
    w % 2 === 1 && (s.left !== s.top && (S = s.left, s.left = s.top, s.top = S), s.width !== s.height && (S = s.width, s.width = s.height, s.height = S)), k.length && (r = If(
      r,
      '<g transform="' + k.join(" ") + '">',
      "</g>"
    ));
  });
  const l = a.width, i = a.height, o = s.width, u = s.height;
  let c, f;
  l === null ? (f = i === null ? "1em" : i === "auto" ? u : i, c = Fi(f, o / u)) : (c = l === "auto" ? o : l, f = i === null ? Fi(c, u / o) : i === "auto" ? u : i);
  const h = {}, d = (y, k) => {
    Pf(k) || (h[y] = k.toString());
  };
  d("width", c), d("height", f);
  const g = [s.left, s.top, o, u];
  return h.viewBox = g.join(" "), {
    attributes: h,
    viewBox: g,
    body: r
  };
}
const Rf = /\sid="(\S+)"/g, Vf = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Ff = 0;
function Lf(e, n = Vf) {
  const t = [];
  let a;
  for (; a = Rf.exec(e); )
    t.push(a[1]);
  if (!t.length)
    return e;
  const s = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return t.forEach((r) => {
    const l = typeof n == "function" ? n(r) : n + (Ff++).toString(), i = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + i + ')([")]|\\.[a-z])', "g"),
      "$1" + l + s + "$3"
    );
  }), e = e.replace(new RegExp(s, "g"), ""), e;
}
const $l = /* @__PURE__ */ Object.create(null);
function Nf(e, n) {
  $l[e] = n;
}
function Cl(e) {
  return $l[e] || $l[""];
}
function ti(e) {
  let n;
  if (typeof e.resources == "string")
    n = [e.resources];
  else if (n = e.resources, !(n instanceof Array) || !n.length)
    return null;
  return {
    // API hosts
    resources: n,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const ni = /* @__PURE__ */ Object.create(null), ls = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], or = [];
for (; ls.length > 0; )
  ls.length === 1 || Math.random() > 0.5 ? or.push(ls.shift()) : or.push(ls.pop());
ni[""] = ti({
  resources: ["https://api.iconify.design"].concat(or)
});
function Bf(e, n) {
  const t = ti(n);
  return t === null ? !1 : (ni[e] = t, !0);
}
function ai(e) {
  return ni[e];
}
const zf = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Li = zf();
function Wf(e, n) {
  const t = ai(e);
  if (!t)
    return 0;
  let a;
  if (!t.maxURL)
    a = 0;
  else {
    let s = 0;
    t.resources.forEach((l) => {
      s = Math.max(s, l.length);
    });
    const r = n + ".json?icons=";
    a = t.maxURL - s - t.path.length - r.length;
  }
  return a;
}
function Yf(e) {
  return e === 404;
}
const Hf = (e, n, t) => {
  const a = [], s = Wf(e, n), r = "icons";
  let l = {
    type: r,
    provider: e,
    prefix: n,
    icons: []
  }, i = 0;
  return t.forEach((o, u) => {
    i += o.length + 1, i >= s && u > 0 && (a.push(l), l = {
      type: r,
      provider: e,
      prefix: n,
      icons: []
    }, i = o.length), l.icons.push(o);
  }), a.push(l), a;
};
function Uf(e) {
  if (typeof e == "string") {
    const n = ai(e);
    if (n)
      return n.path;
  }
  return "/";
}
const qf = (e, n, t) => {
  if (!Li) {
    t("abort", 424);
    return;
  }
  let a = Uf(n.provider);
  switch (n.type) {
    case "icons": {
      const r = n.prefix, i = n.icons.join(","), o = new URLSearchParams({
        icons: i
      });
      a += r + ".json?" + o.toString();
      break;
    }
    case "custom": {
      const r = n.uri;
      a += r.slice(0, 1) === "/" ? r.slice(1) : r;
      break;
    }
    default:
      t("abort", 400);
      return;
  }
  let s = 503;
  Li(e + a).then((r) => {
    const l = r.status;
    if (l !== 200) {
      setTimeout(() => {
        t(Yf(l) ? "abort" : "next", l);
      });
      return;
    }
    return s = 501, r.json();
  }).then((r) => {
    if (typeof r != "object" || r === null) {
      setTimeout(() => {
        r === 404 ? t("abort", r) : t("next", s);
      });
      return;
    }
    setTimeout(() => {
      t("success", r);
    });
  }).catch(() => {
    t("next", s);
  });
}, jf = {
  prepare: Hf,
  send: qf
};
function Gf(e) {
  const n = {
    loaded: [],
    missing: [],
    pending: []
  }, t = /* @__PURE__ */ Object.create(null);
  e.sort((s, r) => s.provider !== r.provider ? s.provider.localeCompare(r.provider) : s.prefix !== r.prefix ? s.prefix.localeCompare(r.prefix) : s.name.localeCompare(r.name));
  let a = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((s) => {
    if (a.name === s.name && a.prefix === s.prefix && a.provider === s.provider)
      return;
    a = s;
    const r = s.provider, l = s.prefix, i = s.name, o = t[r] || (t[r] = /* @__PURE__ */ Object.create(null)), u = o[l] || (o[l] = Ya(r, l));
    let c;
    i in u.icons ? c = n.loaded : l === "" || u.missing.has(i) ? c = n.missing : c = n.pending;
    const f = {
      provider: r,
      prefix: l,
      name: i
    };
    c.push(f);
  }), n;
}
function Pu(e, n) {
  e.forEach((t) => {
    const a = t.loaderCallbacks;
    a && (t.loaderCallbacks = a.filter((s) => s.id !== n));
  });
}
function Kf(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const n = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!n.length)
      return;
    let t = !1;
    const a = e.provider, s = e.prefix;
    n.forEach((r) => {
      const l = r.icons, i = l.pending.length;
      l.pending = l.pending.filter((o) => {
        if (o.prefix !== s)
          return !0;
        const u = o.name;
        if (e.icons[u])
          l.loaded.push({
            provider: a,
            prefix: s,
            name: u
          });
        else if (e.missing.has(u))
          l.missing.push({
            provider: a,
            prefix: s,
            name: u
          });
        else
          return t = !0, !0;
        return !1;
      }), l.pending.length !== i && (t || Pu([e], r.id), r.callback(
        l.loaded.slice(0),
        l.missing.slice(0),
        l.pending.slice(0),
        r.abort
      ));
    });
  }));
}
let Zf = 0;
function Xf(e, n, t) {
  const a = Zf++, s = Pu.bind(null, t, a);
  if (!n.pending.length)
    return s;
  const r = {
    id: a,
    icons: n,
    callback: e,
    abort: s
  };
  return t.forEach((l) => {
    (l.loaderCallbacks || (l.loaderCallbacks = [])).push(r);
  }), s;
}
function Jf(e, n = !0, t = !1) {
  const a = [];
  return e.forEach((s) => {
    const r = typeof s == "string" ? Or(s, n, t) : s;
    r && a.push(r);
  }), a;
}
var Qf = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function eh(e, n, t, a) {
  const s = e.resources.length, r = e.random ? Math.floor(Math.random() * s) : e.index;
  let l;
  if (e.random) {
    let $ = e.resources.slice(0);
    for (l = []; $.length > 1; ) {
      const T = Math.floor(Math.random() * $.length);
      l.push($[T]), $ = $.slice(0, T).concat($.slice(T + 1));
    }
    l = l.concat($);
  } else
    l = e.resources.slice(r).concat(e.resources.slice(0, r));
  const i = Date.now();
  let o = "pending", u = 0, c, f = null, h = [], d = [];
  typeof a == "function" && d.push(a);
  function g() {
    f && (clearTimeout(f), f = null);
  }
  function y() {
    o === "pending" && (o = "aborted"), g(), h.forEach(($) => {
      $.status === "pending" && ($.status = "aborted");
    }), h = [];
  }
  function k($, T) {
    T && (d = []), typeof $ == "function" && d.push($);
  }
  function m() {
    return {
      startTime: i,
      payload: n,
      status: o,
      queriesSent: u,
      queriesPending: h.length,
      subscribe: k,
      abort: y
    };
  }
  function v() {
    o = "failed", d.forEach(($) => {
      $(void 0, c);
    });
  }
  function w() {
    h.forEach(($) => {
      $.status === "pending" && ($.status = "aborted");
    }), h = [];
  }
  function S($, T, _) {
    const A = T !== "success";
    switch (h = h.filter((D) => D !== $), o) {
      case "pending":
        break;
      case "failed":
        if (A || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (T === "abort") {
      c = _, v();
      return;
    }
    if (A) {
      c = _, h.length || (l.length ? x() : v());
      return;
    }
    if (g(), w(), !e.random) {
      const D = e.resources.indexOf($.resource);
      D !== -1 && D !== e.index && (e.index = D);
    }
    o = "completed", d.forEach((D) => {
      D(_);
    });
  }
  function x() {
    if (o !== "pending")
      return;
    g();
    const $ = l.shift();
    if ($ === void 0) {
      if (h.length) {
        f = setTimeout(() => {
          g(), o === "pending" && (w(), v());
        }, e.timeout);
        return;
      }
      v();
      return;
    }
    const T = {
      status: "pending",
      resource: $,
      callback: (_, A) => {
        S(T, _, A);
      }
    };
    h.push(T), u++, f = setTimeout(x, e.rotate), t($, n, T.callback);
  }
  return setTimeout(x), m;
}
function Au(e) {
  const n = {
    ...Qf,
    ...e
  };
  let t = [];
  function a() {
    t = t.filter((i) => i().status === "pending");
  }
  function s(i, o, u) {
    const c = eh(
      n,
      i,
      o,
      (f, h) => {
        a(), u && u(f, h);
      }
    );
    return t.push(c), c;
  }
  function r(i) {
    return t.find((o) => i(o)) || null;
  }
  return {
    query: s,
    find: r,
    setIndex: (i) => {
      n.index = i;
    },
    getIndex: () => n.index,
    cleanup: a
  };
}
function Ni() {
}
const Qr = /* @__PURE__ */ Object.create(null);
function th(e) {
  if (!Qr[e]) {
    const n = ai(e);
    if (!n)
      return;
    const t = Au(n), a = {
      config: n,
      redundancy: t
    };
    Qr[e] = a;
  }
  return Qr[e];
}
function nh(e, n, t) {
  let a, s;
  if (typeof e == "string") {
    const r = Cl(e);
    if (!r)
      return t(void 0, 424), Ni;
    s = r.send;
    const l = th(e);
    l && (a = l.redundancy);
  } else {
    const r = ti(e);
    if (r) {
      a = Au(r);
      const l = e.resources ? e.resources[0] : "", i = Cl(l);
      i && (s = i.send);
    }
  }
  return !a || !s ? (t(void 0, 424), Ni) : a.query(n, s, t)().abort;
}
function Bi() {
}
function ah(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, Kf(e);
  }));
}
function sh(e) {
  const n = [], t = [];
  return e.forEach((a) => {
    (a.match(Mu) ? n : t).push(a);
  }), {
    valid: n,
    invalid: t
  };
}
function is(e, n, t) {
  function a() {
    const s = e.pendingIcons;
    n.forEach((r) => {
      s && s.delete(r), e.icons[r] || e.missing.add(r);
    });
  }
  if (t && typeof t == "object")
    try {
      if (!Ou(e, t).length) {
        a();
        return;
      }
    } catch (s) {
      console.error(s);
    }
  a(), ah(e);
}
function zi(e, n) {
  e instanceof Promise ? e.then((t) => {
    n(t);
  }).catch(() => {
    n(null);
  }) : n(e);
}
function rh(e, n) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(n).sort() : e.iconsToLoad = n, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: t, prefix: a } = e, s = e.iconsToLoad;
    if (delete e.iconsToLoad, !s || !s.length)
      return;
    const r = e.loadIcon;
    if (e.loadIcons && (s.length > 1 || !r)) {
      zi(
        e.loadIcons(s, a, t),
        (c) => {
          is(e, s, c);
        }
      );
      return;
    }
    if (r) {
      s.forEach((c) => {
        const f = r(c, a, t);
        zi(f, (h) => {
          const d = h ? {
            prefix: a,
            icons: {
              [c]: h
            }
          } : null;
          is(e, [c], d);
        });
      });
      return;
    }
    const { valid: l, invalid: i } = sh(s);
    if (i.length && is(e, i, null), !l.length)
      return;
    const o = a.match(Mu) ? Cl(t) : null;
    if (!o) {
      is(e, l, null);
      return;
    }
    o.prepare(t, a, l).forEach((c) => {
      nh(t, c, (f) => {
        is(e, c.icons, f);
      });
    });
  }));
}
const lh = (e, n) => {
  const t = Jf(e, !0, _u()), a = Gf(t);
  if (!a.pending.length) {
    let o = !0;
    return n && setTimeout(() => {
      o && n(
        a.loaded,
        a.missing,
        a.pending,
        Bi
      );
    }), () => {
      o = !1;
    };
  }
  const s = /* @__PURE__ */ Object.create(null), r = [];
  let l, i;
  return a.pending.forEach((o) => {
    const { provider: u, prefix: c } = o;
    if (c === i && u === l)
      return;
    l = u, i = c, r.push(Ya(u, c));
    const f = s[u] || (s[u] = /* @__PURE__ */ Object.create(null));
    f[c] || (f[c] = []);
  }), a.pending.forEach((o) => {
    const { provider: u, prefix: c, name: f } = o, h = Ya(u, c), d = h.pendingIcons || (h.pendingIcons = /* @__PURE__ */ new Set());
    d.has(f) || (d.add(f), s[u][c].push(f));
  }), r.forEach((o) => {
    const u = s[o.provider][o.prefix];
    u.length && rh(o, u);
  }), n ? Xf(n, a, r) : Bi;
};
function ih(e, n) {
  const t = {
    ...e
  };
  for (const a in n) {
    const s = n[a], r = typeof s;
    a in Eu ? (s === null || s && (r === "string" || r === "number")) && (t[a] = s) : r === typeof t[a] && (t[a] = a === "rotate" ? s % 4 : s);
  }
  return t;
}
const oh = /[\s,]+/;
function uh(e, n) {
  n.split(oh).forEach((t) => {
    switch (t.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function ch(e, n = 0) {
  const t = e.replace(/^-?[0-9.]*/, "");
  function a(s) {
    for (; s < 0; )
      s += 4;
    return s % 4;
  }
  if (t === "") {
    const s = parseInt(e);
    return isNaN(s) ? 0 : a(s);
  } else if (t !== e) {
    let s = 0;
    switch (t) {
      case "%":
        s = 25;
        break;
      case "deg":
        s = 90;
    }
    if (s) {
      let r = parseFloat(e.slice(0, e.length - t.length));
      return isNaN(r) ? 0 : (r = r / s, r % 1 === 0 ? a(r) : 0);
    }
  }
  return n;
}
function dh(e, n) {
  let t = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const a in n)
    t += " " + a + '="' + n[a] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + t + ">" + e + "</svg>";
}
function fh(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function hh(e) {
  return "data:image/svg+xml," + fh(e);
}
function mh(e) {
  return 'url("' + hh(e) + '")';
}
const Wi = {
  ...Iu,
  inline: !1
}, vh = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, ph = {
  display: "inline-block"
}, Dl = {
  backgroundColor: "currentColor"
}, Ru = {
  backgroundColor: "transparent"
}, Yi = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, Hi = {
  webkitMask: Dl,
  mask: Dl,
  background: Ru
};
for (const e in Hi) {
  const n = Hi[e];
  for (const t in Yi)
    n[e + t] = Yi[t];
}
const ur = {};
["horizontal", "vertical"].forEach((e) => {
  const n = e.slice(0, 1) + "Flip";
  ur[e + "-flip"] = n, ur[e.slice(0, 1) + "-flip"] = n, ur[e + "Flip"] = n;
});
function Ui(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const qi = (e, n) => {
  const t = ih(Wi, n), a = { ...vh }, s = n.mode || "svg", r = {}, l = n.style, i = typeof l == "object" && !(l instanceof Array) ? l : {};
  for (let y in n) {
    const k = n[y];
    if (k !== void 0)
      switch (y) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          t[y] = k === !0 || k === "true" || k === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof k == "string" && uh(t, k);
          break;
        // Color: override style
        case "color":
          r.color = k;
          break;
        // Rotation as string
        case "rotate":
          typeof k == "string" ? t[y] = ch(k) : typeof k == "number" && (t[y] = k);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          k !== !0 && k !== "true" && delete a["aria-hidden"];
          break;
        default: {
          const m = ur[y];
          m ? (k === !0 || k === "true" || k === 1) && (t[m] = !0) : Wi[y] === void 0 && (a[y] = k);
        }
      }
  }
  const o = Af(e, t), u = o.attributes;
  if (t.inline && (r.verticalAlign = "-0.125em"), s === "svg") {
    a.style = {
      ...r,
      ...i
    }, Object.assign(a, u);
    let y = 0, k = n.id;
    return typeof k == "string" && (k = k.replace(/-/g, "_")), a.innerHTML = Lf(o.body, k ? () => k + "ID" + y++ : "iconifyVue"), wt("svg", a);
  }
  const { body: c, width: f, height: h } = e, d = s === "mask" || (s === "bg" ? !1 : c.indexOf("currentColor") !== -1), g = dh(c, {
    ...u,
    width: f + "",
    height: h + ""
  });
  return a.style = {
    ...r,
    "--svg": mh(g),
    width: Ui(u.width),
    height: Ui(u.height),
    ...ph,
    ...d ? Dl : Ru,
    ...i
  }, wt("span", a);
};
_u(!0);
Nf("", jf);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const n = e.IconifyPreload, t = "Invalid IconifyPreload syntax.";
    typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((a) => {
      try {
        // Check if item is an object and not null/array
        (typeof a != "object" || a === null || a instanceof Array || // Check for 'icons' and 'prefix'
        typeof a.icons != "object" || typeof a.prefix != "string" || // Add icon set
        !Cf(a)) && console.error(t);
      } catch {
        console.error(t);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const n = e.IconifyProviders;
    if (typeof n == "object" && n !== null)
      for (let t in n) {
        const a = "IconifyProviders[" + t + "] is invalid.";
        try {
          const s = n[t];
          if (typeof s != "object" || !s || s.resources === void 0)
            continue;
          Bf(t, s) || console.error(a);
        } catch {
          console.error(a);
        }
      }
  }
}
const gh = {
  ..._r,
  body: ""
}, yh = Te((e, { emit: n }) => {
  const t = te(null);
  function a() {
    var u, c;
    t.value && ((c = (u = t.value).abort) == null || c.call(u), t.value = null);
  }
  const s = te(!!e.ssr), r = te(""), l = Wt(null);
  function i() {
    const u = e.icon;
    if (typeof u == "object" && u !== null && typeof u.body == "string")
      return r.value = "", {
        data: u
      };
    let c;
    if (typeof u != "string" || (c = Or(u, !1, !0)) === null)
      return null;
    let f = Mf(c);
    if (!f) {
      const g = t.value;
      return (!g || g.name !== u) && (f === null ? t.value = {
        name: u
      } : t.value = {
        name: u,
        abort: lh([c], o)
      }), null;
    }
    a(), r.value !== u && (r.value = u, Xe(() => {
      n("load", u);
    }));
    const h = e.customise;
    if (h) {
      f = Object.assign({}, f);
      const g = h(f.body, c.name, c.prefix, c.provider);
      typeof g == "string" && (f.body = g);
    }
    const d = ["iconify"];
    return c.prefix !== "" && d.push("iconify--" + c.prefix), c.provider !== "" && d.push("iconify--" + c.provider), { data: f, classes: d };
  }
  function o() {
    var c;
    const u = i();
    u ? u.data !== ((c = l.value) == null ? void 0 : c.data) && (l.value = u) : l.value = null;
  }
  return s.value ? o() : nt(() => {
    s.value = !0, o();
  }), He(() => e.icon, o), sn(a), () => {
    const u = l.value;
    if (!u)
      return qi(gh, e);
    let c = e;
    return u.classes && (c = {
      ...e,
      class: u.classes.join(" ")
    }), qi({
      ..._r,
      ...u.data
    }, c);
  };
}, {
  props: [
    // Icon and render mode
    "icon",
    "mode",
    "ssr",
    // Layout and style
    "width",
    "height",
    "style",
    "color",
    "inline",
    // Transformations
    "rotate",
    "hFlip",
    "horizontalFlip",
    "vFlip",
    "verticalFlip",
    "flip",
    // Misc
    "id",
    "ariaHidden",
    "customise",
    "title"
  ],
  emits: ["load"]
}), bh = /* @__PURE__ */ Te({
  __name: "VIcon",
  props: {
    icon: {},
    size: { default: 24 },
    color: { default: "currentColor" },
    class: { default: "" },
    loading: { type: Boolean }
  },
  setup(e) {
    const n = C(() => e.color.startsWith("text-")), t = C(() => e.loading ? "lucide:loader-2" : e.icon), a = C(() => typeof e.size == "number" ? `${e.size}px` : e.size), s = C(() => n.value ? e.color : ""), r = C(() => n.value ? void 0 : { color: e.color });
    return (l, i) => (b(), fe(p(yh), {
      class: ne([[{ "v-icon--spin": e.loading }, s.value, e.class], "v-icon"]),
      height: a.value,
      icon: t.value,
      style: Fe(r.value),
      width: a.value,
      "aria-hidden": "true",
      focusable: "false"
    }, null, 8, ["class", "height", "icon", "style", "width"]));
  }
}), xe = /* @__PURE__ */ Ge(bh, [["__scopeId", "data-v-68f452e3"]]), wh = {
  key: 0,
  class: "v-button__icon"
}, kh = {
  key: 1,
  class: "v-button__content"
}, xh = { key: 0 }, Sh = {
  key: 2,
  class: "v-button__icon"
}, Th = /* @__PURE__ */ Te({
  __name: "VButton",
  props: {
    text: { default: "" },
    type: { default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { default: void 0 },
    variant: { default: "default" },
    to: { default: void 0 },
    replace: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = Yt(), t = e, a = C(() => !t.text && !!t.icon && !n.default), s = C(() => {
      switch (t.variant) {
        case "primary":
          return "v-button--primary";
        case "positive":
          return "v-button--positive";
        case "negative":
          return "v-button--negative";
        case "warning":
          return "v-button--warning";
        case "link":
          return "v-button--link";
        case "secondary":
          return "v-button--secondary";
        default:
          return "v-button--primary";
      }
    }), r = C(() => !!t.to);
    return (l, i) => (b(), fe(ht(r.value ? p(hf) : "button"), lt(
      {
        class: [
          "v-button",
          s.value,
          {
            "v-button--icon-only": a.value,
            "v-button--disabled cursor-not-allowed": t.disabled || t.loading
          }
        ]
      },
      r.value ? {
        to: t.disabled || t.loading ? void 0 : t.to,
        replace: t.replace,
        ...l.$attrs
      } : { type: t.type, disabled: t.disabled || t.loading, ...l.$attrs }
    ), {
      default: de(() => [
        l.$slots.iconLeft || t.loading || t.icon ? (b(), M("span", wh, [
          t.loading ? (b(), fe(xe, {
            key: 0,
            loading: t.loading,
            size: 24,
            icon: "lucide:loading"
          }, null, 8, ["loading"])) : U(l.$slots, "iconLeft", { key: 1 }, () => [
            t.icon ? (b(), fe(xe, {
              key: 0,
              icon: t.icon
            }, null, 8, ["icon"])) : P("", !0)
          ], !0)
        ])) : P("", !0),
        a.value ? P("", !0) : (b(), M("span", kh, [
          t.text ? (b(), M("span", xh, ce(t.text), 1)) : P("", !0),
          U(l.$slots, "default", {}, void 0, !0)
        ])),
        l.$slots.iconRight ? (b(), M("span", Sh, [
          U(l.$slots, "iconRight", {}, void 0, !0)
        ])) : P("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), qt = /* @__PURE__ */ Ge(Th, [["__scopeId", "data-v-ec924d87"]]), Mh = { key: 1 }, $h = /* @__PURE__ */ Te({
  __name: "VTag",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "primary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    iconPosition: { default: "left" },
    rounded: { type: Boolean, default: !1 },
    class: { default: "" },
    customColor: { default: void 0 }
  },
  setup(e) {
    const n = e, t = C(() => ({
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18
    })[n.size]), a = C(() => `vtag--${n.size}`), s = C(
      () => n.customColor ? { "--_tag-color": `var(${n.customColor})` } : void 0
    ), r = C(
      () => n.customColor ? `vtag--custom-${n.variant}` : `vtag--${n.variant}-${n.color}`
    ), l = C(() => n.rounded ? "vtag--rounded" : "vtag--square");
    return (i, o) => (b(), M("span", {
      style: Fe(s.value),
      class: ne([[a.value, r.value, l.value, n.class], "vtag"])
    }, [
      e.icon && e.iconPosition === "left" ? (b(), fe(xe, {
        key: 0,
        icon: e.icon,
        size: t.value
      }, null, 8, ["icon", "size"])) : P("", !0),
      e.label || i.$slots.default ? (b(), M("span", Mh, [
        U(i.$slots, "default", {}, () => [
          Ue(ce(e.label), 1)
        ], !0)
      ])) : P("", !0),
      U(i.$slots, "icon-right", {}, () => [
        e.icon && e.iconPosition === "right" ? (b(), fe(xe, {
          key: 0,
          icon: e.icon,
          size: t.value
        }, null, 8, ["icon", "size"])) : P("", !0)
      ], !0)
    ], 6));
  }
}), Vu = /* @__PURE__ */ Ge($h, [["__scopeId", "data-v-6a630cc7"]]), Ch = { class: "vchip__content" }, Dh = {
  key: 1,
  class: "vchip__label"
}, Oh = ["disabled"], _h = /* @__PURE__ */ Te({
  __name: "VChip",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "default" },
    selectedColor: { default: "primary" },
    size: { default: "md" },
    icon: { default: void 0 },
    closable: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    badge: { default: void 0 },
    badgeColor: { default: "primary" },
    class: { default: "" },
    value: { type: [String, Number, Boolean, Object, null], default: void 0 },
    modelValue: { default: void 0 },
    multiple: { type: Boolean, default: !1 },
    valueComparator: { type: Function, default: void 0 }
  },
  emits: ["click", "close", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (h, d) => {
      if (t.valueComparator)
        return t.valueComparator(h, d);
      if (h === d) return !0;
      if (h == null || d == null) return !1;
      if (typeof h == "object" && typeof d == "object")
        try {
          return JSON.stringify(h) === JSON.stringify(d);
        } catch {
          return !1;
        }
      return h === d;
    }, r = C(() => t.modelValue !== void 0 && t.value !== void 0 ? t.multiple ? Array.isArray(t.modelValue) && t.modelValue.some((h) => s(h, t.value)) : s(t.modelValue, t.value) : t.active), l = C(() => ({
      sm: 14,
      md: 16,
      lg: 18
    })[t.size]), i = C(() => `vchip--${t.size}`), o = C(() => {
      if (t.color === "default" && r.value)
        return `vchip--${t.variant}-${t.selectedColor}-selected`;
      const h = `vchip--${t.variant}-${t.color}`;
      return r.value ? `${h}-selected` : h;
    }), u = C(() => t.disabled ? "vchip--disabled" : "vchip--interactive"), c = (h) => {
      if (!t.disabled) {
        if (t.value !== void 0 && t.modelValue !== void 0)
          if (t.multiple) {
            const d = Array.isArray(t.modelValue) ? t.modelValue : [];
            if (d.findIndex((y) => s(y, t.value)) > -1) {
              const y = d.filter((k) => !s(k, t.value));
              a("update:modelValue", y);
            } else
              a("update:modelValue", [...d, t.value]);
          } else
            s(t.modelValue, t.value) ? a("update:modelValue", null) : a("update:modelValue", t.value);
        a("click", h);
      }
    }, f = (h) => {
      t.disabled || a("close", h);
    };
    return (h, d) => (b(), M("span", {
      class: ne([[i.value, o.value, u.value, t.class], "vchip"]),
      onClick: c
    }, [
      E("span", Ch, [
        e.icon ? (b(), fe(xe, {
          key: 0,
          icon: e.icon,
          size: l.value,
          class: "vchip__icon"
        }, null, 8, ["icon", "size"])) : P("", !0),
        e.label || h.$slots.default ? (b(), M("span", Dh, [
          U(h.$slots, "default", {}, () => [
            Ue(ce(e.label), 1)
          ], !0)
        ])) : P("", !0),
        U(h.$slots, "badge", {}, () => [
          e.badge ? (b(), fe(Vu, {
            key: 0,
            color: e.badgeColor,
            label: e.badge,
            size: "sm",
            variant: "outline"
          }, null, 8, ["color", "label"])) : P("", !0)
        ], !0)
      ]),
      e.closable ? (b(), M("button", {
        key: 0,
        disabled: e.disabled,
        class: "vchip__close",
        type: "button",
        onClick: Ve(f, ["stop"])
      }, [
        oe(xe, {
          size: l.value - 2,
          icon: "lucide:x"
        }, null, 8, ["size"])
      ], 8, Oh)) : P("", !0)
    ], 2));
  }
}), q2 = /* @__PURE__ */ Ge(_h, [["__scopeId", "data-v-d99cc188"]]), Eh = { class: "v-checkbox" }, Ih = ["id", "disabled", "value"], Ph = ["for"], Ah = /* @__PURE__ */ Te({
  __name: "VCheckbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    id: {},
    label: {},
    value: { type: [String, Number, Boolean] },
    disabled: { type: Boolean },
    indeterminate: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Cr(), r = C(() => t.id || s), l = C({
      get() {
        return t.modelValue;
      },
      set(o) {
        o !== void 0 && a("update:modelValue", o);
      }
    }), i = te(null);
    return Ut(() => {
      i.value && (i.value.indeterminate = !!t.indeterminate);
    }), (o, u) => (b(), M("div", Eh, [
      mn(E("input", lt({
        id: r.value,
        ref_key: "inputRef",
        ref: i,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => l.value = c),
        disabled: t.disabled,
        value: e.value,
        class: "v-checkbox__input",
        type: "checkbox"
      }, o.$attrs), null, 16, Ih), [
        [rf, l.value]
      ]),
      e.label || o.$slots.label ? (b(), M("label", {
        key: 0,
        class: ne([
          "v-checkbox__label",
          { "v-checkbox__label--disabled": t.disabled }
        ]),
        for: t.disabled ? void 0 : r.value
      }, [
        U(o.$slots, "label", {}, () => [
          Ue(ce(e.label), 1)
        ], !0)
      ], 10, Ph)) : P("", !0)
    ]));
  }
}), Fu = /* @__PURE__ */ Ge(Ah, [["__scopeId", "data-v-914acca3"]]), Rh = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Vh = Object.prototype.toString, Fh = (e) => Vh.call(e) === "[object Object]", Ks = () => {
};
function el(e) {
  return Array.isArray(e) ? e : [e];
}
function Lh(e, n, t) {
  return He(e, n, {
    ...t,
    immediate: !0
  });
}
const Lu = Rh ? window : void 0;
function jt(e) {
  var n;
  const t = tt(e);
  return (n = t == null ? void 0 : t.$el) !== null && n !== void 0 ? n : t;
}
function Fa(...e) {
  const n = (a, s, r, l) => (a.addEventListener(s, r, l), () => a.removeEventListener(s, r, l)), t = C(() => {
    const a = el(tt(e[0])).filter((s) => s != null);
    return a.every((s) => typeof s != "string") ? a : void 0;
  });
  return Lh(() => {
    var a, s;
    return [
      (a = (s = t.value) === null || s === void 0 ? void 0 : s.map((r) => jt(r))) !== null && a !== void 0 ? a : [Lu].filter((r) => r != null),
      el(tt(t.value ? e[1] : e[0])),
      el(p(t.value ? e[2] : e[1])),
      tt(t.value ? e[3] : e[2])
    ];
  }, ([a, s, r, l], i, o) => {
    if (!(a != null && a.length) || !(s != null && s.length) || !(r != null && r.length)) return;
    const u = Fh(l) ? { ...l } : l, c = a.flatMap((f) => s.flatMap((h) => r.map((d) => n(f, h, d, u))));
    o(() => {
      c.forEach((f) => f());
    });
  }, { flush: "post" });
}
function Nh(e, n, t = {}) {
  const { window: a = Lu, ignore: s = [], capture: r = !0, detectIframe: l = !1, controls: i = !1 } = t;
  if (!a) return i ? {
    stop: Ks,
    cancel: Ks,
    trigger: Ks
  } : Ks;
  let o = !0;
  const u = (k) => tt(s).some((m) => {
    if (typeof m == "string") return Array.from(a.document.querySelectorAll(m)).some((v) => v === k.target || k.composedPath().includes(v));
    {
      const v = jt(m);
      return v && (k.target === v || k.composedPath().includes(v));
    }
  });
  function c(k) {
    const m = tt(k);
    return m && m.$.subTree.shapeFlag === 16;
  }
  function f(k, m) {
    const v = tt(k), w = v.$.subTree && v.$.subTree.children;
    return w == null || !Array.isArray(w) ? !1 : w.some((S) => S.el === m.target || m.composedPath().includes(S.el));
  }
  const h = (k) => {
    const m = jt(e);
    if (k.target != null && !(!(m instanceof Element) && c(e) && f(e, k)) && !(!m || m === k.target || k.composedPath().includes(m))) {
      if ("detail" in k && k.detail === 0 && (o = !u(k)), !o) {
        o = !0;
        return;
      }
      n(k);
    }
  };
  let d = !1;
  const g = [
    Fa(a, "click", (k) => {
      d || (d = !0, setTimeout(() => {
        d = !1;
      }, 0), h(k));
    }, {
      passive: !0,
      capture: r
    }),
    Fa(a, "pointerdown", (k) => {
      const m = jt(e);
      o = !u(k) && !!(m && !k.composedPath().includes(m));
    }, { passive: !0 }),
    l && Fa(a, "blur", (k) => {
      setTimeout(() => {
        var m;
        const v = jt(e);
        ((m = a.document.activeElement) === null || m === void 0 ? void 0 : m.tagName) === "IFRAME" && !(v != null && v.contains(a.document.activeElement)) && n(k);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), y = () => g.forEach((k) => k());
  return i ? {
    stop: y,
    cancel: () => {
      o = !1;
    },
    trigger: (k) => {
      o = !0, h(k), o = !1;
    }
  } : y;
}
function Bh(e, n = {}) {
  const { threshold: t = 50, onSwipe: a, onSwipeEnd: s, onSwipeStart: r, passive: l = !0 } = n, i = pa({
    x: 0,
    y: 0
  }), o = pa({
    x: 0,
    y: 0
  }), u = C(() => i.x - o.x), c = C(() => i.y - o.y), { max: f, abs: h } = Math, d = C(() => f(h(u.value), h(c.value)) >= t), g = Wt(!1), y = C(() => d.value ? h(u.value) > h(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), k = (T) => [T.touches[0].clientX, T.touches[0].clientY], m = (T, _) => {
    i.x = T, i.y = _;
  }, v = (T, _) => {
    o.x = T, o.y = _;
  }, w = {
    passive: l,
    capture: !l
  }, S = (T) => {
    g.value && (s == null || s(T, y.value)), g.value = !1;
  }, x = [
    Fa(e, "touchstart", (T) => {
      if (T.touches.length !== 1) return;
      const [_, A] = k(T);
      m(_, A), v(_, A), r == null || r(T);
    }, w),
    Fa(e, "touchmove", (T) => {
      if (T.touches.length !== 1) return;
      const [_, A] = k(T);
      v(_, A), w.capture && !w.passive && Math.abs(u.value) > Math.abs(c.value) && T.preventDefault(), !g.value && d.value && (g.value = !0), g.value && (a == null || a(T));
    }, w),
    Fa(e, ["touchend", "touchcancel"], S, w)
  ];
  return {
    isSwiping: g,
    direction: y,
    coordsStart: i,
    coordsEnd: o,
    lengthX: u,
    lengthY: c,
    stop: () => x.forEach((T) => T())
  };
}
const Ha = Math.min, ma = Math.max, vr = Math.round, Zs = Math.floor, On = (e) => ({
  x: e,
  y: e
}), zh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Wh = {
  start: "end",
  end: "start"
};
function Ol(e, n, t) {
  return ma(e, Ha(n, t));
}
function _s(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ga(e) {
  return e.split("-")[0];
}
function Es(e) {
  return e.split("-")[1];
}
function Nu(e) {
  return e === "x" ? "y" : "x";
}
function si(e) {
  return e === "y" ? "height" : "width";
}
const Yh = /* @__PURE__ */ new Set(["top", "bottom"]);
function Xn(e) {
  return Yh.has(ga(e)) ? "y" : "x";
}
function ri(e) {
  return Nu(Xn(e));
}
function Hh(e, n, t) {
  t === void 0 && (t = !1);
  const a = Es(e), s = ri(e), r = si(s);
  let l = s === "x" ? a === (t ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return n.reference[r] > n.floating[r] && (l = pr(l)), [l, pr(l)];
}
function Uh(e) {
  const n = pr(e);
  return [_l(e), n, _l(n)];
}
function _l(e) {
  return e.replace(/start|end/g, (n) => Wh[n]);
}
const ji = ["left", "right"], Gi = ["right", "left"], qh = ["top", "bottom"], jh = ["bottom", "top"];
function Gh(e, n, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? Gi : ji : n ? ji : Gi;
    case "left":
    case "right":
      return n ? qh : jh;
    default:
      return [];
  }
}
function Kh(e, n, t, a) {
  const s = Es(e);
  let r = Gh(ga(e), t === "start", a);
  return s && (r = r.map((l) => l + "-" + s), n && (r = r.concat(r.map(_l)))), r;
}
function pr(e) {
  return e.replace(/left|right|bottom|top/g, (n) => zh[n]);
}
function Zh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Bu(e) {
  return typeof e != "number" ? Zh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gr(e) {
  const {
    x: n,
    y: t,
    width: a,
    height: s
  } = e;
  return {
    width: a,
    height: s,
    top: t,
    left: n,
    right: n + a,
    bottom: t + s,
    x: n,
    y: t
  };
}
function Ki(e, n, t) {
  let {
    reference: a,
    floating: s
  } = e;
  const r = Xn(n), l = ri(n), i = si(l), o = ga(n), u = r === "y", c = a.x + a.width / 2 - s.width / 2, f = a.y + a.height / 2 - s.height / 2, h = a[i] / 2 - s[i] / 2;
  let d;
  switch (o) {
    case "top":
      d = {
        x: c,
        y: a.y - s.height
      };
      break;
    case "bottom":
      d = {
        x: c,
        y: a.y + a.height
      };
      break;
    case "right":
      d = {
        x: a.x + a.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: a.x - s.width,
        y: f
      };
      break;
    default:
      d = {
        x: a.x,
        y: a.y
      };
  }
  switch (Es(n)) {
    case "start":
      d[l] -= h * (t && u ? -1 : 1);
      break;
    case "end":
      d[l] += h * (t && u ? -1 : 1);
      break;
  }
  return d;
}
async function Xh(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: a,
    y: s,
    platform: r,
    rects: l,
    elements: i,
    strategy: o
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: d = 0
  } = _s(n, e), g = Bu(d), k = i[h ? f === "floating" ? "reference" : "floating" : f], m = gr(await r.getClippingRect({
    element: (t = await (r.isElement == null ? void 0 : r.isElement(k))) == null || t ? k : k.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: o
  })), v = f === "floating" ? {
    x: a,
    y: s,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, w = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(i.floating)), S = await (r.isElement == null ? void 0 : r.isElement(w)) ? await (r.getScale == null ? void 0 : r.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = gr(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: v,
    offsetParent: w,
    strategy: o
  }) : v);
  return {
    top: (m.top - x.top + g.top) / S.y,
    bottom: (x.bottom - m.bottom + g.bottom) / S.y,
    left: (m.left - x.left + g.left) / S.x,
    right: (x.right - m.right + g.right) / S.x
  };
}
const Jh = async (e, n, t) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: l
  } = t, i = r.filter(Boolean), o = await (l.isRTL == null ? void 0 : l.isRTL(n));
  let u = await l.getElementRects({
    reference: e,
    floating: n,
    strategy: s
  }), {
    x: c,
    y: f
  } = Ki(u, a, o), h = a, d = {}, g = 0;
  for (let k = 0; k < i.length; k++) {
    var y;
    const {
      name: m,
      fn: v
    } = i[k], {
      x: w,
      y: S,
      data: x,
      reset: $
    } = await v({
      x: c,
      y: f,
      initialPlacement: a,
      placement: h,
      strategy: s,
      middlewareData: d,
      rects: u,
      platform: {
        ...l,
        detectOverflow: (y = l.detectOverflow) != null ? y : Xh
      },
      elements: {
        reference: e,
        floating: n
      }
    });
    c = w ?? c, f = S ?? f, d = {
      ...d,
      [m]: {
        ...d[m],
        ...x
      }
    }, $ && g <= 50 && (g++, typeof $ == "object" && ($.placement && (h = $.placement), $.rects && (u = $.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: n,
      strategy: s
    }) : $.rects), {
      x: c,
      y: f
    } = Ki(u, h, o)), k = -1);
  }
  return {
    x: c,
    y: f,
    placement: h,
    strategy: s,
    middlewareData: d
  };
}, Qh = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: a,
      placement: s,
      rects: r,
      platform: l,
      elements: i,
      middlewareData: o
    } = n, {
      element: u,
      padding: c = 0
    } = _s(e, n) || {};
    if (u == null)
      return {};
    const f = Bu(c), h = {
      x: t,
      y: a
    }, d = ri(s), g = si(d), y = await l.getDimensions(u), k = d === "y", m = k ? "top" : "left", v = k ? "bottom" : "right", w = k ? "clientHeight" : "clientWidth", S = r.reference[g] + r.reference[d] - h[d] - r.floating[g], x = h[d] - r.reference[d], $ = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(u));
    let T = $ ? $[w] : 0;
    (!T || !await (l.isElement == null ? void 0 : l.isElement($))) && (T = i.floating[w] || r.floating[g]);
    const _ = S / 2 - x / 2, A = T / 2 - y[g] / 2 - 1, D = Ha(f[m], A), Y = Ha(f[v], A), L = D, X = T - y[g] - Y, se = T / 2 - y[g] / 2 + _, ie = Ol(L, se, X), ue = !o.arrow && Es(s) != null && se !== ie && r.reference[g] / 2 - (se < L ? D : Y) - y[g] / 2 < 0, G = ue ? se < L ? se - L : se - X : 0;
    return {
      [d]: h[d] + G,
      data: {
        [d]: ie,
        centerOffset: se - ie - G,
        ...ue && {
          alignmentOffset: G
        }
      },
      reset: ue
    };
  }
}), em = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, a;
      const {
        placement: s,
        middlewareData: r,
        rects: l,
        initialPlacement: i,
        platform: o,
        elements: u
      } = n, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: y = !0,
        ...k
      } = _s(e, n);
      if ((t = r.arrow) != null && t.alignmentOffset)
        return {};
      const m = ga(s), v = Xn(i), w = ga(i) === i, S = await (o.isRTL == null ? void 0 : o.isRTL(u.floating)), x = h || (w || !y ? [pr(i)] : Uh(i)), $ = g !== "none";
      !h && $ && x.push(...Kh(i, y, g, S));
      const T = [i, ...x], _ = await o.detectOverflow(n, k), A = [];
      let D = ((a = r.flip) == null ? void 0 : a.overflows) || [];
      if (c && A.push(_[m]), f) {
        const se = Hh(s, l, S);
        A.push(_[se[0]], _[se[1]]);
      }
      if (D = [...D, {
        placement: s,
        overflows: A
      }], !A.every((se) => se <= 0)) {
        var Y, L;
        const se = (((Y = r.flip) == null ? void 0 : Y.index) || 0) + 1, ie = T[se];
        if (ie && (!(f === "alignment" ? v !== Xn(ie) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((q) => Xn(q.placement) === v ? q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: se,
              overflows: D
            },
            reset: {
              placement: ie
            }
          };
        let ue = (L = D.filter((G) => G.overflows[0] <= 0).sort((G, q) => G.overflows[1] - q.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!ue)
          switch (d) {
            case "bestFit": {
              var X;
              const G = (X = D.filter((q) => {
                if ($) {
                  const Z = Xn(q.placement);
                  return Z === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((Z) => Z > 0).reduce((Z, N) => Z + N, 0)]).sort((q, Z) => q[1] - Z[1])[0]) == null ? void 0 : X[0];
              G && (ue = G);
              break;
            }
            case "initialPlacement":
              ue = i;
              break;
          }
        if (s !== ue)
          return {
            reset: {
              placement: ue
            }
          };
      }
      return {};
    }
  };
}, tm = /* @__PURE__ */ new Set(["left", "top"]);
async function nm(e, n) {
  const {
    placement: t,
    platform: a,
    elements: s
  } = e, r = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), l = ga(t), i = Es(t), o = Xn(t) === "y", u = tm.has(l) ? -1 : 1, c = r && o ? -1 : 1, f = _s(n, e);
  let {
    mainAxis: h,
    crossAxis: d,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof g == "number" && (d = i === "end" ? g * -1 : g), o ? {
    x: d * c,
    y: h * u
  } : {
    x: h * u,
    y: d * c
  };
}
const am = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, a;
      const {
        x: s,
        y: r,
        placement: l,
        middlewareData: i
      } = n, o = await nm(n, e);
      return l === ((t = i.offset) == null ? void 0 : t.placement) && (a = i.arrow) != null && a.alignmentOffset ? {} : {
        x: s + o.x,
        y: r + o.y,
        data: {
          ...o,
          placement: l
        }
      };
    }
  };
}, sm = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: a,
        placement: s,
        platform: r
      } = n, {
        mainAxis: l = !0,
        crossAxis: i = !1,
        limiter: o = {
          fn: (m) => {
            let {
              x: v,
              y: w
            } = m;
            return {
              x: v,
              y: w
            };
          }
        },
        ...u
      } = _s(e, n), c = {
        x: t,
        y: a
      }, f = await r.detectOverflow(n, u), h = Xn(ga(s)), d = Nu(h);
      let g = c[d], y = c[h];
      if (l) {
        const m = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", w = g + f[m], S = g - f[v];
        g = Ol(w, g, S);
      }
      if (i) {
        const m = h === "y" ? "top" : "left", v = h === "y" ? "bottom" : "right", w = y + f[m], S = y - f[v];
        y = Ol(w, y, S);
      }
      const k = o.fn({
        ...n,
        [d]: g,
        [h]: y
      });
      return {
        ...k,
        data: {
          x: k.x - t,
          y: k.y - a,
          enabled: {
            [d]: l,
            [h]: i
          }
        }
      };
    }
  };
};
function Er() {
  return typeof window < "u";
}
function ba(e) {
  return li(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Gt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Pn(e) {
  var n;
  return (n = (li(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function li(e) {
  return Er() ? e instanceof Node || e instanceof Gt(e).Node : !1;
}
function yn(e) {
  return Er() ? e instanceof Element || e instanceof Gt(e).Element : !1;
}
function En(e) {
  return Er() ? e instanceof HTMLElement || e instanceof Gt(e).HTMLElement : !1;
}
function Zi(e) {
  return !Er() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Gt(e).ShadowRoot;
}
const rm = /* @__PURE__ */ new Set(["inline", "contents"]);
function Is(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: a,
    display: s
  } = bn(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + a + t) && !rm.has(s);
}
const lm = /* @__PURE__ */ new Set(["table", "td", "th"]);
function im(e) {
  return lm.has(ba(e));
}
const om = [":popover-open", ":modal"];
function Ir(e) {
  return om.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
const um = ["transform", "translate", "scale", "rotate", "perspective"], cm = ["transform", "translate", "scale", "rotate", "perspective", "filter"], dm = ["paint", "layout", "strict", "content"];
function ii(e) {
  const n = oi(), t = yn(e) ? bn(e) : e;
  return um.some((a) => t[a] ? t[a] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || cm.some((a) => (t.willChange || "").includes(a)) || dm.some((a) => (t.contain || "").includes(a));
}
function fm(e) {
  let n = ta(e);
  for (; En(n) && !Ua(n); ) {
    if (ii(n))
      return n;
    if (Ir(n))
      return null;
    n = ta(n);
  }
  return null;
}
function oi() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const hm = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ua(e) {
  return hm.has(ba(e));
}
function bn(e) {
  return Gt(e).getComputedStyle(e);
}
function Pr(e) {
  return yn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ta(e) {
  if (ba(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Zi(e) && e.host || // Fallback.
    Pn(e)
  );
  return Zi(n) ? n.host : n;
}
function zu(e) {
  const n = ta(e);
  return Ua(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : En(n) && Is(n) ? n : zu(n);
}
function Ms(e, n, t) {
  var a;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const s = zu(e), r = s === ((a = e.ownerDocument) == null ? void 0 : a.body), l = Gt(s);
  if (r) {
    const i = El(l);
    return n.concat(l, l.visualViewport || [], Is(s) ? s : [], i && t ? Ms(i) : []);
  }
  return n.concat(s, Ms(s, [], t));
}
function El(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Wu(e) {
  const n = bn(e);
  let t = parseFloat(n.width) || 0, a = parseFloat(n.height) || 0;
  const s = En(e), r = s ? e.offsetWidth : t, l = s ? e.offsetHeight : a, i = vr(t) !== r || vr(a) !== l;
  return i && (t = r, a = l), {
    width: t,
    height: a,
    $: i
  };
}
function ui(e) {
  return yn(e) ? e : e.contextElement;
}
function La(e) {
  const n = ui(e);
  if (!En(n))
    return On(1);
  const t = n.getBoundingClientRect(), {
    width: a,
    height: s,
    $: r
  } = Wu(n);
  let l = (r ? vr(t.width) : t.width) / a, i = (r ? vr(t.height) : t.height) / s;
  return (!l || !Number.isFinite(l)) && (l = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: l,
    y: i
  };
}
const mm = /* @__PURE__ */ On(0);
function Yu(e) {
  const n = Gt(e);
  return !oi() || !n.visualViewport ? mm : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function vm(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Gt(e) ? !1 : n;
}
function ya(e, n, t, a) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const s = e.getBoundingClientRect(), r = ui(e);
  let l = On(1);
  n && (a ? yn(a) && (l = La(a)) : l = La(e));
  const i = vm(r, t, a) ? Yu(r) : On(0);
  let o = (s.left + i.x) / l.x, u = (s.top + i.y) / l.y, c = s.width / l.x, f = s.height / l.y;
  if (r) {
    const h = Gt(r), d = a && yn(a) ? Gt(a) : a;
    let g = h, y = El(g);
    for (; y && a && d !== g; ) {
      const k = La(y), m = y.getBoundingClientRect(), v = bn(y), w = m.left + (y.clientLeft + parseFloat(v.paddingLeft)) * k.x, S = m.top + (y.clientTop + parseFloat(v.paddingTop)) * k.y;
      o *= k.x, u *= k.y, c *= k.x, f *= k.y, o += w, u += S, g = Gt(y), y = El(g);
    }
  }
  return gr({
    width: c,
    height: f,
    x: o,
    y: u
  });
}
function Ar(e, n) {
  const t = Pr(e).scrollLeft;
  return n ? n.left + t : ya(Pn(e)).left + t;
}
function Hu(e, n) {
  const t = e.getBoundingClientRect(), a = t.left + n.scrollLeft - Ar(e, t), s = t.top + n.scrollTop;
  return {
    x: a,
    y: s
  };
}
function pm(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: a,
    strategy: s
  } = e;
  const r = s === "fixed", l = Pn(a), i = n ? Ir(n.floating) : !1;
  if (a === l || i && r)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = On(1);
  const c = On(0), f = En(a);
  if ((f || !f && !r) && ((ba(a) !== "body" || Is(l)) && (o = Pr(a)), En(a))) {
    const d = ya(a);
    u = La(a), c.x = d.x + a.clientLeft, c.y = d.y + a.clientTop;
  }
  const h = l && !f && !r ? Hu(l, o) : On(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - o.scrollLeft * u.x + c.x + h.x,
    y: t.y * u.y - o.scrollTop * u.y + c.y + h.y
  };
}
function gm(e) {
  return Array.from(e.getClientRects());
}
function ym(e) {
  const n = Pn(e), t = Pr(e), a = e.ownerDocument.body, s = ma(n.scrollWidth, n.clientWidth, a.scrollWidth, a.clientWidth), r = ma(n.scrollHeight, n.clientHeight, a.scrollHeight, a.clientHeight);
  let l = -t.scrollLeft + Ar(e);
  const i = -t.scrollTop;
  return bn(a).direction === "rtl" && (l += ma(n.clientWidth, a.clientWidth) - s), {
    width: s,
    height: r,
    x: l,
    y: i
  };
}
const Xi = 25;
function bm(e, n) {
  const t = Gt(e), a = Pn(e), s = t.visualViewport;
  let r = a.clientWidth, l = a.clientHeight, i = 0, o = 0;
  if (s) {
    r = s.width, l = s.height;
    const c = oi();
    (!c || c && n === "fixed") && (i = s.offsetLeft, o = s.offsetTop);
  }
  const u = Ar(a);
  if (u <= 0) {
    const c = a.ownerDocument, f = c.body, h = getComputedStyle(f), d = c.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, g = Math.abs(a.clientWidth - f.clientWidth - d);
    g <= Xi && (r -= g);
  } else u <= Xi && (r += u);
  return {
    width: r,
    height: l,
    x: i,
    y: o
  };
}
const wm = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function km(e, n) {
  const t = ya(e, !0, n === "fixed"), a = t.top + e.clientTop, s = t.left + e.clientLeft, r = En(e) ? La(e) : On(1), l = e.clientWidth * r.x, i = e.clientHeight * r.y, o = s * r.x, u = a * r.y;
  return {
    width: l,
    height: i,
    x: o,
    y: u
  };
}
function Ji(e, n, t) {
  let a;
  if (n === "viewport")
    a = bm(e, t);
  else if (n === "document")
    a = ym(Pn(e));
  else if (yn(n))
    a = km(n, t);
  else {
    const s = Yu(e);
    a = {
      x: n.x - s.x,
      y: n.y - s.y,
      width: n.width,
      height: n.height
    };
  }
  return gr(a);
}
function Uu(e, n) {
  const t = ta(e);
  return t === n || !yn(t) || Ua(t) ? !1 : bn(t).position === "fixed" || Uu(t, n);
}
function xm(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let a = Ms(e, [], !1).filter((i) => yn(i) && ba(i) !== "body"), s = null;
  const r = bn(e).position === "fixed";
  let l = r ? ta(e) : e;
  for (; yn(l) && !Ua(l); ) {
    const i = bn(l), o = ii(l);
    !o && i.position === "fixed" && (s = null), (r ? !o && !s : !o && i.position === "static" && !!s && wm.has(s.position) || Is(l) && !o && Uu(e, l)) ? a = a.filter((c) => c !== l) : s = i, l = ta(l);
  }
  return n.set(e, a), a;
}
function Sm(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: a,
    strategy: s
  } = e;
  const l = [...t === "clippingAncestors" ? Ir(n) ? [] : xm(n, this._c) : [].concat(t), a], i = l[0], o = l.reduce((u, c) => {
    const f = Ji(n, c, s);
    return u.top = ma(f.top, u.top), u.right = Ha(f.right, u.right), u.bottom = Ha(f.bottom, u.bottom), u.left = ma(f.left, u.left), u;
  }, Ji(n, i, s));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function Tm(e) {
  const {
    width: n,
    height: t
  } = Wu(e);
  return {
    width: n,
    height: t
  };
}
function Mm(e, n, t) {
  const a = En(n), s = Pn(n), r = t === "fixed", l = ya(e, !0, r, n);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = On(0);
  function u() {
    o.x = Ar(s);
  }
  if (a || !a && !r)
    if ((ba(n) !== "body" || Is(s)) && (i = Pr(n)), a) {
      const d = ya(n, !0, r, n);
      o.x = d.x + n.clientLeft, o.y = d.y + n.clientTop;
    } else s && u();
  r && !a && s && u();
  const c = s && !a && !r ? Hu(s, i) : On(0), f = l.left + i.scrollLeft - o.x - c.x, h = l.top + i.scrollTop - o.y - c.y;
  return {
    x: f,
    y: h,
    width: l.width,
    height: l.height
  };
}
function tl(e) {
  return bn(e).position === "static";
}
function Qi(e, n) {
  if (!En(e) || bn(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return Pn(e) === t && (t = t.ownerDocument.body), t;
}
function qu(e, n) {
  const t = Gt(e);
  if (Ir(e))
    return t;
  if (!En(e)) {
    let s = ta(e);
    for (; s && !Ua(s); ) {
      if (yn(s) && !tl(s))
        return s;
      s = ta(s);
    }
    return t;
  }
  let a = Qi(e, n);
  for (; a && im(a) && tl(a); )
    a = Qi(a, n);
  return a && Ua(a) && tl(a) && !ii(a) ? t : a || fm(e) || t;
}
const $m = async function(e) {
  const n = this.getOffsetParent || qu, t = this.getDimensions, a = await t(e.floating);
  return {
    reference: Mm(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function Cm(e) {
  return bn(e).direction === "rtl";
}
const Dm = {
  convertOffsetParentRelativeRectToViewportRelativeRect: pm,
  getDocumentElement: Pn,
  getClippingRect: Sm,
  getOffsetParent: qu,
  getElementRects: $m,
  getClientRects: gm,
  getDimensions: Tm,
  getScale: La,
  isElement: yn,
  isRTL: Cm
};
function ju(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function Om(e, n) {
  let t = null, a;
  const s = Pn(e);
  function r() {
    var i;
    clearTimeout(a), (i = t) == null || i.disconnect(), t = null;
  }
  function l(i, o) {
    i === void 0 && (i = !1), o === void 0 && (o = 1), r();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: h,
      height: d
    } = u;
    if (i || n(), !h || !d)
      return;
    const g = Zs(f), y = Zs(s.clientWidth - (c + h)), k = Zs(s.clientHeight - (f + d)), m = Zs(c), w = {
      rootMargin: -g + "px " + -y + "px " + -k + "px " + -m + "px",
      threshold: ma(0, Ha(1, o)) || 1
    };
    let S = !0;
    function x($) {
      const T = $[0].intersectionRatio;
      if (T !== o) {
        if (!S)
          return l();
        T ? l(!1, T) : a = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !ju(u, e.getBoundingClientRect()) && l(), S = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, w);
    }
    t.observe(e);
  }
  return l(!0), r;
}
function _m(e, n, t, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: r = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = a, u = ui(e), c = s || r ? [...u ? Ms(u) : [], ...Ms(n)] : [];
  c.forEach((m) => {
    s && m.addEventListener("scroll", t, {
      passive: !0
    }), r && m.addEventListener("resize", t);
  });
  const f = u && i ? Om(u, t) : null;
  let h = -1, d = null;
  l && (d = new ResizeObserver((m) => {
    let [v] = m;
    v && v.target === u && d && (d.unobserve(n), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = d) == null || w.observe(n);
    })), t();
  }), u && !o && d.observe(u), d.observe(n));
  let g, y = o ? ya(e) : null;
  o && k();
  function k() {
    const m = ya(e);
    y && !ju(y, m) && t(), y = m, g = requestAnimationFrame(k);
  }
  return t(), () => {
    var m;
    c.forEach((v) => {
      s && v.removeEventListener("scroll", t), r && v.removeEventListener("resize", t);
    }), f == null || f(), (m = d) == null || m.disconnect(), d = null, o && cancelAnimationFrame(g);
  };
}
const Em = am, Im = sm, Pm = em, Am = Qh, Rm = (e, n, t) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform: Dm,
    ...t
  }, r = {
    ...s.platform,
    _c: a
  };
  return Jh(e, n, {
    ...s,
    platform: r
  });
};
function Vm(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Il(e) {
  if (Vm(e)) {
    const n = e.$el;
    return li(n) && ba(n) === "#comment" ? null : n;
  }
  return e;
}
function Ea(e) {
  return typeof e == "function" ? e() : p(e);
}
function Fm(e) {
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const t = Il(Ea(e.element));
      return t == null ? {} : Am({
        element: t,
        padding: e.padding
      }).fn(n);
    }
  };
}
function Gu(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function eo(e, n) {
  const t = Gu(e);
  return Math.round(n * t) / t;
}
function Lm(e, n, t) {
  t === void 0 && (t = {});
  const a = t.whileElementsMounted, s = C(() => {
    var T;
    return (T = Ea(t.open)) != null ? T : !0;
  }), r = C(() => Ea(t.middleware)), l = C(() => {
    var T;
    return (T = Ea(t.placement)) != null ? T : "bottom";
  }), i = C(() => {
    var T;
    return (T = Ea(t.strategy)) != null ? T : "absolute";
  }), o = C(() => {
    var T;
    return (T = Ea(t.transform)) != null ? T : !0;
  }), u = C(() => Il(e.value)), c = C(() => Il(n.value)), f = te(0), h = te(0), d = te(i.value), g = te(l.value), y = Wt({}), k = te(!1), m = C(() => {
    const T = {
      position: d.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return T;
    const _ = eo(c.value, f.value), A = eo(c.value, h.value);
    return o.value ? {
      ...T,
      transform: "translate(" + _ + "px, " + A + "px)",
      ...Gu(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: d.value,
      left: _ + "px",
      top: A + "px"
    };
  });
  let v;
  function w() {
    if (u.value == null || c.value == null)
      return;
    const T = s.value;
    Rm(u.value, c.value, {
      middleware: r.value,
      placement: l.value,
      strategy: i.value
    }).then((_) => {
      f.value = _.x, h.value = _.y, d.value = _.strategy, g.value = _.placement, y.value = _.middlewareData, k.value = T !== !1;
    });
  }
  function S() {
    typeof v == "function" && (v(), v = void 0);
  }
  function x() {
    if (S(), a === void 0) {
      w();
      return;
    }
    if (u.value != null && c.value != null) {
      v = a(u.value, c.value, w);
      return;
    }
  }
  function $() {
    s.value || (k.value = !1);
  }
  return He([r, l, i, s], w, {
    flush: "sync"
  }), He([u, c], x, {
    flush: "sync"
  }), He(s, $, {
    flush: "sync"
  }), gu() && Dr(S), {
    x: Sa(f),
    y: Sa(h),
    strategy: Sa(d),
    placement: Sa(g),
    middlewareData: Sa(y),
    isPositioned: Sa(k),
    floatingStyles: m,
    update: w
  };
}
const Ku = 6048e5, Nm = 864e5, Bm = 6e4, zm = 36e5, Wm = 1e3, to = Symbol.for("constructDateFrom");
function ut(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && to in e ? e[to](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Le(e, n) {
  return ut(n || e, e);
}
function en(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return isNaN(n) ? ut((t == null ? void 0 : t.in) || e, NaN) : (n && a.setDate(a.getDate() + n), a);
}
function vn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return ut(e, NaN);
  if (!n)
    return a;
  const s = a.getDate(), r = ut(e, a.getTime());
  r.setMonth(a.getMonth() + n + 1, 0);
  const l = r.getDate();
  return s >= l ? r : (a.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    s
  ), a);
}
function Zu(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: r = 0,
    days: l = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = Le(e, t == null ? void 0 : t.in), f = s || a ? vn(c, s + a * 12) : c, h = l || r ? en(f, l + r * 7) : f, d = o + i * 60, y = (u + d * 60) * 1e3;
  return ut(e, +h + y);
}
let Ym = {};
function wa() {
  return Ym;
}
function an(e, n) {
  var i, o, u, c;
  const t = wa(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Le(e, n == null ? void 0 : n.in), r = s.getDay(), l = (r < a ? 7 : 0) + r - a;
  return s.setDate(s.getDate() - l), s.setHours(0, 0, 0, 0), s;
}
function qa(e, n) {
  return an(e, { ...n, weekStartsOn: 1 });
}
function Xu(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = ut(t, 0);
  s.setFullYear(a + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const r = qa(s), l = ut(t, 0);
  l.setFullYear(a, 0, 4), l.setHours(0, 0, 0, 0);
  const i = qa(l);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function yr(e) {
  const n = Le(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Ps(e, ...n) {
  const t = ut.bind(
    null,
    n.find((a) => typeof a == "object")
  );
  return n.map(t);
}
function no(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Ju(e, n, t) {
  const [a, s] = Ps(
    t == null ? void 0 : t.in,
    e,
    n
  ), r = no(a), l = no(s), i = +r - yr(r), o = +l - yr(l);
  return Math.round((i - o) / Nm);
}
function Hm(e, n) {
  const t = Xu(e, n), a = ut(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), qa(a);
}
function Um(e, n, t) {
  return vn(e, n * 3, t);
}
function ci(e, n, t) {
  return vn(e, n * 12, t);
}
function ao(e, n) {
  const t = +Le(e) - +Le(n);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function Qu(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function bs(e) {
  return !(!Qu(e) && typeof e != "number" || isNaN(+Le(e)));
}
function so(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function qm(e, n, t) {
  const [a, s] = Ps(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return a.getFullYear() - s.getFullYear();
}
function jm(e) {
  return (n) => {
    const a = (e ? Math[e] : Math.trunc)(n);
    return a === 0 ? 0 : a;
  };
}
function Gm(e, n, t) {
  const [a, s] = Ps(
    t == null ? void 0 : t.in,
    e,
    n
  ), r = ao(a, s), l = Math.abs(qm(a, s));
  a.setFullYear(1584), s.setFullYear(1584);
  const i = ao(a, s) === -r, o = r * (l - +i);
  return o === 0 ? 0 : o;
}
function ec(e, n) {
  const [t, a] = Ps(e, n.start, n.end);
  return { start: t, end: a };
}
function di(e, n) {
  const { start: t, end: a } = ec(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const r = s ? +t : +a, l = s ? a : t;
  l.setHours(0, 0, 0, 0);
  let i = 1;
  const o = [];
  for (; +l <= r; )
    o.push(ut(t, l)), l.setDate(l.getDate() + i), l.setHours(0, 0, 0, 0);
  return s ? o.reverse() : o;
}
function da(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function Km(e, n) {
  const { start: t, end: a } = ec(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const r = s ? +da(t) : +da(a);
  let l = da(s ? a : t), i = 1;
  const o = [];
  for (; +l <= r; )
    o.push(ut(t, l)), l = Um(l, i);
  return s ? o.reverse() : o;
}
function Zm(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function tc(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Na(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function fi(e, n) {
  var i, o, u, c;
  const t = wa(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Le(e, n == null ? void 0 : n.in), r = s.getDay(), l = (r < a ? -7 : 0) + 6 - (r - a);
  return s.setDate(s.getDate() + l), s.setHours(23, 59, 59, 999), s;
}
function ro(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
const Xm = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Jm = (e, n, t) => {
  let a;
  const s = Xm[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function nl(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Qm = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ev = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, tv = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nv = {
  date: nl({
    formats: Qm,
    defaultWidth: "full"
  }),
  time: nl({
    formats: ev,
    defaultWidth: "full"
  }),
  dateTime: nl({
    formats: tv,
    defaultWidth: "full"
  })
}, av = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, sv = (e, n, t, a) => av[e];
function os(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : l;
      s = e.formattingValues[i] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[l];
    }
    const r = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[r];
  };
}
const rv = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, lv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, iv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ov = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, uv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, cv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, dv = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, fv = {
  ordinalNumber: dv,
  era: os({
    values: rv,
    defaultWidth: "wide"
  }),
  quarter: os({
    values: lv,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: os({
    values: iv,
    defaultWidth: "wide"
  }),
  day: os({
    values: ov,
    defaultWidth: "wide"
  }),
  dayPeriod: os({
    values: uv,
    defaultWidth: "wide",
    formattingValues: cv,
    defaultFormattingWidth: "wide"
  })
};
function us(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], r = n.match(s);
    if (!r)
      return null;
    const l = r[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? mv(i, (f) => f.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      hv(i, (f) => f.test(l))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(l.length);
    return { value: u, rest: c };
  };
}
function hv(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function mv(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function vv(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], r = n.match(e.parsePattern);
    if (!r) return null;
    let l = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const i = n.slice(s.length);
    return { value: l, rest: i };
  };
}
const pv = /^(\d+)(th|st|nd|rd)?/i, gv = /\d+/i, yv = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, bv = {
  any: [/^b/i, /^(a|c)/i]
}, wv = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, kv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Sv = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Tv = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Mv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, $v = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Cv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Dv = {
  ordinalNumber: vv({
    matchPattern: pv,
    parsePattern: gv,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: us({
    matchPatterns: yv,
    defaultMatchWidth: "wide",
    parsePatterns: bv,
    defaultParseWidth: "any"
  }),
  quarter: us({
    matchPatterns: wv,
    defaultMatchWidth: "wide",
    parsePatterns: kv,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: us({
    matchPatterns: xv,
    defaultMatchWidth: "wide",
    parsePatterns: Sv,
    defaultParseWidth: "any"
  }),
  day: us({
    matchPatterns: Tv,
    defaultMatchWidth: "wide",
    parsePatterns: Mv,
    defaultParseWidth: "any"
  }),
  dayPeriod: us({
    matchPatterns: $v,
    defaultMatchWidth: "any",
    parsePatterns: Cv,
    defaultParseWidth: "any"
  })
}, nc = {
  code: "en-US",
  formatDistance: Jm,
  formatLong: nv,
  formatRelative: sv,
  localize: fv,
  match: Dv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ov(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return Ju(t, Na(t)) + 1;
}
function hi(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = +qa(t) - +Hm(t);
  return Math.round(a / Ku) + 1;
}
function mi(e, n) {
  var c, f, h, d;
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = wa(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((d = (h = s.locale) == null ? void 0 : h.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, l = ut((n == null ? void 0 : n.in) || e, 0);
  l.setFullYear(a + 1, 0, r), l.setHours(0, 0, 0, 0);
  const i = an(l, n), o = ut((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0);
  const u = an(o, n);
  return +t >= +i ? a + 1 : +t >= +u ? a : a - 1;
}
function _v(e, n) {
  var i, o, u, c;
  const t = wa(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = mi(e, n), r = ut((n == null ? void 0 : n.in) || e, 0);
  return r.setFullYear(s, 0, a), r.setHours(0, 0, 0, 0), an(r, n);
}
function vi(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = +an(t, n) - +_v(t, n);
  return Math.round(a / Ku) + 1;
}
function ot(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const Un = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return ot(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : ot(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return ot(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return ot(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return ot(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return ot(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return ot(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), s = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return ot(s, n.length);
  }
}, Ta = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, lo = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), s = a > 0 ? a : 1 - a;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return Un.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const s = mi(e, a), r = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const l = r % 100;
      return ot(l, 2);
    }
    return n === "Yo" ? t.ordinalNumber(r, { unit: "year" }) : ot(r, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Xu(e);
    return ot(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return ot(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return ot(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return ot(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Un.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return ot(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const s = vi(e, a);
    return n === "wo" ? t.ordinalNumber(s, { unit: "week" }) : ot(s, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = hi(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : ot(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Un.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = Ov(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : ot(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const s = e.getDay(), r = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(r);
      // Padded numerical value
      case "ee":
        return ot(r, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(r, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const s = e.getDay(), r = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(r);
      // Padded numerical value
      case "cc":
        return ot(r, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), s = a === 0 ? 7 : a;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return ot(s, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a === 12 ? s = Ta.noon : a === 0 ? s = Ta.midnight : s = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a >= 17 ? s = Ta.evening : a >= 12 ? s = Ta.afternoon : a >= 4 ? s = Ta.morning : s = Ta.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return Un.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Un.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : ot(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : ot(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Un.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Un.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Un.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return oo(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ua(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ua(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return oo(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ua(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ua(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + io(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ua(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + io(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ua(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(+e / 1e3);
    return ot(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return ot(+e, n.length);
  }
};
function io(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.trunc(a / 60), r = a % 60;
  return r === 0 ? t + String(s) : t + String(s) + n + ot(r, 2);
}
function oo(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ot(Math.abs(e) / 60, 2) : ua(e, n);
}
function ua(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = ot(Math.trunc(a / 60), 2), r = ot(a % 60, 2);
  return t + s + n + r;
}
const uo = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, ac = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, Ev = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], s = t[2];
  if (!s)
    return uo(e, n);
  let r;
  switch (a) {
    case "P":
      r = n.dateTime({ width: "short" });
      break;
    case "PP":
      r = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = n.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", uo(a, n)).replace("{{time}}", ac(s, n));
}, Pl = {
  p: ac,
  P: Ev
}, Iv = /^D+$/, Pv = /^Y+$/, Av = ["D", "DD", "YY", "YYYY"];
function sc(e) {
  return Iv.test(e);
}
function rc(e) {
  return Pv.test(e);
}
function Al(e, n, t) {
  const a = Rv(e, n, t);
  if (console.warn(a), Av.includes(e)) throw new RangeError(a);
}
function Rv(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Vv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Fv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Lv = /^'([^]*?)'?$/, Nv = /''/g, Bv = /[a-zA-Z]/;
function Qt(e, n, t) {
  var c, f, h, d, g, y, k, m;
  const a = wa(), s = (t == null ? void 0 : t.locale) ?? a.locale ?? nc, r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((d = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, l = (t == null ? void 0 : t.weekStartsOn) ?? ((y = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? a.weekStartsOn ?? ((m = (k = a.locale) == null ? void 0 : k.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = Le(e, t == null ? void 0 : t.in);
  if (!bs(i))
    throw new RangeError("Invalid time value");
  let o = n.match(Fv).map((v) => {
    const w = v[0];
    if (w === "p" || w === "P") {
      const S = Pl[w];
      return S(v, s.formatLong);
    }
    return v;
  }).join("").match(Vv).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const w = v[0];
    if (w === "'")
      return { isToken: !1, value: zv(v) };
    if (lo[w])
      return { isToken: !0, value: v };
    if (w.match(Bv))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: v };
  });
  s.localize.preprocessor && (o = s.localize.preprocessor(i, o));
  const u = {
    firstWeekContainsDate: r,
    weekStartsOn: l,
    locale: s
  };
  return o.map((v) => {
    if (!v.isToken) return v.value;
    const w = v.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && rc(w) || !(t != null && t.useAdditionalDayOfYearTokens) && sc(w)) && Al(w, n, String(e));
    const S = lo[w[0]];
    return S(i, w, s.localize, u);
  }).join("");
}
function zv(e) {
  const n = e.match(Lv);
  return n ? n[1].replace(Nv, "'") : e;
}
function Wv(e, n) {
  return Le(e, n == null ? void 0 : n.in).getDay();
}
function Yv(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = t.getMonth(), r = ut(t, 0);
  return r.setFullYear(a, s + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function Hv() {
  return Object.assign({}, wa());
}
function In(e, n) {
  return Le(e, n == null ? void 0 : n.in).getHours();
}
function Uv(e, n) {
  const t = Le(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Nn(e, n) {
  return Le(e, n == null ? void 0 : n.in).getMinutes();
}
function Ze(e, n) {
  return Le(e, n == null ? void 0 : n.in).getMonth();
}
function na(e) {
  return Le(e).getSeconds();
}
function Be(e, n) {
  return Le(e, n == null ? void 0 : n.in).getFullYear();
}
function Cn(e, n) {
  return +Le(e) > +Le(n);
}
function Ln(e, n) {
  return +Le(e) < +Le(n);
}
function Ia(e, n) {
  return +Le(e) == +Le(n);
}
function qv(e, n) {
  const t = jv(n) ? new n(0) : ut(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function jv(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const Gv = 10;
class lc {
  constructor() {
    we(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class Kv extends lc {
  constructor(n, t, a, s, r) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = s, r && (this.subPriority = r);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class Zv extends lc {
  constructor(t, a) {
    super();
    we(this, "priority", Gv);
    we(this, "subPriority", -1);
    this.context = t || ((s) => ut(a, s));
  }
  set(t, a) {
    return a.timestampIsSet ? t : ut(t, qv(t, this.context));
  }
}
class at {
  run(n, t, a, s) {
    const r = this.parse(n, t, a, s);
    return r ? {
      setter: new Kv(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class Xv extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 140);
    we(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, a, s) {
    return a.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const kt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Mn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function xt(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function mt(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function $n(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, r = t[3] ? parseInt(t[3], 10) : 0, l = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (s * zm + r * Bm + l * Wm),
    rest: n.slice(t[0].length)
  };
}
function ic(e) {
  return mt(kt.anyDigitsSigned, e);
}
function yt(e, n) {
  switch (e) {
    case 1:
      return mt(kt.singleDigit, n);
    case 2:
      return mt(kt.twoDigits, n);
    case 3:
      return mt(kt.threeDigits, n);
    case 4:
      return mt(kt.fourDigits, n);
    default:
      return mt(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function br(e, n) {
  switch (e) {
    case 1:
      return mt(kt.singleDigitSigned, n);
    case 2:
      return mt(kt.twoDigitsSigned, n);
    case 3:
      return mt(kt.threeDigitsSigned, n);
    case 4:
      return mt(kt.fourDigitsSigned, n);
    default:
      return mt(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function pi(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function oc(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let s;
  if (a <= 50)
    s = e || 100;
  else {
    const r = a + 50, l = Math.trunc(r / 100) * 100, i = e >= r % 100;
    s = e + l - (i ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function uc(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Jv extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    const r = (l) => ({
      year: l,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return xt(yt(4, t), r);
      case "yo":
        return xt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          r
        );
      default:
        return xt(yt(a.length, t), r);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s) {
    const r = t.getFullYear();
    if (s.isTwoDigitYear) {
      const i = oc(
        s.year,
        r
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const l = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Qv extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const r = (l) => ({
      year: l,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return xt(yt(4, t), r);
      case "Yo":
        return xt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          r
        );
      default:
        return xt(yt(a.length, t), r);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s, r) {
    const l = mi(t, r);
    if (s.isTwoDigitYear) {
      const o = oc(
        s.year,
        l
      );
      return t.setFullYear(
        o,
        0,
        r.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), an(t, r);
    }
    const i = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(i, 0, r.firstWeekContainsDate), t.setHours(0, 0, 0, 0), an(t, r);
  }
}
class ep extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return br(a === "R" ? 4 : a.length, t);
  }
  set(t, a, s) {
    const r = ut(t, 0);
    return r.setFullYear(s, 0, 4), r.setHours(0, 0, 0, 0), qa(r);
  }
}
class tp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return br(a === "u" ? 4 : a.length, t);
  }
  set(t, a, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class np extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 120);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return yt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ap extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 120);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return yt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class sp extends at {
  constructor() {
    super(...arguments);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    we(this, "priority", 110);
  }
  parse(t, a, s) {
    const r = (l) => l - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return xt(
          mt(kt.month, t),
          r
        );
      // 01, 02, ..., 12
      case "MM":
        return xt(yt(2, t), r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return xt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class rp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 110);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const r = (l) => l - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return xt(
          mt(kt.month, t),
          r
        );
      // 01, 02, ..., 12
      case "LL":
        return xt(yt(2, t), r);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return xt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function lp(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = vi(a, t) - n;
  return a.setDate(a.getDate() - s * 7), Le(a, t == null ? void 0 : t.in);
}
class ip extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 100);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "w":
        return mt(kt.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s, r) {
    return an(lp(t, s, r), r);
  }
}
function op(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = hi(a, t) - n;
  return a.setDate(a.getDate() - s * 7), a;
}
class up extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 100);
    we(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "I":
        return mt(kt.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s) {
    return qa(op(t, s));
  }
}
const cp = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], dp = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class fp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "subPriority", 1);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "d":
        return mt(kt.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear(), r = uc(s), l = t.getMonth();
    return r ? a >= 1 && a <= dp[l] : a >= 1 && a <= cp[l];
  }
  set(t, a, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class hp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "subpriority", 1);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "D":
      case "DD":
        return mt(kt.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear();
    return uc(s) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function gi(e, n, t) {
  var f, h, d, g;
  const a = wa(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((h = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : h.weekStartsOn) ?? a.weekStartsOn ?? ((g = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : g.weekStartsOn) ?? 0, r = Le(e, t == null ? void 0 : t.in), l = r.getDay(), o = (n % 7 + 7) % 7, u = 7 - s, c = n < 0 || n > 6 ? n - (l + u) % 7 : (o + u) % 7 - (l + u) % 7;
  return en(r, c, t);
}
class mp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, r) {
    return t = gi(t, s, r), t.setHours(0, 0, 0, 0), t;
  }
}
class vp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, r) {
    const l = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + r.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return xt(yt(a.length, t), l);
      // 3rd
      case "eo":
        return xt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, r) {
    return t = gi(t, s, r), t.setHours(0, 0, 0, 0), t;
  }
}
class pp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, r) {
    const l = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + r.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return xt(yt(a.length, t), l);
      // 3rd
      case "co":
        return xt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, r) {
    return t = gi(t, s, r), t.setHours(0, 0, 0, 0), t;
  }
}
function gp(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = Uv(a, t), r = n - s;
  return en(a, r, t);
}
class yp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const r = (l) => l === 0 ? 7 : l;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return yt(a.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return xt(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // T
      case "iiiii":
        return xt(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tu
      case "iiiiii":
        return xt(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tuesday
      case "iiii":
      default:
        return xt(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, s) {
    return t = gp(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class bp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 80);
    we(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(pi(s), 0, 0, 0), t;
  }
}
class wp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 80);
    we(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(pi(s), 0, 0, 0), t;
  }
}
class kp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 80);
    we(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(pi(s), 0, 0, 0), t;
  }
}
class xp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "h":
        return mt(kt.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, s) {
    const r = t.getHours() >= 12;
    return r && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !r && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Sp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "H":
        return mt(kt.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class Tp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "K":
        return mt(kt.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Mp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "k":
        return mt(kt.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, s) {
    const r = s <= 24 ? s % 24 : s;
    return t.setHours(r, 0, 0, 0), t;
  }
}
class $p extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 60);
    we(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "m":
        return mt(kt.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class Cp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 50);
    we(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "s":
        return mt(kt.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setSeconds(s, 0), t;
  }
}
class Dp extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 30);
    we(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const s = (r) => Math.trunc(r * Math.pow(10, -a.length + 3));
    return xt(yt(a.length, t), s);
  }
  set(t, a, s) {
    return t.setMilliseconds(s), t;
  }
}
class Op extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 10);
    we(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return $n(
          Mn.basicOptionalMinutes,
          t
        );
      case "XX":
        return $n(Mn.basic, t);
      case "XXXX":
        return $n(
          Mn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return $n(
          Mn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return $n(Mn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ut(
      t,
      t.getTime() - yr(t) - s
    );
  }
}
class _p extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 10);
    we(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return $n(
          Mn.basicOptionalMinutes,
          t
        );
      case "xx":
        return $n(Mn.basic, t);
      case "xxxx":
        return $n(
          Mn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return $n(
          Mn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return $n(Mn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ut(
      t,
      t.getTime() - yr(t) - s
    );
  }
}
class Ep extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 40);
    we(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return ic(t);
  }
  set(t, a, s) {
    return [ut(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class Ip extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 20);
    we(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return ic(t);
  }
  set(t, a, s) {
    return [ut(t, s), { timestampIsSet: !0 }];
  }
}
const Pp = {
  G: new Xv(),
  y: new Jv(),
  Y: new Qv(),
  R: new ep(),
  u: new tp(),
  Q: new np(),
  q: new ap(),
  M: new sp(),
  L: new rp(),
  w: new ip(),
  I: new up(),
  d: new fp(),
  D: new hp(),
  E: new mp(),
  e: new vp(),
  c: new pp(),
  i: new yp(),
  a: new bp(),
  b: new wp(),
  B: new kp(),
  h: new xp(),
  H: new Sp(),
  K: new Tp(),
  k: new Mp(),
  m: new $p(),
  s: new Cp(),
  S: new Dp(),
  X: new Op(),
  x: new _p(),
  t: new Ep(),
  T: new Ip()
}, Ap = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Rp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vp = /^'([^]*?)'?$/, Fp = /''/g, Lp = /\S/, Np = /[a-zA-Z]/;
function Rl(e, n, t, a) {
  var k, m, v, w, S, x, $, T;
  const s = () => ut((a == null ? void 0 : a.in) || t, NaN), r = Hv(), l = (a == null ? void 0 : a.locale) ?? r.locale ?? nc, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((m = (k = a == null ? void 0 : a.locale) == null ? void 0 : k.options) == null ? void 0 : m.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((w = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((x = (S = a == null ? void 0 : a.locale) == null ? void 0 : S.options) == null ? void 0 : x.weekStartsOn) ?? r.weekStartsOn ?? ((T = ($ = r.locale) == null ? void 0 : $.options) == null ? void 0 : T.weekStartsOn) ?? 0;
  if (!n)
    return e ? s() : Le(t, a == null ? void 0 : a.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: l
  }, c = [new Zv(a == null ? void 0 : a.in, t)], f = n.match(Rp).map((_) => {
    const A = _[0];
    if (A in Pl) {
      const D = Pl[A];
      return D(_, l.formatLong);
    }
    return _;
  }).join("").match(Ap), h = [];
  for (let _ of f) {
    !(a != null && a.useAdditionalWeekYearTokens) && rc(_) && Al(_, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && sc(_) && Al(_, n, e);
    const A = _[0], D = Pp[A];
    if (D) {
      const { incompatibleTokens: Y } = D;
      if (Array.isArray(Y)) {
        const X = h.find(
          (se) => Y.includes(se.token) || se.token === A
        );
        if (X)
          throw new RangeError(
            `The format string mustn't contain \`${X.fullToken}\` and \`${_}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${_}\` and any other token at the same time`
        );
      h.push({ token: A, fullToken: _ });
      const L = D.run(
        e,
        _,
        l.match,
        u
      );
      if (!L)
        return s();
      c.push(L.setter), e = L.rest;
    } else {
      if (A.match(Np))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + A + "`"
        );
      if (_ === "''" ? _ = "'" : A === "'" && (_ = Bp(_)), e.indexOf(_) === 0)
        e = e.slice(_.length);
      else
        return s();
    }
  }
  if (e.length > 0 && Lp.test(e))
    return s();
  const d = c.map((_) => _.priority).sort((_, A) => A - _).filter((_, A, D) => D.indexOf(_) === A).map(
    (_) => c.filter((A) => A.priority === _).sort((A, D) => D.subPriority - A.subPriority)
  ).map((_) => _[0]);
  let g = Le(t, a == null ? void 0 : a.in);
  if (isNaN(+g)) return s();
  const y = {};
  for (const _ of d) {
    if (!_.validate(g, u))
      return s();
    const A = _.set(g, y, u);
    Array.isArray(A) ? (g = A[0], Object.assign(y, A[1])) : g = A;
  }
  return g;
}
function Bp(e) {
  return e.match(Vp)[1].replace(Fp, "'");
}
function co(e, n, t) {
  const [a, s] = Ps(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +da(a) == +da(s);
}
function cc(e, n, t) {
  return en(e, -n, t);
}
function zp(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 30) return ut(e, NaN);
  const a = Le(e, n == null ? void 0 : n.in), s = a.getSeconds() / 60, r = a.getMilliseconds() / 1e3 / 60, l = a.getMinutes() + s + r, i = (n == null ? void 0 : n.roundingMethod) ?? "round", u = jm(i)(l / t) * t;
  return a.setMinutes(u, 0, 0), a;
}
function dc(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = a.getFullYear(), r = a.getDate(), l = ut(e, 0);
  l.setFullYear(s, n, 15), l.setHours(0, 0, 0, 0);
  const i = Yv(l);
  return a.setMonth(n, Math.min(r, i)), a;
}
function qe(e, n, t) {
  let a = Le(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ut(e, NaN) : (n.year != null && a.setFullYear(n.year), n.month != null && (a = dc(a, n.month)), n.date != null && a.setDate(n.date), n.hours != null && a.setHours(n.hours), n.minutes != null && a.setMinutes(n.minutes), n.seconds != null && a.setSeconds(n.seconds), n.milliseconds != null && a.setMilliseconds(n.milliseconds), a);
}
function Wp(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return a.setMilliseconds(n), a;
}
function Yp(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return a.setSeconds(n), a;
}
function hn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ut(e, NaN) : (a.setFullYear(n), a);
}
function ja(e, n, t) {
  return vn(e, -n, t);
}
function Hp(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: r = 0,
    days: l = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = ja(e, s + a * 12, t), f = cc(c, l + r * 7, t), h = o + i * 60, g = (u + h * 60) * 1e3;
  return ut(e, +f - g);
}
function fc(e, n, t) {
  return ci(e, -n, t);
}
function Up(e, n, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: t
  }).format(n).split(/\s/g).slice(2).join(" ");
}
const al = {}, vs = {};
function fa(e, n) {
  try {
    const a = (al[e] || (al[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(n).split("GMT")[1];
    return a in vs ? vs[a] : fo(a, a.split(":"));
  } catch {
    if (e in vs) return vs[e];
    const t = e == null ? void 0 : e.match(qp);
    return t ? fo(e, t.slice(1)) : NaN;
  }
}
const qp = /([+-]\d\d):?(\d\d)?/;
function fo(e, n) {
  const t = +(n[0] || 0), a = +(n[1] || 0), s = +(n[2] || 0) / 60;
  return vs[e] = t * 60 + a > 0 ? t * 60 + a + s : t * 60 - a - s;
}
class Dn extends Date {
  //#region static
  constructor(...n) {
    super(), n.length > 1 && typeof n[n.length - 1] == "string" && (this.timeZone = n.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(fa(this.timeZone, this)) ? this.setTime(NaN) : n.length ? typeof n[0] == "number" && (n.length === 1 || n.length === 2 && typeof n[1] != "number") ? this.setTime(n[0]) : typeof n[0] == "string" ? this.setTime(+new Date(n[0])) : n[0] instanceof Date ? this.setTime(+n[0]) : (this.setTime(+new Date(...n)), hc(this), Vl(this)) : this.setTime(Date.now());
  }
  static tz(n, ...t) {
    return t.length ? new Dn(...t, n) : new Dn(Date.now(), n);
  }
  //#endregion
  //#region time zone
  withTimeZone(n) {
    return new Dn(+this, n);
  }
  getTimezoneOffset() {
    const n = -fa(this.timeZone, this);
    return n > 0 ? Math.floor(n) : Math.ceil(n);
  }
  //#endregion
  //#region time
  setTime(n) {
    return Date.prototype.setTime.apply(this, arguments), Vl(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Dn(+new Date(n), this.timeZone);
  }
  //#endregion
}
const ho = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!ho.test(e)) return;
  const n = e.replace(ho, "$1UTC");
  Dn.prototype[n] && (e.startsWith("get") ? Dn.prototype[e] = function() {
    return this.internal[n]();
  } : (Dn.prototype[e] = function() {
    return Date.prototype[n].apply(this.internal, arguments), jp(this), +this;
  }, Dn.prototype[n] = function() {
    return Date.prototype[n].apply(this, arguments), Vl(this), +this;
  }));
});
function Vl(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-fa(e.timeZone, e) * 60));
}
function jp(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), hc(e);
}
function hc(e) {
  const n = fa(e.timeZone, e), t = n > 0 ? Math.floor(n) : Math.ceil(n), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), r = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), l = s - r, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  l && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + l);
  const o = s - t;
  o && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + o);
  const u = /* @__PURE__ */ new Date(+e);
  u.setUTCSeconds(0);
  const c = s > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, f = Math.round(-(fa(e.timeZone, e) * 60)) % 60;
  (f || c) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + f), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + f + c));
  const h = fa(e.timeZone, e), d = h > 0 ? Math.floor(h) : Math.ceil(h), y = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - d, k = d !== t, m = y - o;
  if (k && m) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + m);
    const v = fa(e.timeZone, e), w = v > 0 ? Math.floor(v) : Math.ceil(v), S = d - w;
    S && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + S), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + S));
  }
}
class Pa extends Dn {
  //#region static
  static tz(n, ...t) {
    return t.length ? new Pa(...t, n) : new Pa(Date.now(), n);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [n, t, a] = this.tzComponents(), s = `${n}${t}:${a}`;
    return this.internal.toISOString().slice(0, -1) + s;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [n, t, a, s] = this.internal.toUTCString().split(" ");
    return `${n == null ? void 0 : n.slice(0, -1)} ${a} ${t} ${s}`;
  }
  toTimeString() {
    const n = this.internal.toUTCString().split(" ")[4], [t, a, s] = this.tzComponents();
    return `${n} GMT${t}${a}${s} (${Up(this.timeZone, this)})`;
  }
  toLocaleString(n, t) {
    return Date.prototype.toLocaleString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(n, t) {
    return Date.prototype.toLocaleDateString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(n, t) {
    return Date.prototype.toLocaleTimeString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const n = this.getTimezoneOffset(), t = n > 0 ? "-" : "+", a = String(Math.floor(Math.abs(n) / 60)).padStart(2, "0"), s = String(Math.abs(n) % 60).padStart(2, "0");
    return [t, a, s];
  }
  //#endregion
  withTimeZone(n) {
    return new Pa(+this, n);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Pa(+new Date(n), this.timeZone);
  }
  //#endregion
}
function As() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      wt("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      wt("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      wt("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function Gp() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      wt("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function mc() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function vc() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function pc() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      wt("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function gc() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function yc() {
  return wt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      wt("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const bc = Symbol("ContextKey"), Kp = (e, n) => {
  const { setTimeModelValue: t } = Dt(), a = Wg(e), s = te(null), r = pa({
    menuFocused: !1,
    shiftKeyInMenu: !1,
    isInputFocused: !1,
    isTextInputDate: !1,
    arrowNavigationLevel: 0
  }), l = a.getDate(/* @__PURE__ */ new Date()), i = te(""), o = te([{ month: Ze(l), year: Be(l) }]), u = pa({ hours: 0, minutes: 0, seconds: 0 });
  t(u, null, l, a.range.value.enabled);
  const c = C({
    get: () => s.value,
    set: (y) => {
      s.value = y;
    }
  }), f = C(
    () => (y) => o.value[y] ? o.value[y].month : 0
  ), h = C(
    () => (y) => o.value[y] ? o.value[y].year : 0
  ), d = (y, k) => {
    r[y] = k;
  }, g = () => {
    t(u, c.value, l, a.range.value.enabled);
  };
  Va(bc, {
    rootProps: e,
    defaults: a,
    modelValue: c,
    state: Xl(r),
    rootEmit: n,
    calendars: o,
    month: f,
    year: h,
    time: u,
    today: l,
    inputValue: i,
    setState: d,
    updateTime: g,
    getDate: a.getDate
  });
}, Ke = () => {
  const e = Qn(bc);
  if (!e)
    throw new Error("Can't use context");
  return e;
};
var dn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(dn || {}), va = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(va || {}), Vt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Vt || {});
const Zp = ["timestamp", "date", "iso"];
var fn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(fn || {}), dt = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(dt || {}), Aa = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(Aa || {}), wc = /* @__PURE__ */ ((e) => (e[e.Sunday = 0] = "Sunday", e[e.Monday = 1] = "Monday", e[e.Tuesday = 2] = "Tuesday", e[e.Wednesday = 3] = "Wednesday", e[e.Thursday = 4] = "Thursday", e[e.Friday = 5] = "Friday", e[e.Saturday = 6] = "Saturday", e))(wc || {});
const Xp = () => {
  const { rootProps: e, state: n } = Ke(), t = C(() => n.arrowNavigationLevel), a = te(-1), s = te(-1);
  He(t, (v, w) => {
    m(v === 0 && w > 0);
  });
  const r = te([]), l = te(/* @__PURE__ */ new Map()), i = () => {
    const v = Array.from(
      document.querySelectorAll(`[data-dp-action-element="${t.value}"]`)
    ), w = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map();
    for (const x of v) {
      const $ = x.getBoundingClientRect(), T = $.top, _ = $.left;
      w.has(T) || w.set(T, []), w.get(T).push(x), S.set(x, { row: T, col: _ });
    }
    r.value = Array.from(w.entries()).sort((x, $) => x[0] - $[0]).map(([x, $]) => o($, S)), l.value = S;
  }, o = (v, w) => v.sort((S, x) => {
    const $ = w.get(S), T = w.get(x);
    return $.col - T.col;
  }), u = (v, w) => {
    t.value === 0 && (a.value = v, s.value = w);
  }, c = (v) => {
    if (![dt.arrowUp, dt.arrowDown, dt.arrowLeft, dt.arrowRight].includes(v.key))
      return;
    i(), v.preventDefault();
    const w = document.activeElement;
    if (!(w != null && w.hasAttribute("data-dp-action-element")))
      return;
    let S = -1, x = -1;
    for (let $ = 0; $ < r.value.length; $++) {
      const T = r.value[$].indexOf(w);
      if (T !== -1) {
        S = $, x = T;
        break;
      }
    }
    if (S !== -1)
      switch (v.key) {
        case dt.arrowLeft:
          return f(S, x);
        case dt.arrowRight:
          return h(S, x);
        case dt.arrowUp:
          return d(S, x);
        case dt.arrowDown:
          return g(S, x);
        default:
          return;
      }
  }, f = (v, w) => {
    if (w > 0) {
      const S = r.value[v][w - 1];
      u(v, w - 1), S && S.focus();
    }
  }, h = (v, w) => {
    if (w < r.value[v].length - 1) {
      const S = r.value[v][w + 1];
      u(v, w + 1), S && S.focus();
    }
  }, d = (v, w) => {
    if (v > 0) {
      const S = r.value[v - 1], x = Math.min(w, S.length - 1), $ = S[x];
      u(v - 1, x), $ && $.focus();
    }
  }, g = (v, w) => {
    if (v < r.value.length - 1) {
      const S = r.value[v + 1], x = Math.min(w, S.length - 1), $ = S[x];
      u(v + 1, x), $ && $.focus();
    }
  }, y = () => {
    Xe().then(() => {
      var w;
      i();
      const v = (w = r.value[a.value]) == null ? void 0 : w[s.value];
      v && k(v);
    });
  }, k = (v) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        v.focus({ preventScroll: !0 });
      });
    });
  }, m = (v) => {
    if (v)
      return y();
    const w = document.querySelector(`[data-dp-element-active="${t.value}"]`);
    if (w && !v)
      k(w);
    else {
      const S = document.querySelector(`[data-dp-action-element="${t.value}"]`);
      S && k(S);
    }
  };
  nt(() => {
    e.arrowNavigation && (m(!1), document.addEventListener("keydown", c));
  }), sn(() => {
    e.arrowNavigation && document.removeEventListener("keydown", c);
  });
}, Jp = () => {
  const { checkPartialRangeValue: e, checkRangeEnabled: n, isValidDate: t } = rn(), { convertType: a, errorMapper: s } = Dt(), {
    getDate: r,
    rootEmit: l,
    state: i,
    rootProps: o,
    inputValue: u,
    defaults: { textInput: c, range: f, multiDates: h, timeConfig: d, formats: g },
    modelValue: y,
    updateTime: k
  } = Ke(), { setTime: m, getWeekFromDate: v } = Rt(), { formatSelectedDate: w, formatForTextInput: S } = aa();
  He(
    y,
    (V, j) => {
      l("internal-model-change", y.value), JSON.stringify(j ?? {}) !== JSON.stringify(V ?? {}) && k();
    },
    { deep: !0 }
  ), He(f, (V, j) => {
    V.enabled !== j.enabled && (y.value = null);
  }), He(
    () => g.value.input,
    () => {
      me();
    }
  );
  const x = (V) => V ? o.modelType ? pe(V) : {
    hours: In(V),
    minutes: Nn(V),
    seconds: d.value.enableSeconds ? na(V) : 0
  } : null, $ = (V) => o.modelType ? pe(V) : { month: Ze(V), year: Be(V) }, T = (V) => Array.isArray(V) ? h.value.enabled ? V.map((j) => _(j, hn(r(), j))) : n(
    () => [
      hn(r(), V[0]),
      V[1] ? hn(r(), V[1]) : e(f.value.partialRange)
    ],
    f.value.enabled
  ) : hn(r(), +V), _ = (V, j) => (typeof V == "string" || typeof V == "number") && o.modelType ? be(V) : j, A = (V) => Array.isArray(V) ? [
    _(V[0], m(V[0])),
    _(V[1], m(V[1]))
  ] : _(V, m(V)), D = (V) => {
    const j = qe(r(), { date: 1 });
    return Array.isArray(V) ? h.value.enabled ? V.map(
      (H) => _(H, qe(j, { month: +H.month, year: +H.year }))
    ) : n(
      () => [
        _(V[0], qe(j, { month: +V[0].month, year: +V[0].year })),
        _(
          V[1],
          V[1] ? qe(j, { month: +V[1].month, year: +V[1].year }) : e(f.value.partialRange)
        )
      ],
      f.value.enabled
    ) : _(V, qe(j, { month: +V.month, year: +V.year }));
  }, Y = (V) => {
    if (Array.isArray(V))
      return V.map((j) => be(j));
    throw new Error(s.dateArr("multi-dates"));
  }, L = (V) => {
    if (Array.isArray(V) && f.value.enabled) {
      const j = V[0], H = V[1];
      return [
        r(Array.isArray(j) ? j[0] : null),
        Array.isArray(H) && H.length ? r(H[0]) : null
      ];
    }
    return r(V[0]);
  }, X = (V) => o.modelAuto ? Array.isArray(V) ? [be(V[0]), be(V[1])] : o.autoApply ? [be(V)] : [be(V), null] : Array.isArray(V) ? n(
    () => V[1] ? [
      be(V[0]),
      V[1] ? be(V[1]) : e(f.value.partialRange)
    ] : [be(V[0])],
    f.value.enabled
  ) : be(V), se = () => {
    Array.isArray(y.value) && f.value.enabled && y.value.length === 1 && y.value.push(e(f.value.partialRange));
  }, ie = () => {
    const V = y.value;
    return [
      pe(V[0]),
      V[1] ? pe(V[1]) : e(f.value.partialRange)
    ];
  }, ue = () => Array.isArray(y.value) ? y.value[1] ? ie() : pe(a(y.value[0])) : [], G = () => (y.value || []).map((V) => pe(V)), q = (V = !1) => (V || se(), o.modelAuto ? ue() : h.value.enabled ? G() : Array.isArray(y.value) ? n(() => ie(), f.value.enabled) : pe(a(y.value))), Z = (V) => !V || Array.isArray(V) && !V.length ? null : o.timePicker ? A(a(V)) : o.monthPicker ? D(a(V)) : o.yearPicker ? T(a(V)) : h.value.enabled ? Y(a(V)) : o.weekPicker ? L(a(V)) : X(a(V)), N = (V) => {
    if (i.isTextInputDate) return;
    const j = Z(V);
    t(a(j)) ? (y.value = a(j), me()) : (y.value = null, u.value = "");
  }, ae = () => y.value ? h.value.enabled ? y.value.map((V) => w(V)).join("; ") : c.value.enabled ? S() : w(y.value) : "", me = () => {
    u.value = ae();
  }, be = (V) => o.modelType ? Zp.includes(o.modelType) ? r(V) : o.modelType === "format" && typeof g.value.input == "string" ? Rl(V, g.value.input, r(), { locale: o.locale }) : Rl(V, o.modelType, r(), { locale: o.locale }) : r(V), pe = (V) => V ? o.modelType ? o.modelType === "timestamp" ? +V : o.modelType === "iso" ? V.toISOString() : o.modelType === "format" && typeof g.value.input == "string" ? w(V) : w(V, o.modelType) : V : null, De = (V) => {
    l("update:model-value", V);
  }, ge = (V) => Array.isArray(y.value) ? h.value.enabled ? y.value.map((j) => V(j)) : [V(y.value[0]), y.value[1] ? V(y.value[1]) : null] : V(a(y.value)), K = () => {
    if (Array.isArray(y.value)) {
      const V = v(y.value[0], o.weekStart), j = y.value[1] ? v(y.value[1], o.weekStart) : [];
      return [V.map((H) => r(H)), j.map((H) => r(H))];
    }
    return v(y.value, o.weekStart).map((V) => r(V));
  }, ye = (V) => De(a(ge(V))), Me = () => l("update:model-value", K());
  return {
    checkBeforeEmit: () => y.value ? f.value.enabled ? f.value.partialRange ? y.value.length >= 1 : y.value.length === 2 : !!y.value : !1,
    parseExternalModelValue: N,
    formatInputValue: me,
    emitModelValue: () => (me(), o.monthPicker ? ye($) : o.timePicker ? ye(x) : o.yearPicker ? ye(Be) : o.weekPicker ? Me() : De(q()))
  };
}, Rs = () => {
  const {
    defaults: { transitions: e }
  } = Ke(), n = C(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), t = C(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: n, showTransition: !!e.value, menuTransition: t };
}, Vs = (e) => {
  const {
    today: n,
    time: t,
    modelValue: a,
    defaults: { range: s }
  } = Ke(), { setTimeModelValue: r } = Dt();
  He(
    s,
    (l, i) => {
      l.enabled !== i.enabled && r(t, a.value, n, s.value.enabled);
    },
    { deep: !0 }
  ), He(
    a,
    (l, i) => {
      e && JSON.stringify(l ?? {}) !== JSON.stringify(i ?? {}) && e();
    },
    { deep: !0 }
  );
}, rn = () => {
  const {
    defaults: { safeDates: e, range: n, multiDates: t, filters: a, timeConfig: s },
    rootProps: r,
    getDate: l
  } = Ke(), { getMapKeyType: i, getMapDate: o, errorMapper: u, convertType: c } = Dt(), { isDateBefore: f, isDateAfter: h, isDateEqual: d, resetDate: g, getDaysInBetween: y, setTimeValue: k, getTimeObj: m, setTime: v } = Rt(), w = (I) => e.value.disabledDates ? typeof e.value.disabledDates == "function" ? e.value.disabledDates(l(I)) : !!o(I, e.value.disabledDates) : !1, S = (I) => e.value.maxDate ? r.yearPicker ? Be(I) > Be(e.value.maxDate) : h(I, e.value.maxDate) : !1, x = (I) => e.value.minDate ? r.yearPicker ? Be(I) < Be(e.value.minDate) : f(I, e.value.minDate) : !1, $ = (I) => {
    var W;
    if (!I) return !1;
    const B = S(I), J = x(I), R = w(I), ee = a.value.months.map((he) => +he).includes(Ze(I)), O = (W = a.value.weekDays) != null && W.length ? a.value.weekDays.some((he) => +he === Wv(I)) : !1, z = Y(I), F = Be(I), le = F < +r.yearRange[0] || F > +r.yearRange[1];
    return !(B || J || R || ee || le || O || z);
  }, T = (I, B) => f(...Me(e.value.minDate, I, B)) || d(...Me(e.value.minDate, I, B)), _ = (I, B) => h(...Me(e.value.maxDate, I, B)) || d(...Me(e.value.maxDate, I, B)), A = (I, B, J) => {
    let R = !1;
    return e.value.maxDate && J && _(I, B) && (R = !0), e.value.minDate && !J && T(I, B) && (R = !0), R;
  }, D = (I, B, J, R) => {
    let ee = !1;
    return R && (e.value.minDate || e.value.maxDate) ? e.value.minDate && e.value.maxDate ? ee = A(I, B, J) : (e.value.minDate && T(I, B) || e.value.maxDate && _(I, B)) && (ee = !0) : ee = !0, ee;
  }, Y = (I) => Array.isArray(e.value.allowedDates) && !e.value.allowedDates.length ? !0 : e.value.allowedDates ? !o(
    I,
    e.value.allowedDates,
    i(r.monthPicker, r.yearPicker)
  ) : !1, L = (I) => !$(I), X = (I) => n.value.noDisabledRange ? !di({ start: I[0], end: I[1] }).some((B) => L(B)) : !0, se = (I) => {
    if (I) {
      const B = Be(I);
      return B >= +r.yearRange[0] && B <= r.yearRange[1];
    }
    return !0;
  }, ie = (I, B) => !!(Array.isArray(I) && I[B] && (n.value.maxRange || n.value.minRange) && se(I[B])), ue = (I, B, J = 0) => {
    if (ie(B, J) && se(I)) {
      const R = Ju(I, B[J]), ee = y(B[J], I), O = ee.length === 1 ? 0 : ee.filter((F) => L(F)).length, z = Math.abs(R) - (n.value.minMaxRawRange ? 0 : O);
      if (n.value.minRange && n.value.maxRange)
        return z >= +n.value.minRange && z <= +n.value.maxRange;
      if (n.value.minRange) return z >= +n.value.minRange;
      if (n.value.maxRange) return z <= +n.value.maxRange;
    }
    return !0;
  }, G = () => !s.value.enableTimePicker || r.monthPicker || r.yearPicker || s.value.ignoreTimeValidation, q = (I) => Array.isArray(I) ? [I[0] ? k(I[0]) : null, I[1] ? k(I[1]) : null] : k(I), Z = (I, B, J) => B ? I.find(
    (R) => +R.hours === In(B) && R.minutes === "*" ? !0 : +R.minutes === Nn(B) && +R.hours === In(B)
  ) && J : !1, N = (I, B, J) => {
    const [R, ee] = I, [O, z] = B;
    return !Z(R, O, J) && !Z(ee, z, J) && J;
  }, ae = (I, B) => {
    const J = Array.isArray(B) ? B : [B];
    return Array.isArray(r.disabledTimes) ? Array.isArray(r.disabledTimes[0]) ? N(r.disabledTimes, J, I) : !J.some((R) => Z(r.disabledTimes, R, I)) : I;
  }, me = (I, B) => {
    const J = Array.isArray(B) ? [m(B[0]), B[1] ? m(B[1]) : void 0] : m(B), R = !r.disabledTimes(J);
    return I && R;
  }, be = (I, B) => r.disabledTimes ? Array.isArray(r.disabledTimes) ? ae(B, I) : me(B, I) : B, pe = (I) => {
    let B = !0;
    if (!I || G()) return !0;
    const J = !e.value.minDate && !e.value.maxDate ? q(I) : I;
    return (r.maxTime || e.value.maxDate) && (B = j(
      r.maxTime,
      e.value.maxDate,
      "max",
      c(J),
      B
    )), (r.minTime || e.value.minDate) && (B = j(
      r.minTime,
      e.value.minDate,
      "min",
      c(J),
      B
    )), be(I, B);
  }, De = (I) => {
    if (!r.monthPicker) return !0;
    let B = !0;
    const J = l(g(I));
    if (e.value.minDate && e.value.maxDate) {
      const R = l(g(e.value.minDate)), ee = l(g(e.value.maxDate));
      return h(J, R) && f(J, ee) || d(J, R) || d(J, ee);
    }
    if (e.value.minDate) {
      const R = l(g(e.value.minDate));
      B = h(J, R) || d(J, R);
    }
    if (e.value.maxDate) {
      const R = l(g(e.value.maxDate));
      B = f(J, R) || d(J, R);
    }
    return B;
  }, ge = C(() => (I) => !s.value.enableTimePicker || s.value.ignoreTimeValidation ? !0 : pe(I)), K = C(() => (I) => r.monthPicker ? Array.isArray(I) && (n.value.enabled || t.value.enabled) ? !I.filter((B) => !De(B)).length : De(I) : !0), ye = (I, B, J) => {
    if (!B || J && !e.value.maxDate || !J && !e.value.minDate) return !1;
    const R = J ? vn(I, 1) : ja(I, 1), ee = [Ze(R), Be(R)];
    return J ? !_(...ee) : !T(...ee);
  }, Me = (I, B, J) => [qe(l(I), { date: 1 }), qe(l(), { month: B, year: J, date: 1 })], V = (I, B, J, R) => {
    if (!I) return !0;
    if (R) {
      const ee = J === "max" ? Ln(I, B) : Cn(I, B), O = { seconds: 0, milliseconds: 0 };
      return ee || Ia(qe(I, O), qe(B, O));
    }
    return J === "max" ? I.getTime() <= B.getTime() : I.getTime() >= B.getTime();
  }, j = (I, B, J, R, ee) => {
    if (Array.isArray(R)) {
      const z = H(I, R[0], B), F = H(I, R[1], B);
      return V(R[0], z, J, !!B) && V(R[1], F, J, !!B) && ee;
    }
    const O = H(I, R, B);
    return V(R, O, J, !!B) && ee;
  }, H = (I, B, J) => I ? v(I, B) : l(J ?? B);
  return {
    isDisabled: L,
    validateDate: $,
    validateMonthYearInRange: D,
    isDateRangeAllowed: X,
    checkMinMaxRange: ue,
    isValidTime: pe,
    validateMonthYear: ye,
    validateMinDate: T,
    validateMaxDate: _,
    isValidDate: (I) => Array.isArray(I) ? bs(I[0]) && (I[1] ? bs(I[1]) : !0) : I ? bs(I) : !1,
    checkPartialRangeValue: (I) => {
      if (I) return null;
      throw new Error(u.prop("partial-range"));
    },
    checkRangeEnabled: (I, B) => {
      if (B) return I();
      throw new Error(u.prop("range"));
    },
    checkMinMaxValue: (I, B, J) => {
      const R = J != null, ee = B != null;
      if (!R && !ee) return !1;
      const O = +J, z = +B;
      return R && ee ? +I > O || +I < z : R ? +I > O : ee ? +I < z : !1;
    },
    isTimeValid: ge,
    isMonthValid: K
  };
}, Qp = (e) => {
  const {
    rootEmit: n,
    rootProps: t,
    defaults: { timeConfig: a, flow: s }
  } = Ke(), r = te(0), l = pa({
    [va.timePicker]: !a.value.enableTimePicker || t.timePicker || t.monthPicker,
    [va.calendar]: !1,
    [va.header]: !1
  }), i = C(() => t.monthPicker || t.timePicker), o = (d) => {
    var g, y;
    if ((y = (g = s.value) == null ? void 0 : g.steps) != null && y.length) {
      if (!d && i.value) return h();
      l[d] = !0, Object.keys(l).filter((k) => !l[k]).length || h();
    }
  }, u = () => {
    var d, g, y, k;
    (g = (d = s.value) == null ? void 0 : d.steps) != null && g.length && r.value !== -1 && (r.value += 1, n("flow-step", r.value), h()), ((k = (y = s.value) == null ? void 0 : y.steps) == null ? void 0 : k.length) === r.value && Xe().then(() => c());
  }, c = () => {
    r.value = -1;
  }, f = (d, g, ...y) => {
    var k, m, v;
    ((k = s.value) == null ? void 0 : k.steps[r.value]) === d && e.value && ((v = (m = e.value)[g]) == null || v.call(m, ...y));
  }, h = (d = 0) => {
    var y;
    d && (r.value += d), f(Vt.month, "toggleMonthPicker", !0), f(Vt.year, "toggleYearPicker", !0), f(Vt.calendar, "toggleTimePicker", !1, !0), f(Vt.time, "toggleTimePicker", !0, !0);
    const g = (y = s.value) == null ? void 0 : y.steps[r.value];
    (g === Vt.hours || g === Vt.minutes || g === Vt.seconds) && f(g, "toggleTimePicker", !0, !0, g);
  };
  return { childMount: o, updateFlowStep: u, resetFlow: c, handleFlow: h, flowStep: r };
};
function sl(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
function cs(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : l;
      s = e.formattingValues[i] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[l];
    }
    const r = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[r];
  };
}
function ds(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], r = n.match(s);
    if (!r)
      return null;
    const l = r[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? tg(i, (f) => f.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      eg(i, (f) => f.test(l))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(l.length);
    return { value: u, rest: c };
  };
}
function eg(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function tg(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function ng(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], r = n.match(e.parsePattern);
    if (!r) return null;
    let l = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const i = n.slice(s.length);
    return { value: l, rest: i };
  };
}
const ag = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, sg = (e, n, t) => {
  let a;
  const s = ag[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
}, rg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, lg = (e, n, t, a) => rg[e], ig = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, og = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ug = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, cg = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, dg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, hg = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, mg = {
  ordinalNumber: hg,
  era: cs({
    values: ig,
    defaultWidth: "wide"
  }),
  quarter: cs({
    values: og,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: cs({
    values: ug,
    defaultWidth: "wide"
  }),
  day: cs({
    values: cg,
    defaultWidth: "wide"
  }),
  dayPeriod: cs({
    values: dg,
    defaultWidth: "wide",
    formattingValues: fg,
    defaultFormattingWidth: "wide"
  })
}, vg = /^(\d+)(th|st|nd|rd)?/i, pg = /\d+/i, gg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, yg = {
  any: [/^b/i, /^(a|c)/i]
}, bg = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, wg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xg = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Sg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Tg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Mg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $g = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Cg = {
  ordinalNumber: ng({
    matchPattern: vg,
    parsePattern: pg,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ds({
    matchPatterns: gg,
    defaultMatchWidth: "wide",
    parsePatterns: yg,
    defaultParseWidth: "any"
  }),
  quarter: ds({
    matchPatterns: bg,
    defaultMatchWidth: "wide",
    parsePatterns: wg,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ds({
    matchPatterns: kg,
    defaultMatchWidth: "wide",
    parsePatterns: xg,
    defaultParseWidth: "any"
  }),
  day: ds({
    matchPatterns: Sg,
    defaultMatchWidth: "wide",
    parsePatterns: Tg,
    defaultParseWidth: "any"
  }),
  dayPeriod: ds({
    matchPatterns: Mg,
    defaultMatchWidth: "any",
    parsePatterns: $g,
    defaultParseWidth: "any"
  })
}, Dg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Og = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, _g = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Eg = {
  date: sl({
    formats: Dg,
    defaultWidth: "full"
  }),
  time: sl({
    formats: Og,
    defaultWidth: "full"
  }),
  dateTime: sl({
    formats: _g,
    defaultWidth: "full"
  })
}, Ig = {
  code: "en-US",
  formatDistance: sg,
  formatLong: Eg,
  formatRelative: lg,
  localize: mg,
  match: Cg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, mo = {
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1,
  autoSwitchStartEnd: !0
}, Pg = {
  allowStopPropagation: !0,
  closeOnScroll: !1,
  modeHeight: 255,
  allowPreventDefault: !1,
  closeOnClearValue: !0,
  closeOnAutoApply: !0,
  noSwipe: !1,
  keepActionRow: !1,
  onClickOutside: void 0,
  tabOutClosesMenu: !0,
  arrowLeft: void 0,
  keepViewOnOffsetClick: !1,
  timeArrowHoldThreshold: 0,
  shadowDom: !1,
  mobileBreakpoint: 600,
  setDateOnMenuClose: !1,
  escClose: !0,
  spaceConfirm: !0,
  monthChangeOnArrows: !0,
  monthChangeOnScroll: !0
}, vo = {
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: "open",
  selectOnFocus: !1,
  rangeSeparator: " - ",
  escClose: !0,
  format: void 0,
  maskFormat: void 0,
  applyOnBlur: !1,
  separators: void 0
}, Ag = {
  dates: [],
  years: [],
  months: [],
  quarters: [],
  weeks: [],
  weekdays: [],
  options: { highlightDisabled: !1 }
}, Rg = {
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  selectBtnLabel: "Select",
  cancelBtnLabel: "Cancel",
  nowBtnLabel: "Now",
  nowBtnRound: void 0
}, Vg = {
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`
}, po = {
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down"
}, Fg = {
  weekDays: [],
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] }
}, Lg = {
  month: "LLL",
  year: "yyyy",
  weekDay: "EEEEEE",
  quarter: "MMMM",
  day: "d",
  input: void 0,
  preview: void 0
}, Ng = {
  enableTimePicker: !0,
  ignoreTimeValidation: !1,
  enableSeconds: !1,
  enableMinutes: !0,
  is24: !0,
  noHoursOverlay: !1,
  noMinutesOverlay: !1,
  noSecondsOverlay: !1,
  hoursGridIncrement: 1,
  minutesGridIncrement: 5,
  secondsGridIncrement: 5,
  hoursIncrement: 1,
  minutesIncrement: 1,
  secondsIncrement: 1,
  timePickerInline: !1,
  startTime: void 0
}, Bg = {
  flowStep: 0,
  menuWrapRef: null,
  collapse: !1
}, zg = {
  weekStart: wc.Monday,
  yearRange: () => [1900, 2100],
  ui: () => ({}),
  locale: () => Ig,
  dark: !1,
  transitions: !0,
  hideNavigation: () => [],
  vertical: !1,
  hideMonthYearSelect: !1,
  disableYearSelect: !1,
  autoApply: !1,
  disabledDates: () => [],
  hideOffsetDates: !1,
  noToday: !1,
  markers: () => [],
  presetDates: () => [],
  preventMinMaxNavigation: !1,
  reverseYears: !1,
  weekPicker: !1,
  arrowNavigation: !1,
  monthPicker: !1,
  yearPicker: !1,
  quarterPicker: !1,
  timePicker: !1,
  modelAuto: !1,
  multiDates: !1,
  range: !1,
  inline: !1,
  sixWeeks: !1,
  focusStartDate: !1,
  yearFirst: !1,
  loading: !1,
  centered: !1
}, go = {
  name: void 0,
  required: !1,
  autocomplete: "off",
  state: void 0,
  clearable: !0,
  alwaysClearable: !1,
  hideInputIcon: !1,
  id: void 0,
  inputmode: "none"
}, Xs = {
  type: "local",
  hideOnOffsetDates: !1,
  label: "W"
}, Wg = (e) => {
  const { getMapKey: n, getMapKeyType: t, getTimeObjFromCurrent: a } = Dt();
  function s(G, q) {
    let Z;
    return e.timezone ? Z = new Pa(G ?? /* @__PURE__ */ new Date(), e.timezone) : Z = G ? new Date(G) : /* @__PURE__ */ new Date(), q ? qe(Z, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }) : Z;
  }
  const r = () => {
    const G = X.value.enableSeconds ? ":ss" : "", q = X.value.enableMinutes ? ":mm" : "";
    return X.value.is24 ? `HH${q}${G}` : `hh${q}${G} aa`;
  }, l = () => {
    var G;
    return e.monthPicker ? "MM/yyyy" : e.timePicker ? r() : e.weekPicker ? `${((G = $.value) == null ? void 0 : G.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : X.value.enableTimePicker ? `MM/dd/yyyy, ${r()}` : "MM/dd/yyyy";
  }, i = (G) => a(s(), G, X.value.enableSeconds), o = () => A.value.enabled ? X.value.startTime && Array.isArray(X.value.startTime) ? [i(X.value.startTime[0]), i(X.value.startTime[1])] : null : X.value.startTime && !Array.isArray(X.value.startTime) ? i(X.value.startTime) : null, u = (G) => G ? typeof G == "boolean" ? G ? 2 : 0 : Math.max(+G, 2) : 0, c = (G) => {
    const q = t(e.monthPicker, e.yearPicker);
    return new Map(
      G.map((Z) => {
        const N = s(Z, f.value);
        return [n(N, q), N];
      })
    );
  }, f = C(() => e.monthPicker || e.yearPicker || e.quarterPicker), h = C(() => {
    const G = typeof e.multiCalendars == "object" && e.multiCalendars, q = {
      static: !0,
      solo: !1
    };
    if (!e.multiCalendars) return { ...q, count: u(!1) };
    const Z = G ? e.multiCalendars : {}, N = G ? Z.count ?? !0 : e.multiCalendars, ae = u(N);
    return Object.assign(q, Z, { count: ae });
  }), d = C(() => o()), g = C(() => ({ ...Vg, ...e.ariaLabels })), y = C(() => ({ ...Fg, ...e.filters })), k = C(() => typeof e.transitions == "boolean" ? e.transitions ? po : !1 : { ...po, ...e.transitions }), m = C(() => ({ ...Rg, ...e.actionRow })), v = C(() => typeof e.textInput == "object" ? {
    ...vo,
    ...e.textInput,
    format: typeof e.textInput.format == "string" ? e.textInput.format : Y.value.input,
    pattern: e.textInput.format ?? Y.value.input,
    enabled: !0
  } : {
    ...vo,
    format: Y.value.input,
    pattern: Y.value.input,
    enabled: e.textInput
  }), w = C(() => {
    const G = { input: !1 };
    return typeof e.inline == "object" ? { ...G, ...e.inline, enabled: !0 } : {
      enabled: e.inline,
      ...G
    };
  }), S = C(() => ({ ...Pg, ...e.config })), x = C(() => typeof e.highlight == "function" ? e.highlight : {
    ...Ag,
    ...e.highlight
  }), $ = C(() => {
    var G, q;
    return typeof e.weekNumbers == "object" ? {
      type: ((G = e.weekNumbers) == null ? void 0 : G.type) ?? Xs.type,
      hideOnOffsetDates: ((q = e.weekNumbers) == null ? void 0 : q.hideOnOffsetDates) ?? Xs.hideOnOffsetDates,
      label: e.weekNumbers.label ?? Xs.label
    } : e.weekNumbers ? Xs : void 0;
  }), T = C(() => {
    var G, q;
    return typeof e.multiDates == "boolean" ? { enabled: e.multiDates, dragSelect: !0, limit: null } : {
      enabled: !!e.multiDates,
      limit: (G = e.multiDates) != null && G.limit ? +e.multiDates.limit : null,
      dragSelect: ((q = e.multiDates) == null ? void 0 : q.dragSelect) ?? !0
    };
  }), _ = C(() => {
    var G;
    return {
      minDate: e.minDate ? s(e.minDate) : null,
      maxDate: e.maxDate ? s(e.maxDate) : null,
      disabledDates: Array.isArray(e.disabledDates) ? c(e.disabledDates) : e.disabledDates,
      allowedDates: Array.isArray(e.allowedDates) ? c(e.allowedDates) : null,
      highlight: typeof x.value == "object" && Array.isArray(x.value.dates) ? c(x.value.dates) : x.value,
      markers: (G = e.markers) != null && G.length ? new Map(
        e.markers.map((q) => {
          const Z = s(q.date);
          return [n(Z, Aa.DATE), q];
        })
      ) : null
    };
  }), A = C(() => typeof e.range == "object" ? { enabled: !0, ...mo, ...e.range } : {
    enabled: e.range,
    ...mo
  }), D = C(() => ({
    ...Object.fromEntries(
      Object.keys(e.ui).map((G) => {
        const q = G, Z = e.ui[q];
        if (q === "dayClass") return [q, e.ui[q]];
        const N = typeof e.ui[q] == "string" ? { [Z]: !0 } : Object.fromEntries(Z.map((ae) => [ae, !0]));
        return [G, N];
      })
    )
  })), Y = C(() => {
    var G, q;
    return {
      ...Lg,
      ...e.formats,
      input: ((G = e.formats) == null ? void 0 : G.input) ?? l(),
      preview: ((q = e.formats) == null ? void 0 : q.preview) ?? l()
    };
  }), L = C(() => {
    if (e.teleport)
      return typeof e.teleport == "string" ? e.teleport : typeof e.teleport == "boolean" ? "body" : e.teleport;
  }), X = C(() => ({ ...Ng, ...e.timeConfig })), se = C(() => {
    if (e.flow)
      return { steps: [], partial: !1, ...e.flow };
  }), ie = C(() => {
    const G = v.value.enabled ? "text" : "none";
    return e.inputAttrs ? { ...go, inputmode: G, ...e.inputAttrs } : { ...go, inputmode: G };
  }), ue = C(() => {
    var G, q, Z, N, ae, me;
    return {
      offset: ((G = e.floating) == null ? void 0 : G.offset) ?? 10,
      arrow: ((q = e.floating) == null ? void 0 : q.arrow) ?? !0,
      strategy: ((Z = e.floating) == null ? void 0 : Z.strategy) ?? void 0,
      placement: ((N = e.floating) == null ? void 0 : N.placement) ?? void 0,
      flip: ((ae = e.floating) == null ? void 0 : ae.flip) ?? !0,
      shift: ((me = e.floating) == null ? void 0 : me.shift) ?? !0
    };
  });
  return {
    transitions: k,
    multiCalendars: h,
    startTime: d,
    ariaLabels: g,
    filters: y,
    actionRow: m,
    textInput: v,
    inline: w,
    config: S,
    highlight: x,
    weekNumbers: $,
    range: A,
    safeDates: _,
    multiDates: T,
    ui: D,
    formats: Y,
    teleport: L,
    timeConfig: X,
    flow: se,
    inputAttrs: ie,
    floatingConfig: ue,
    getDate: s
  };
}, Dt = () => {
  const e = (v, w) => Qt(v, w ?? Aa.DATE), n = (v, w) => v ? Aa.MONTH_AND_YEAR : w ? Aa.YEAR : Aa.DATE, t = (v, w, S) => w.get(e(v, S)), a = (v) => v, s = (v) => v === 0 ? v : !v || Number.isNaN(+v) ? null : +v, r = () => [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "[data-datepicker-instance]"
  ].join(", "), l = (v, w) => {
    let S = [...document.querySelectorAll(r())];
    S = S.filter(($) => !v.contains($) || "datepicker-instance" in $.dataset);
    const x = S.indexOf(v);
    if (x >= 0 && (w ? x - 1 >= 0 : x + 1 <= S.length))
      return S[x + (w ? -1 : 1)];
  }, i = (v) => String(v).padStart(2, "0"), o = (v, w) => v == null ? void 0 : v.querySelector(`[data-dp-element="${w}"]`), u = (v, w, S = !1) => {
    v && w.allowStopPropagation && (S && v.stopImmediatePropagation(), v.stopPropagation());
  }, c = (v, w, S = !1, x) => {
    if (v.key === dt.enter || v.key === dt.space)
      return S && v.preventDefault(), w();
    if (x) return x(v);
  }, f = (v, w) => {
    w.allowStopPropagation && v.stopPropagation(), w.allowPreventDefault && v.preventDefault();
  }, h = (v) => {
    if (v)
      return [...v.querySelectorAll("input, button, select, textarea, a[href]")][0];
  }, d = () => "ontouchstart" in globalThis || navigator.maxTouchPoints > 0, g = (v) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][v], y = (v) => {
    const w = [], S = (x) => x.filter(($) => !!$);
    for (let x = 0; x < v.length; x += 3) {
      const $ = [v[x], v[x + 1], v[x + 2]];
      w.push(S($));
    }
    return w;
  }, k = {
    prop: (v) => `"${v}" prop must be enabled!`,
    dateArr: (v) => `You need to use array as "model-value" binding in order to support "${v}"`
  }, m = (v, w, S, x, $) => {
    const T = {
      hours: In,
      minutes: Nn,
      seconds: na
    };
    if (!w) return x ? [T[v](S), T[v](S)] : T[v](S);
    if (Array.isArray(w) && x) {
      const _ = w[0] ?? S, A = w[1];
      return [T[v](_), A ? T[v](A) : $[v][1] ?? T[v](S)];
    }
    return Array.isArray(w) && !x ? T[v](w[w.length - 1] ?? S) : T[v](w);
  };
  return {
    getMapKey: e,
    getMapKeyType: n,
    getMapDate: t,
    convertType: a,
    getNumVal: s,
    findNextFocusableElement: l,
    padZero: i,
    getElWithin: o,
    checkStopPropagation: u,
    checkKeyDown: c,
    handleEventPropagation: f,
    findFocusableEl: h,
    isTouchDevice: d,
    hoursToAmPmHours: g,
    getGroupedList: y,
    setTimeModelValue: (v, w, S, x) => {
      v.hours = m("hours", w, S, x, v), v.minutes = m("minutes", w, S, x, v), v.seconds = m("seconds", w, S, x, v);
    },
    getTimeObjFromCurrent: (v, w, S) => {
      const x = {
        hours: In(v),
        minutes: Nn(v),
        seconds: S ? na(v) : 0
      };
      return Object.assign(x, w);
    },
    errorMapper: k
  };
}, Rt = () => {
  const { getDate: e } = Ke(), { getMapDate: n, getGroupedList: t } = Dt(), a = (m, v) => {
    if (!m) return e();
    const w = e(m), S = qe(w, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    return v ? Zm(S) : S;
  }, s = (m, v) => {
    const w = e(v);
    return qe(w, {
      hours: +(m.hours ?? In(w)),
      minutes: +(m.minutes ?? Nn(w)),
      seconds: +(m.seconds ?? na(w)),
      milliseconds: 0
    });
  }, r = (m, v) => {
    const w = an(m, { weekStartsOn: +v }), S = fi(m, { weekStartsOn: +v });
    return [w, S];
  }, l = (m, v) => !m || !v ? !1 : Ln(a(m), a(v)), i = (m, v) => !m || !v ? !1 : Ia(a(m), a(v)), o = (m, v) => !m || !v ? !1 : Cn(a(m), a(v)), u = (m, v, w) => m != null && m[0] && (m != null && m[1]) ? o(w, m[0]) && l(w, m[1]) : m != null && m[0] && v ? o(w, m[0]) && l(w, v) || l(w, m[0]) && o(w, v) : !1, c = (m, v) => {
    const w = o(m, v) ? v : m, S = o(v, m) ? v : m;
    return di({ start: w, end: S });
  }, f = (m) => `dp-${Qt(m, "yyyy-MM-dd")}`, h = (m) => a(qe(e(m), { date: 1 })), d = (m, v) => {
    if (v) {
      const w = Be(e(v));
      if (w > m) return 12;
      if (w === m) return Ze(e(v));
    }
  }, g = (m, v) => {
    if (v) {
      const w = Be(e(v));
      return w < m ? -1 : w === m ? Ze(e(v)) : void 0;
    }
  }, y = (m) => {
    if (m) return Be(e(m));
  }, k = (m) => ({
    hours: In(m),
    minutes: Nn(m),
    seconds: na(m)
  });
  return {
    resetDateTime: a,
    groupListAndMap: (m, v) => t(m).map((w) => w.map((S) => {
      const { active: x, disabled: $, isBetween: T, highlighted: _ } = v(S);
      return {
        ...S,
        active: x,
        disabled: $,
        className: {
          dp__overlay_cell_active: x,
          dp__overlay_cell: !x,
          dp__overlay_cell_disabled: $,
          dp__overlay_cell_pad: !0,
          dp__overlay_cell_active_disabled: $ && x,
          dp__cell_in_between: T,
          "dp--highlighted": _
        }
      };
    })),
    setTime: s,
    getWeekFromDate: r,
    isDateAfter: o,
    isDateBefore: l,
    isDateBetween: u,
    isDateEqual: i,
    getDaysInBetween: c,
    getCellId: f,
    resetDate: h,
    getMinMonth: d,
    getMaxMonth: g,
    getYearFromDate: y,
    getTimeObj: k,
    setTimeValue: (m) => qe(e(), k(m)),
    sanitizeTime: (m, v, w) => v && (w || w === 0) ? Object.fromEntries(
      ["hours", "minutes", "seconds"].map((S) => S === v ? [S, w] : [S, Number.isNaN(+m[S]) ? void 0 : +m[S]])
    ) : {
      hours: Number.isNaN(+m.hours) ? void 0 : +m.hours,
      minutes: Number.isNaN(+m.minutes) ? void 0 : +m.minutes,
      seconds: Number.isNaN(+(m.seconds ?? "")) ? void 0 : +m.seconds
    },
    getBeforeAndAfterInRange: (m, v) => {
      const w = cc(a(v), m), S = en(a(v), m);
      return { before: w, after: S };
    },
    isModelAuto: (m) => Array.isArray(m) ? !!m[0] && !!m[1] : !1,
    matchDate: (m, v) => m ? v ? v instanceof Map ? !!n(m, v) : v(e(m)) : !1 : !0,
    checkHighlightMonth: (m, v, w) => typeof m == "function" ? m({ month: v, year: w }) : m.months.some((S) => S.month === v && S.year === w),
    checkHighlightYear: (m, v) => typeof m == "function" ? m(v) : m.years.includes(v)
  };
}, Rr = () => {
  const {
    defaults: { config: e }
  } = Ke(), n = te(0);
  nt(() => {
    t(), globalThis.addEventListener("resize", t, { passive: !0 });
  }), sn(() => {
    globalThis.removeEventListener("resize", t);
  });
  const t = () => {
    n.value = globalThis.document.documentElement.clientWidth;
  };
  return {
    isMobile: C(() => n.value <= e.value.mobileBreakpoint ? !0 : void 0)
  };
}, aa = () => {
  const {
    getDate: e,
    state: n,
    modelValue: t,
    rootProps: a,
    defaults: { formats: s, textInput: r }
  } = Ke(), l = (g) => Qt(hn(e(), g), s.value.year, { locale: a.locale }), i = (g) => Qt(dc(e(), g), s.value.month, { locale: a.locale }), o = (g) => Qt(g, s.value.weekDay, { locale: a.locale }), u = (g) => Qt(g, s.value.quarter, { locale: a.locale }), c = (g, y) => [g, y].map((k) => u(k)).join("-"), f = (g) => Qt(g, s.value.day, { locale: a.locale }), h = (g, y, k) => {
    const m = k ? s.value.preview : s.value.input;
    if (!g) return "";
    if (typeof m == "function") return m(g);
    const v = y ?? m, w = { locale: a.locale };
    return Array.isArray(g) ? `${Qt(g[0], v, w)}${a.modelAuto && !g[1] ? "" : r.value.rangeSeparator}${g[1] ? Qt(g[1], v, w) : ""}` : Qt(g, v, w);
  }, d = () => {
    const g = (y) => Qt(y, r.value.format);
    return Array.isArray(t.value) ? `${g(t.value[0])} ${r.value.rangeSeparator} ${t.value[1] ? g(t.value[1]) : ""}` : "";
  };
  return {
    formatYear: l,
    formatMonth: i,
    formatWeekDay: o,
    formatQuarter: u,
    formatSelectedDate: h,
    formatForTextInput: () => n.isInputFocused && t.value ? Array.isArray(t.value) ? d() : Qt(t.value, r.value.format) : h(t.value),
    formatPreview: (g) => h(g, void 0, !0),
    formatQuarterText: c,
    formatDay: f
  };
}, Vr = () => {
  const { rootProps: e } = Ke(), { formatYear: n, formatMonth: t } = aa();
  return {
    getMonths: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((a) => ({
      text: t(a),
      value: a
    })),
    getYears: () => {
      const a = [];
      for (let s = +e.yearRange[0]; s <= +e.yearRange[1]; s++)
        a.push({ value: +s, text: n(s) });
      return e.reverseYears ? a.reverse() : a;
    },
    isOutOfYearRange: (a) => a < +e.yearRange[0] || a > +e.yearRange[1]
  };
}, Yg = (e) => ({
  openMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.openMenu();
  },
  closeMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.closeMenu();
  },
  selectDate: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.selectDate();
  },
  clearValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.clearValue();
  },
  formatInputValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.formatInputValue();
  },
  updateInternalModelValue: (n) => {
    var t;
    return (t = e.value) == null ? void 0 : t.updateInternalModelValue(n);
  },
  setMonthYear: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.setMonthYear(n, t);
  },
  parseModel: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.parseModel();
  },
  switchView: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.switchView(n, t);
  },
  handleFlow: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.handleFlow();
  },
  toggleMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.toggleMenu();
  },
  dpMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpMenuRef();
  },
  dpWrapMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpWrapMenuRef();
  },
  inputRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.inputRef();
  }
}), Za = () => ({
  boolHtmlAttribute: (e) => e ? !0 : void 0
}), Hg = () => {
  const {
    getDate: e,
    rootProps: n,
    defaults: { textInput: t, startTime: a, timeConfig: s }
  } = Ke(), { getTimeObjFromCurrent: r } = Dt(), l = te(!1), i = C(
    () => Array.isArray(a.value) ? a.value[0] : a.value ?? r(e(), {}, s.value.enableSeconds)
  ), o = (c, f) => {
    var w, S;
    const h = /[^a-zA-Z]+/g, d = /\D+/g, g = f.split(d), y = c.split(h), k = c.match(h) || [], m = f.match(d) || [];
    let v = "";
    for (let x = 0; x < g.length && x < y.length; x++) {
      x > 0 && m[x - 1] && (v += k[x - 1] || m[x - 1]);
      const $ = (w = g[x]) == null ? void 0 : w.length;
      v += (S = y[x]) == null ? void 0 : S.slice(0, $);
    }
    return v;
  }, u = (c, f, h) => {
    const d = Rl(c, o(f, c), e(), {
      locale: n.locale
    });
    return bs(d) && Qu(d) ? h || l.value ? d : qe(d, {
      hours: +i.value.hours,
      minutes: +i.value.minutes,
      seconds: +(i.value.seconds ?? 0),
      milliseconds: 0
    }) : null;
  };
  return {
    textPasted: l,
    parseFreeInput: (c, f) => {
      if (typeof t.value.pattern == "string")
        return u(c, t.value.pattern, f);
      if (Array.isArray(t.value.pattern)) {
        let h = null;
        for (const d of t.value.pattern)
          if (h = u(c, d, f), h)
            break;
        return h;
      }
      return typeof t.value.pattern == "function" ? t.value.pattern(c) : null;
    },
    applyMaxValues: (c, f) => {
      const h = {
        MM: 12,
        DD: 31,
        hh: 23,
        mm: 59,
        ss: 59
      };
      let d = "", g = 0;
      for (let y = 0; y < f.length; y++) {
        const k = f[y], m = k.length, v = c.slice(g, g + m);
        if (!v) break;
        if (v.length < m)
          d += v;
        else {
          let w = Number.parseInt(v, 10);
          h[k] && w > h[k] && (w = h[k]), d += w.toString().padStart(m, "0").slice(0, m);
        }
        g += m;
      }
      return d;
    },
    createMaskedValue: (c, f) => {
      const h = /(YYYY|MM|DD|hh|mm|ss)/g, d = [...f.matchAll(h)].map((v) => v[0]), g = f.replace(h, "|").split("|").filter(Boolean), y = d.map((v) => v.length);
      let k = "", m = 0;
      for (let v = 0; v < d.length; v++) {
        const w = y[v], S = c.slice(m, m + w);
        if (!S) break;
        k += S, S.length === w && g[v] && (k += g[v]), m += w;
      }
      return k;
    }
  };
};
var gn = /* @__PURE__ */ ((e) => (e.Input = "input", e.DatePicker = "date-picker", e.Calendar = "calendar", e.DatePickerHeader = "date-picker-header", e.Menu = "menu", e.ActionRow = "action-row", e.TimePicker = "time-picker", e.TimeInput = "time-input", e.PassTrough = "pass-trough", e.MonthPicker = "month-picker", e.YearMode = "year-mode", e.QuarterPicker = "quarter-picker", e.YearPicker = "year-picker", e))(gn || {});
const Ma = [
  "time-input",
  "time-picker",
  "pass-trough"
  /* PassTrough */
], kc = [
  { name: "trigger", use: [
    "input"
    /* Input */
  ] },
  { name: "input-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "clear-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "dp-input", use: [
    "input"
    /* Input */
  ] },
  { name: "clock-icon", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "arrow-left", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "arrow-right", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  {
    name: "arrow-up",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "arrow-down",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "calendar-icon",
    use: [
      "date-picker-header",
      "time-picker",
      "pass-trough",
      "year-mode"
      /* YearMode */
    ]
  },
  { name: "day", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "month-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker"
      /* MonthPicker */
    ]
  },
  {
    name: "year-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "year-mode",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "year-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "hours-overlay-value",
    use: Ma
  },
  {
    name: "hours-overlay-header",
    use: Ma
  },
  {
    name: "minutes-overlay-value",
    use: Ma
  },
  {
    name: "minutes-overlay-header",
    use: Ma
  },
  {
    name: "seconds-overlay-value",
    use: Ma
  },
  {
    name: "seconds-overlay-header",
    use: Ma
  },
  { name: "hours", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "minutes", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "seconds", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "action-buttons", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "action-preview", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "calendar-header", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "marker-tooltip", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-extra", use: [
    "menu"
    /* Menu */
  ] },
  { name: "time-picker-overlay", use: [
    "time-picker",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "am-pm-button", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "left-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  { name: "right-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  {
    name: "month-year",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "time-picker", use: [
    "date-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-row", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "marker", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "quarter", use: [
    "quarter-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "top-extra",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "quarter-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  {
    name: "tp-inline-arrow-up",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "tp-inline-arrow-down",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  { name: "arrow", use: [
    "menu"
    /* Menu */
  ] },
  { name: "menu-header", use: [
    "menu"
    /* Menu */
  ] }
], _n = (e, n) => kc.filter((t) => e[t.name] && t.use.includes(n)).map((t) => t.name), xc = (e, n) => kc.map((t) => t.name).concat((n == null ? void 0 : n.filter((t) => t.slot).map((t) => t.slot)) ?? []).filter((t) => !!e[t]), Ug = {
  key: 1,
  class: "dp__input_wrap"
}, qg = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], jg = {
  key: 1,
  class: "dp--clear-btn"
}, Gg = ["aria-label"], Kg = /* @__PURE__ */ Te({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 }
  },
  emits: ["clear", "open", "set-input-date", "close", "select-date", "set-empty-date", "toggle", "focus", "blur", "real-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: r,
      inputValue: l,
      rootProps: i,
      defaults: { textInput: o, ariaLabels: u, inline: c, config: f, range: h, multiDates: d, ui: g, inputAttrs: y }
    } = Ke(), { checkMinMaxRange: k, isValidDate: m } = rn(), { parseFreeInput: v, textPasted: w, createMaskedValue: S, applyMaxValues: x } = Hg(), { checkKeyDown: $, checkStopPropagation: T } = Dt(), { boolHtmlAttribute: _ } = Za(), A = Qe("dp-input"), D = te(null), Y = te(!1), L = C(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !o.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !y.value.clearable,
        dp__input_icon_pad: !y.value.hideInputIcon,
        dp__input_valid: typeof y.value.state == "boolean" ? y.value.state : !1,
        dp__input_invalid: typeof y.value.state == "boolean" ? !y.value.state : !1,
        dp__input_focus: Y.value || s.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        ...g.value.input
      })
    ), X = () => {
      a("set-input-date", null), y && i.autoApply && (a("set-empty-date"), D.value = null);
    }, se = (V) => {
      var j;
      if ((j = o.value.separators) != null && j.length) {
        const H = new RegExp(
          o.value.separators.map((I) => I.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")
        );
        return V.split(H);
      }
      return V.split(o.value.rangeSeparator);
    }, ie = (V) => {
      const [j, H] = se(V);
      if (j) {
        const I = v(j.trim(), l.value), B = H ? v(H.trim(), l.value) : void 0;
        if (Cn(I, B)) return;
        const J = I && B ? [I, B] : [I];
        k(B, J, 0) && (D.value = I ? J : null);
      }
    }, ue = () => {
      w.value = !0;
    }, G = (V) => {
      if (h.value.enabled)
        ie(V);
      else if (d.value.enabled) {
        const j = V.split(";");
        D.value = j.map((H) => v(H.trim())).filter((H) => !!H);
      } else
        D.value = v(V, l.value);
    }, q = (V) => {
      var B, J;
      const j = typeof V == "string" ? V : (B = V.target) == null ? void 0 : B.value, H = (J = o == null ? void 0 : o.value) == null ? void 0 : J.maskFormat;
      let I = j;
      if (typeof H == "string") {
        const R = /(YYYY|MM|DD|hh|mm|ss)/g, ee = [...H.matchAll(R)].map((F) => F[0]), O = j.replace(/\D/g, ""), z = x(O, ee);
        I = S(z, H);
      }
      I === "" ? X() : (o.value.openMenu && !s.isMenuOpen && a("open"), G(I), a("set-input-date", D.value)), w.value = !1, l.value = I, r("text-input", V, D.value);
    }, Z = (V) => {
      o.value.enabled ? (G(V.target.value), o.value.enterSubmit && m(D.value) && l.value !== "" ? (a("set-input-date", D.value, !0), D.value = null) : o.value.enterSubmit && l.value === "" && (D.value = null, a("clear"))) : me(V);
    }, N = (V, j) => {
      o.value.enabled && o.value.tabSubmit && !j && G(V.target.value), o.value.tabSubmit && m(D.value) && l.value !== "" ? (a("set-input-date", D.value, !0, !0), D.value = null) : o.value.tabSubmit && l.value === "" && (D.value = null, a("clear"));
    }, ae = () => {
      Y.value = !0, a("focus"), Xe().then(() => {
        var V;
        o.value.enabled && o.value.selectOnFocus && ((V = A.value) == null || V.select());
      });
    }, me = (V) => {
      if (T(V, f.value, !0), o.value.enabled && o.value.openMenu && !c.value.input) {
        if (o.value.openMenu === "open" && !s.isMenuOpen) return a("open");
        if (o.value.openMenu === "toggle") return a("toggle");
      } else o.value.enabled || a("toggle");
    }, be = () => {
      a("real-blur"), Y.value = !1, (!s.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), (i.autoApply && o.value.enabled && D.value && !s.isMenuOpen || o.value.applyOnBlur) && (a("set-input-date", D.value), a("select-date"), D.value = null);
    }, pe = (V) => {
      T(V, f.value, !0), a("clear");
    }, De = () => {
      a("close");
    }, ge = (V) => {
      if (V.key === "Tab" && N(V), V.key === "Enter" && Z(V), V.key === "Escape" && o.value.escClose && De(), !o.value.enabled) {
        if (V.code === "Tab") return;
        V.preventDefault();
      }
    }, K = () => {
      var V;
      (V = A.value) == null || V.focus({ preventScroll: !0 });
    }, ye = (V) => {
      D.value = V;
    }, Me = (V) => {
      V.key === dt.tab && N(V, !0);
    };
    return n({
      focusInput: K,
      setParsedDate: ye
    }), (V, j) => {
      var H, I;
      return b(), M("div", { onClick: me }, [
        !V.$slots["dp-input"] && !p(c).enabled ? U(V.$slots, "trigger", { key: 0 }) : P("", !0),
        !V.$slots.trigger && (!p(c).enabled || p(c).input) ? (b(), M("div", Ug, [
          !V.$slots.trigger && (!p(c).enabled || p(c).enabled && p(c).input) ? U(V.$slots, "dp-input", {
            key: 0,
            value: p(l),
            isMenuOpen: e.isMenuOpen,
            onInput: q,
            onEnter: Z,
            onTab: N,
            onClear: pe,
            onBlur: be,
            onKeypress: ge,
            onPaste: ue,
            onFocus: ae,
            openMenu: () => V.$emit("open"),
            closeMenu: () => V.$emit("close"),
            toggleMenu: () => V.$emit("toggle")
          }, () => [
            E("input", {
              id: p(y).id,
              ref: "dp-input",
              "data-test-id": "dp-input",
              name: p(y).name,
              class: ne(L.value),
              inputmode: p(y).inputmode,
              placeholder: p(i).placeholder,
              disabled: p(_)(p(i).disabled),
              readonly: p(_)(p(i).readonly),
              required: p(_)(p(y).required),
              value: p(l),
              autocomplete: p(y).autocomplete,
              "aria-label": p(u).input,
              "aria-disabled": p(i).disabled || void 0,
              "aria-invalid": p(y).state === !1 ? !0 : void 0,
              onInput: q,
              onBlur: be,
              onFocus: ae,
              onKeypress: ge,
              onKeydown: j[0] || (j[0] = (B) => ge(B)),
              onPaste: ue,
              onInvalid: j[1] || (j[1] = (B) => p(r)("invalid", B))
            }, null, 42, qg)
          ]) : P("", !0),
          E("div", {
            onClick: j[4] || (j[4] = (B) => a("toggle"))
          }, [
            V.$slots["input-icon"] && !p(y).hideInputIcon ? (b(), M("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: j[2] || (j[2] = (B) => a("toggle"))
            }, [
              U(V.$slots, "input-icon")
            ])) : P("", !0),
            !V.$slots["input-icon"] && !p(y).hideInputIcon && !V.$slots["dp-input"] ? (b(), fe(p(As), {
              key: 1,
              "aria-label": (H = p(u)) == null ? void 0 : H.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: j[3] || (j[3] = (B) => a("toggle"))
            }, null, 8, ["aria-label"])) : P("", !0)
          ]),
          V.$slots["clear-icon"] && (p(y).alwaysClearable || p(l) && p(y).clearable && !p(i).disabled && !p(i).readonly) ? (b(), M("span", jg, [
            U(V.$slots, "clear-icon", { clear: pe })
          ])) : P("", !0),
          !V.$slots["clear-icon"] && (p(y).alwaysClearable || p(y).clearable && p(l) && !p(i).disabled && !p(i).readonly) ? (b(), M("button", {
            key: 2,
            "aria-label": (I = p(u)) == null ? void 0 : I.clearInput,
            class: "dp--clear-btn",
            type: "button",
            "data-test-id": "clear-input-value-btn",
            onKeydown: j[5] || (j[5] = (B) => p($)(B, () => pe(B), !0, Me)),
            onClick: j[6] || (j[6] = Ve((B) => pe(B), ["prevent"]))
          }, [
            oe(p(Gp), { class: "dp__input_icons" })
          ], 40, Gg)) : P("", !0)
        ])) : P("", !0)
      ]);
    };
  }
}), Zg = {
  ref: "action-row",
  class: "dp__action_row"
}, Xg = ["title"], Jg = {
  ref: "action-buttons-container",
  class: "dp__action_buttons",
  "data-dp-element": "action-row"
}, Qg = ["disabled"], ey = /* @__PURE__ */ Te({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { default: 0 }
  },
  emits: ["close-picker", "select-date", "select-now"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      rootEmit: s,
      rootProps: r,
      modelValue: l,
      defaults: { actionRow: i, multiCalendars: o, inline: u, range: c, multiDates: f, formats: h }
    } = Ke(), { isTimeValid: d, isMonthValid: g } = rn(), { formatPreview: y } = aa(), { checkKeyDown: k, convertType: m } = Dt(), { boolHtmlAttribute: v } = Za(), w = Qe("action-buttons-container"), S = Qe("action-row"), x = te(!1), $ = te({});
    nt(() => {
      T(), globalThis.addEventListener("resize", T);
    }), sn(() => {
      globalThis.removeEventListener("resize", T);
    });
    const T = () => {
      x.value = !1, setTimeout(() => {
        var q, Z;
        const ue = (q = w.value) == null ? void 0 : q.getBoundingClientRect(), G = (Z = S.value) == null ? void 0 : Z.getBoundingClientRect();
        ue && G && ($.value.maxWidth = `${G.width - ue.width - 20}px`), x.value = !0;
      }, 0);
    }, _ = C(() => c.value.enabled && !c.value.partialRange && l.value ? l.value.length === 2 : !0), A = C(
      () => !d.value(l.value) || !g.value(l.value) || !_.value
    ), D = () => {
      const ue = h.value.preview;
      return r.timePicker || r.monthPicker, ue(m(l.value));
    }, Y = () => {
      const ue = l.value;
      return o.value.count > 0 ? `${y(ue[0])} - ${y(ue[1])}` : [y(ue[0]), y(ue[1])];
    }, L = C(() => !l.value || !a.menuMount ? "" : typeof h.value.preview == "string" ? Array.isArray(l.value) ? l.value.length === 2 && l.value[1] ? Y() : f.value.enabled ? l.value.map((ue) => `${y(ue)}`) : r.modelAuto ? `${y(l.value[0])}` : `${y(l.value[0])} -` : y(l.value) : D()), X = () => f.value.enabled ? "; " : " - ", se = C(
      () => Array.isArray(L.value) ? L.value.join(X()) : L.value
    ), ie = () => {
      d.value(l.value) && g.value(l.value) && _.value ? t("select-date") : s("invalid-select");
    };
    return (ue, G) => (b(), M("div", Zg, [
      ue.$slots["action-row"] ? U(ue.$slots, "action-row", Mt(lt({ key: 0 }, {
        modelValue: p(l),
        disabled: A.value,
        selectDate: () => ue.$emit("select-date"),
        closePicker: () => ue.$emit("close-picker")
      }))) : (b(), M(Se, { key: 1 }, [
        p(i).showPreview ? (b(), M("div", {
          key: 0,
          class: "dp__selection_preview",
          title: se.value || void 0,
          style: Fe($.value)
        }, [
          ue.$slots["action-preview"] && x.value ? U(ue.$slots, "action-preview", {
            key: 0,
            value: p(l),
            formatValue: se.value
          }) : P("", !0),
          !ue.$slots["action-preview"] && x.value ? (b(), M(Se, { key: 1 }, [
            Ue(ce(se.value), 1)
          ], 64)) : P("", !0)
        ], 12, Xg)) : P("", !0),
        E("div", Jg, [
          ue.$slots["action-buttons"] ? U(ue.$slots, "action-buttons", {
            key: 0,
            value: p(l),
            selectDate: ie,
            selectionDisabled: A.value
          }) : P("", !0),
          ue.$slots["action-buttons"] ? P("", !0) : (b(), M(Se, { key: 1 }, [
            !p(u).enabled && p(i).showCancel ? (b(), M("button", {
              key: 0,
              ref: "cancel-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: G[0] || (G[0] = (q) => ue.$emit("close-picker")),
              onKeydown: G[1] || (G[1] = (q) => p(k)(q, () => ue.$emit("close-picker")))
            }, ce(p(i).cancelBtnLabel), 545)) : P("", !0),
            p(i).showNow ? (b(), M("button", {
              key: 1,
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: G[2] || (G[2] = (q) => ue.$emit("select-now")),
              onKeydown: G[3] || (G[3] = (q) => p(k)(q, () => ue.$emit("select-now")))
            }, ce(p(i).nowBtnLabel), 33)) : P("", !0),
            p(i).showSelect ? (b(), M("button", {
              key: 2,
              ref: "select-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_select",
              disabled: p(v)(A.value),
              "data-test-id": "select-button",
              onKeydown: G[4] || (G[4] = (q) => p(k)(q, () => ie())),
              onClick: ie
            }, ce(p(i).selectBtnLabel), 41, Qg)) : P("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Fr = () => {
  const {
    rootProps: e,
    defaults: { multiCalendars: n }
  } = Ke(), t = C(() => (r) => {
    var l;
    return (l = e.hideNavigation) == null ? void 0 : l.includes(r);
  }), a = C(() => (r) => n.value.count ? n.value.solo ? !0 : r === 0 : !0), s = C(() => (r) => n.value.count ? n.value.solo ? !0 : r === n.value.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: a, showRightIcon: s };
}, ty = ["role", "aria-label", "tabindex"], ny = { class: "dp__selection_grid_header" }, ay = ["aria-selected", "aria-disabled", "data-dp-action-element", "data-dp-element-active", "data-test-id", "onClick", "onKeydown", "onMouseover"], sy = ["aria-label", "data-dp-action-element"], Fs = /* @__PURE__ */ Te({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    useRelative: { type: Boolean },
    height: {},
    overlayLabel: {},
    isLast: { type: Boolean },
    level: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      setState: s,
      defaults: { ariaLabels: r, config: l }
    } = Ke(), { hideNavigationButtons: i } = Fr(), { handleEventPropagation: o, checkKeyDown: u } = Dt(), c = Qe("toggle-button"), f = Qe("overlay-container"), h = Qe("grid-wrap"), d = te(!1), g = te(null), y = te(), k = te(0);
    lf(() => {
      g.value = null;
    }), nt(async () => {
      await Xe(), $(), s("arrowNavigationLevel", a.level ?? 1);
    }), sn(() => {
      s("arrowNavigationLevel", (a.level ?? 1) - 1);
    });
    const m = C(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !a.useRelative,
        "dp--overlay-relative": a.useRelative
      })
    ), v = C(
      () => a.useRelative ? { height: `${a.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), w = C(() => ({
      dp__overlay_col: !0
    })), S = C(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: d.value,
        dp__button_bottom: a.isLast
      })
    ), x = C(() => {
      var X, se;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((X = a.items) == null ? void 0 : X.length) <= 6,
        dp__container_block: ((se = a.items) == null ? void 0 : se.length) > 6
      };
    });
    He(
      () => a.items,
      () => $(!1),
      { deep: !0 }
    );
    const $ = (X = !0) => {
      Xe().then(() => {
        const se = document.querySelector(`[data-dp-element-active="${a.level ?? 1}"]`), ie = jt(h), ue = jt(c), G = jt(f), q = ue ? ue.getBoundingClientRect().height : 0;
        ie && (ie.getBoundingClientRect().height ? k.value = ie.getBoundingClientRect().height - q : k.value = l.value.modeHeight - q), se && G && X && (G.scrollTop = se.offsetTop - G.offsetTop - (k.value / 2 - se.getBoundingClientRect().height) - q);
      });
    }, T = (X) => {
      X.disabled || t("selected", X.value);
    }, _ = () => {
      t("toggle"), t("reset-flow");
    }, A = (X) => {
      l.value.escClose && (_(), o(X, l.value));
    }, D = (X) => {
      y.value = X, t("hover-value", X);
    }, Y = (X) => {
      if (X.key === dt.esc) return A(X);
    }, L = (X) => {
      if (X.key === dt.enter) return _();
    };
    return (X, se) => {
      var ie;
      return b(), M("div", {
        ref: "grid-wrap",
        class: ne(m.value),
        style: Fe(v.value),
        role: e.useRelative ? void 0 : "dialog",
        "aria-label": e.overlayLabel,
        tabindex: e.useRelative ? void 0 : "0",
        onKeydown: Y,
        onClick: se[0] || (se[0] = Ve(() => {
        }, ["prevent"]))
      }, [
        E("div", {
          ref: "overlay-container",
          class: ne(x.value),
          style: Fe({ "--dp-overlay-height": `${k.value}px` }),
          role: "grid"
        }, [
          E("div", ny, [
            U(X.$slots, "header")
          ]),
          U(X.$slots, "overlay", {}, () => [
            (b(!0), M(Se, null, Pe(e.items, (ue, G) => (b(), M("div", {
              key: G,
              class: ne(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
              role: "row"
            }, [
              (b(!0), M(Se, null, Pe(ue, (q) => (b(), M("div", {
                key: q.value,
                role: "gridcell",
                class: ne(w.value),
                "aria-selected": q.active || void 0,
                "aria-disabled": q.disabled || void 0,
                "data-dp-action-element": e.level ?? 1,
                "data-dp-element-active": q.active ? e.level ?? 1 : void 0,
                tabindex: "0",
                "data-test-id": q.text,
                onClick: Ve((Z) => T(q), ["prevent"]),
                onKeydown: (Z) => p(u)(Z, () => T(q), !0),
                onMouseover: (Z) => D(q.value)
              }, [
                E("div", {
                  class: ne(q.className)
                }, [
                  U(X.$slots, "item", { item: q }, () => [
                    Ue(ce(q.text), 1)
                  ])
                ], 2)
              ], 42, ay))), 128))
            ], 2))), 128))
          ])
        ], 6),
        X.$slots["button-icon"] ? mn((b(), M("button", {
          key: 0,
          ref: "toggle-button",
          type: "button",
          "aria-label": (ie = p(r)) == null ? void 0 : ie.toggleOverlay,
          class: ne(S.value),
          tabindex: "0",
          "data-dp-action-element": e.level ?? 1,
          onClick: _,
          onKeydown: L
        }, [
          U(X.$slots, "button-icon")
        ], 42, sy)), [
          [Fn, !p(i)(e.type)]
        ]) : P("", !0)
      ], 46, ty);
    };
  }
}), ry = ["data-dp-mobile"], Lr = /* @__PURE__ */ Te({
  __name: "InstanceWrap",
  props: {
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const {
      defaults: { multiCalendars: n }
    } = Ke(), { isMobile: t } = Rr(), a = C(
      () => n.value.count > 0 ? [...new Array(n.value.count).keys()] : [0]
    );
    return (s, r) => (b(), M("div", {
      class: ne({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: p(n).count > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": p(t)
    }, [
      U(s.$slots, "default", {
        instances: a.value,
        wrapClass: { dp__instance_calendar: p(n).count > 0 }
      })
    ], 10, ry));
  }
}), ly = ["data-dp-element", "aria-label", "aria-disabled"], ws = /* @__PURE__ */ Te({
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const { checkKeyDown: t } = Dt(), a = n;
    return (s, r) => (b(), M("button", {
      ref: "arrow-btn",
      type: "button",
      "data-dp-element": e.elName,
      "data-dp-action-element": "0",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: r[0] || (r[0] = (l) => a("activate")),
      onKeydown: r[1] || (r[1] = (l) => p(t)(l, () => a("activate"), !0))
    }, [
      E("span", {
        class: ne(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        U(s.$slots, "default")
      ], 2)
    ], 40, ly));
  }
}), iy = ["aria-label", "data-test-id"], Sc = /* @__PURE__ */ Te({
  __name: "YearModePicker",
  props: {
    items: {},
    instance: {},
    year: {},
    showYearPicker: { type: Boolean, default: !1 },
    isDisabled: {}
  },
  emits: ["handle-year", "year-select", "toggle-year-picker"],
  setup(e, { emit: n }) {
    const t = n, a = e, { showRightIcon: s, showLeftIcon: r } = Fr(), {
      rootProps: l,
      defaults: { config: i, ariaLabels: o, ui: u }
    } = Ke(), { showTransition: c, transitionName: f } = Rs(), { formatYear: h } = aa(), { boolHtmlAttribute: d } = Za(), g = te(!1), y = C(() => h(a.year)), k = (w = !1, S) => {
      g.value = !g.value, t("toggle-year-picker", { flow: w, show: S });
    }, m = (w) => {
      g.value = !1, t("year-select", w);
    }, v = (w = !1) => {
      t("handle-year", w);
    };
    return (w, S) => {
      var x, $, T, _, A;
      return b(), M(Se, null, [
        E("div", {
          class: ne(["dp--year-mode-picker", { "dp--hidden-el": g.value }])
        }, [
          p(r)(e.instance) ? (b(), fe(ws, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (x = p(o)) == null ? void 0 : x.prevYear,
            disabled: p(d)(e.isDisabled(!1)),
            class: ne(($ = p(u)) == null ? void 0 : $.navBtnPrev),
            onActivate: S[0] || (S[0] = (D) => v(!1))
          }, {
            default: de(() => [
              w.$slots["arrow-left"] ? U(w.$slots, "arrow-left", { key: 0 }) : P("", !0),
              w.$slots["arrow-left"] ? P("", !0) : (b(), fe(p(mc), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
          E("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(T = p(o)) == null ? void 0 : T.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            "data-dp-action-element": "0",
            onClick: S[1] || (S[1] = () => k(!1)),
            onKeydown: S[2] || (S[2] = It(Ve(() => k(!1), ["prevent"]), ["enter"]))
          }, [
            w.$slots.year ? U(w.$slots, "year", {
              key: 0,
              text: y.value,
              value: e.year
            }) : P("", !0),
            w.$slots.year ? P("", !0) : (b(), M(Se, { key: 1 }, [
              Ue(ce(e.year), 1)
            ], 64))
          ], 40, iy),
          p(s)(e.instance) ? (b(), fe(ws, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (_ = p(o)) == null ? void 0 : _.nextYear,
            disabled: p(d)(e.isDisabled(!0)),
            class: ne((A = p(u)) == null ? void 0 : A.navBtnNext),
            onActivate: S[3] || (S[3] = (D) => v(!0))
          }, {
            default: de(() => [
              w.$slots["arrow-right"] ? U(w.$slots, "arrow-right", { key: 0 }) : P("", !0),
              w.$slots["arrow-right"] ? P("", !0) : (b(), fe(p(vc), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : P("", !0)
        ], 2),
        oe(vt, {
          name: p(f)(e.showYearPicker),
          css: p(c)
        }, {
          default: de(() => {
            var D, Y;
            return [
              e.showYearPicker ? (b(), fe(Fs, {
                key: 0,
                items: e.items,
                config: p(i),
                "is-last": p(l).autoApply && !p(i).keepActionRow,
                "overlay-label": (Y = (D = p(o)) == null ? void 0 : D.yearPicker) == null ? void 0 : Y.call(D, !0),
                type: "year",
                onToggle: k,
                onSelected: S[4] || (S[4] = (L) => m(L))
              }, ft({
                "button-icon": de(() => [
                  w.$slots["calendar-icon"] ? U(w.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                  w.$slots["calendar-icon"] ? P("", !0) : (b(), fe(p(As), { key: 1 }))
                ]),
                _: 2
              }, [
                w.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: de(({ item: L }) => [
                    U(w.$slots, "year-overlay-value", {
                      text: L.text,
                      value: L.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "config", "is-last", "overlay-label"])) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Tc = (e) => {
  const {
    getDate: n,
    rootEmit: t,
    state: a,
    month: s,
    year: r,
    modelValue: l,
    calendars: i,
    rootProps: o,
    defaults: { multiCalendars: u, range: c, safeDates: f, filters: h, highlight: d }
  } = Ke(), { resetDate: g, getYearFromDate: y, checkHighlightYear: k, groupListAndMap: m } = Rt(), { getYears: v } = Vr(), { validateMonthYear: w, checkMinMaxValue: S } = rn(), x = te([!1]), $ = C(() => v()), T = C(() => (N, ae) => {
    const me = qe(g(n()), {
      month: s.value(N),
      year: r.value(N)
    }), be = ae ? tc(me) : Na(me);
    return w(be, o.preventMinMaxNavigation, ae);
  }), _ = () => Array.isArray(l.value) && u.value.solo && l.value[1], A = () => {
    for (let N = 0; N < u.value.count; N++)
      if (N === 0)
        i.value[N] = i.value[0];
      else if (N === u.value.count - 1 && _())
        i.value[N] = {
          month: Ze(l.value[1]),
          year: Be(l.value[1])
        };
      else {
        const ae = qe(n(), i.value[N - 1]);
        i.value[N] = { month: Ze(ae), year: Be(ci(ae, 1)) };
      }
  }, D = (N) => {
    if (!N) return A();
    const ae = qe(n(), i.value[N]);
    return i.value[0].year = Be(fc(ae, u.value.count - 1)), A();
  }, Y = (N, ae) => {
    const me = Gm(ae, N);
    return c.value.showLastInRange && me > 1 ? ae : N;
  }, L = (N) => o.focusStartDate || u.value.solo ? N[0] : N[1] ? Y(N[0], N[1]) : N[0], X = () => {
    if (l.value) {
      const N = Array.isArray(l.value) ? L(l.value) : l.value;
      i.value[0] = { month: Ze(N), year: Be(N) };
    }
  }, se = () => {
    X(), u.value.count && A();
  };
  He(l, (N, ae) => {
    a.isTextInputDate && JSON.stringify(N ?? {}) !== JSON.stringify(ae ?? {}) && se();
  }), nt(() => {
    se();
  });
  const ie = (N, ae) => {
    i.value[ae].year = N, t("update-month-year", { instance: ae, year: N, month: i.value[ae].month }), u.value.count && !u.value.solo && D(ae);
  }, ue = C(() => (N) => m($.value, (ae) => {
    var De;
    const me = r.value(N) === ae.value, be = S(
      ae.value,
      y(f.value.minDate),
      y(f.value.maxDate)
    ) || ((De = h.value.years) == null ? void 0 : De.includes(r.value(N))), pe = k(d.value, ae.value);
    return { active: me, disabled: be, highlighted: pe };
  })), G = (N, ae) => {
    ie(N, ae), Z(ae);
  }, q = (N, ae = !1) => {
    if (!T.value(N, ae)) {
      const me = ae ? r.value(N) + 1 : r.value(N) - 1;
      ie(me, N);
    }
  }, Z = (N, ae = !1, me) => {
    ae || e("reset-flow"), me === void 0 ? x.value[N] = !x.value[N] : x.value[N] = me, x.value[N] ? t("overlay-toggle", { open: !0, overlay: Vt.year }) : t("overlay-toggle", { open: !1, overlay: Vt.year });
  };
  return {
    isDisabled: T,
    groupedYears: ue,
    showYearPicker: x,
    selectYear: ie,
    setStartDate: () => {
      o.startDate && (l.value && o.focusStartDate || !l.value) && ie(Be(n(o.startDate)), 0);
    },
    toggleYearPicker: Z,
    handleYearSelect: G,
    handleYear: q
  };
}, Nr = () => {
  const { isDateAfter: e, isDateBefore: n, isDateEqual: t } = Rt(), {
    getDate: a,
    rootEmit: s,
    rootProps: r,
    modelValue: l,
    defaults: { range: i }
  } = Ke();
  return {
    getRangeWithFixedDate: (o) => Array.isArray(l.value) && (l.value.length === 2 || l.value.length === 1 && i.value.partialRange) ? i.value.fixedStart && (e(o, l.value[0]) || t(o, l.value[0])) ? [l.value[0], o] : i.value.fixedEnd && (n(o, l.value[1]) || t(o, l.value[1])) ? [o, l.value[1]] : (s("invalid-fixed-range", o), l.value) : [],
    setPresetDate: (o) => {
      Array.isArray(o.value) && o.value.length <= 2 && i.value.enabled ? l.value = o.value.map((u) => a(u)) : Array.isArray(o.value) || (l.value = a(o.value));
    },
    checkRangeAutoApply: (o, u, c) => {
      i && (o[0] && o[1] && r.autoApply && u("auto-apply", c), o[0] && !o[1] && (r.modelAuto || i.value.partialRange) && r.autoApply && u("auto-apply", c));
    },
    setMonthOrYearRange: (o) => {
      let u = l.value ? l.value.slice() : [];
      return u.length === 2 && u[1] !== null && (u = []), u.length ? (n(o, u[0]) ? u.unshift(o) : u[1] = o, s("range-end", o)) : (u = [o], s("range-start", o)), u;
    },
    handleMultiDatesSelect: (o, u) => {
      if (l.value && Array.isArray(l.value))
        if (l.value.some((c) => t(o, c))) {
          const c = l.value.filter((f) => !t(f, o));
          l.value = c.length ? c : null;
        } else (u && +u > l.value.length || !u) && l.value.push(o);
      else
        l.value = [o];
    }
  };
}, oy = (e, n) => {
  const {
    getDate: t,
    rootEmit: a,
    state: s,
    calendars: r,
    year: l,
    modelValue: i,
    rootProps: o,
    defaults: { range: u, highlight: c, safeDates: f, filters: h, multiDates: d }
  } = Ke();
  Vs(() => {
    s.isTextInputDate && G(Be(t(o.startDate)), 0);
  });
  const { checkMinMaxRange: g, checkMinMaxValue: y } = rn(), { isDateBetween: k, resetDateTime: m, resetDate: v, getMinMonth: w, getMaxMonth: S, checkHighlightMonth: x, groupListAndMap: $ } = Rt(), { checkRangeAutoApply: T, getRangeWithFixedDate: _, handleMultiDatesSelect: A, setMonthOrYearRange: D, setPresetDate: Y } = Nr(), { padZero: L } = Dt(), { getMonths: X, isOutOfYearRange: se } = Vr(), ie = C(() => X()), ue = te(null), {
    selectYear: G,
    groupedYears: q,
    showYearPicker: Z,
    toggleYearPicker: N,
    handleYearSelect: ae,
    handleYear: me,
    isDisabled: be,
    setStartDate: pe
  } = Tc(n);
  nt(() => {
    pe();
  });
  const De = (W) => W ? { month: Ze(W), year: Be(W) } : { month: null, year: null }, ge = () => i.value ? Array.isArray(i.value) ? i.value.map((W) => De(W)) : De(i.value) : De(), K = (W, he) => {
    const Oe = r.value[W], Re = ge();
    return Array.isArray(Re) ? Re.some((_e) => _e.year === (Oe == null ? void 0 : Oe.year) && _e.month === he) : (Oe == null ? void 0 : Oe.year) === Re.year && he === Re.month;
  }, ye = (W, he, Oe) => {
    var _e, ze;
    const Re = ge();
    return Array.isArray(Re) ? l.value(he) === ((_e = Re[Oe]) == null ? void 0 : _e.year) && W === ((ze = Re[Oe]) == null ? void 0 : ze.month) : !1;
  }, Me = (W, he) => {
    if (u.value.enabled) {
      const Oe = ge();
      if (Array.isArray(i.value) && Array.isArray(Oe)) {
        const Re = ye(W, he, 0) || ye(W, he, 1), _e = qe(v(t()), { month: W, year: l.value(he) });
        return k(i.value, ue.value, _e) && !Re;
      }
      return !1;
    }
    return !1;
  }, V = C(() => (W) => $(ie.value, (he) => {
    var Nt;
    const Oe = K(W, he.value), Re = y(
      he.value,
      w(l.value(W), f.value.minDate),
      S(l.value(W), f.value.maxDate)
    ) || F(f.value.disabledDates, l.value(W), he.value) || ((Nt = h.value.months) == null ? void 0 : Nt.includes(he.value)) || !le(f.value.allowedDates, l.value(W), he.value) || se(l.value(W)), _e = Me(he.value, W), ze = x(c.value, he.value, l.value(W));
    return { active: Oe, disabled: Re, isBetween: _e, highlighted: ze };
  })), j = (W, he) => qe(v(t()), { month: W, year: l.value(he) }), H = (W, he) => {
    const Oe = i.value ? i.value : v(t());
    i.value = qe(Oe, { month: W, year: l.value(he) }), n("auto-apply"), n("update-flow-step");
  }, I = (W, he) => {
    const Oe = j(W, he);
    u.value.fixedEnd || u.value.fixedStart ? i.value = _(Oe) : i.value ? g(Oe, i.value) && (i.value = D(j(W, he))) : i.value = [j(W, he)], Xe().then(() => {
      T(i.value, n, i.value.length < 2);
    });
  }, B = (W, he) => {
    A(j(W, he), d.value.limit), n("auto-apply", !0);
  }, J = (W, he) => (r.value[he].month = W, ee(he, r.value[he].year, W), d.value.enabled ? B(W, he) : u.value.enabled ? I(W, he) : H(W, he)), R = (W, he) => {
    G(W, he), ee(he, W, null);
  }, ee = (W, he, Oe) => {
    let Re = Oe;
    if (!Re && Re !== 0) {
      const _e = ge();
      Re = Array.isArray(_e) ? _e[W].month : _e.month;
    }
    a("update-month-year", { instance: W, year: he, month: Re });
  }, O = (W, he) => {
    ue.value = j(W, he);
  }, z = (W) => {
    Y({
      value: W
    }), n("auto-apply");
  }, F = (W, he, Oe) => {
    if (W instanceof Map) {
      const Re = `${L(Oe + 1)}-${he}`;
      return W.size ? W.has(Re) : !1;
    }
    return typeof W == "function" ? W(m(qe(t(), { month: Oe, year: he }), !0)) : !1;
  }, le = (W, he, Oe) => {
    if (W instanceof Map) {
      const Re = `${L(Oe + 1)}-${he}`;
      return W.size ? W.has(Re) : !0;
    }
    return !0;
  };
  return {
    groupedMonths: V,
    groupedYears: q,
    year: l,
    isDisabled: be,
    showYearPicker: Z,
    modelValue: i,
    toggleYearPicker: N,
    handleYearSelect: ae,
    handleYear: me,
    presetDate: z,
    setHoverDate: O,
    selectMonth: J,
    selectYear: R,
    getModelMonthYear: ge
  };
}, uy = /* @__PURE__ */ Te({
  __name: "MonthPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply", "update-flow-step", "mount"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, r = Yt(), {
      rootProps: l,
      defaults: { config: i }
    } = Ke(), o = _n(r, gn.YearMode);
    nt(() => {
      a("mount");
    });
    const {
      groupedMonths: u,
      groupedYears: c,
      year: f,
      isDisabled: h,
      showYearPicker: d,
      modelValue: g,
      presetDate: y,
      setHoverDate: k,
      selectMonth: m,
      selectYear: v,
      toggleYearPicker: w,
      handleYearSelect: S,
      handleYear: x,
      getModelMonthYear: $
    } = oy(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: g,
      year: f,
      getModelMonthYear: $,
      selectMonth: m,
      selectYear: v,
      handleYear: x
    }), presetDate: y, toggleYearPicker: (T) => w(0, T) }), (T, _) => (b(), fe(Lr, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: de(({ instances: A, wrapClass: D }) => [
        (b(!0), M(Se, null, Pe(A, (Y) => (b(), M("div", {
          key: Y,
          class: ne(D)
        }, [
          T.$slots["top-extra"] ? U(T.$slots, "top-extra", {
            key: 0,
            value: p(g)
          }) : P("", !0),
          U(T.$slots, "month-year", lt({ ref_for: !0 }, {
            year: p(f),
            months: p(u)(Y),
            years: p(c)(Y),
            selectMonth: p(m),
            selectYear: p(v),
            instance: Y
          }), () => [
            oe(Fs, {
              items: p(u)(Y),
              "is-last": p(l).autoApply && !p(i).keepActionRow,
              height: p(i).modeHeight,
              "no-overlay-focus": !!(e.noOverlayFocus || p(l).textInput),
              "use-relative": "",
              level: 0,
              type: "month",
              onSelected: (L) => p(m)(L, Y),
              onHoverValue: (L) => p(k)(L, Y)
            }, ft({
              header: de(() => [
                oe(Sc, {
                  items: p(c)(Y),
                  instance: Y,
                  "show-year-picker": p(d)[Y],
                  year: p(f)(Y),
                  "is-disabled": (L) => p(h)(Y, L),
                  onHandleYear: (L) => p(x)(Y, L),
                  onYearSelect: (L) => p(S)(L, Y),
                  onToggleYearPicker: (L) => p(w)(Y, L == null ? void 0 : L.flow, L == null ? void 0 : L.show)
                }, ft({ _: 2 }, [
                  Pe(p(o), (L, X) => ({
                    name: L,
                    fn: de((se) => [
                      U(T.$slots, L, lt({ ref_for: !0 }, se))
                    ])
                  }))
                ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
              ]),
              _: 2
            }, [
              T.$slots["month-overlay-value"] ? {
                name: "item",
                fn: de(({ item: L }) => [
                  U(T.$slots, "month-overlay-value", {
                    text: L.text,
                    value: L.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "onSelected", "onHoverValue"])
          ])
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), cy = (e, n) => {
  const {
    rootEmit: t,
    getDate: a,
    state: s,
    modelValue: r,
    rootProps: l,
    defaults: { highlight: i, multiDates: o, filters: u, range: c, safeDates: f }
  } = Ke(), { getYears: h } = Vr(), { isDateBetween: d, resetDate: g, resetDateTime: y, getYearFromDate: k, checkHighlightYear: m, groupListAndMap: v } = Rt(), { checkRangeAutoApply: w, setMonthOrYearRange: S } = Nr(), { checkMinMaxValue: x, checkMinMaxRange: $ } = rn();
  Vs(() => {
    s.isTextInputDate && (_.value = Be(a(l.startDate)));
  });
  const T = te(null), _ = te();
  nt(() => {
    l.startDate && (r.value && l.focusStartDate || !r.value) && (_.value = Be(a(l.startDate)));
  });
  const A = (ie) => Array.isArray(r.value) ? r.value.some((ue) => Be(ue) === ie) : r.value ? Be(r.value) === ie : !1, D = (ie) => c.value.enabled && Array.isArray(r.value) ? d(r.value, T.value, se(ie)) : !1, Y = (ie) => {
    var ue;
    return (ue = f.value.allowedDates) != null && ue.size ? f.value.allowedDates.has(`${ie}`) : !0;
  }, L = (ie) => f.value.disabledDates instanceof Map ? f.value.disabledDates.size ? f.value.disabledDates.has(`${ie}`) : !1 : typeof f.value.disabledDates == "function" ? f.value.disabledDates(hn(y(Na(a())), ie)) : !0, X = C(() => v(h(), (ie) => {
    const ue = A(ie.value), G = x(
      ie.value,
      k(f.value.minDate),
      k(f.value.maxDate)
    ) || u.value.years.includes(ie.value) || !Y(ie.value) || L(ie.value), q = D(ie.value) && !ue, Z = m(i.value, ie.value);
    return { active: ue, disabled: G, isBetween: q, highlighted: Z };
  })), se = (ie) => hn(g(Na(a())), ie);
  return {
    groupedYears: X,
    focusYear: _,
    setHoverValue: (ie) => {
      T.value = hn(g(a()), ie);
    },
    selectYear: (ie) => {
      var ue;
      if (t("update-month-year", { instance: 0, year: ie, month: Number.NaN }), o.value.enabled)
        return r.value ? Array.isArray(r.value) && (((ue = r.value) == null ? void 0 : ue.map((G) => Be(G))).includes(ie) ? r.value = r.value.filter((G) => Be(G) !== ie) : r.value.push(hn(y(a()), ie))) : r.value = [hn(y(Na(a())), ie)], n("auto-apply", !0);
      c.value.enabled ? $(se(ie), r.value) && (r.value = S(se(ie)), Xe().then(() => {
        w(r.value, n, r.value.length < 2);
      })) : (r.value = se(ie), n("auto-apply"));
    }
  };
}, dy = /* @__PURE__ */ Te({
  __name: "YearPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      modelValue: r,
      defaults: { config: l },
      rootProps: i
    } = Ke(), { groupedYears: o, focusYear: u, selectYear: c, setHoverValue: f } = cy(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: r,
      selectYear: c
    }) }), (h, d) => (b(), M("div", null, [
      h.$slots["top-extra"] ? U(h.$slots, "top-extra", {
        key: 0,
        value: p(r)
      }) : P("", !0),
      h.$slots["month-year"] ? U(h.$slots, "month-year", Mt(lt({ key: 1 }, {
        years: p(o),
        selectYear: p(c)
      }))) : (b(), fe(Fs, {
        key: 2,
        items: p(o),
        "is-last": p(i).autoApply && !p(l).keepActionRow,
        height: p(l).modeHeight,
        "no-overlay-focus": !!(e.noOverlayFocus || p(i).textInput),
        "focus-value": p(u),
        type: "year",
        "use-relative": "",
        onSelected: p(c),
        onHoverValue: p(f)
      }, ft({ _: 2 }, [
        h.$slots["year-overlay-value"] ? {
          name: "item",
          fn: de(({ item: g }) => [
            U(h.$slots, "year-overlay-value", {
              text: g.text,
              value: g.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), fy = {
  key: 0,
  class: "dp__time_input"
}, hy = ["data-compact", "data-collapsed"], my = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], vy = ["aria-label", "disabled", "data-dp-action-element", "data-test-id", "onKeydown", "onClick"], py = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], gy = { key: 0 }, yy = ["aria-label", "data-dp-action-element", "data-compact"], by = /* @__PURE__ */ Te({
  __name: "TimeInput",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    order: {},
    closeTimePickerBtn: {},
    disabledTimesConfig: {},
    validateTime: {}
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "overlay-opened", "overlay-closed", "set-hours", "set-minutes", "reset-flow", "mounted"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: r,
      rootEmit: l,
      rootProps: i,
      defaults: { ariaLabels: o, filters: u, config: c, range: f, multiCalendars: h, timeConfig: d }
    } = Ke(), { checkKeyDown: g, hoursToAmPmHours: y } = Dt(), { boolHtmlAttribute: k } = Za(), { sanitizeTime: m, groupListAndMap: v } = Rt(), { transitionName: w, showTransition: S } = Rs(), x = pa({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), $ = te("AM"), T = te(null), _ = te(), A = te(!1);
    nt(() => {
      a("mounted");
    });
    const D = (F) => qe(r(), {
      hours: F.hours,
      minutes: F.minutes,
      seconds: d.value.enableSeconds ? F.seconds : 0,
      milliseconds: 0
    }), Y = C(() => i.timePicker || d.value.timePickerInline ? 0 : 1), L = C(
      () => (F) => De(F, s[F]) || se(F, s[F])
    ), X = C(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), se = (F, le) => f.value.enabled && !f.value.disableTimeRangeValidation ? !s.validateTime(F, le) : !1, ie = (F, le) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const W = le ? +d.value[`${F}Increment`] : -+d.value[`${F}Increment`], he = s[F] + W;
        return !s.validateTime(F, he);
      }
      return !1;
    }, ue = C(() => (F) => !V(+s[F] + +d.value[`${F}Increment`], F) || ie(F, !0)), G = C(() => (F) => !V(+s[F] - +d.value[`${F}Increment`], F) || ie(F, !1)), q = (F, le) => Zu(qe(r(), F), le), Z = (F, le) => Hp(qe(r(), F), le), N = C(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !d.value.timePickerInline,
        dp__time_col_reg_block: !d.value.enableSeconds && d.value.is24 && !d.value.timePickerInline,
        dp__time_col_reg_inline: !d.value.enableSeconds && d.value.is24 && d.value.timePickerInline,
        dp__time_col_reg_with_button: !d.value.enableSeconds && !d.value.is24,
        dp__time_col_sec: d.value.enableSeconds && d.value.is24,
        dp__time_col_sec_with_button: d.value.enableSeconds && !d.value.is24
      })
    ), ae = C(
      () => d.value.timePickerInline && f.value.enabled && !h.value.count
    ), me = C(() => {
      const F = [{ type: "hours" }];
      return d.value.enableMinutes && F.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), d.value.enableSeconds && F.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), F;
    }), be = C(() => me.value.filter((F) => !F.separator)), pe = C(() => (F) => {
      if (F === "hours") {
        const le = R(+s.hours);
        return { text: le < 10 ? `0${le}` : `${le}`, value: le };
      }
      return { text: s[F] < 10 ? `0${s[F]}` : `${s[F]}`, value: s[F] };
    }), De = (F, le) => {
      var he;
      if (!s.disabledTimesConfig) return !1;
      const W = s.disabledTimesConfig(s.order, F === "hours" ? le : void 0);
      return W[F] ? !!((he = W[F]) != null && he.includes(le)) : !0;
    }, ge = (F, le) => le !== "hours" || $.value === "AM" ? F : F + 12, K = (F) => {
      const le = d.value.is24 ? 24 : 12, W = F === "hours" ? le : 60, he = +d.value[`${F}GridIncrement`], Oe = F === "hours" && !d.value.is24 ? he : 0, Re = [];
      for (let _e = Oe; _e < W; _e += he)
        Re.push({
          value: d.value.is24 ? _e : ge(_e, F),
          text: _e < 10 ? `0${_e}` : `${_e}`
        });
      return F === "hours" && !d.value.is24 && Re.unshift({ value: $.value === "PM" ? 12 : 0, text: "12" }), v(Re, (_e) => ({ active: !1, disabled: u.value.times[F].includes(_e.value) || !V(_e.value, F) || De(F, _e.value) || se(F, _e.value) }));
    }, ye = (F) => F >= 0 ? F : 59, Me = (F) => F >= 0 ? F : 23, V = (F, le) => {
      const W = i.minTime ? D(m(i.minTime)) : null, he = i.maxTime ? D(m(i.maxTime)) : null, Oe = D(
        m(
          X.value,
          le,
          le === "minutes" || le === "seconds" ? ye(F) : Me(F)
        )
      );
      return W && he ? (Ln(Oe, he) || Ia(Oe, he)) && (Cn(Oe, W) || Ia(Oe, W)) : W ? Cn(Oe, W) || Ia(Oe, W) : he ? Ln(Oe, he) || Ia(Oe, he) : !0;
    }, j = (F) => d.value[`no${F[0].toUpperCase() + F.slice(1)}Overlay`], H = (F) => {
      j(F) || (x[F] = !x[F], x[F] ? (A.value = !0, a("overlay-opened", F)) : (A.value = !1, a("overlay-closed", F)));
    }, I = (F) => F === "hours" ? In : F === "minutes" ? Nn : na, B = () => {
      _.value && clearTimeout(_.value);
    }, J = (F, le = !0, W) => {
      const he = le ? q : Z, Oe = le ? +d.value[`${F}Increment`] : -+d.value[`${F}Increment`];
      V(+s[F] + Oe, F) && a(
        `update:${F}`,
        I(F)(
          he({ [F]: +s[F] }, { [F]: +d.value[`${F}Increment`] })
        )
      ), !(W != null && W.keyboard) && c.value.timeArrowHoldThreshold && (_.value = setTimeout(() => {
        J(F, le);
      }, c.value.timeArrowHoldThreshold));
    }, R = (F) => d.value.is24 ? F : (F >= 12 ? $.value = "PM" : $.value = "AM", y(F)), ee = () => {
      $.value === "PM" ? ($.value = "AM", a("update:hours", s.hours - 12)) : ($.value = "PM", a("update:hours", s.hours + 12)), l("am-pm-change", $.value);
    }, O = (F) => {
      x[F] = !0;
    }, z = (F, le) => (H(F), a(`update:${F}`, le));
    return n({ openChildCmp: O }), (F, le) => p(i).disabled ? P("", !0) : (b(), M("div", fy, [
      (b(!0), M(Se, null, Pe(me.value, (W, he) => {
        var Oe, Re, _e;
        return b(), M("div", {
          key: he,
          class: ne(N.value),
          "data-compact": ae.value && !p(d).enableSeconds,
          "data-collapsed": ae.value && p(d).enableSeconds
        }, [
          W.separator ? (b(), M(Se, { key: 0 }, [
            A.value ? P("", !0) : (b(), M(Se, { key: 0 }, [
              Ue(":")
            ], 64))
          ], 64)) : (b(), M(Se, { key: 1 }, [
            E("button", {
              type: "button",
              class: ne({
                dp__btn: !0,
                dp__inc_dec_button: !p(d).timePickerInline,
                dp__inc_dec_button_inline: p(d).timePickerInline,
                dp__tp_inline_btn_top: p(d).timePickerInline,
                dp__inc_dec_button_disabled: ue.value(W.type),
                "dp--hidden-el": A.value
              }),
              "data-test-id": `${W.type}-time-inc-btn-${s.order}`,
              "aria-label": (Oe = p(o)) == null ? void 0 : Oe.incrementValue(W.type),
              tabindex: "0",
              "data-dp-action-element": Y.value,
              onKeydown: (ze) => p(g)(ze, () => J(W.type, !0, { keyboard: !0 }), !0),
              onClick: (ze) => p(c).timeArrowHoldThreshold ? void 0 : J(W.type, !0),
              onMousedown: (ze) => p(c).timeArrowHoldThreshold ? J(W.type, !0) : void 0,
              onMouseup: B
            }, [
              p(d).timePickerInline ? U(F.$slots, "tp-inline-arrow-up", { key: 1 }, () => [
                le[2] || (le[2] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                le[3] || (le[3] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : U(F.$slots, "arrow-up", { key: 0 }, () => [
                oe(p(gc))
              ])
            ], 42, my),
            E("button", {
              type: "button",
              "aria-label": `${pe.value(W.type).text}-${(Re = p(o)) == null ? void 0 : Re.openTpOverlay(W.type)}`,
              class: ne({
                dp__time_display: !0,
                dp__time_display_block: !p(d).timePickerInline,
                dp__time_display_inline: p(d).timePickerInline,
                "dp--time-invalid": L.value(W.type),
                "dp--time-overlay-btn": !L.value(W.type),
                "dp--hidden-el": A.value
              }),
              disabled: p(k)(j(W.type)),
              tabindex: "0",
              "data-dp-action-element": Y.value,
              "data-test-id": `${W.type}-toggle-overlay-btn-${s.order}`,
              onKeydown: (ze) => p(g)(ze, () => H(W.type), !0),
              onClick: (ze) => H(W.type)
            }, [
              U(F.$slots, W.type, {
                text: pe.value(W.type).text,
                value: pe.value(W.type).value
              }, () => [
                Ue(ce(pe.value(W.type).text), 1)
              ])
            ], 42, vy),
            E("button", {
              type: "button",
              class: ne({
                dp__btn: !0,
                dp__inc_dec_button: !p(d).timePickerInline,
                dp__inc_dec_button_inline: p(d).timePickerInline,
                dp__tp_inline_btn_bottom: p(d).timePickerInline,
                dp__inc_dec_button_disabled: G.value(W.type),
                "dp--hidden-el": A.value
              }),
              "data-test-id": `${W.type}-time-dec-btn-${s.order}`,
              "aria-label": (_e = p(o)) == null ? void 0 : _e.decrementValue(W.type),
              tabindex: "0",
              "data-dp-action-element": Y.value,
              onKeydown: (ze) => p(g)(ze, () => J(W.type, !1, { keyboard: !0 }), !0),
              onClick: (ze) => p(c).timeArrowHoldThreshold ? void 0 : J(W.type, !1),
              onMousedown: (ze) => p(c).timeArrowHoldThreshold ? J(W.type, !1) : void 0,
              onMouseup: B
            }, [
              p(d).timePickerInline ? U(F.$slots, "tp-inline-arrow-down", { key: 1 }, () => [
                le[4] || (le[4] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                le[5] || (le[5] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : U(F.$slots, "arrow-down", { key: 0 }, () => [
                oe(p(yc))
              ])
            ], 42, py)
          ], 64))
        ], 10, hy);
      }), 128)),
      p(d).is24 ? P("", !0) : (b(), M("div", gy, [
        U(F.$slots, "am-pm-button", {
          toggle: ee,
          value: $.value
        }, () => {
          var W;
          return [
            E("button", {
              ref_key: "amPmButton",
              ref: T,
              type: "button",
              class: "dp__pm_am_button",
              role: "button",
              "aria-label": (W = p(o)) == null ? void 0 : W.amPmButton,
              tabindex: "0",
              "data-dp-action-element": Y.value,
              "data-compact": ae.value,
              onClick: ee,
              onKeydown: le[0] || (le[0] = (he) => p(g)(he, () => ee(), !0))
            }, ce($.value), 41, yy)
          ];
        })
      ])),
      (b(!0), M(Se, null, Pe(be.value, (W, he) => (b(), fe(vt, {
        key: he,
        name: p(w)(x[W.type]),
        css: p(S)
      }, {
        default: de(() => {
          var Oe, Re;
          return [
            x[W.type] ? (b(), fe(Fs, {
              key: 0,
              items: K(W.type),
              "is-last": p(i).autoApply && !p(c).keepActionRow,
              type: W.type,
              "aria-labels": p(o),
              level: p(d).timePickerInline || p(i).timePicker ? 1 : 2,
              "overlay-label": (Re = (Oe = p(o)).timeOverlay) == null ? void 0 : Re.call(Oe, W.type),
              onSelected: (_e) => z(W.type, _e),
              onToggle: (_e) => H(W.type),
              onResetFlow: le[1] || (le[1] = (_e) => F.$emit("reset-flow"))
            }, ft({
              "button-icon": de(() => [
                U(F.$slots, "clock-icon", {}, () => [
                  F.$slots["clock-icon"] ? P("", !0) : (b(), fe(ht(p(d).timePickerInline ? p(As) : p(pc)), { key: 0 }))
                ])
              ]),
              _: 2
            }, [
              F.$slots[`${W.type}-overlay-value`] ? {
                name: "item",
                fn: de(({ item: _e }) => [
                  U(F.$slots, `${W.type}-overlay-value`, {
                    text: _e.text,
                    value: _e.value
                  })
                ]),
                key: "0"
              } : void 0,
              F.$slots[`${W.type}-overlay-header`] ? {
                name: "header",
                fn: de(() => [
                  U(F.$slots, `${W.type}-overlay-header`, {
                    toggle: () => H(W.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "type", "aria-labels", "level", "overlay-label", "onSelected", "onToggle"])) : P("", !0)
          ];
        }),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), wy = ["data-dp-mobile"], ky = ["aria-label", "tabindex"], xy = ["role", "aria-label", "tabindex"], Sy = ["aria-label"], Mc = /* @__PURE__ */ Te({
  __name: "TimePicker",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    disabledTimesConfig: { type: [Function, null] },
    noOverlayFocus: { type: Boolean },
    validateTime: { type: Function }
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "mount", "reset-flow"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: r,
      setState: l,
      modelValue: i,
      rootProps: o,
      defaults: { ariaLabels: u, textInput: c, config: f, range: h, timeConfig: d }
    } = Ke(), { isModelAuto: g } = Rt(), { checkKeyDown: y, findFocusableEl: k } = Dt(), { transitionName: m, showTransition: v } = Rs(), { hideNavigationButtons: w } = Fr(), { isMobile: S } = Rr(), x = Yt(), $ = Qe("overlay"), T = Qe("close-tp-btn"), _ = Qe("tp-input"), A = te(!1);
    nt(() => {
      a("mount");
    });
    const D = C(() => h.value.enabled && o.modelAuto ? g(i.value) : !0), Y = te(!1), L = (pe) => ({
      hours: Array.isArray(s.hours) ? s.hours[pe] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[pe] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[pe] : s.seconds
    }), X = C(() => {
      const pe = [];
      if (h.value.enabled)
        for (let De = 0; De < 2; De++)
          pe.push(L(De));
      else
        pe.push(L(0));
      return pe;
    }), se = (pe, De = !1, ge = "") => {
      De || a("reset-flow"), Y.value = pe, l("arrowNavigationLevel", pe ? 1 : 0), r("overlay-toggle", { open: pe, overlay: Vt.time }), Xe(() => {
        var K;
        ge !== "" && ((K = _.value) != null && K[0]) && _.value[0].openChildCmp(ge);
      });
    }, ie = C(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !f.value.keepActionRow
    })), ue = _n(x, gn.TimeInput), G = (pe, De, ge) => h.value.enabled ? De === 0 ? [pe, X.value[1][ge]] : [X.value[0][ge], pe] : pe, q = (pe) => {
      a("update:hours", pe);
    }, Z = (pe) => {
      a("update:minutes", pe);
    }, N = (pe) => {
      a("update:seconds", pe);
    }, ae = () => {
      if ($.value && !c.value.enabled && !s.noOverlayFocus) {
        const pe = k($.value);
        pe && pe.focus({ preventScroll: !0 });
      }
    }, me = (pe) => {
      A.value = !1, r("overlay-toggle", { open: !1, overlay: pe });
    }, be = (pe) => {
      A.value = !0, r("overlay-toggle", { open: !0, overlay: pe });
    };
    return n({ toggleTimePicker: se }), (pe, De) => {
      var ge;
      return b(), M("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": p(S)
      }, [
        !p(o).timePicker && !p(d).timePickerInline ? mn((b(), M("button", {
          key: 0,
          ref: "open-tp-btn",
          type: "button",
          "data-dp-action-element": "0",
          class: ne({ ...ie.value, "dp--hidden-el": Y.value }),
          "aria-label": (ge = p(u)) == null ? void 0 : ge.openTimePicker,
          tabindex: e.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: De[0] || (De[0] = (K) => p(y)(K, () => se(!0))),
          onClick: De[1] || (De[1] = (K) => se(!0))
        }, [
          U(pe.$slots, "clock-icon", {}, () => [
            oe(p(pc))
          ])
        ], 42, ky)), [
          [Fn, !p(w)("time")]
        ]) : P("", !0),
        oe(vt, {
          name: p(m)(Y.value),
          css: p(v) && !p(d).timePickerInline
        }, {
          default: de(() => {
            var K, ye;
            return [
              Y.value || p(o).timePicker || p(d).timePickerInline ? (b(), M("div", {
                key: 0,
                ref: "overlay",
                role: p(d).timePickerInline ? void 0 : "dialog",
                class: ne({
                  dp__overlay: !p(d).timePickerInline,
                  "dp--overlay-absolute": !p(o).timePicker && !p(d).timePickerInline,
                  "dp--overlay-relative": p(o).timePicker
                }),
                style: Fe(p(o).timePicker ? { height: `${p(f).modeHeight}px` } : void 0),
                "aria-label": (K = p(u)) == null ? void 0 : K.timePicker,
                tabindex: p(d).timePickerInline ? void 0 : 0
              }, [
                E("div", {
                  class: ne(
                    p(d).timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  U(pe.$slots, "time-picker-overlay", {
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: q,
                    setMinutes: Z,
                    setSeconds: N
                  }, () => [
                    E("div", {
                      class: ne(p(d).timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                    }, [
                      (b(!0), M(Se, null, Pe(X.value, (Me, V) => mn((b(), fe(by, lt({ key: V }, { ref_for: !0 }, {
                        order: V,
                        hours: Me.hours,
                        minutes: Me.minutes,
                        seconds: Me.seconds,
                        closeTimePickerBtn: T.value,
                        disabledTimesConfig: e.disabledTimesConfig,
                        disabled: V === 0 ? p(h).fixedStart : p(h).fixedEnd
                      }, {
                        ref_for: !0,
                        ref: "tp-input",
                        "validate-time": (j, H) => e.validateTime(j, G(H, V, j)),
                        "onUpdate:hours": (j) => q(G(j, V, "hours")),
                        "onUpdate:minutes": (j) => Z(G(j, V, "minutes")),
                        "onUpdate:seconds": (j) => N(G(j, V, "seconds")),
                        onMounted: ae,
                        onOverlayClosed: me,
                        onOverlayOpened: be
                      }), ft({ _: 2 }, [
                        Pe(p(ue), (j, H) => ({
                          name: j,
                          fn: de((I) => [
                            U(pe.$slots, j, lt({ ref_for: !0 }, I))
                          ])
                        }))
                      ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                        [Fn, V === 0 ? !0 : D.value]
                      ])), 128))
                    ], 2)
                  ]),
                  !p(o).timePicker && !p(d).timePickerInline ? mn((b(), M("button", {
                    key: 0,
                    ref: "close-tp-btn",
                    "data-dp-action-element": "1",
                    type: "button",
                    class: ne({ ...ie.value, "dp--hidden-el": A.value }),
                    "aria-label": (ye = p(u)) == null ? void 0 : ye.closeTimePicker,
                    tabindex: "0",
                    onKeydown: De[2] || (De[2] = (Me) => p(y)(Me, () => se(!1))),
                    onClick: De[3] || (De[3] = (Me) => se(!1))
                  }, [
                    U(pe.$slots, "calendar-icon", {}, () => [
                      oe(p(As))
                    ])
                  ], 42, Sy)), [
                    [Fn, !p(w)("time")]
                  ]) : P("", !0)
                ], 2)
              ], 14, xy)) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, wy);
    };
  }
}), $c = (e) => {
  const {
    getDate: n,
    modelValue: t,
    time: a,
    rootProps: s,
    defaults: { range: r, timeConfig: l }
  } = Ke(), { isDateEqual: i, setTime: o } = Rt(), u = (T, _) => Array.isArray(a[T]) ? a[T][_] : a[T], c = (T) => l.value.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[T] : a.seconds : 0, f = (T, _) => T ? o(
    _ !== void 0 ? { hours: u("hours", _), minutes: u("minutes", _), seconds: c(_) } : { hours: a.hours, minutes: a.minutes, seconds: c() },
    T
  ) : Yp(n(), c(_)), h = (T, _) => {
    a[T] = _;
  }, d = C(() => s.modelAuto && r.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : r.value.enabled), g = (T, _) => {
    const A = Object.fromEntries(
      Object.keys(a).map((D) => D === T ? [D, _] : [D, a[D]].slice())
    );
    if (d.value && !r.value.disableTimeRangeValidation) {
      const D = (L) => t.value ? o(
        {
          hours: A.hours[L],
          minutes: A.minutes[L],
          seconds: A.seconds[L]
        },
        t.value[L]
      ) : null, Y = (L) => Wp(t.value[L], 0);
      return !(i(D(0), D(1)) && (Cn(D(0), Y(1)) || Ln(D(1), Y(0))));
    }
    return !0;
  }, y = (T, _) => {
    g(T, _) && (h(T, _), e && e());
  }, k = (T) => {
    y("hours", T);
  }, m = (T) => {
    y("minutes", T);
  }, v = (T) => {
    y("seconds", T);
  }, w = (T, _) => {
    k(T.hours), m(T.minutes), v(T.seconds), t.value && _(t.value);
  }, S = (T) => {
    if (T) {
      const _ = Array.isArray(T), A = _ ? [+T[0].hours, +T[1].hours] : +T.hours, D = _ ? [+T[0].minutes, +T[1].minutes] : +T.minutes, Y = _ ? [+(T[0].seconds ?? 0), +(T[1].seconds ?? 0)] : +(T.seconds ?? 0);
      h("hours", A), h("minutes", D), l.value.enableSeconds && h("seconds", Y);
    }
  }, x = (T, _) => {
    const A = {
      hours: Array.isArray(a.hours) ? a.hours[T] : a.hours,
      disabledArr: []
    };
    return (_ || _ === 0) && (A.hours = _), Array.isArray(s.disabledTimes) && (A.disabledArr = r.value.enabled && Array.isArray(s.disabledTimes[T]) ? s.disabledTimes[T] : s.disabledTimes), A;
  }, $ = C(() => (T, _) => {
    var A;
    if (Array.isArray(s.disabledTimes)) {
      const { disabledArr: D, hours: Y } = x(T, _), L = D.filter((X) => +X.hours === Y);
      return ((A = L[0]) == null ? void 0 : A.minutes) === "*" ? { hours: [Y], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (L == null ? void 0 : L.map((X) => +X.minutes)) ?? [],
        seconds: (L == null ? void 0 : L.map((X) => X.seconds ? +X.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    assignTime: h,
    updateHours: k,
    updateMinutes: m,
    updateSeconds: v,
    getSetDateTime: f,
    updateTimeValues: w,
    getSecondsValue: c,
    assignStartTime: S,
    validateTime: g,
    disabledTimesConfig: $
  };
}, Ty = (e) => {
  const {
    getDate: n,
    time: t,
    modelValue: a,
    state: s,
    defaults: { startTime: r, range: l, timeConfig: i }
  } = Ke(), { getTimeObj: o } = Rt();
  Vs(() => {
    s.isTextInputDate && x();
  });
  const { updateTimeValues: u, getSetDateTime: c, assignTime: f, assignStartTime: h, disabledTimesConfig: d, validateTime: g } = $c(y);
  function y() {
    e("update-flow-step");
  }
  const k = (T) => {
    const { hours: _, minutes: A, seconds: D } = T;
    return { hours: +_, minutes: +A, seconds: D ? +D : 0 };
  }, m = () => {
    if (i.value.startTime) {
      if (Array.isArray(i.value.startTime)) {
        const _ = k(i.value.startTime[0]), A = k(i.value.startTime[1]);
        return [qe(n(), _), qe(n(), A)];
      }
      const T = k(i.value.startTime);
      return qe(n(), T);
    }
    return l.value.enabled ? [null, null] : null;
  }, v = () => {
    if (l.value.enabled) {
      const [T, _] = m();
      a.value = [c(T, 0), c(_, 1)];
    } else
      a.value = c(m());
  }, w = (T) => Array.isArray(T) ? [o(n(T[0])), o(n(T[1]))] : [o(T ?? n())], S = (T, _, A) => {
    f("hours", T), f("minutes", _), f("seconds", i.value.enableSeconds ? A : 0);
  }, x = () => {
    const [T, _] = w(a.value);
    return l.value.enabled ? S(
      [T.hours, _.hours],
      [T.minutes, _.minutes],
      [T.seconds, _.seconds]
    ) : S(T.hours, T.minutes, T.seconds);
  };
  nt(() => (h(r.value), a.value ? x() : v()));
  const $ = () => {
    Array.isArray(a.value) ? a.value = a.value.map((T, _) => T && c(T, _)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: t,
    disabledTimesConfig: d,
    validateTime: g,
    updateTime: (T) => {
      u(T, $);
    }
  };
}, My = /* @__PURE__ */ Te({
  __name: "TimePickerSolo",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["time-update", "mount", "reset-flow", "update-flow-step"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Yt(), r = _n(s, gn.TimePicker), l = Qe("time-input"), { time: i, modelValue: o, disabledTimesConfig: u, updateTime: c, validateTime: f } = Ty(a);
    return nt(() => {
      a("mount");
    }), n({ getSidebarProps: () => ({
      modelValue: o,
      time: i,
      updateTime: c
    }), toggleTimePicker: (h, d = !1, g = "") => {
      var y;
      (y = l.value) == null || y.toggleTimePicker(h, d, g);
    } }), (h, d) => (b(), fe(Lr, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: de(({ wrapClass: g }) => [
        E("div", {
          class: ne(g)
        }, [
          oe(Mc, lt({ ref: "time-input" }, h.$props, {
            hours: p(i).hours,
            minutes: p(i).minutes,
            seconds: p(i).seconds,
            "disabled-times-config": p(u),
            "validate-time": p(f),
            "onUpdate:hours": d[0] || (d[0] = (y) => p(c)({ hours: y, minutes: p(i).minutes, seconds: p(i).seconds })),
            "onUpdate:minutes": d[1] || (d[1] = (y) => p(c)({ hours: p(i).hours, minutes: y, seconds: p(i).seconds })),
            "onUpdate:seconds": d[2] || (d[2] = (y) => p(c)({ hours: p(i).hours, minutes: p(i).minutes, seconds: y })),
            onResetFlow: d[3] || (d[3] = (y) => h.$emit("reset-flow"))
          }), ft({ _: 2 }, [
            Pe(p(r), (y, k) => ({
              name: y,
              fn: de((m) => [
                U(h.$slots, y, Mt(Ft(m)))
              ])
            }))
          ]), 1040, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time"])
        ], 2)
      ]),
      _: 3
    }));
  }
}), $y = (e, n) => {
  const {
    getDate: t,
    rootProps: a,
    defaults: { filters: s }
  } = Ke(), { validateMonthYearInRange: r, validateMonthYear: l } = rn(), i = (h, d) => {
    let g = h;
    return s.value.months.includes(Ze(g)) ? (g = d ? vn(h, 1) : ja(h, 1), i(g, d)) : g;
  }, o = (h, d) => {
    let g = h;
    return s.value.years.includes(Be(g)) ? (g = d ? ci(h, 1) : fc(h, 1), o(g, d)) : g;
  }, u = (h, d = !1) => {
    const g = qe(t(), { month: e.month, year: e.year });
    let y = h ? vn(g, 1) : ja(g, 1);
    a.disableYearSelect && (y = hn(y, e.year));
    let k = Ze(y), m = Be(y);
    s.value.months.includes(k) && (y = i(y, h), k = Ze(y), m = Be(y)), s.value.years.includes(m) && (y = o(y, h), m = Be(y)), r(k, m, h, a.preventMinMaxNavigation) && c(k, m, d);
  }, c = (h, d, g = !1) => {
    n("update-month-year", { month: h, year: d, fromNav: g });
  }, f = C(() => (h) => l(
    qe(t(), { month: e.month, year: e.year }),
    a.preventMinMaxNavigation,
    h
  ));
  return { handleMonthYearChange: u, isDisabled: f, updateMonthYear: c };
}, Cy = { class: "dp--header-wrap" }, Dy = {
  key: 0,
  class: "dp__month_year_wrap"
}, Oy = { key: 0 }, _y = { class: "dp__month_year_wrap" }, Ey = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], Iy = /* @__PURE__ */ Te({
  __name: "DpHeader",
  props: {
    month: {},
    year: {},
    instance: {},
    years: {},
    months: {},
    menuWrapRef: {}
  },
  emits: ["mount", "reset-flow", "update-month-year"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: r,
      rootProps: l,
      modelValue: i,
      defaults: { ariaLabels: o, filters: u, config: c, highlight: f, safeDates: h, ui: d }
    } = Ke(), { transitionName: g, showTransition: y } = Rs(), { showLeftIcon: k, showRightIcon: m } = Fr(), { handleMonthYearChange: v, isDisabled: w, updateMonthYear: S } = $y(s, a), { getMaxMonth: x, getMinMonth: $, getYearFromDate: T, groupListAndMap: _, checkHighlightYear: A, checkHighlightMonth: D } = Rt(), { checkKeyDown: Y } = Dt(), { formatYear: L } = aa(), { checkMinMaxValue: X } = rn(), { boolHtmlAttribute: se } = Za(), ie = te(!1), ue = te(!1), G = te(!1);
    nt(() => {
      a("mount");
    });
    const q = (j) => ({
      get: () => s[j],
      set: (H) => {
        const I = j === dn.month ? dn.year : dn.month;
        a("update-month-year", { [j]: H, [I]: s[I] }), j === dn.month ? ge(!0) : K(!0);
      }
    }), Z = C(q(dn.month)), N = C(q(dn.year)), ae = C(() => (j) => ({
      month: s.month,
      year: s.year,
      items: j === dn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: S,
      toggle: j === dn.month ? ge : K
    })), me = C(() => s.months.find((H) => H.value === s.month) || { text: "", value: 0 }), be = C(() => _(s.months, (j) => {
      const H = s.month === j.value, I = X(
        j.value,
        $(s.year, h.value.minDate),
        x(s.year, h.value.maxDate)
      ) || u.value.months.includes(j.value), B = D(f.value, j.value, s.year);
      return { active: H, disabled: I, highlighted: B };
    })), pe = C(() => _(s.years, (j) => {
      const H = s.year === j.value, I = X(
        j.value,
        T(h.value.minDate),
        T(h.value.maxDate)
      ) || u.value.years.includes(j.value), B = A(f.value, j.value);
      return { active: H, disabled: I, highlighted: B };
    })), De = (j, H, I) => {
      I === void 0 ? j.value = !j.value : j.value = I, j.value ? (G.value = !0, r("overlay-toggle", { open: !0, overlay: H })) : (G.value = !1, r("overlay-toggle", { open: !1, overlay: H }));
    }, ge = (j = !1, H) => {
      ye(j), De(ie, Vt.month, H);
    }, K = (j = !1, H) => {
      ye(j), De(ue, Vt.year, H);
    }, ye = (j) => {
      j || a("reset-flow");
    }, Me = C(() => {
      var j, H, I, B, J, R;
      return [
        {
          type: dn.month,
          index: 1,
          toggle: ge,
          modelValue: Z.value,
          updateModelValue: (ee) => Z.value = ee,
          text: me.value.text,
          showSelectionGrid: ie.value,
          items: be.value,
          ariaLabel: (j = o.value) == null ? void 0 : j.openMonthsOverlay,
          overlayLabel: ((I = (H = o.value).monthPicker) == null ? void 0 : I.call(H, !0)) ?? void 0
        },
        {
          type: dn.year,
          index: 2,
          toggle: K,
          modelValue: N.value,
          updateModelValue: (ee) => N.value = ee,
          text: L(s.year),
          showSelectionGrid: ue.value,
          items: pe.value,
          ariaLabel: (B = o.value) == null ? void 0 : B.openYearsOverlay,
          overlayLabel: ((R = (J = o.value).yearPicker) == null ? void 0 : R.call(J, !0)) ?? void 0
        }
      ];
    }), V = C(() => l.disableYearSelect ? [Me.value[0]] : l.yearFirst ? [...Me.value].reverse() : Me.value);
    return n({
      toggleMonthPicker: ge,
      toggleYearPicker: K,
      handleMonthYearChange: v
    }), (j, H) => {
      var I, B, J, R, ee, O;
      return b(), M("div", Cy, [
        j.$slots["month-year"] ? (b(), M("div", Dy, [
          U(j.$slots, "month-year", Mt(Ft({
            month: e.month,
            year: e.year,
            months: e.months,
            years: e.years,
            updateMonthYear: p(S),
            handleMonthYearChange: p(v),
            instance: e.instance,
            isDisabled: p(w)
          })))
        ])) : (b(), M(Se, { key: 1 }, [
          j.$slots["top-extra"] ? (b(), M("div", Oy, [
            U(j.$slots, "top-extra", { value: p(i) })
          ])) : P("", !0),
          E("div", _y, [
            p(k)(e.instance) && !p(l).vertical ? (b(), fe(ws, {
              key: 0,
              "aria-label": (I = p(o)) == null ? void 0 : I.prevMonth,
              disabled: p(se)(p(w)(!1)),
              class: ne((B = p(d)) == null ? void 0 : B.navBtnPrev),
              "el-name": "action-prev",
              onActivate: H[0] || (H[0] = (z) => p(v)(!1, !0))
            }, {
              default: de(() => [
                j.$slots["arrow-left"] ? U(j.$slots, "arrow-left", { key: 0 }) : P("", !0),
                j.$slots["arrow-left"] ? P("", !0) : (b(), fe(p(mc), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
            E("div", {
              class: ne(["dp__month_year_wrap", {
                dp__year_disable_select: p(l).disableYearSelect
              }])
            }, [
              (b(!0), M(Se, null, Pe(V.value, (z) => (b(), M(Se, {
                key: z.type
              }, [
                E("button", {
                  type: "button",
                  "data-dp-element": `overlay-${z.type}`,
                  class: ne(["dp__btn dp__month_year_select", { "dp--hidden-el": G.value }]),
                  "aria-label": `${z.text}-${z.ariaLabel}`,
                  "data-test-id": `${z.type}-toggle-overlay-${e.instance}`,
                  tabindex: "0",
                  "data-dp-action-element": "0",
                  onClick: (F) => z.toggle(!1),
                  onKeydown: (F) => p(Y)(F, () => z.toggle(), !0)
                }, [
                  j.$slots[z.type] ? U(j.$slots, z.type, {
                    key: 0,
                    text: z.text,
                    value: s[z.type]
                  }) : P("", !0),
                  j.$slots[z.type] ? P("", !0) : (b(), M(Se, { key: 1 }, [
                    Ue(ce(z.text), 1)
                  ], 64))
                ], 42, Ey),
                oe(vt, {
                  name: p(g)(z.showSelectionGrid),
                  css: p(y)
                }, {
                  default: de(() => [
                    z.showSelectionGrid ? (b(), fe(Fs, {
                      key: 0,
                      items: z.items,
                      "is-last": p(l).autoApply && !p(c).keepActionRow,
                      "skip-button-ref": !1,
                      type: z.type,
                      "header-refs": [],
                      "menu-wrap-ref": e.menuWrapRef,
                      "overlay-label": z.overlayLabel,
                      onSelected: z.updateModelValue,
                      onToggle: z.toggle
                    }, ft({
                      "button-icon": de(() => [
                        j.$slots["calendar-icon"] ? U(j.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                        j.$slots["calendar-icon"] ? P("", !0) : (b(), fe(p(As), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      j.$slots[`${z.type}-overlay-value`] ? {
                        name: "item",
                        fn: de(({ item: F }) => [
                          U(j.$slots, `${z.type}-overlay-value`, {
                            text: F.text,
                            value: F.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      j.$slots[`${z.type}-overlay`] ? {
                        name: "overlay",
                        fn: de(() => [
                          U(j.$slots, `${z.type}-overlay`, lt({ ref_for: !0 }, ae.value(z.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      j.$slots[`${z.type}-overlay-header`] ? {
                        name: "header",
                        fn: de(() => [
                          U(j.$slots, `${z.type}-overlay-header`, {
                            toggle: z.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "is-last", "type", "menu-wrap-ref", "overlay-label", "onSelected", "onToggle"])) : P("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            p(k)(e.instance) && p(l).vertical ? (b(), fe(ws, {
              key: 1,
              "aria-label": (J = p(o)) == null ? void 0 : J.prevMonth,
              "el-name": "action-prev",
              disabled: p(se)(p(w)(!1)),
              class: ne((R = p(d)) == null ? void 0 : R.navBtnPrev),
              onActivate: H[1] || (H[1] = (z) => p(v)(!1, !0))
            }, {
              default: de(() => [
                j.$slots["arrow-up"] ? U(j.$slots, "arrow-up", { key: 0 }) : P("", !0),
                j.$slots["arrow-up"] ? P("", !0) : (b(), fe(p(gc), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
            p(m)(e.instance) ? (b(), fe(ws, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: p(se)(p(w)(!0)),
              "aria-label": (ee = p(o)) == null ? void 0 : ee.nextMonth,
              class: ne((O = p(d)) == null ? void 0 : O.navBtnNext),
              onActivate: H[2] || (H[2] = (z) => p(v)(!0, !0))
            }, {
              default: de(() => [
                j.$slots[p(l).vertical ? "arrow-down" : "arrow-right"] ? U(j.$slots, p(l).vertical ? "arrow-down" : "arrow-right", { key: 0 }) : P("", !0),
                j.$slots[p(l).vertical ? "arrow-down" : "arrow-right"] ? P("", !0) : (b(), fe(ht(p(l).vertical ? p(yc) : p(vc)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : P("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), Py = {
  class: "dp__calendar_header",
  role: "row"
}, Ay = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, Ry = ["aria-label"], Vy = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, Fy = { class: "dp__cell_inner" }, Ly = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "data-dp-element-active", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], Ny = /* @__PURE__ */ Te({
  __name: "DpCalendar",
  props: {
    instance: {},
    mappedDates: {},
    month: {},
    year: {}
  },
  emits: ["mount", "select-date", "set-hover-date", "handle-scroll", "handle-swipe"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: r,
      rootEmit: l,
      rootProps: i,
      defaults: { transitions: o, config: u, ariaLabels: c, multiCalendars: f, weekNumbers: h, multiDates: d, ui: g }
    } = Ke(), { isDateAfter: y, isDateEqual: k, resetDateTime: m, getCellId: v } = Rt(), { checkKeyDown: w, checkStopPropagation: S, isTouchDevice: x } = Dt(), { formatWeekDay: $ } = aa(), T = Qe("calendar-wrap"), _ = Qe("active-tooltip"), A = te([]), D = te(null), Y = te(!0), L = te(!1), X = te(""), se = te({
      bottom: "",
      left: "",
      transform: ""
    }), ie = te({ left: "50%" });
    Bh(T, {
      onSwipeEnd: (O, z) => {
        u.value.noSwipe || (i.vertical ? (z === "up" || z === "down") && a("handle-swipe", z === "up" ? "left" : "right") : (z === "left" || z === "right") && a("handle-swipe", z === "right" ? "left" : "right"));
      }
    });
    const ue = C(() => i.calendar ? i.calendar(s.mappedDates) : s.mappedDates), G = C(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames() : ee());
    nt(() => {
      a("mount", { cmp: "calendar", dayRefs: A.value }), u.value.monthChangeOnScroll && T.value && T.value.addEventListener("wheel", j, { passive: !1 });
    }), sn(() => {
      u.value.monthChangeOnScroll && T.value && T.value.removeEventListener("wheel", j);
    });
    const q = (O) => O ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", Z = (O, z) => {
      if (i.transitions) {
        const F = m(qe(r(), { month: s.month, year: s.year }));
        X.value = y(m(qe(r(), { month: O, year: z })), F) ? o.value[q(!0)] : o.value[q(!1)], Y.value = !1, Xe(() => {
          Y.value = !0;
        });
      }
    }, N = C(
      () => ({
        ...g.value.calendar
      })
    ), ae = (O) => ({ type: "dot", ...O }), me = C(() => (O) => {
      const z = ae(O);
      return {
        dp__marker_dot: z.type === "dot",
        dp__marker_line: z.type === "line"
      };
    }), be = C(() => (O) => k(O, D.value)), pe = C(() => ({
      dp__calendar: !0,
      dp__calendar_next: f.value.count > 0 && s.instance !== 0
    })), De = C(() => (O) => i.hideOffsetDates ? O.current : !0), ge = async (O, z) => {
      var Oe;
      const { width: F, height: le } = O.getBoundingClientRect();
      D.value = z.value;
      let W = { left: `${F / 2}px` }, he = -50;
      if (await Xe(), (Oe = _.value) == null ? void 0 : Oe[0]) {
        const { left: Re, width: _e } = _.value[0].getBoundingClientRect();
        Re < 0 && (W = { left: "0" }, he = 0, ie.value.left = `${F / 2}px`), globalThis.innerWidth < Re + _e && (W = { right: "0" }, he = 0, ie.value.left = `${_e - F / 2}px`);
      }
      se.value = {
        bottom: `${le}px`,
        ...W,
        transform: `translateX(${he}%)`
      };
    }, K = async (O, z, F) => {
      var W, he, Oe, Re, _e;
      const le = jt((he = (W = A.value) == null ? void 0 : W[z]) == null ? void 0 : he[F]);
      le && ((Oe = O.marker) != null && Oe.customPosition && ((_e = (Re = O.marker) == null ? void 0 : Re.tooltip) != null && _e.length) ? se.value = O.marker.customPosition(le) : await ge(le, O), l("tooltip-open", O.marker));
    }, ye = async (O, z, F) => {
      var le, W;
      if (L.value && d.value.enabled && d.value.dragSelect)
        return a("select-date", O);
      if (a("set-hover-date", O), (W = (le = O.marker) == null ? void 0 : le.tooltip) == null ? void 0 : W.length) {
        if (i.hideOffsetDates && !O.current) return;
        await K(O, z, F);
      }
    }, Me = (O) => {
      D.value && (D.value = null, se.value = structuredClone({ bottom: "", left: "", transform: "" }), l("tooltip-close", O.marker));
    }, V = (O, z, F) => {
      O && (Array.isArray(A.value[z]) ? A.value[z][F] = O : A.value[z] = [O]);
    }, j = (O) => {
      u.value.monthChangeOnScroll && (O.preventDefault(), a("handle-scroll", O));
    }, H = (O) => h.value ? h.value.type === "local" ? vi(O.value, {
      weekStartsOn: +i.weekStart,
      locale: i.locale
    }) : h.value.type === "iso" ? hi(O.value) : typeof h.value.type == "function" ? h.value.type(O.value) : "" : "", I = (O) => {
      var F;
      const z = O[0];
      return (F = h.value) != null && F.hideOnOffsetDates ? O.some((le) => le.current) ? H(z) : "" : H(z);
    }, B = (O, z, F = !0) => {
      !F && x() || (!d.value.enabled || u.value.allowPreventDefault) && (S(O, u.value), a("select-date", z));
    }, J = (O) => {
      S(O, u.value);
    }, R = (O) => {
      d.value.enabled && d.value.dragSelect ? (L.value = !0, a("select-date", O)) : d.value.enabled && a("select-date", O);
    }, ee = () => {
      const O = r(), z = an(O, { locale: i.locale, weekStartsOn: +i.weekStart }), F = fi(O, { locale: i.locale, weekStartsOn: +i.weekStart });
      return di({ start: z, end: F }).map((le) => $(le));
    };
    return n({ triggerTransition: Z }), (O, z) => (b(), M("div", {
      class: ne(pe.value)
    }, [
      E("div", {
        ref: "calendar-wrap",
        class: ne(N.value),
        role: "grid"
      }, [
        E("div", Py, [
          p(h) ? (b(), M("div", Ay, ce(p(h).label), 1)) : P("", !0),
          (b(!0), M(Se, null, Pe(G.value, (F, le) => {
            var W, he;
            return b(), M("div", {
              key: le,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (he = (W = p(c)) == null ? void 0 : W.weekDay) == null ? void 0 : he.call(W, le)
            }, [
              U(O.$slots, "calendar-header", {
                day: F,
                index: le
              }, () => [
                Ue(ce(F), 1)
              ])
            ], 8, Ry);
          }), 128))
        ]),
        z[2] || (z[2] = E("div", { class: "dp__calendar_header_separator" }, null, -1)),
        oe(vt, {
          name: X.value,
          css: !!p(o)
        }, {
          default: de(() => [
            Y.value ? (b(), M("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: z[1] || (z[1] = (F) => L.value = !1)
            }, [
              (b(!0), M(Se, null, Pe(ue.value, (F, le) => (b(), M("div", {
                key: le,
                class: "dp__calendar_row",
                role: "row"
              }, [
                p(h) ? (b(), M("div", Vy, [
                  E("div", Fy, ce(I(F.days)), 1)
                ])) : P("", !0),
                (b(!0), M(Se, null, Pe(F.days, (W, he) => {
                  var Oe, Re, _e;
                  return b(), M("div", {
                    id: p(v)(W.value),
                    ref_for: !0,
                    ref: (ze) => V(ze, le, he),
                    key: he + le,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-selected": (W.classData.dp__active_date || W.classData.dp__range_start || W.classData.dp__range_end) ?? void 0,
                    "aria-disabled": W.classData.dp__cell_disabled || void 0,
                    "aria-label": (Re = (Oe = p(c)) == null ? void 0 : Oe.day) == null ? void 0 : Re.call(Oe, W),
                    tabindex: !W.current && p(i).hideOffsetDates ? void 0 : 0,
                    "data-test-id": p(v)(W.value),
                    "data-dp-element-active": W.classData.dp__active_date ? 0 : void 0,
                    "data-dp-action-element": "0",
                    onClick: Ve((ze) => B(ze, W), ["prevent"]),
                    onTouchend: (ze) => B(ze, W, !1),
                    onKeydown: (ze) => p(w)(ze, () => O.$emit("select-date", W)),
                    onMouseenter: (ze) => ye(W, le, he),
                    onMouseleave: (ze) => Me(W),
                    onMousedown: (ze) => R(W),
                    onMouseup: z[0] || (z[0] = (ze) => L.value = !1)
                  }, [
                    E("div", {
                      class: ne(["dp__cell_inner", W.classData])
                    }, [
                      O.$slots.day && De.value(W) ? U(O.$slots, "day", {
                        key: 0,
                        day: +W.text,
                        date: W.value
                      }) : P("", !0),
                      O.$slots.day ? P("", !0) : (b(), M(Se, { key: 1 }, [
                        Ue(ce(W.text), 1)
                      ], 64)),
                      W.marker && De.value(W) ? U(O.$slots, "marker", {
                        key: 2,
                        marker: W.marker,
                        day: +W.text,
                        date: W.value
                      }, () => [
                        E("div", {
                          class: ne(me.value(W.marker)),
                          style: Fe(W.marker.color ? { backgroundColor: W.marker.color } : {})
                        }, null, 6)
                      ]) : P("", !0),
                      be.value(W.value) ? (b(), M("div", {
                        key: 3,
                        ref_for: !0,
                        ref: "active-tooltip",
                        class: "dp__marker_tooltip",
                        style: Fe(se.value)
                      }, [
                        (_e = W.marker) != null && _e.tooltip ? (b(), M("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: J
                        }, [
                          (b(!0), M(Se, null, Pe(W.marker.tooltip, (ze, Nt) => (b(), M("div", {
                            key: Nt,
                            class: "dp__tooltip_text"
                          }, [
                            U(O.$slots, "marker-tooltip", {
                              tooltip: ze,
                              day: W.value
                            }, () => [
                              E("div", {
                                class: "dp__tooltip_mark",
                                style: Fe(ze.color ? { backgroundColor: ze.color } : {})
                              }, null, 4),
                              E("div", null, ce(ze.text), 1)
                            ])
                          ]))), 128)),
                          E("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Fe(ie.value)
                          }, null, 4)
                        ])) : P("", !0)
                      ], 4)) : P("", !0)
                    ], 2)
                  ], 40, Ly);
                }), 128))
              ]))), 128))
            ], 32)) : P("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), By = (e, n, t, a) => {
  const s = te([]), r = te(/* @__PURE__ */ new Date()), l = te(), {
    getDate: i,
    rootEmit: o,
    calendars: u,
    month: c,
    year: f,
    time: h,
    modelValue: d,
    rootProps: g,
    today: y,
    state: k,
    defaults: { multiCalendars: m, startTime: v, range: w, config: S, safeDates: x, multiDates: $, timeConfig: T, flow: _ }
  } = Ke(), { validateMonthYearInRange: A, isDisabled: D, isDateRangeAllowed: Y, checkMinMaxRange: L } = rn(), { updateTimeValues: X, getSetDateTime: se, assignTime: ie, assignStartTime: ue, validateTime: G, disabledTimesConfig: q } = $c(a), { formatDay: Z } = aa(), { resetDateTime: N, setTime: ae, isDateBefore: me, isDateEqual: be, getDaysInBetween: pe } = Rt(), { checkRangeAutoApply: De, getRangeWithFixedDate: ge, handleMultiDatesSelect: K, setPresetDate: ye } = Nr(), { getMapDate: Me } = Dt();
  Vs(() => R(k.isTextInputDate));
  const V = (Q) => !S.value.keepViewOnOffsetClick || Q ? !0 : !l.value, j = (Q, ve, Ae, We = !1) => {
    var st, Ht, on;
    V(We) && ((st = u.value)[Q] ?? (st[Q] = u.value[Q] = { month: 0, year: 0 }), u.value[Q].month = ve ?? ((Ht = u.value[Q]) == null ? void 0 : Ht.month), u.value[Q].year = Ae ?? ((on = u.value[Q]) == null ? void 0 : on.year));
  }, H = () => {
    g.autoApply && n("select-date");
  }, I = () => {
    v.value && ue(v.value);
  };
  nt(() => {
    d.value || (Nt(), I()), R(!0), g.focusStartDate && g.startDate && Nt();
  });
  const B = C(() => {
    var Q, ve, Ae;
    return (ve = (Q = _.value) == null ? void 0 : Q.steps) != null && ve.length && !((Ae = _.value) != null && Ae.partial) ? e.flowStep === _.value.steps.length : !0;
  }), J = () => {
    var Q, ve, Ae;
    g.autoApply && B.value && n("auto-apply", (Q = _.value) != null && Q.partial ? e.flowStep !== ((Ae = (ve = _.value) == null ? void 0 : ve.steps) == null ? void 0 : Ae.length) : !1);
  }, R = (Q = !1) => {
    if (d.value)
      return Array.isArray(d.value) ? (s.value = d.value, Oe(Q)) : F(d.value, Q);
    if (m.value.count && Q && !g.startDate)
      return z(i(), Q);
  }, ee = () => Array.isArray(d.value) && w.value.enabled ? Ze(d.value[0]) === Ze(d.value[1] ?? d.value[0]) : !1, O = (Q) => {
    const ve = vn(Q, 1);
    return { month: Ze(ve), year: Be(ve) };
  }, z = (Q = i(), ve = !1) => {
    if ((!m.value.count || !m.value.static || ve) && j(0, Ze(Q), Be(Q)), m.value.count && (!d.value || ee() || !m.value.solo) && (!m.value.solo || ve))
      for (let Ae = 1; Ae < m.value.count; Ae++) {
        const We = qe(i(), { month: c.value(Ae - 1), year: f.value(Ae - 1) }), st = Zu(We, { months: 1 });
        u.value[Ae] = { month: Ze(st), year: Be(st) };
      }
  }, F = (Q, ve) => {
    z(Q), ie("hours", In(Q)), ie("minutes", Nn(Q)), ie("seconds", na(Q)), m.value.count && ve && ze();
  }, le = (Q) => {
    if (m.value.count) {
      if (m.value.solo) return 0;
      const ve = Ze(Q[0]), Ae = Ze(Q[1]);
      return Math.abs(Ae - ve) < m.value.count ? 0 : 1;
    }
    return 1;
  }, W = (Q, ve) => {
    Q[1] && w.value.showLastInRange ? z(Q[le(Q)], ve) : z(Q[0], ve);
    const Ae = (We, st) => [
      We(Q[0]),
      Q != null && Q[1] ? We(Q[1]) : h[st][1]
    ];
    ie("hours", Ae(In, "hours")), ie("minutes", Ae(Nn, "minutes")), ie("seconds", Ae(na, "seconds"));
  }, he = (Q, ve) => {
    if ((w.value.enabled || g.weekPicker) && !$.value.enabled)
      return W(Q, ve);
    if ($.value.enabled && ve) {
      const Ae = Q[Q.length - 1];
      return F(Ae, ve);
    }
  }, Oe = (Q) => {
    const ve = d.value;
    he(ve, Q), m.value.count && m.value.solo && ze();
  }, Re = (Q, ve) => {
    const Ae = qe(i(), { month: c.value(ve), year: f.value(ve) }), We = Q < 0 ? vn(Ae, 1) : ja(Ae, 1);
    A(Ze(We), Be(We), Q < 0, g.preventMinMaxNavigation) && (j(ve, Ze(We), Be(We)), o("update-month-year", { instance: ve, month: Ze(We), year: Be(We) }), m.value.count && !m.value.solo && _e(ve), t());
  }, _e = (Q) => {
    for (let ve = Q - 1; ve >= 0; ve--) {
      const Ae = ja(qe(i(), { month: c.value(ve + 1), year: f.value(ve + 1) }), 1);
      j(ve, Ze(Ae), Be(Ae));
    }
    for (let ve = Q + 1; ve <= m.value.count - 1; ve++) {
      const Ae = vn(qe(i(), { month: c.value(ve - 1), year: f.value(ve - 1) }), 1);
      j(ve, Ze(Ae), Be(Ae));
    }
  }, ze = () => {
    if (Array.isArray(d.value) && d.value.length === 2) {
      const Q = i(i(d.value[1] ?? vn(d.value[0], 1))), [ve, Ae] = [Ze(d.value[0]), Be(d.value[0])], [We, st] = [Ze(d.value[1]), Be(d.value[1])];
      (ve !== We || ve === We && Ae !== st) && m.value.solo && j(1, Ze(Q), Be(Q));
    } else d.value && !Array.isArray(d.value) && (j(0, Ze(d.value), Be(d.value)), z(i()));
  }, Nt = () => {
    g.startDate && (j(0, Ze(i(g.startDate)), Be(i(g.startDate))), m.value.count && _e(0));
  }, Ot = (Q, ve) => {
    if (S.value.monthChangeOnScroll) {
      const Ae = Date.now() - r.value.getTime(), We = Math.abs(Q.deltaY);
      let st = 500;
      We > 1 && (st = 100), We > 100 && (st = 0), Ae > st && (r.value = /* @__PURE__ */ new Date(), Re(
        S.value.monthChangeOnScroll === "inverse" ? Q.deltaY : -Q.deltaY,
        ve
      ));
    }
  }, Bt = (Q, ve, Ae = !1) => {
    S.value.monthChangeOnArrows && g.vertical === Ae && kn(Q, ve);
  }, kn = (Q, ve) => {
    Re(Q === "right" ? -1 : 1, ve);
  }, Wn = (Q) => {
    if (x.value.markers)
      return Me(Q.value, x.value.markers);
  }, _t = (Q, ve) => {
    switch (g.sixWeeks === !0 ? "append" : g.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [Q == 0, !0];
      case "fair":
        return [Q == 0 || ve > Q, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Et = (Q, ve, Ae, We) => {
    if (g.sixWeeks && Q.length < 6) {
      const st = 6 - Q.length, Ht = (ve.getDay() + 7 - We) % 7, on = 6 - (Ae.getDay() + 7 - We) % 7, [re, ke] = _t(Ht, on);
      for (let Ye = 1; Ye <= st; Ye++)
        if (ke ? !!(Ye % 2) == re : re) {
          const $e = Q[0].days[0], je = $t(en($e.value, -7), Ze(ve));
          Q.unshift({ days: je });
        } else {
          const $e = Q[Q.length - 1], je = $e.days[$e.days.length - 1], St = $t(en(je.value, 1), Ze(ve));
          Q.push({ days: St });
        }
    }
    return Q;
  }, $t = (Q, ve) => {
    const Ae = i(Q), We = [];
    for (let st = 0; st < 7; st++) {
      const Ht = en(Ae, st), on = Ze(Ht) !== ve;
      We.push({
        text: g.hideOffsetDates && on ? "" : Z(Ht),
        value: Ht,
        current: !on,
        classData: {}
      });
    }
    return We;
  }, xn = (Q, ve) => {
    const Ae = [], We = i(new Date(ve, Q)), st = i(new Date(ve, Q + 1, 0)), Ht = g.weekStart, on = an(We, { weekStartsOn: Ht }), re = (ke) => {
      const Ye = $t(ke, Q);
      if (Ae.push({ days: Ye }), !Ae[Ae.length - 1].days.some(($e) => be(i($e.value), N(st)))) {
        const $e = en(ke, 7);
        re($e);
      }
    };
    return re(on), Et(Ae, We, st, Ht);
  }, ln = (Q) => {
    const ve = ae(
      { hours: h.hours, minutes: h.minutes, seconds: xa() },
      i(Q.value)
    );
    o("date-click", ve), $.value.enabled ? K(ve, $.value.limit) : d.value = ve, a(), Xe().then(() => {
      J();
    });
  }, Zt = (Q) => w.value.noDisabledRange ? pe(s.value[0], Q).some((ve) => D(ve)) : !1, Ee = () => {
    s.value = d.value ? d.value.slice().filter((Q) => !!Q) : [], s.value.length === 2 && !(w.value.fixedStart || w.value.fixedEnd) && (s.value = []);
  }, ct = (Q, ve) => {
    const Ae = [i(Q.value), en(i(Q.value), +w.value.autoRange)];
    Y(Ae) ? (ve && Ct(Q.value), s.value = Ae) : o("invalid-date", Q.value);
  }, Ct = (Q) => {
    const ve = Ze(i(Q)), Ae = Be(i(Q));
    if (j(0, ve, Ae), m.value.count > 0)
      for (let We = 1; We < m.value.count; We++) {
        const st = O(
          qe(i(Q), { year: f.value(We - 1), month: c.value(We - 1) })
        );
        j(We, st.month, st.year);
      }
  }, Sn = (Q) => {
    if (Zt(Q.value) || !L(Q.value, d.value, w.value.fixedStart ? 0 : 1))
      return o("invalid-date", Q.value);
    s.value = ge(i(Q.value));
  }, Tn = (Q, ve) => {
    if (Ee(), w.value.autoRange) return ct(Q, ve);
    if (w.value.fixedStart || w.value.fixedEnd) return Sn(Q);
    s.value[0] ? L(i(Q.value), d.value) && !Zt(Q.value) ? me(i(Q.value), i(s.value[0])) ? w.value.autoSwitchStartEnd ? (s.value.unshift(i(Q.value)), o("range-end", s.value[0])) : (s.value[0] = i(Q.value), o("range-start", s.value[0])) : (s.value[1] = i(Q.value), o("range-end", s.value[1])) : o("invalid-date", Q.value) : (s.value[0] = i(Q.value), o("range-start", s.value[0]));
  }, xa = (Q = !0) => T.value.enableSeconds ? Array.isArray(h.seconds) ? Q ? h.seconds[0] : h.seconds[1] : h.seconds : 0, as = (Q) => {
    s.value[Q] = ae(
      {
        hours: h.hours[Q],
        minutes: h.minutes[Q],
        seconds: xa(Q !== 1)
      },
      s.value[Q]
    );
  }, Kr = () => {
    var Q, ve;
    s.value[0] && s.value[1] && +((Q = s.value) == null ? void 0 : Q[0]) > +((ve = s.value) == null ? void 0 : ve[1]) && (s.value.reverse(), o("range-start", s.value[0]), o("range-end", s.value[1]));
  }, Hs = () => {
    var Q, ve, Ae;
    s.value.length && (s.value[0] && !s.value[1] ? as(0) : (as(0), as(1), a()), Kr(), d.value = s.value.slice(), De(
      s.value,
      n,
      s.value.length < 2 || (Q = _.value) != null && Q.steps.length ? e.flowStep !== ((Ae = (ve = _.value) == null ? void 0 : ve.steps) == null ? void 0 : Ae.length) : !1
    ));
  }, Yn = (Q, ve = !1) => {
    if (D(Q.value) || !Q.current && g.hideOffsetDates)
      return o("invalid-date", Q.value);
    if (l.value = structuredClone(Q), !w.value.enabled) return ln(Q);
    Array.isArray(h.hours) && Array.isArray(h.minutes) && !$.value.enabled && (Tn(Q, ve), Hs());
  }, Us = (Q, ve) => {
    var We, st;
    j(Q, ve.month, ve.year, !0), m.value.count && !m.value.solo && _e(Q), o("update-month-year", { instance: Q, month: ve.month, year: ve.year }), t(m.value.solo ? Q : void 0);
    const Ae = (st = (We = _.value) == null ? void 0 : We.steps) != null && st.length ? _.value.steps[e.flowStep] : void 0;
    !ve.fromNav && (Ae === Vt.month || Ae === Vt.year) && a();
  }, Pi = (Q) => {
    ye({
      value: Q
    }), H(), g.multiCalendars && Xe().then(() => R(!0));
  }, bt = () => {
    var ve;
    let Q = i();
    return (ve = g.actionRow) != null && ve.nowBtnRound && (Q = zp(Q, {
      roundingMethod: g.actionRow.nowBtnRound.rounding ?? "ceil",
      nearestTo: g.actionRow.nowBtnRound.roundTo ?? 15
    })), Q;
  }, Zr = () => {
    const Q = bt();
    !w.value.enabled && !$.value.enabled ? d.value = Q : d.value && Array.isArray(d.value) && d.value[0] ? $.value.enabled ? d.value = [...d.value, Q] : d.value = me(Q, d.value[0]) ? [Q, d.value[0]] : [d.value[0], Q] : d.value = [Q], H();
  }, qs = () => {
    if (Array.isArray(d.value))
      if ($.value.enabled) {
        const Q = js();
        d.value[d.value.length - 1] = se(Q);
      } else
        d.value = d.value.map((Q, ve) => Q && se(Q, ve));
    else
      d.value = se(d.value);
    n("time-update");
  }, js = () => Array.isArray(d.value) && d.value.length ? d.value[d.value.length - 1] : null, Xr = (Q) => {
    let ve = "";
    if (w.value.enabled && Array.isArray(d.value))
      for (const Ae of Object.keys(Q)) {
        const We = Q[Ae];
        Array.isArray(We) && (h[Ae][0] !== We[0] && (ve = "range-start"), h[Ae][1] !== We[1] && (ve = "range-start"));
      }
    return ve;
  };
  return {
    calendars: u,
    modelValue: d,
    month: c,
    year: f,
    time: h,
    disabledTimesConfig: q,
    today: y,
    validateTime: G,
    getCalendarDays: xn,
    getMarker: Wn,
    handleScroll: Ot,
    handleSwipe: kn,
    handleArrow: Bt,
    selectDate: Yn,
    updateMonthYear: Us,
    presetDate: Pi,
    selectCurrentDate: Zr,
    updateTime: (Q) => {
      const ve = Xr(Q);
      X(Q, qs), ve && o(ve, d.value[ve === "range-start" ? 0 : 1]);
    },
    assignMonthAndYear: z,
    setStartTime: I
  };
}, zy = () => {
  const {
    isModelAuto: e,
    matchDate: n,
    isDateAfter: t,
    isDateBefore: a,
    isDateBetween: s,
    isDateEqual: r,
    getWeekFromDate: l,
    getBeforeAndAfterInRange: i
  } = Rt(), {
    getDate: o,
    today: u,
    rootProps: c,
    defaults: { multiCalendars: f, multiDates: h, ui: d, highlight: g, safeDates: y, range: k },
    modelValue: m
  } = Ke(), { isDisabled: v } = rn(), w = te(null), S = (O) => {
    !O.current && c.hideOffsetDates || (w.value = O.value);
  }, x = () => {
    w.value = null;
  }, $ = (O) => Array.isArray(m.value) && k.value.enabled && m.value[0] && w.value ? O ? t(w.value, m.value[0]) : a(w.value, m.value[0]) : !0, T = (O, z) => {
    const F = () => m.value ? z ? m.value[0] || null : m.value[1] : null, le = m.value && Array.isArray(m.value) ? F() : null;
    return r(o(O.value), le);
  }, _ = (O) => {
    const z = Array.isArray(m.value) ? m.value[0] : null;
    return O ? !a(w.value, z) : !0;
  }, A = (O, z = !0) => (k.value.enabled || c.weekPicker) && Array.isArray(m.value) && m.value.length === 2 ? c.hideOffsetDates && !O.current ? !1 : r(o(O.value), m.value[z ? 0 : 1]) : k.value.enabled ? T(O, z) && _(z) || r(O.value, Array.isArray(m.value) ? m.value[0] : null) && $(z) : !1, D = (O, z) => {
    if (Array.isArray(m.value) && m.value[0] && m.value.length === 1) {
      const F = r(O.value, w.value);
      return z ? t(m.value[0], O.value) && F : a(m.value[0], O.value) && F;
    }
    return !1;
  }, Y = (O) => !m.value || c.hideOffsetDates && !O.current ? !1 : k.value.enabled ? c.modelAuto && Array.isArray(m.value) ? r(O.value, m.value[0] ?? u) : !1 : h.value.enabled && Array.isArray(m.value) ? m.value.some((z) => r(z, O.value)) : r(O.value, m.value ? m.value : u), L = (O) => {
    if (k.value.autoRange || c.weekPicker) {
      if (w.value) {
        if (c.hideOffsetDates && !O.current) return !1;
        const z = en(w.value, +k.value.autoRange), F = l(o(w.value), c.weekStart);
        return c.weekPicker ? r(F[1], o(O.value)) : r(z, o(O.value));
      }
      return !1;
    }
    return !1;
  }, X = (O) => {
    if (k.value.autoRange || c.weekPicker) {
      if (w.value) {
        const z = en(w.value, +k.value.autoRange);
        if (c.hideOffsetDates && !O.current) return !1;
        const F = l(o(w.value), c.weekStart);
        return c.weekPicker ? t(O.value, F[0]) && a(O.value, F[1]) : t(O.value, w.value) && a(O.value, z);
      }
      return !1;
    }
    return !1;
  }, se = (O) => {
    if (k.value.autoRange || c.weekPicker) {
      if (w.value) {
        if (c.hideOffsetDates && !O.current) return !1;
        const z = l(o(w.value), c.weekStart);
        return c.weekPicker ? r(z[0], O.value) : r(w.value, O.value);
      }
      return !1;
    }
    return !1;
  }, ie = (O) => s(m.value, w.value, O.value), ue = () => c.modelAuto && Array.isArray(m.value) ? !!m.value[0] : !1, G = () => c.modelAuto ? e(m.value) : !0, q = (O) => {
    if (c.weekPicker) return !1;
    const z = k.value.enabled ? !A(O) && !A(O, !1) : !0;
    return !v(O.value) && !Y(O) && !(!O.current && c.hideOffsetDates) && z;
  }, Z = (O) => k.value.enabled ? c.modelAuto ? ue() && Y(O) : !1 : Y(O), N = (O) => g.value ? n(O.value, y.value.highlight) : !1, ae = (O) => {
    const z = v(O.value);
    return z && (typeof g.value == "function" ? !g.value(O.value, z) : !g.value.options.highlightDisabled);
  }, me = (O) => {
    var z;
    return typeof g.value == "function" ? g.value(O.value) : (z = g.value.weekdays) == null ? void 0 : z.includes(O.value.getDay());
  }, be = (O) => (k.value.enabled || c.weekPicker) && (!(f.value.count > 0) || O.current) && G() && !(!O.current && c.hideOffsetDates) && !Y(O) ? ie(O) : !1, pe = (O) => {
    if (Array.isArray(m.value) && m.value.length === 1) {
      const { before: z, after: F } = i(+k.value.maxRange, m.value[0]);
      return Ln(O.value, z) || Cn(O.value, F);
    }
    return !1;
  }, De = (O) => {
    if (Array.isArray(m.value) && m.value.length === 1) {
      const { before: z, after: F } = i(+k.value.minRange, m.value[0]);
      return s([z, F], m.value[0], O.value);
    }
    return !1;
  }, ge = (O) => k.value.enabled && (k.value.maxRange || k.value.minRange) ? k.value.maxRange && k.value.minRange ? pe(O) || De(O) : k.value.maxRange ? pe(O) : De(O) : !1, K = (O) => {
    const { isRangeStart: z, isRangeEnd: F } = j(O), le = k.value.enabled ? z || F : !1;
    return {
      dp__cell_offset: !O.current,
      dp__pointer: !c.disabled && !(!O.current && c.hideOffsetDates) && !v(O.value) && !ge(O),
      dp__cell_disabled: v(O.value) || ge(O),
      dp__cell_highlight: !ae(O) && (N(O) || me(O)) && !Z(O) && !le && !se(O) && !(be(O) && c.weekPicker) && !F,
      dp__cell_highlight_active: !ae(O) && (N(O) || me(O)) && Z(O),
      dp__today: !c.noToday && r(O.value, u) && O.current,
      "dp--past": a(O.value, u),
      "dp--future": t(O.value, u)
    };
  }, ye = (O) => ({
    dp__active_date: Z(O),
    dp__date_hover: q(O)
  }), Me = (O) => {
    if (m.value && !Array.isArray(m.value)) {
      const z = l(m.value, c.weekStart);
      return {
        ...R(O),
        dp__range_start: r(z[0], O.value),
        dp__range_end: r(z[1], O.value),
        dp__range_between_week: t(O.value, z[0]) && a(O.value, z[1])
      };
    }
    return {
      ...R(O)
    };
  }, V = (O) => {
    if (m.value && Array.isArray(m.value)) {
      const z = l(m.value[0], c.weekStart), F = m.value[1] ? l(m.value[1], c.weekStart) : [];
      return {
        ...R(O),
        dp__range_start: r(z[0], O.value) || r(F[0], O.value),
        dp__range_end: r(z[1], O.value) || r(F[1], O.value),
        dp__range_between_week: t(O.value, z[0]) && a(O.value, z[1]) || t(O.value, F[0]) && a(O.value, F[1]),
        dp__range_between: t(O.value, z[1]) && a(O.value, F[0])
      };
    }
    return {
      ...R(O)
    };
  }, j = (O) => {
    const z = f.value.count > 0 ? O.current && A(O) && G() : A(O) && G(), F = f.value.count > 0 ? O.current && A(O, !1) && G() : A(O, !1) && G();
    return { isRangeStart: z, isRangeEnd: F };
  }, H = (O) => k.value.enabled && (k.value.fixedStart || k.value.fixedEnd) && Array.isArray(m.value) && m.value.length === 2, I = (O, z, F, le) => !H(m.value) || !w.value ? !1 : z ? k.value.fixedEnd && r(O.value, w.value) && Ln(O.value, m.value[0]) && !F : k.value.fixedStart && r(O.value, w.value) && Cn(O.value, m.value[1]) && !le, B = (O, z) => !H(m.value) || !w.value ? !1 : z ? k.value.fixedEnd && Cn(O.value, w.value) && Ln(O.value, m.value[0]) : k.value.fixedStart && Ln(O.value, w.value) && Cn(O.value, m.value[1]), J = (O) => {
    const { isRangeStart: z, isRangeEnd: F } = j(O);
    return {
      dp__range_start: z,
      dp__range_end: F,
      dp__range_between: be(O),
      dp__date_hover: r(O.value, w.value) && !z && !F && !c.weekPicker,
      dp__date_hover_start: D(O, !0) || I(O, !0, z, F),
      dp__date_hover_end: D(O, !1) || I(O, !1, z, F),
      "dp--extended-fixed-start": B(O, !0),
      "dp--extended-fixed-end": B(O, !1)
    };
  }, R = (O) => ({
    ...J(O),
    dp__cell_auto_range: X(O),
    dp__cell_auto_range_start: se(O),
    dp__cell_auto_range_end: L(O)
  }), ee = (O) => k.value.enabled ? k.value.autoRange ? R(O) : c.modelAuto ? { ...ye(O), ...J(O) } : c.weekPicker ? V(O) : J(O) : c.weekPicker ? Me(O) : ye(O);
  return {
    setHoverDate: S,
    clearHoverDate: x,
    getDayClassData: (O) => c.hideOffsetDates && !O.current ? {} : {
      ...K(O),
      ...ee(O),
      [d.value.dayClass ? d.value.dayClass(O.value, m.value) : ""]: !0,
      ...d.value.calendarCell
    }
  };
}, Wy = { key: 0 }, Yy = /* @__PURE__ */ Te({
  __name: "DatePicker",
  props: /* @__PURE__ */ yu({
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  }, Bg),
  emits: ["mount", "update-flow-step", "reset-flow", "focus-menu", "select-date", "time-update", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      month: r,
      year: l,
      modelValue: i,
      time: o,
      disabledTimesConfig: u,
      today: c,
      validateTime: f,
      getCalendarDays: h,
      getMarker: d,
      handleArrow: g,
      handleScroll: y,
      handleSwipe: k,
      selectDate: m,
      updateMonthYear: v,
      presetDate: w,
      selectCurrentDate: S,
      updateTime: x,
      assignMonthAndYear: $,
      setStartTime: T
    } = By(s, a, ye, Me), _ = Yt(), { setHoverDate: A, getDayClassData: D, clearHoverDate: Y } = zy(), {
      getDate: L,
      rootEmit: X,
      rootProps: se,
      defaults: { multiCalendars: ie, timeConfig: ue }
    } = Ke(), { getYears: G, getMonths: q } = Vr(), { getCellId: Z } = Rt(), N = Qe("calendar-header"), ae = Qe("calendar"), me = Qe("time-picker"), be = _n(_, gn.Calendar), pe = _n(_, gn.DatePickerHeader), De = _n(_, gn.TimePicker), ge = (ee) => {
      a("mount", ee);
    };
    He(
      ie,
      (ee, O) => {
        ee.count - O.count > 0 && $();
      },
      { deep: !0 }
    );
    const K = C(() => (ee) => h(r.value(ee), l.value(ee)).map((O) => ({
      ...O,
      days: O.days.map((z) => (z.marker = d(z), z.classData = D(z), z))
    })));
    function ye(ee) {
      var O, z, F;
      ee || ee === 0 ? (z = (O = ae.value) == null ? void 0 : O[ee]) == null || z.triggerTransition(r.value(ee), l.value(ee)) : (F = ae.value) == null || F.forEach((le, W) => le == null ? void 0 : le.triggerTransition(r.value(W), l.value(W)));
    }
    function Me() {
      a("update-flow-step");
    }
    const V = (ee, O, z = 0) => {
      var F, le;
      (le = (F = N.value) == null ? void 0 : F[z]) == null || le.toggleMonthPicker(ee, O);
    }, j = (ee, O, z = 0) => {
      var F, le;
      (le = (F = N.value) == null ? void 0 : F[z]) == null || le.toggleYearPicker(ee, O);
    }, H = (ee, O, z) => {
      var F;
      (F = me.value) == null || F.toggleTimePicker(ee, O, z);
    }, I = (ee, O) => {
      var z;
      if (!se.range) {
        const F = i.value ? i.value : c, le = O ? L(O) : F, W = ee ? an(le, { weekStartsOn: 1 }) : fi(le, { weekStartsOn: 1 });
        m({
          value: W,
          current: Ze(le) === r.value(0),
          text: "",
          classData: {}
        }), (z = document.getElementById(Z(W))) == null || z.focus();
      }
    }, B = (ee) => {
      var O, z;
      (z = (O = N.value) == null ? void 0 : O[0]) == null || z.handleMonthYearChange(ee, !0);
    }, J = (ee) => {
      v(0, { month: r.value(0), year: l.value(0) + (ee ? 1 : -1), fromNav: !0 });
    }, R = (ee) => {
      X("overlay-toggle", { open: !1, overlay: ee }), a("focus-menu");
    };
    return n({
      clearHoverDate: Y,
      presetDate: w,
      selectCurrentDate: S,
      handleArrow: g,
      updateMonthYear: v,
      setStartTime: T,
      toggleMonthPicker: V,
      toggleYearPicker: j,
      toggleTimePicker: H,
      getSidebarProps: () => ({
        modelValue: i,
        month: r,
        year: l,
        time: o,
        updateTime: x,
        updateMonthYear: v,
        selectDate: m,
        presetDate: w
      }),
      changeMonth: B,
      changeYear: J,
      selectWeekDate: I
    }), (ee, O) => (b(), M(Se, null, [
      oe(Lr, { collapse: e.collapse }, {
        default: de(({ instances: z, wrapClass: F }) => [
          (b(!0), M(Se, null, Pe(z, (le) => (b(), M("div", {
            key: le,
            class: ne(F)
          }, [
            p(se).hideMonthYearSelect ? P("", !0) : (b(), fe(Iy, {
              key: 0,
              ref_for: !0,
              ref: "calendar-header",
              months: p(q)(),
              years: p(G)(),
              month: p(r)(le),
              year: p(l)(le),
              instance: le,
              "menu-wrap-ref": e.menuWrapRef,
              onMount: O[0] || (O[0] = (W) => ge(p(va).header)),
              onResetFlow: O[1] || (O[1] = (W) => ee.$emit("reset-flow")),
              onUpdateMonthYear: (W) => p(v)(le, W),
              onOverlayClosed: R
            }, ft({ _: 2 }, [
              Pe(p(pe), (W, he) => ({
                name: W,
                fn: de((Oe) => [
                  U(ee.$slots, W, lt({ ref_for: !0 }, Oe))
                ])
              }))
            ]), 1032, ["months", "years", "month", "year", "instance", "menu-wrap-ref", "onUpdateMonthYear"])),
            oe(Ny, {
              ref_for: !0,
              ref: "calendar",
              "mapped-dates": K.value(le),
              instance: le,
              month: p(r)(le),
              year: p(l)(le),
              onSelectDate: (W) => p(m)(W, le !== 1),
              onSetHoverDate: O[2] || (O[2] = (W) => p(A)(W)),
              onHandleScroll: (W) => p(y)(W, le),
              onHandleSwipe: (W) => p(k)(W, le),
              onMount: O[3] || (O[3] = (W) => ge(p(va).calendar))
            }, ft({ _: 2 }, [
              Pe(p(be), (W, he) => ({
                name: W,
                fn: de((Oe) => [
                  U(ee.$slots, W, lt({ ref_for: !0 }, Oe))
                ])
              }))
            ]), 1032, ["mapped-dates", "instance", "month", "year", "onSelectDate", "onHandleScroll", "onHandleSwipe"])
          ], 2))), 128))
        ]),
        _: 3
      }, 8, ["collapse"]),
      p(ue).enableTimePicker ? (b(), M("div", Wy, [
        U(ee.$slots, "time-picker", Mt(Ft({ time: p(o), updateTime: p(x) })), () => [
          oe(Mc, {
            ref: "time-picker",
            hours: p(o).hours,
            minutes: p(o).minutes,
            seconds: p(o).seconds,
            "disabled-times-config": p(u),
            "validate-time": p(f),
            "no-overlay-focus": e.noOverlayFocus,
            onMount: O[4] || (O[4] = (z) => ge(p(va).timePicker)),
            "onUpdate:hours": O[5] || (O[5] = (z) => p(x)({ hours: z, minutes: p(o).minutes, seconds: p(o).seconds })),
            "onUpdate:minutes": O[6] || (O[6] = (z) => p(x)({ hours: p(o).hours, minutes: z, seconds: p(o).seconds })),
            "onUpdate:seconds": O[7] || (O[7] = (z) => p(x)({ hours: p(o).hours, minutes: p(o).minutes, seconds: z })),
            onResetFlow: O[8] || (O[8] = (z) => ee.$emit("reset-flow"))
          }, ft({ _: 2 }, [
            Pe(p(De), (z, F) => ({
              name: z,
              fn: de((le) => [
                U(ee.$slots, z, Mt(Ft(le)))
              ])
            }))
          ]), 1032, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time", "no-overlay-focus"])
        ])
      ])) : P("", !0)
    ], 64));
  }
}), Hy = (e, n) => {
  const {
    getDate: t,
    modelValue: a,
    year: s,
    calendars: r,
    defaults: { highlight: l, range: i, multiDates: o }
  } = Ke(), { isDateBetween: u, isDateEqual: c } = Rt(), { checkRangeAutoApply: f, handleMultiDatesSelect: h, setMonthOrYearRange: d } = Nr();
  Vs();
  const { isDisabled: g } = rn(), { formatQuarterText: y } = aa(), {
    selectYear: k,
    groupedYears: m,
    showYearPicker: v,
    isDisabled: w,
    toggleYearPicker: S,
    handleYearSelect: x,
    handleYear: $,
    setStartDate: T
  } = Tc(n), _ = te();
  nt(() => {
    T();
  });
  const A = C(() => (G) => a.value ? Array.isArray(a.value) ? a.value.some((q) => co(G, q)) : co(a.value, G) : !1), D = (G) => {
    if (i.value.enabled) {
      if (Array.isArray(a.value)) {
        const q = c(G, a.value[0]) || c(G, a.value[1]);
        return u(a.value, _.value, G) && !q;
      }
      return !1;
    }
    return !1;
  }, Y = (G, q) => G.quarter === so(q) && G.year === Be(q), L = (G) => typeof l.value == "function" ? l.value({ quarter: so(G), year: Be(G) }) : l.value.quarters.some((q) => Y(q, G)), X = C(() => (G) => {
    const q = qe(t(), { year: s.value(G) });
    return Km({
      start: Na(q),
      end: tc(q)
    }).map((Z) => {
      const N = da(Z), ae = ro(Z), me = g(Z), be = D(N), pe = L(N);
      return {
        text: y(N, ae),
        value: N,
        active: A.value(N),
        highlighted: pe,
        disabled: me,
        isBetween: be
      };
    });
  }), se = (G) => {
    h(G, o.value.limit), n("auto-apply", !0);
  }, ie = (G) => {
    a.value = d(G), f(a.value, n, a.value.length < 2);
  }, ue = (G) => {
    a.value = G, n("auto-apply");
  };
  return {
    groupedYears: m,
    year: s,
    isDisabled: w,
    quarters: X,
    showYearPicker: v,
    modelValue: a,
    selectYear: k,
    toggleYearPicker: S,
    handleYearSelect: x,
    handleYear: $,
    setHoverDate: (G) => {
      _.value = G;
    },
    selectQuarter: (G, q, Z) => {
      if (!Z)
        return r.value[q].month = Ze(ro(G)), o.value.enabled ? se(G) : i.value.enabled ? ie(G) : ue(G);
    }
  };
}, Uy = { class: "dp--quarter-items" }, qy = ["data-test-id", "disabled", "onClick", "onMouseover"], jy = /* @__PURE__ */ Te({
  __name: "QuarterPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      defaults: { config: r }
    } = Ke(), l = Yt(), { boolHtmlAttribute: i } = Za(), o = _n(l, gn.YearMode), {
      groupedYears: u,
      year: c,
      isDisabled: f,
      quarters: h,
      modelValue: d,
      showYearPicker: g,
      setHoverDate: y,
      selectQuarter: k,
      toggleYearPicker: m,
      handleYearSelect: v,
      handleYear: w
    } = Hy(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: d,
      year: c,
      selectQuarter: k,
      handleYearSelect: v,
      handleYear: w
    }) }), (S, x) => (b(), fe(Lr, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: de(({ instances: $, wrapClass: T }) => [
        (b(!0), M(Se, null, Pe($, (_) => (b(), M("div", {
          key: _,
          class: ne(T)
        }, [
          E("div", {
            class: "dp-quarter-picker-wrap",
            style: Fe({ minHeight: `${p(r).modeHeight}px` })
          }, [
            S.$slots["top-extra"] ? U(S.$slots, "top-extra", {
              key: 0,
              value: p(d)
            }) : P("", !0),
            E("div", null, [
              oe(Sc, {
                items: p(u)(_),
                instance: _,
                "show-year-picker": p(g)[_],
                year: p(c)(_),
                "is-disabled": (A) => p(f)(_, A),
                onHandleYear: (A) => p(w)(_, A),
                onYearSelect: (A) => p(v)(A, _),
                onToggleYearPicker: (A) => p(m)(_, A == null ? void 0 : A.flow, A == null ? void 0 : A.show)
              }, ft({ _: 2 }, [
                Pe(p(o), (A, D) => ({
                  name: A,
                  fn: de((Y) => [
                    U(S.$slots, A, lt({ ref_for: !0 }, Y))
                  ])
                }))
              ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
            ]),
            E("div", Uy, [
              (b(!0), M(Se, null, Pe(p(h)(_), (A, D) => (b(), M("div", { key: D }, [
                E("button", {
                  type: "button",
                  class: ne(["dp--qr-btn", {
                    "dp--qr-btn-active": A.active,
                    "dp--qr-btn-between": A.isBetween,
                    "dp--qr-btn-disabled": A.disabled,
                    "dp--highlighted": A.highlighted
                  }]),
                  "data-dp-action-element": "0",
                  "data-test-id": A.value,
                  disabled: p(i)(A.disabled),
                  onClick: (Y) => p(k)(A.value, _, A.disabled),
                  onMouseover: (Y) => p(y)(A.value)
                }, [
                  U(S.$slots, "quarter", {
                    value: A.value,
                    text: A.text
                  }, () => [
                    Ue(ce(A.text), 1)
                  ])
                ], 42, qy)
              ]))), 128))
            ])
          ], 4)
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), Gy = ["id", "tabindex", "role", "aria-label"], Ky = {
  key: 0,
  class: "dp--menu-load-container"
}, Zy = {
  key: 1,
  class: "dp--menu-header"
}, Xy = ["data-dp-mobile"], Jy = {
  key: 0,
  class: "dp__sidebar_left"
}, Qy = ["data-dp-mobile"], e0 = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], t0 = { class: "dp__instance_calendar" }, n0 = {
  key: 2,
  class: "dp__sidebar_right"
}, a0 = {
  key: 2,
  class: "dp__action_extra"
}, s0 = /* @__PURE__ */ Te({
  __name: "DatepickerMenu",
  props: {
    collapse: { type: Boolean },
    noOverlayFocus: { type: Boolean },
    getInputRect: { type: Function }
  },
  emits: ["close-picker", "select-date", "auto-apply", "time-update", "menu-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Yt(), {
      state: r,
      rootProps: l,
      defaults: { textInput: i, inline: o, config: u, ui: c, ariaLabels: f },
      setState: h
    } = Ke(), { isMobile: d } = Rr(), { handleEventPropagation: g, getElWithin: y, checkStopPropagation: k, checkKeyDown: m } = Dt();
    Xp();
    const v = Qe("inner-menu"), w = Qe("dp-menu"), S = Qe("dyn-cmp"), x = te(0), $ = te(!1), T = te(!1), { flowStep: _, updateFlowStep: A, childMount: D, resetFlow: Y, handleFlow: L } = Qp(S), X = (R) => {
      T.value = !0, u.value.allowPreventDefault && R.preventDefault(), k(R, u.value, !0);
    };
    nt(() => {
      $.value = !0, se(), globalThis.addEventListener("resize", se);
      const R = jt(w);
      R && !i.value.enabled && !o.value.enabled && h("menuFocused", !0), R && (R.addEventListener("pointerdown", X), R.addEventListener("mousedown", X)), document.addEventListener("mousedown", J);
    }), sn(() => {
      globalThis.removeEventListener("resize", se), document.removeEventListener("mousedown", J);
      const R = jt(w);
      R && (R.removeEventListener("pointerdown", X), R.removeEventListener("mousedown", X));
    });
    const se = () => {
      const R = jt(v);
      R && (x.value = R.getBoundingClientRect().width);
    }, ie = C(() => l.monthPicker ? uy : l.yearPicker ? dy : l.timePicker ? My : l.quarterPicker ? jy : Yy), ue = () => {
      const R = jt(w);
      R && R.focus({ preventScroll: !0 });
    }, G = C(() => {
      var R;
      return ((R = S.value) == null ? void 0 : R.getSidebarProps()) || {};
    }), q = _n(s, gn.ActionRow), Z = _n(s, gn.PassTrough), N = C(() => ({
      dp__menu_disabled: l.disabled,
      dp__menu_readonly: l.readonly,
      "dp-menu-loading": l.loading
    })), ae = C(
      () => ({
        dp__menu: !0,
        dp__menu_index: !o.value.enabled,
        dp__relative: o.value.enabled,
        ...c.value.menu
      })
    ), me = (R) => {
      k(R, u.value, !0);
    }, be = (R) => {
      u.value.escClose && (a("close-picker"), g(R, u.value));
    }, pe = (R) => {
      l.arrowNavigation || (R === fn.left || R === fn.up ? ye("handleArrow", fn.left, 0, R === fn.up) : ye("handleArrow", fn.right, 0, R === fn.down));
    }, De = (R) => {
      h("shiftKeyInMenu", R.shiftKey), !l.hideMonthYearSelect && R.code === dt.tab && R.target.classList.contains("dp__menu") && r.shiftKeyInMenu && (R.preventDefault(), k(R, u.value, !0), a("close-picker"));
    }, ge = (R) => {
      var ee, O, z;
      (ee = S.value) == null || ee.toggleTimePicker(!1, !1), (O = S.value) == null || O.toggleMonthPicker(!1, !1, R), (z = S.value) == null || z.toggleYearPicker(!1, !1, R);
    }, K = (R, ee = 0) => {
      var O, z, F;
      return R === "month" ? (O = S.value) == null ? void 0 : O.toggleMonthPicker(!1, !0, ee) : R === "year" ? (z = S.value) == null ? void 0 : z.toggleYearPicker(!1, !0, ee) : R === "time" ? (F = S.value) == null ? void 0 : F.toggleTimePicker(!0, !1) : ge(ee);
    }, ye = (R, ...ee) => {
      var O, z;
      (O = S.value) != null && O[R] && ((z = S.value) == null || z[R](...ee));
    }, Me = () => {
      ye("selectCurrentDate");
    }, V = (R) => {
      ye("presetDate", tt(R));
    }, j = () => {
      ye("clearHoverDate");
    }, H = (R, ee) => {
      ye("updateMonthYear", R, ee);
    }, I = (R, ee) => {
      R.preventDefault(), pe(ee);
    }, B = (R) => {
      var ee, O, z;
      if (De(R), R.key === dt.home || R.key === dt.end)
        return ye(
          "selectWeekDate",
          R.key === dt.home,
          R.target.getAttribute("id")
        );
      switch ((R.key === dt.pageUp || R.key === dt.pageDown) && (R.shiftKey ? (ye("changeYear", R.key === dt.pageUp), (ee = y(w.value, "overlay-year")) == null || ee.focus()) : (ye("changeMonth", R.key === dt.pageUp), (O = y(w.value, R.key === dt.pageUp ? "action-prev" : "action-next")) == null || O.focus()), R.target.getAttribute("id") && ((z = w.value) == null || z.focus({ preventScroll: !0 }))), R.key) {
        case dt.esc:
          return be(R);
        case dt.arrowLeft:
          return I(R, fn.left);
        case dt.arrowRight:
          return I(R, fn.right);
        case dt.arrowUp:
          return I(R, fn.up);
        case dt.arrowDown:
          return I(R, fn.down);
        default:
          return;
      }
    }, J = (R) => {
      var ee;
      o.value.enabled && !o.value.input && !((ee = w.value) != null && ee.contains(R.target)) && T.value && (T.value = !1, a("menu-blur"));
    };
    return n({
      updateMonthYear: H,
      switchView: K,
      onValueCleared: () => {
        var R, ee;
        (ee = (R = S.value) == null ? void 0 : R.setStartTime) == null || ee.call(R);
      },
      handleFlow: L
    }), (R, ee) => {
      var O, z, F;
      return b(), M("div", {
        id: p(l).menuId,
        ref: "dp-menu",
        tabindex: p(o).enabled ? void 0 : "0",
        role: p(o).enabled ? void 0 : "dialog",
        "aria-label": (O = p(f)) == null ? void 0 : O.menu,
        class: ne(ae.value),
        onMouseleave: j,
        onClick: me,
        onKeydown: B
      }, [
        (p(l).disabled || p(l).readonly) && p(o).enabled || p(l).loading ? (b(), M("div", {
          key: 0,
          class: ne(N.value)
        }, [
          p(l).loading ? (b(), M("div", Ky, [...ee[5] || (ee[5] = [
            E("span", { class: "dp--menu-loader" }, null, -1)
          ])])) : P("", !0)
        ], 2)) : P("", !0),
        R.$slots["menu-header"] ? (b(), M("div", Zy, [
          U(R.$slots, "menu-header")
        ])) : P("", !0),
        U(R.$slots, "arrow"),
        E("div", {
          ref: "inner-menu",
          class: ne({
            dp__menu_content_wrapper: ((z = p(l).presetDates) == null ? void 0 : z.length) || !!R.$slots["left-sidebar"] || !!R.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((F = p(l).presetDates) == null ? void 0 : F.length) || !!R.$slots["left-sidebar"] || !!R.$slots["right-sidebar"])
          }),
          "data-dp-mobile": p(d),
          style: Fe({ "--dp-menu-width": `${x.value}px` })
        }, [
          R.$slots["left-sidebar"] ? (b(), M("div", Jy, [
            U(R.$slots, "left-sidebar", Mt(Ft(G.value)))
          ])) : P("", !0),
          p(l).presetDates.length ? (b(), M("div", {
            key: 1,
            class: ne({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": p(d)
          }, [
            (b(!0), M(Se, null, Pe(p(l).presetDates, (le, W) => (b(), M(Se, { key: W }, [
              le.slot ? U(R.$slots, le.slot, {
                key: 0,
                presetDate: V,
                label: le.label,
                value: le.value
              }) : (b(), M("button", {
                key: 1,
                type: "button",
                style: Fe(le.style || {}),
                class: ne(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": le.testId ?? void 0,
                "data-dp-mobile": p(d),
                onClick: Ve((he) => V(le.value), ["prevent"]),
                onKeydown: (he) => p(m)(he, () => V(le.value), !0)
              }, ce(le.label), 47, e0))
            ], 64))), 128))
          ], 10, Qy)) : P("", !0),
          E("div", t0, [
            (b(), fe(ht(ie.value), {
              ref: "dyn-cmp",
              "flow-step": p(_),
              collapse: e.collapse,
              "no-overlay-focus": e.noOverlayFocus,
              "menu-wrap-ref": w.value,
              onMount: p(D),
              onUpdateFlowStep: p(A),
              onResetFlow: p(Y),
              onFocusMenu: ue,
              onSelectDate: ee[0] || (ee[0] = (le) => R.$emit("select-date")),
              onAutoApply: ee[1] || (ee[1] = (le) => R.$emit("auto-apply", le)),
              onTimeUpdate: ee[2] || (ee[2] = (le) => R.$emit("time-update"))
            }, ft({ _: 2 }, [
              Pe(p(Z), (le, W) => ({
                name: le,
                fn: de((he) => [
                  U(R.$slots, le, Mt(Ft({ ...he })))
                ])
              }))
            ]), 1064, ["flow-step", "collapse", "no-overlay-focus", "menu-wrap-ref", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ]),
          R.$slots["right-sidebar"] ? (b(), M("div", n0, [
            U(R.$slots, "right-sidebar", Mt(Ft(G.value)))
          ])) : P("", !0)
        ], 14, Xy),
        R.$slots["action-extra"] ? (b(), M("div", a0, [
          R.$slots["action-extra"] ? U(R.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: Me
          }) : P("", !0)
        ])) : P("", !0),
        !p(l).autoApply || p(u).keepActionRow ? (b(), fe(ey, {
          key: 3,
          "menu-mount": $.value,
          "calendar-width": x.value,
          onClosePicker: ee[3] || (ee[3] = (le) => R.$emit("close-picker")),
          onSelectDate: ee[4] || (ee[4] = (le) => R.$emit("select-date")),
          onSelectNow: Me
        }, ft({ _: 2 }, [
          Pe(p(q), (le, W) => ({
            name: le,
            fn: de((he) => [
              U(R.$slots, le, Mt(Ft(he)))
            ])
          }))
        ]), 1032, ["menu-mount", "calendar-width"])) : P("", !0)
      ], 42, Gy);
    };
  }
}), r0 = ["data-dp-mobile"], l0 = /* @__PURE__ */ Te({
  __name: "VueDatePicker",
  setup(e, { expose: n }) {
    const {
      rootEmit: t,
      setState: a,
      inputValue: s,
      modelValue: r,
      rootProps: l,
      defaults: { inline: i, config: o, textInput: u, range: c, multiDates: f, teleport: h, floatingConfig: d }
    } = Ke(), { validateDate: g, isValidTime: y } = rn(), { menuTransition: k, showTransition: m } = Rs(), { isMobile: v } = Rr(), { findNextFocusableElement: w, getNumVal: S } = Dt(), x = Yt(), $ = te(!1), T = te(i.value.enabled || l.centered), _ = hr(l, "modelValue"), A = hr(l, "timezone"), D = Qe("dp-menu-wrap"), Y = Qe("dp-menu"), L = Qe("input-cmp"), X = Qe("picker-wrapper"), se = Qe("menu-arrow"), ie = te(!1), ue = te(!1), G = te(!1), q = te(!0), Z = (Ee) => (d.value.arrow && Ee.push(
      Fm({ element: d.value.arrow === !0 ? se : d.value.arrow })
    ), d.value.flip && Ee.push(Pm(typeof d.value.flip == "object" ? d.value.flip : {})), d.value.shift && Ee.push(Im(typeof d.value.shift == "object" ? d.value.shift : {})), Ee), { floatingStyles: N, middlewareData: ae, placement: me, y: be } = Lm(
      L,
      D,
      {
        strategy: d.value.strategy,
        placement: d.value.placement,
        middleware: Z([Em(d.value.offset)]),
        whileElementsMounted: _m
      }
    );
    nt(() => {
      ge(l.modelValue), Xe().then(() => {
        i.value.enabled || globalThis.addEventListener("resize", J);
      }), i.value.enabled && ($.value = !0), globalThis.addEventListener("keyup", R), globalThis.addEventListener("keydown", ee);
    }), sn(() => {
      i.value.enabled || globalThis.removeEventListener("resize", J), globalThis.removeEventListener("keyup", R), globalThis.removeEventListener("keydown", ee);
    });
    const pe = xc(x, l.presetDates), De = _n(x, gn.Input);
    He(
      [_, A],
      () => {
        ge(_.value);
      },
      { deep: !0 }
    ), He([me, be], () => {
      !i.value.enabled && !l.centered && q.value && (T.value = !1, Xe().then(() => {
        q.value = !1, T.value = !0;
      }));
    });
    const { parseExternalModelValue: ge, emitModelValue: K, formatInputValue: ye, checkBeforeEmit: Me } = Jp(), V = C(
      () => ({
        dp__main: !0,
        dp__theme_dark: l.dark,
        dp__theme_light: !l.dark,
        dp__flex_display: i.value.enabled,
        "dp--flex-display-collapsed": G.value,
        dp__flex_display_with_input: i.value.input
      })
    ), j = C(() => l.dark ? "dp__theme_dark" : "dp__theme_light"), H = C(() => i.value.enabled && (l.timePicker || l.monthPicker || l.yearPicker || l.quarterPicker)), I = () => {
      var Ee, ct;
      return ((ct = (Ee = L.value) == null ? void 0 : Ee.$el) == null ? void 0 : ct.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, B = () => {
      $.value && o.value.closeOnScroll && _e();
    }, J = () => {
      var ct;
      const Ee = ((ct = Y.value) == null ? void 0 : ct.$el.getBoundingClientRect().width) ?? 0;
      G.value = document.body.offsetWidth <= Ee;
    }, R = (Ee) => {
      Ee.key === "Tab" && !i.value.enabled && !l.teleport && o.value.tabOutClosesMenu && (X.value.contains(document.activeElement) || _e()), ue.value = Ee.shiftKey;
    }, ee = (Ee) => {
      ue.value = Ee.shiftKey;
    }, O = () => {
      !l.disabled && !l.readonly && (q.value = !0, $.value = !0, $.value && t("open"), $.value || Re(), ge(l.modelValue));
    }, z = () => {
      var Ee, ct;
      s.value = "", Re(), (Ee = Y.value) == null || Ee.onValueCleared(), (ct = L.value) == null || ct.setParsedDate(null), t("update:model-value", null), t("cleared"), o.value.closeOnClearValue && _e();
    }, F = () => {
      const Ee = r.value;
      return !Ee || !Array.isArray(Ee) && g(Ee) ? !0 : Array.isArray(Ee) ? f.value.enabled || Ee.length === 2 && g(Ee[0]) && g(Ee[1]) ? !0 : c.value.partialRange && !l.timePicker ? g(Ee[0]) : !1 : !1;
    }, le = () => {
      Me() && F() ? (K(), _e()) : t("invalid-select");
    }, W = (Ee) => {
      he(), K(), o.value.closeOnAutoApply && !Ee && _e();
    }, he = () => {
      L.value && u.value.enabled && L.value.setParsedDate(r.value);
    }, Oe = (Ee = !1) => {
      l.autoApply && y(r.value) && F() && (c.value.enabled && Array.isArray(r.value) ? (c.value.partialRange || r.value.length === 2) && W(Ee) : W(Ee));
    }, Re = () => {
      u.value.enabled || (r.value = null);
    }, _e = (Ee = !1) => {
      q.value = !0, Ee && r.value && o.value.setDateOnMenuClose && le(), i.value.enabled || ($.value && ($.value = !1, a("menuFocused", !1), a("shiftKeyInMenu", !1), t("closed"), s.value && ge(_.value)), Re(), t("blur"));
    }, ze = (Ee, ct, Ct = !1) => {
      if (!Ee) {
        r.value = null;
        return;
      }
      const Sn = Array.isArray(Ee) ? Ee.every((xa) => g(xa)) : g(Ee), Tn = y(Ee);
      Sn && Tn ? (a("isTextInputDate", !0), r.value = Ee, ct ? (ie.value = Ct, le(), t("text-submit")) : l.autoApply && Oe(!0), Xe().then(() => {
        a("isTextInputDate", !1);
      })) : t("invalid-date", Ee);
    }, Nt = () => {
      l.autoApply && y(r.value) && K(), he();
    }, Ot = () => $.value ? _e() : O(), Bt = (Ee) => {
      r.value = Ee;
    }, kn = () => {
      u.value.enabled && (a("isInputFocused", !0), ye()), t("focus");
    }, Wn = () => {
      var Ee;
      u.value.enabled && (a("isInputFocused", !1), ge(l.modelValue), ie.value && ((Ee = w(X.value, ue.value)) == null || Ee.focus())), t("blur");
    }, _t = (Ee, ct) => {
      Y.value && Y.value.updateMonthYear(ct ?? 0, {
        month: S(Ee.month),
        year: S(Ee.year)
      });
    }, Et = (Ee) => {
      ge(Ee ?? l.modelValue);
    }, $t = (Ee, ct) => {
      var Ct;
      (Ct = Y.value) == null || Ct.switchView(Ee, ct);
    }, xn = (Ee, ct) => {
      if ($.value)
        return o.value.onClickOutside ? o.value.onClickOutside(Ee, ct) : _e(!0);
    }, ln = (Ee = 0) => {
      var ct;
      (ct = Y.value) == null || ct.handleFlow(Ee);
    }, Zt = () => D;
    return Nh(D, (Ee) => xn(F, Ee), {
      ignore: [L]
    }), n({
      closeMenu: _e,
      selectDate: le,
      clearValue: z,
      openMenu: O,
      onScroll: B,
      formatInputValue: ye,
      // exposed for testing purposes
      updateInternalModelValue: Bt,
      // modify internal modelValue
      setMonthYear: _t,
      parseModel: Et,
      switchView: $t,
      toggleMenu: Ot,
      handleFlow: ln,
      getDpWrapMenuRef: Zt,
      dpMenuRef: () => Y,
      dpWrapMenuRef: () => D,
      inputRef: () => L
    }), (Ee, ct) => (b(), M("div", {
      ref: "picker-wrapper",
      class: ne(V.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": p(v)
    }, [
      oe(Kg, {
        ref: "input-cmp",
        "is-menu-open": $.value,
        onClear: z,
        onOpen: O,
        onSetInputDate: ze,
        onSetEmptyDate: p(K),
        onSelectDate: le,
        onToggle: Ot,
        onClose: _e,
        onFocus: kn,
        onBlur: Wn,
        onRealBlur: ct[0] || (ct[0] = (Ct) => p(a)("isInputFocused", !1))
      }, ft({ _: 2 }, [
        Pe(p(De), (Ct, Sn) => ({
          name: Ct,
          fn: de((Tn) => [
            U(Ee.$slots, Ct, Mt(Ft(Tn)))
          ])
        }))
      ]), 1032, ["is-menu-open", "onSetEmptyDate"]),
      oe(zn, {
        to: p(h),
        disabled: !p(h)
      }, {
        default: de(() => [
          E("div", {
            ref: "dp-menu-wrap",
            class: ne({
              "dp--menu-wrapper": !p(i).enabled,
              dp__outer_menu_wrap: !0,
              "dp--centered": p(l).centered
            }),
            style: Fe(!p(i).enabled && !p(l).centered ? p(N) : void 0)
          }, [
            oe(vt, {
              name: p(k)(p(me).startsWith("top")),
              css: p(m) && !p(i).enabled && !p(l).centered && T.value
            }, {
              default: de(() => [
                $.value && T.value ? (b(), fe(s0, {
                  key: 0,
                  ref: "dp-menu",
                  class: ne({ [j.value]: !0 }),
                  "no-overlay-focus": H.value,
                  collapse: G.value,
                  "get-input-rect": I,
                  onClosePicker: _e,
                  onSelectDate: le,
                  onAutoApply: Oe,
                  onTimeUpdate: Nt,
                  onMenuBlur: ct[1] || (ct[1] = (Ct) => p(t)("blur"))
                }, ft({ _: 2 }, [
                  Pe(p(pe), (Ct, Sn) => ({
                    name: Ct,
                    fn: de((Tn) => [
                      U(Ee.$slots, Ct, Mt(Ft({ ...Tn })))
                    ])
                  })),
                  !p(i).enabled && !p(l).centered && p(d).arrow === !0 ? {
                    name: "arrow",
                    fn: de(() => {
                      var Ct, Sn;
                      return [
                        E("div", {
                          ref: "menu-arrow",
                          class: ne({
                            dp__arrow_top: p(me) === "bottom",
                            dp__arrow_bottom: p(me) === "top"
                          }),
                          style: Fe({
                            left: ((Ct = p(ae).arrow) == null ? void 0 : Ct.x) != null ? `${p(ae).arrow.x}px` : "",
                            top: ((Sn = p(ae).arrow) == null ? void 0 : Sn.y) != null ? `${p(ae).arrow.y}px` : ""
                          })
                        }, null, 6)
                      ];
                    }),
                    key: "0"
                  } : void 0
                ]), 1032, ["class", "no-overlay-focus", "collapse"])) : P("", !0)
              ]),
              _: 3
            }, 8, ["name", "css"])
          ], 6)
        ]),
        _: 3
      }, 8, ["to", "disabled"])
    ], 10, r0));
  }
}), i0 = /* @__PURE__ */ Te({
  __name: "VueDatePickerRoot",
  props: /* @__PURE__ */ yu({
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    modelType: {},
    dark: { type: Boolean },
    transitions: { type: [Boolean, Object] },
    ariaLabels: {},
    hideNavigation: {},
    timezone: {},
    vertical: { type: Boolean },
    hideMonthYearSelect: { type: Boolean },
    disableYearSelect: { type: Boolean },
    yearRange: {},
    autoApply: { type: Boolean },
    disabledDates: { type: [Array, Function] },
    startDate: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    allowedDates: {},
    markers: {},
    presetDates: {},
    flow: {},
    preventMinMaxNavigation: { type: Boolean },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    filters: {},
    arrowNavigation: { type: Boolean },
    highlight: { type: [Function, Object] },
    teleport: { type: [String, Boolean] },
    centered: { type: Boolean },
    locale: {},
    weekStart: {},
    weekNumbers: { type: [Boolean, Object] },
    dayNames: { type: [Function, Array] },
    monthPicker: { type: Boolean },
    yearPicker: { type: Boolean },
    modelAuto: { type: Boolean },
    formats: {},
    multiDates: { type: [Boolean, Object] },
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    inputAttrs: {},
    timeConfig: {},
    placeholder: {},
    timePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    menuId: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    inline: { type: [Boolean, Object] },
    textInput: { type: [Boolean, Object] },
    sixWeeks: { type: [Boolean, String] },
    actionRow: {},
    focusStartDate: { type: Boolean },
    disabledTimes: { type: [Function, Array] },
    calendar: { type: Function },
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    ui: {},
    floating: {}
  }, zg),
  emits: ["update:model-value", "internal-model-change", "text-submit", "text-input", "open", "closed", "focus", "blur", "cleared", "flow-step", "update-month-year", "invalid-select", "invalid-fixed-range", "invalid-date", "tooltip-open", "tooltip-close", "am-pm-change", "range-start", "range-end", "date-click", "overlay-toggle", "invalid"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e;
    Kp(s, a);
    const r = Yt(), l = xc(r, s.presetDates), i = Qe("date-picker");
    return n(Yg(i)), (o, u) => (b(), fe(l0, { ref: "date-picker" }, ft({ _: 2 }, [
      Pe(p(l), (c, f) => ({
        name: c,
        fn: de((h) => [
          U(o.$slots, c, Mt(Ft(h)))
        ])
      }))
    ]), 1536));
  }
}), Cc = vf("theme", () => {
  const e = te("auto"), n = te("light"), t = C(() => n.value === "dark"), a = C(() => n.value === "light"), s = C(() => e.value === "auto"), r = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", l = (f) => f === "auto" ? r() : f, i = (f) => {
    document.documentElement.setAttribute("data-theme", f);
  }, o = (f) => {
    e.value = f;
    const h = l(f);
    n.value = h, i(h), localStorage.setItem("theme-mode", f);
  };
  return {
    themeMode: e,
    resolvedTheme: n,
    isDark: t,
    isLight: a,
    isAuto: s,
    setThemeMode: o,
    toggleTheme: () => {
      const f = e.value === "light" ? "dark" : e.value === "dark" ? "auto" : "light";
      o(f);
    },
    initTheme: () => {
      const h = localStorage.getItem("theme-mode") || "auto";
      o(h);
      const d = window.matchMedia("(prefers-color-scheme: dark)"), g = (y) => {
        e.value === "auto" && (n.value = y.matches ? "dark" : "light", i(n.value));
      };
      d.addEventListener("change", g);
    }
  };
}), o0 = {
  key: 0,
  class: "v-datepicker-label"
}, u0 = { class: "v-datepicker-icon-wrapper" }, c0 = { class: "v-datepicker-clear-wrapper" }, d0 = {
  key: 1,
  class: "v-datepicker-helper-text"
}, f0 = {
  key: 0,
  class: "form-error"
}, h0 = /* @__PURE__ */ Te({
  inheritAttrs: !1,
  __name: "VDatepicker",
  props: /* @__PURE__ */ ea({
    name: { default: "" },
    helperText: { default: "" },
    validation: { default: void 0 },
    size: { default: "md" },
    icon: { default: "lucide:calendar" },
    autoApply: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    width: { default: "100%" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Cc(), t = Ds(e, "modelValue"), a = Yt(), s = [
      "input-icon",
      "clear-icon",
      "arrow-left",
      "arrow-right",
      "arrow-up",
      "arrow-down",
      "clock-icon",
      "calendar-icon"
    ], r = e;
    return (l, i) => {
      var o, u, c, f;
      return b(), M("div", {
        class: ne([`v-datepicker--${e.size}`, "v-datepicker-wrapper"]),
        style: Fe({ width: r.width })
      }, [
        r.name ? (b(), M("label", o0, ce(r.name), 1)) : P("", !0),
        oe(p(i0), lt({
          modelValue: t.value,
          "onUpdate:modelValue": i[0] || (i[0] = (h) => t.value = h),
          "auto-apply": r.autoApply,
          "calendar-class-name": "v-datepicker-calendar",
          class: [
            "v-datepicker",
            {
              "v-datepicker-error": (o = e.validation) == null ? void 0 : o.$error,
              "v-datepicker-no-clear": !r.clearable
            }
          ],
          dark: p(n).isDark,
          "input-class-name": [
            "v-datepicker-input",
            {
              "v-datepicker-input-error": (u = e.validation) == null ? void 0 : u.$error
            }
          ],
          "menu-class-name": "v-datepicker-menu",
          timezone: "UTC",
          "week-start": 0
        }, l.$attrs), ft({ _: 2 }, [
          p(a)["input-icon"] ? {
            name: "input-icon",
            fn: de(() => [
              U(l.$slots, "input-icon", {}, void 0, !0)
            ]),
            key: "0"
          } : {
            name: "input-icon",
            fn: de(() => [
              E("div", u0, [
                oe(xe, {
                  icon: e.icon,
                  class: "v-datepicker-icon"
                }, null, 8, ["icon"])
              ])
            ]),
            key: "1"
          },
          r.clearable ? r.clearable && p(a)["clear-icon"] ? {
            name: "clear-icon",
            fn: de((h) => [
              U(l.$slots, "clear-icon", Mt(Ft(h)), void 0, !0)
            ]),
            key: "3"
          } : {
            name: "clear-icon",
            fn: de(({ clear: h }) => [
              E("div", c0, [
                oe(xe, {
                  class: "v-datepicker-clear-icon",
                  icon: "lucide:x",
                  onClick: h
                }, null, 8, ["onClick"])
              ])
            ]),
            key: "4"
          } : {
            name: "clear-icon",
            fn: de(() => []),
            key: "2"
          },
          p(a)["arrow-left"] ? {
            name: "arrow-left",
            fn: de(() => [
              U(l.$slots, "arrow-left", {}, void 0, !0)
            ]),
            key: "5"
          } : {
            name: "arrow-left",
            fn: de(() => [
              oe(xe, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-left"
              })
            ]),
            key: "6"
          },
          p(a)["arrow-right"] ? {
            name: "arrow-right",
            fn: de(() => [
              U(l.$slots, "arrow-right", {}, void 0, !0)
            ]),
            key: "7"
          } : {
            name: "arrow-right",
            fn: de(() => [
              oe(xe, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-right"
              })
            ]),
            key: "8"
          },
          p(a)["arrow-up"] ? {
            name: "arrow-up",
            fn: de(() => [
              U(l.$slots, "arrow-up", {}, void 0, !0)
            ]),
            key: "9"
          } : {
            name: "arrow-up",
            fn: de(() => [
              oe(xe, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-up"
              })
            ]),
            key: "10"
          },
          p(a)["arrow-down"] ? {
            name: "arrow-down",
            fn: de(() => [
              U(l.$slots, "arrow-down", {}, void 0, !0)
            ]),
            key: "11"
          } : {
            name: "arrow-down",
            fn: de(() => [
              oe(xe, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-down"
              })
            ]),
            key: "12"
          },
          p(a)["clock-icon"] ? {
            name: "clock-icon",
            fn: de(() => [
              U(l.$slots, "clock-icon", {}, void 0, !0)
            ]),
            key: "13"
          } : {
            name: "clock-icon",
            fn: de(() => [
              oe(xe, {
                class: "v-datepicker-clock-icon",
                icon: "lucide:clock"
              })
            ]),
            key: "14"
          },
          p(a)["calendar-icon"] ? {
            name: "calendar-icon",
            fn: de(() => [
              U(l.$slots, "calendar-icon", {}, void 0, !0)
            ]),
            key: "15"
          } : {
            name: "calendar-icon",
            fn: de(() => [
              oe(xe, {
                icon: e.icon,
                class: "v-datepicker-calendar-icon"
              }, null, 8, ["icon"])
            ]),
            key: "16"
          },
          Pe(p(a), (h, d) => ({
            name: d,
            fn: de((g) => [
              s.includes(d) ? P("", !0) : U(l.$slots, d, Mt(lt({ key: 0 }, g)), void 0, !0)
            ])
          }))
        ]), 1040, ["modelValue", "auto-apply", "class", "dark", "input-class-name"]),
        E("fieldset", {
          class: ne([{ "v-datepicker-fieldset--error": (c = e.validation) == null ? void 0 : c.$error }, "v-datepicker-fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: ne([{ "v-datepicker-legend--visible": !!r.name }, "v-datepicker-legend"])
          }, [
            E("span", null, ce(r.name), 1)
          ], 2)
        ], 2),
        e.helperText && !((f = e.validation) != null && f.$error) ? (b(), M("p", d0, ce(e.helperText), 1)) : P("", !0),
        oe(vt, {
          mode: "out-in",
          name: "error-slide"
        }, {
          default: de(() => {
            var h, d, g, y;
            return [
              (h = e.validation) != null && h.$error ? (b(), M("p", f0, ce((y = (g = (d = e.validation) == null ? void 0 : d.$errors) == null ? void 0 : g[0]) == null ? void 0 : y.$message), 1)) : P("", !0)
            ];
          }),
          _: 1
        })
      ], 6);
    };
  }
}), j2 = /* @__PURE__ */ Ge(h0, [["__scopeId", "data-v-7925760e"]]);
class ka extends Error {
}
class m0 extends ka {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class v0 extends ka {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class p0 extends ka {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class Ra extends ka {
}
class Dc extends ka {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class Pt extends ka {
}
class qn extends ka {
  constructor() {
    super("Zone is an abstract class");
  }
}
const Ce = "numeric", wn = "short", Kt = "long", wr = {
  year: Ce,
  month: Ce,
  day: Ce
}, Oc = {
  year: Ce,
  month: wn,
  day: Ce
}, g0 = {
  year: Ce,
  month: wn,
  day: Ce,
  weekday: wn
}, _c = {
  year: Ce,
  month: Kt,
  day: Ce
}, Ec = {
  year: Ce,
  month: Kt,
  day: Ce,
  weekday: Kt
}, Ic = {
  hour: Ce,
  minute: Ce
}, Pc = {
  hour: Ce,
  minute: Ce,
  second: Ce
}, Ac = {
  hour: Ce,
  minute: Ce,
  second: Ce,
  timeZoneName: wn
}, Rc = {
  hour: Ce,
  minute: Ce,
  second: Ce,
  timeZoneName: Kt
}, Vc = {
  hour: Ce,
  minute: Ce,
  hourCycle: "h23"
}, Fc = {
  hour: Ce,
  minute: Ce,
  second: Ce,
  hourCycle: "h23"
}, Lc = {
  hour: Ce,
  minute: Ce,
  second: Ce,
  hourCycle: "h23",
  timeZoneName: wn
}, Nc = {
  hour: Ce,
  minute: Ce,
  second: Ce,
  hourCycle: "h23",
  timeZoneName: Kt
}, Bc = {
  year: Ce,
  month: Ce,
  day: Ce,
  hour: Ce,
  minute: Ce
}, zc = {
  year: Ce,
  month: Ce,
  day: Ce,
  hour: Ce,
  minute: Ce,
  second: Ce
}, Wc = {
  year: Ce,
  month: wn,
  day: Ce,
  hour: Ce,
  minute: Ce
}, Yc = {
  year: Ce,
  month: wn,
  day: Ce,
  hour: Ce,
  minute: Ce,
  second: Ce
}, y0 = {
  year: Ce,
  month: wn,
  day: Ce,
  weekday: wn,
  hour: Ce,
  minute: Ce
}, Hc = {
  year: Ce,
  month: Kt,
  day: Ce,
  hour: Ce,
  minute: Ce,
  timeZoneName: wn
}, Uc = {
  year: Ce,
  month: Kt,
  day: Ce,
  hour: Ce,
  minute: Ce,
  second: Ce,
  timeZoneName: wn
}, qc = {
  year: Ce,
  month: Kt,
  day: Ce,
  weekday: Kt,
  hour: Ce,
  minute: Ce,
  timeZoneName: Kt
}, jc = {
  year: Ce,
  month: Kt,
  day: Ce,
  weekday: Kt,
  hour: Ce,
  minute: Ce,
  second: Ce,
  timeZoneName: Kt
};
class Ls {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new qn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new qn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new qn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, t) {
    throw new qn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    throw new qn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new qn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new qn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new qn();
  }
}
let rl = null;
class Br extends Ls {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return rl === null && (rl = new Br()), rl;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: t, locale: a }) {
    return sd(n, t, a);
  }
  /** @override **/
  formatOffset(n, t) {
    return ks(this.offset(n), t);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Fl = /* @__PURE__ */ new Map();
function b0(e) {
  let n = Fl.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Fl.set(e, n)), n;
}
const w0 = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function k0(e, n) {
  const t = e.format(n).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(t), [, s, r, l, i, o, u, c] = a;
  return [l, s, r, i, o, u, c];
}
function x0(e, n) {
  const t = e.formatToParts(n), a = [];
  for (let s = 0; s < t.length; s++) {
    const { type: r, value: l } = t[s], i = w0[r];
    r === "era" ? a[i] = l : Ne(i) || (a[i] = parseInt(l, 10));
  }
  return a;
}
const ll = /* @__PURE__ */ new Map();
class Bn extends Ls {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    let t = ll.get(n);
    return t === void 0 && ll.set(n, t = new Bn(n)), t;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ll.clear(), Fl.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = Bn.isValidZone(n);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, { format: t, locale: a }) {
    return sd(n, t, a, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return ks(this.offset(n), t);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    if (!this.valid) return NaN;
    const t = new Date(n);
    if (isNaN(t)) return NaN;
    const a = b0(this.name);
    let [s, r, l, i, o, u, c] = a.formatToParts ? x0(a, t) : k0(a, t);
    i === "BC" && (s = -Math.abs(s) + 1);
    const h = Wr({
      year: s,
      month: r,
      day: l,
      hour: o === 24 ? 0 : o,
      minute: u,
      second: c,
      millisecond: 0
    });
    let d = +t;
    const g = d % 1e3;
    return d -= g >= 0 ? g : 1e3 + g, (h - d) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let yo = {};
function S0(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = yo[t];
  return a || (a = new Intl.ListFormat(e, n), yo[t] = a), a;
}
const Ll = /* @__PURE__ */ new Map();
function Nl(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Ll.get(t);
  return a === void 0 && (a = new Intl.DateTimeFormat(e, n), Ll.set(t, a)), a;
}
const Bl = /* @__PURE__ */ new Map();
function T0(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Bl.get(t);
  return a === void 0 && (a = new Intl.NumberFormat(e, n), Bl.set(t, a)), a;
}
const zl = /* @__PURE__ */ new Map();
function M0(e, n = {}) {
  const { base: t, ...a } = n, s = JSON.stringify([e, a]);
  let r = zl.get(s);
  return r === void 0 && (r = new Intl.RelativeTimeFormat(e, n), zl.set(s, r)), r;
}
let ps = null;
function $0() {
  return ps || (ps = new Intl.DateTimeFormat().resolvedOptions().locale, ps);
}
const Wl = /* @__PURE__ */ new Map();
function Gc(e) {
  let n = Wl.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat(e).resolvedOptions(), Wl.set(e, n)), n;
}
const Yl = /* @__PURE__ */ new Map();
function C0(e) {
  let n = Yl.get(e);
  if (!n) {
    const t = new Intl.Locale(e);
    n = "getWeekInfo" in t ? t.getWeekInfo() : t.weekInfo, "minimalDays" in n || (n = { ...Kc, ...n }), Yl.set(e, n);
  }
  return n;
}
function D0(e) {
  const n = e.indexOf("-x-");
  n !== -1 && (e = e.substring(0, n));
  const t = e.indexOf("-u-");
  if (t === -1)
    return [e];
  {
    let a, s;
    try {
      a = Nl(e).resolvedOptions(), s = e;
    } catch {
      const o = e.substring(0, t);
      a = Nl(o).resolvedOptions(), s = o;
    }
    const { numberingSystem: r, calendar: l } = a;
    return [s, r, l];
  }
}
function O0(e, n, t) {
  return (t || n) && (e.includes("-u-") || (e += "-u"), t && (e += `-ca-${t}`), n && (e += `-nu-${n}`)), e;
}
function _0(e) {
  const n = [];
  for (let t = 1; t <= 12; t++) {
    const a = Ie.utc(2009, t, 1);
    n.push(e(a));
  }
  return n;
}
function E0(e) {
  const n = [];
  for (let t = 1; t <= 7; t++) {
    const a = Ie.utc(2016, 11, 13 + t);
    n.push(e(a));
  }
  return n;
}
function Js(e, n, t, a) {
  const s = e.listingMode();
  return s === "error" ? null : s === "en" ? t(n) : a(n);
}
function I0(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || Gc(e.locale).numberingSystem === "latn";
}
class P0 {
  constructor(n, t, a) {
    this.padTo = a.padTo || 0, this.floor = a.floor || !1;
    const { padTo: s, floor: r, ...l } = a;
    if (!t || Object.keys(l).length > 0) {
      const i = { useGrouping: !1, ...a };
      a.padTo > 0 && (i.minimumIntegerDigits = a.padTo), this.inf = T0(n, i);
    }
  }
  format(n) {
    if (this.inf) {
      const t = this.floor ? Math.floor(n) : n;
      return this.inf.format(t);
    } else {
      const t = this.floor ? Math.floor(n) : xi(n, 3);
      return Tt(t, this.padTo);
    }
  }
}
class A0 {
  constructor(n, t, a) {
    this.opts = a, this.originalZone = void 0;
    let s;
    if (this.opts.timeZone)
      this.dt = n;
    else if (n.zone.type === "fixed") {
      const l = -1 * (n.offset / 60), i = l >= 0 ? `Etc/GMT+${l}` : `Etc/GMT${l}`;
      n.offset !== 0 && Bn.create(i).valid ? (s = i, this.dt = n) : (s = "UTC", this.dt = n.offset === 0 ? n : n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    } else n.zone.type === "system" ? this.dt = n : n.zone.type === "iana" ? (this.dt = n, s = n.zone.name) : (s = "UTC", this.dt = n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    const r = { ...this.opts };
    r.timeZone = r.timeZone || s, this.dtf = Nl(t, r);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: n }) => n).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const n = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? n.map((t) => {
      if (t.type === "timeZoneName") {
        const a = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...t,
          value: a
        };
      } else
        return t;
    }) : n;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class R0 {
  constructor(n, t, a) {
    this.opts = { style: "long", ...a }, !t && nd() && (this.rtf = M0(n, a));
  }
  format(n, t) {
    return this.rtf ? this.rtf.format(n, t) : ab(t, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, t) {
    return this.rtf ? this.rtf.formatToParts(n, t) : [];
  }
}
const Kc = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class rt {
  static fromOpts(n) {
    return rt.create(
      n.locale,
      n.numberingSystem,
      n.outputCalendar,
      n.weekSettings,
      n.defaultToEN
    );
  }
  static create(n, t, a, s, r = !1) {
    const l = n || gt.defaultLocale, i = l || (r ? "en-US" : $0()), o = t || gt.defaultNumberingSystem, u = a || gt.defaultOutputCalendar, c = Ul(s) || gt.defaultWeekSettings;
    return new rt(i, o, u, c, l);
  }
  static resetCache() {
    ps = null, Ll.clear(), Bl.clear(), zl.clear(), Wl.clear(), Yl.clear();
  }
  static fromObject({ locale: n, numberingSystem: t, outputCalendar: a, weekSettings: s } = {}) {
    return rt.create(n, t, a, s);
  }
  constructor(n, t, a, s, r) {
    const [l, i, o] = D0(n);
    this.locale = l, this.numberingSystem = t || i || null, this.outputCalendar = a || o || null, this.weekSettings = s, this.intl = O0(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = r, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = I0(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), t = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && t ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : rt.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      Ul(n.weekSettings) || this.weekSettings,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, t = !1) {
    return Js(this, n, id, () => {
      const a = this.intl === "ja" || this.intl.startsWith("ja-");
      t &= !a;
      const s = t ? { month: n, day: "numeric" } : { month: n }, r = t ? "format" : "standalone";
      if (!this.monthsCache[r][n]) {
        const l = a ? (i) => this.dtFormatter(i, s).format() : (i) => this.extract(i, s, "month");
        this.monthsCache[r][n] = _0(l);
      }
      return this.monthsCache[r][n];
    });
  }
  weekdays(n, t = !1) {
    return Js(this, n, cd, () => {
      const a = t ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, s = t ? "format" : "standalone";
      return this.weekdaysCache[s][n] || (this.weekdaysCache[s][n] = E0(
        (r) => this.extract(r, a, "weekday")
      )), this.weekdaysCache[s][n];
    });
  }
  meridiems() {
    return Js(
      this,
      void 0,
      () => dd,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Ie.utc(2016, 11, 13, 9), Ie.utc(2016, 11, 13, 19)].map(
            (t) => this.extract(t, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n) {
    return Js(this, n, fd, () => {
      const t = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [Ie.utc(-40, 1, 1), Ie.utc(2017, 1, 1)].map(
        (a) => this.extract(a, t, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, t, a) {
    const s = this.dtFormatter(n, t), r = s.formatToParts(), l = r.find((i) => i.type.toLowerCase() === a);
    return l ? l.value : null;
  }
  numberFormatter(n = {}) {
    return new P0(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, t = {}) {
    return new A0(n, this.intl, t);
  }
  relFormatter(n = {}) {
    return new R0(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return S0(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || Gc(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : ad() ? C0(this.locale) : Kc;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let il = null;
class Lt extends Ls {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return il === null && (il = new Lt(0)), il;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? Lt.utcInstance : new Lt(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const t = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (t)
        return new Lt(Yr(t[1], t[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${ks(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${ks(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return ks(this.fixed, t);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class V0 extends Ls {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Zn(e, n) {
  if (Ne(e) || e === null)
    return n;
  if (e instanceof Ls)
    return e;
  if (W0(e)) {
    const t = e.toLowerCase();
    return t === "default" ? n : t === "local" || t === "system" ? Br.instance : t === "utc" || t === "gmt" ? Lt.utcInstance : Lt.parseSpecifier(t) || Bn.create(e);
  } else return Jn(e) ? Lt.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new V0(e);
}
const yi = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, bo = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, F0 = yi.hanidec.replace(/[\[|\]]/g, "").split("");
function L0(e) {
  let n = parseInt(e, 10);
  if (isNaN(n)) {
    n = "";
    for (let t = 0; t < e.length; t++) {
      const a = e.charCodeAt(t);
      if (e[t].search(yi.hanidec) !== -1)
        n += F0.indexOf(e[t]);
      else
        for (const s in bo) {
          const [r, l] = bo[s];
          a >= r && a <= l && (n += a - r);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
const Hl = /* @__PURE__ */ new Map();
function N0() {
  Hl.clear();
}
function un({ numberingSystem: e }, n = "") {
  const t = e || "latn";
  let a = Hl.get(t);
  a === void 0 && (a = /* @__PURE__ */ new Map(), Hl.set(t, a));
  let s = a.get(n);
  return s === void 0 && (s = new RegExp(`${yi[t]}${n}`), a.set(n, s)), s;
}
let wo = () => Date.now(), ko = "system", xo = null, So = null, To = null, Mo = 60, $o, Co = null;
class gt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return wo;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    wo = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    ko = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Zn(ko, Br.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return xo;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    xo = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return So;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    So = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return To;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    To = n;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Co;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(n) {
    Co = Ul(n);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return Mo;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(n) {
    Mo = n % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return $o;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    $o = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    rt.resetCache(), Bn.resetCache(), Ie.resetCache(), N0();
  }
}
class pn {
  constructor(n, t) {
    this.reason = n, this.explanation = t;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const Zc = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Xc = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function tn(e, n) {
  return new pn(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${e}, which is invalid`
  );
}
function bi(e, n, t) {
  const a = new Date(Date.UTC(e, n - 1, t));
  e < 100 && e >= 0 && a.setUTCFullYear(a.getUTCFullYear() - 1900);
  const s = a.getUTCDay();
  return s === 0 ? 7 : s;
}
function Jc(e, n, t) {
  return t + (Ns(e) ? Xc : Zc)[n - 1];
}
function Qc(e, n) {
  const t = Ns(e) ? Xc : Zc, a = t.findIndex((r) => r < n), s = n - t[a];
  return { month: a + 1, day: s };
}
function wi(e, n) {
  return (e - n + 7) % 7 + 1;
}
function kr(e, n = 4, t = 1) {
  const { year: a, month: s, day: r } = e, l = Jc(a, s, r), i = wi(bi(a, s, r), t);
  let o = Math.floor((l - i + 14 - n) / 7), u;
  return o < 1 ? (u = a - 1, o = $s(u, n, t)) : o > $s(a, n, t) ? (u = a + 1, o = 1) : u = a, { weekYear: u, weekNumber: o, weekday: i, ...Hr(e) };
}
function Do(e, n = 4, t = 1) {
  const { weekYear: a, weekNumber: s, weekday: r } = e, l = wi(bi(a, 1, n), t), i = Ba(a);
  let o = s * 7 + r - l - 7 + n, u;
  o < 1 ? (u = a - 1, o += Ba(u)) : o > i ? (u = a + 1, o -= Ba(a)) : u = a;
  const { month: c, day: f } = Qc(u, o);
  return { year: u, month: c, day: f, ...Hr(e) };
}
function ol(e) {
  const { year: n, month: t, day: a } = e, s = Jc(n, t, a);
  return { year: n, ordinal: s, ...Hr(e) };
}
function Oo(e) {
  const { year: n, ordinal: t } = e, { month: a, day: s } = Qc(n, t);
  return { year: n, month: a, day: s, ...Hr(e) };
}
function _o(e, n) {
  if (!Ne(e.localWeekday) || !Ne(e.localWeekNumber) || !Ne(e.localWeekYear)) {
    if (!Ne(e.weekday) || !Ne(e.weekNumber) || !Ne(e.weekYear))
      throw new Ra(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Ne(e.localWeekday) || (e.weekday = e.localWeekday), Ne(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Ne(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function B0(e, n = 4, t = 1) {
  const a = zr(e.weekYear), s = nn(
    e.weekNumber,
    1,
    $s(e.weekYear, n, t)
  ), r = nn(e.weekday, 1, 7);
  return a ? s ? r ? !1 : tn("weekday", e.weekday) : tn("week", e.weekNumber) : tn("weekYear", e.weekYear);
}
function z0(e) {
  const n = zr(e.year), t = nn(e.ordinal, 1, Ba(e.year));
  return n ? t ? !1 : tn("ordinal", e.ordinal) : tn("year", e.year);
}
function ed(e) {
  const n = zr(e.year), t = nn(e.month, 1, 12), a = nn(e.day, 1, xr(e.year, e.month));
  return n ? t ? a ? !1 : tn("day", e.day) : tn("month", e.month) : tn("year", e.year);
}
function td(e) {
  const { hour: n, minute: t, second: a, millisecond: s } = e, r = nn(n, 0, 23) || n === 24 && t === 0 && a === 0 && s === 0, l = nn(t, 0, 59), i = nn(a, 0, 59), o = nn(s, 0, 999);
  return r ? l ? i ? o ? !1 : tn("millisecond", s) : tn("second", a) : tn("minute", t) : tn("hour", n);
}
function Ne(e) {
  return typeof e > "u";
}
function Jn(e) {
  return typeof e == "number";
}
function zr(e) {
  return typeof e == "number" && e % 1 === 0;
}
function W0(e) {
  return typeof e == "string";
}
function Y0(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function nd() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function ad() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function H0(e) {
  return Array.isArray(e) ? e : [e];
}
function Eo(e, n, t) {
  if (e.length !== 0)
    return e.reduce((a, s) => {
      const r = [n(s), s];
      return a && t(a[0], r[0]) === a[0] ? a : r;
    }, null)[1];
}
function U0(e, n) {
  return n.reduce((t, a) => (t[a] = e[a], t), {});
}
function Ga(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function Ul(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Pt("Week settings must be an object");
  if (!nn(e.firstDay, 1, 7) || !nn(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((n) => !nn(n, 1, 7)))
    throw new Pt("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function nn(e, n, t) {
  return zr(e) && e >= n && e <= t;
}
function q0(e, n) {
  return e - n * Math.floor(e / n);
}
function Tt(e, n = 2) {
  const t = e < 0;
  let a;
  return t ? a = "-" + ("" + -e).padStart(n, "0") : a = ("" + e).padStart(n, "0"), a;
}
function Kn(e) {
  if (!(Ne(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function ra(e) {
  if (!(Ne(e) || e === null || e === ""))
    return parseFloat(e);
}
function ki(e) {
  if (!(Ne(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function xi(e, n, t = "round") {
  const a = 10 ** n;
  switch (t) {
    case "expand":
      return e > 0 ? Math.ceil(e * a) / a : Math.floor(e * a) / a;
    case "trunc":
      return Math.trunc(e * a) / a;
    case "round":
      return Math.round(e * a) / a;
    case "floor":
      return Math.floor(e * a) / a;
    case "ceil":
      return Math.ceil(e * a) / a;
    default:
      throw new RangeError(`Value rounding ${t} is out of range`);
  }
}
function Ns(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Ba(e) {
  return Ns(e) ? 366 : 365;
}
function xr(e, n) {
  const t = q0(n - 1, 12) + 1, a = e + (n - t) / 12;
  return t === 2 ? Ns(a) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][t - 1];
}
function Wr(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(e.year, e.month - 1, e.day)), +n;
}
function Io(e, n, t) {
  return -wi(bi(e, 1, n), t) + n - 1;
}
function $s(e, n = 4, t = 1) {
  const a = Io(e, n, t), s = Io(e + 1, n, t);
  return (Ba(e) - a + s) / 7;
}
function ql(e) {
  return e > 99 ? e : e > gt.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function sd(e, n, t, a = null) {
  const s = new Date(e), r = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  a && (r.timeZone = a);
  const l = { timeZoneName: n, ...r }, i = new Intl.DateTimeFormat(t, l).formatToParts(s).find((o) => o.type.toLowerCase() === "timezonename");
  return i ? i.value : null;
}
function Yr(e, n) {
  let t = parseInt(e, 10);
  Number.isNaN(t) && (t = 0);
  const a = parseInt(n, 10) || 0, s = t < 0 || Object.is(t, -0) ? -a : a;
  return t * 60 + s;
}
function rd(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(n))
    throw new Pt(`Invalid unit value ${e}`);
  return n;
}
function Sr(e, n) {
  const t = {};
  for (const a in e)
    if (Ga(e, a)) {
      const s = e[a];
      if (s == null) continue;
      t[n(a)] = rd(s);
    }
  return t;
}
function ks(e, n) {
  const t = Math.trunc(Math.abs(e / 60)), a = Math.trunc(Math.abs(e % 60)), s = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${s}${Tt(t, 2)}:${Tt(a, 2)}`;
    case "narrow":
      return `${s}${t}${a > 0 ? `:${a}` : ""}`;
    case "techie":
      return `${s}${Tt(t, 2)}${Tt(a, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Hr(e) {
  return U0(e, ["hour", "minute", "second", "millisecond"]);
}
const j0 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], ld = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], G0 = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function id(e) {
  switch (e) {
    case "narrow":
      return [...G0];
    case "short":
      return [...ld];
    case "long":
      return [...j0];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const od = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], ud = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], K0 = ["M", "T", "W", "T", "F", "S", "S"];
function cd(e) {
  switch (e) {
    case "narrow":
      return [...K0];
    case "short":
      return [...ud];
    case "long":
      return [...od];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const dd = ["AM", "PM"], Z0 = ["Before Christ", "Anno Domini"], X0 = ["BC", "AD"], J0 = ["B", "A"];
function fd(e) {
  switch (e) {
    case "narrow":
      return [...J0];
    case "short":
      return [...X0];
    case "long":
      return [...Z0];
    default:
      return null;
  }
}
function Q0(e) {
  return dd[e.hour < 12 ? 0 : 1];
}
function eb(e, n) {
  return cd(n)[e.weekday - 1];
}
function tb(e, n) {
  return id(n)[e.month - 1];
}
function nb(e, n) {
  return fd(n)[e.year < 0 ? 0 : 1];
}
function ab(e, n, t = "always", a = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, r = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (t === "auto" && r) {
    const f = e === "days";
    switch (n) {
      case 1:
        return f ? "tomorrow" : `next ${s[e][0]}`;
      case -1:
        return f ? "yesterday" : `last ${s[e][0]}`;
      case 0:
        return f ? "today" : `this ${s[e][0]}`;
    }
  }
  const l = Object.is(n, -0) || n < 0, i = Math.abs(n), o = i === 1, u = s[e], c = a ? o ? u[1] : u[2] || u[1] : o ? s[e][0] : e;
  return l ? `${i} ${c} ago` : `in ${i} ${c}`;
}
function Po(e, n) {
  let t = "";
  for (const a of e)
    a.literal ? t += a.val : t += n(a.val);
  return t;
}
const sb = {
  D: wr,
  DD: Oc,
  DDD: _c,
  DDDD: Ec,
  t: Ic,
  tt: Pc,
  ttt: Ac,
  tttt: Rc,
  T: Vc,
  TT: Fc,
  TTT: Lc,
  TTTT: Nc,
  f: Bc,
  ff: Wc,
  fff: Hc,
  ffff: qc,
  F: zc,
  FF: Yc,
  FFF: Uc,
  FFFF: jc
};
class At {
  static create(n, t = {}) {
    return new At(n, t);
  }
  static parseFormat(n) {
    let t = null, a = "", s = !1;
    const r = [];
    for (let l = 0; l < n.length; l++) {
      const i = n.charAt(l);
      i === "'" ? ((a.length > 0 || s) && r.push({
        literal: s || /^\s+$/.test(a),
        val: a === "" ? "'" : a
      }), t = null, a = "", s = !s) : s || i === t ? a += i : (a.length > 0 && r.push({ literal: /^\s+$/.test(a), val: a }), a = i, t = i);
    }
    return a.length > 0 && r.push({ literal: s || /^\s+$/.test(a), val: a }), r;
  }
  static macroTokenToFormatOpts(n) {
    return sb[n];
  }
  constructor(n, t) {
    this.opts = t, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, t) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...t }).format();
  }
  dtFormatter(n, t = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...t });
  }
  formatDateTime(n, t) {
    return this.dtFormatter(n, t).format();
  }
  formatDateTimeParts(n, t) {
    return this.dtFormatter(n, t).formatToParts();
  }
  formatInterval(n, t) {
    return this.dtFormatter(n.start, t).dtf.formatRange(n.start.toJSDate(), n.end.toJSDate());
  }
  resolvedOptions(n, t) {
    return this.dtFormatter(n, t).resolvedOptions();
  }
  num(n, t = 0, a = void 0) {
    if (this.opts.forceSimple)
      return Tt(n, t);
    const s = { ...this.opts };
    return t > 0 && (s.padTo = t), a && (s.signDisplay = a), this.loc.numberFormatter(s).format(n);
  }
  formatDateTimeFromString(n, t) {
    const a = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", r = (d, g) => this.loc.extract(n, d, g), l = (d) => n.isOffsetFixed && n.offset === 0 && d.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, d.format) : "", i = () => a ? Q0(n) : r({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), o = (d, g) => a ? tb(n, d) : r(g ? { month: d } : { month: d, day: "numeric" }, "month"), u = (d, g) => a ? eb(n, d) : r(
      g ? { weekday: d } : { weekday: d, month: "long", day: "numeric" },
      "weekday"
    ), c = (d) => {
      const g = At.macroTokenToFormatOpts(d);
      return g ? this.formatWithSystemDefault(n, g) : d;
    }, f = (d) => a ? nb(n, d) : r({ era: d }, "era"), h = (d) => {
      switch (d) {
        // ms
        case "S":
          return this.num(n.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(n.millisecond, 3);
        // seconds
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        // minutes
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        // hours
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        // offset
        case "Z":
          return l({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return l({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return l({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return n.zoneName;
        // meridiems
        case "a":
          return i();
        // dates
        case "d":
          return s ? r({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return s ? r({ day: "2-digit" }, "day") : this.num(n.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return s ? r({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return s ? r({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return o("short", !0);
        case "LLLL":
          return o("long", !0);
        case "LLLLL":
          return o("narrow", !0);
        // months - format
        case "M":
          return s ? r({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return s ? r({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return o("short", !1);
        case "MMMM":
          return o("long", !1);
        case "MMMMM":
          return o("narrow", !1);
        // years
        case "y":
          return s ? r({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return s ? r({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? r({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return s ? r({ year: "numeric" }, "year") : this.num(n.year, 6);
        // eras
        case "G":
          return f("short");
        case "GG":
          return f("long");
        case "GGGGG":
          return f("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "n":
          return this.num(n.localWeekNumber);
        case "nn":
          return this.num(n.localWeekNumber, 2);
        case "ii":
          return this.num(n.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(n.localWeekYear, 4);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return c(d);
      }
    };
    return Po(At.parseFormat(t), h);
  }
  formatDurationFromString(n, t) {
    const a = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, s = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, r = (c, f) => (h) => {
      const d = s(h);
      if (d) {
        const g = f.isNegativeDuration && d !== f.largestUnit ? a : 1;
        let y;
        return this.opts.signMode === "negativeLargestOnly" && d !== f.largestUnit ? y = "never" : this.opts.signMode === "all" ? y = "always" : y = "auto", this.num(c.get(d) * g, h.length, y);
      } else
        return h;
    }, l = At.parseFormat(t), i = l.reduce(
      (c, { literal: f, val: h }) => f ? c : c.concat(h),
      []
    ), o = n.shiftTo(...i.map(s).filter((c) => c)), u = {
      isNegativeDuration: o < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(o.values)[0]
    };
    return Po(l, r(o, u));
  }
}
const hd = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Xa(...e) {
  const n = e.reduce((t, a) => t + a.source, "");
  return RegExp(`^${n}$`);
}
function Ja(...e) {
  return (n) => e.reduce(
    ([t, a, s], r) => {
      const [l, i, o] = r(n, s);
      return [{ ...t, ...l }, i || a, o];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Qa(e, ...n) {
  if (e == null)
    return [null, null];
  for (const [t, a] of n) {
    const s = t.exec(e);
    if (s)
      return a(s);
  }
  return [null, null];
}
function md(...e) {
  return (n, t) => {
    const a = {};
    let s;
    for (s = 0; s < e.length; s++)
      a[e[s]] = Kn(n[t + s]);
    return [a, null, t + s];
  };
}
const vd = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, rb = `(?:${vd.source}?(?:\\[(${hd.source})\\])?)?`, Si = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, pd = RegExp(`${Si.source}${rb}`), Ti = RegExp(`(?:[Tt]${pd.source})?`), lb = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, ib = /(\d{4})-?W(\d\d)(?:-?(\d))?/, ob = /(\d{4})-?(\d{3})/, ub = md("weekYear", "weekNumber", "weekDay"), cb = md("year", "ordinal"), db = /(\d{4})-(\d\d)-(\d\d)/, gd = RegExp(
  `${Si.source} ?(?:${vd.source}|(${hd.source}))?`
), fb = RegExp(`(?: ${gd.source})?`);
function za(e, n, t) {
  const a = e[n];
  return Ne(a) ? t : Kn(a);
}
function hb(e, n) {
  return [{
    year: za(e, n),
    month: za(e, n + 1, 1),
    day: za(e, n + 2, 1)
  }, null, n + 3];
}
function es(e, n) {
  return [{
    hours: za(e, n, 0),
    minutes: za(e, n + 1, 0),
    seconds: za(e, n + 2, 0),
    milliseconds: ki(e[n + 3])
  }, null, n + 4];
}
function Bs(e, n) {
  const t = !e[n] && !e[n + 1], a = Yr(e[n + 1], e[n + 2]), s = t ? null : Lt.instance(a);
  return [{}, s, n + 3];
}
function zs(e, n) {
  const t = e[n] ? Bn.create(e[n]) : null;
  return [{}, t, n + 1];
}
const mb = RegExp(`^T?${Si.source}$`), vb = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function pb(e) {
  const [n, t, a, s, r, l, i, o, u] = e, c = n[0] === "-", f = o && o[0] === "-", h = (d, g = !1) => d !== void 0 && (g || d && c) ? -d : d;
  return [
    {
      years: h(ra(t)),
      months: h(ra(a)),
      weeks: h(ra(s)),
      days: h(ra(r)),
      hours: h(ra(l)),
      minutes: h(ra(i)),
      seconds: h(ra(o), o === "-0"),
      milliseconds: h(ki(u), f)
    }
  ];
}
const gb = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Mi(e, n, t, a, s, r, l) {
  const i = {
    year: n.length === 2 ? ql(Kn(n)) : Kn(n),
    month: ld.indexOf(t) + 1,
    day: Kn(a),
    hour: Kn(s),
    minute: Kn(r)
  };
  return l && (i.second = Kn(l)), e && (i.weekday = e.length > 3 ? od.indexOf(e) + 1 : ud.indexOf(e) + 1), i;
}
const yb = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function bb(e) {
  const [
    ,
    n,
    t,
    a,
    s,
    r,
    l,
    i,
    o,
    u,
    c,
    f
  ] = e, h = Mi(n, s, a, t, r, l, i);
  let d;
  return o ? d = gb[o] : u ? d = 0 : d = Yr(c, f), [h, new Lt(d)];
}
function wb(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const kb = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, xb = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Sb = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Ao(e) {
  const [, n, t, a, s, r, l, i] = e;
  return [Mi(n, s, a, t, r, l, i), Lt.utcInstance];
}
function Tb(e) {
  const [, n, t, a, s, r, l, i] = e;
  return [Mi(n, i, t, a, s, r, l), Lt.utcInstance];
}
const Mb = Xa(lb, Ti), $b = Xa(ib, Ti), Cb = Xa(ob, Ti), Db = Xa(pd), yd = Ja(
  hb,
  es,
  Bs,
  zs
), Ob = Ja(
  ub,
  es,
  Bs,
  zs
), _b = Ja(
  cb,
  es,
  Bs,
  zs
), Eb = Ja(
  es,
  Bs,
  zs
);
function Ib(e) {
  return Qa(
    e,
    [Mb, yd],
    [$b, Ob],
    [Cb, _b],
    [Db, Eb]
  );
}
function Pb(e) {
  return Qa(wb(e), [yb, bb]);
}
function Ab(e) {
  return Qa(
    e,
    [kb, Ao],
    [xb, Ao],
    [Sb, Tb]
  );
}
function Rb(e) {
  return Qa(e, [vb, pb]);
}
const Vb = Ja(es);
function Fb(e) {
  return Qa(e, [mb, Vb]);
}
const Lb = Xa(db, fb), Nb = Xa(gd), Bb = Ja(
  es,
  Bs,
  zs
);
function zb(e) {
  return Qa(
    e,
    [Lb, yd],
    [Nb, Bb]
  );
}
const Ro = "Invalid Duration", bd = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Wb = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...bd
}, Xt = 146097 / 400, $a = 146097 / 4800, Yb = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Xt / 7,
    days: Xt,
    hours: Xt * 24,
    minutes: Xt * 24 * 60,
    seconds: Xt * 24 * 60 * 60,
    milliseconds: Xt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Xt / 28,
    days: Xt / 4,
    hours: Xt * 24 / 4,
    minutes: Xt * 24 * 60 / 4,
    seconds: Xt * 24 * 60 * 60 / 4,
    milliseconds: Xt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: $a / 7,
    days: $a,
    hours: $a * 24,
    minutes: $a * 24 * 60,
    seconds: $a * 24 * 60 * 60,
    milliseconds: $a * 24 * 60 * 60 * 1e3
  },
  ...bd
}, ha = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Hb = ha.slice(0).reverse();
function Rn(e, n, t = !1) {
  const a = {
    values: t ? n.values : { ...e.values, ...n.values || {} },
    loc: e.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || e.conversionAccuracy,
    matrix: n.matrix || e.matrix
  };
  return new Je(a);
}
function wd(e, n) {
  let t = n.milliseconds ?? 0;
  for (const a of Hb.slice(1))
    n[a] && (t += n[a] * e[a].milliseconds);
  return t;
}
function Vo(e, n) {
  const t = wd(e, n) < 0 ? -1 : 1;
  ha.reduceRight((a, s) => {
    if (Ne(n[s]))
      return a;
    if (a) {
      const r = n[a] * t, l = e[s][a], i = Math.floor(r / l);
      n[s] += i * t, n[a] -= i * l * t;
    }
    return s;
  }, null), ha.reduce((a, s) => {
    if (Ne(n[s]))
      return a;
    if (a) {
      const r = n[a] % 1;
      n[a] -= r, n[s] += r * e[a][s];
    }
    return s;
  }, null);
}
function Fo(e) {
  const n = {};
  for (const [t, a] of Object.entries(e))
    a !== 0 && (n[t] = a);
  return n;
}
class Je {
  /**
   * @private
   */
  constructor(n) {
    const t = n.conversionAccuracy === "longterm" || !1;
    let a = t ? Yb : Wb;
    n.matrix && (a = n.matrix), this.values = n.values, this.loc = n.loc || rt.create(), this.conversionAccuracy = t ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, t) {
    return Je.fromObject({ milliseconds: n }, t);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(n, t = {}) {
    if (n == null || typeof n != "object")
      throw new Pt(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new Je({
      values: Sr(n, Je.normalizeUnit),
      loc: rt.fromObject(t),
      conversionAccuracy: t.conversionAccuracy,
      matrix: t.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (Jn(n))
      return Je.fromMillis(n);
    if (Je.isDuration(n))
      return n;
    if (typeof n == "object")
      return Je.fromObject(n);
    throw new Pt(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, t) {
    const [a] = Rb(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, t) {
    const [a] = Fb(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Pt("need to specify a reason the Duration is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (gt.throwOnInvalid)
      throw new p0(a);
    return new Je({ invalid: a });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const t = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!t) throw new Dc(n);
    return t;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(n, t = {}) {
    const a = {
      ...t,
      floor: t.round !== !1 && t.floor !== !1
    };
    return this.isValid ? At.create(this.loc, a).formatDurationFromString(this, n) : Ro;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(n = {}) {
    if (!this.isValid) return Ro;
    const t = n.showZeros !== !1, a = ha.map((s) => {
      const r = this.values[s];
      return Ne(r) || r === 0 && !t ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: s.slice(0, -1) }).format(r);
    }).filter((s) => s);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += xi(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const t = this.toMillis();
    return t < 0 || t >= 864e5 ? null : (n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n,
      includeOffset: !1
    }, Ie.fromMillis(t, { zone: "UTC" }).toISOTime(n));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? wd(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n), a = {};
    for (const s of ha)
      (Ga(t.values, s) || Ga(this.values, s)) && (a[s] = t.get(s) + this.get(s));
    return Rn(this, { values: a }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return this.plus(t.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const t = {};
    for (const a of Object.keys(this.values))
      t[a] = rd(n(this.values[a], a));
    return Rn(this, { values: t }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[Je.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = { ...this.values, ...Sr(n, Je.normalizeUnit) };
    return Rn(this, { values: t });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: t, conversionAccuracy: a, matrix: s } = {}) {
    const l = { loc: this.loc.clone({ locale: n, numberingSystem: t }), matrix: s, conversionAccuracy: a };
    return Rn(this, l);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return Vo(this.matrix, n), Rn(this, { values: n }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const n = Fo(this.normalize().shiftToAll().toObject());
    return Rn(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((l) => Je.normalizeUnit(l));
    const t = {}, a = {}, s = this.toObject();
    let r;
    for (const l of ha)
      if (n.indexOf(l) >= 0) {
        r = l;
        let i = 0;
        for (const u in a)
          i += this.matrix[u][l] * a[u], a[u] = 0;
        Jn(s[l]) && (i += s[l]);
        const o = Math.trunc(i);
        t[l] = o, a[l] = (i * 1e3 - o * 1e3) / 1e3;
      } else Jn(s[l]) && (a[l] = s[l]);
    for (const l in a)
      a[l] !== 0 && (t[r] += l === r ? a[l] : a[l] / this.matrix[r][l]);
    return Vo(this.matrix, t), Rn(this, { values: t }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const t of Object.keys(this.values))
      n[t] = this.values[t] === 0 ? 0 : -this.values[t];
    return Rn(this, { values: n }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const n = Fo(this.values);
    return Rn(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function t(a, s) {
      return a === void 0 || a === 0 ? s === void 0 || s === 0 : a === s;
    }
    for (const a of ha)
      if (!t(this.values[a], n.values[a]))
        return !1;
    return !0;
  }
}
const Ca = "Invalid Interval";
function Ub(e, n) {
  return !e || !e.isValid ? pt.invalid("missing or invalid start") : !n || !n.isValid ? pt.invalid("missing or invalid end") : n < e ? pt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${n.toISO()}`
  ) : null;
}
class pt {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Pt("need to specify a reason the Interval is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (gt.throwOnInvalid)
      throw new v0(a);
    return new pt({ invalid: a });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, t) {
    const a = fs(n), s = fs(t), r = Ub(a, s);
    return r ?? new pt({
      start: a,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, t) {
    const a = Je.fromDurationLike(t), s = fs(n);
    return pt.fromDateTimes(s, s.plus(a));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, t) {
    const a = Je.fromDurationLike(t), s = fs(n);
    return pt.fromDateTimes(s.minus(a), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, t) {
    const [a, s] = (n || "").split("/", 2);
    if (a && s) {
      let r, l;
      try {
        r = Ie.fromISO(a, t), l = r.isValid;
      } catch {
        l = !1;
      }
      let i, o;
      try {
        i = Ie.fromISO(s, t), o = i.isValid;
      } catch {
        o = !1;
      }
      if (l && o)
        return pt.fromDateTimes(r, i);
      if (l) {
        const u = Je.fromISO(s, t);
        if (u.isValid)
          return pt.after(r, u);
      } else if (o) {
        const u = Je.fromISO(a, t);
        if (u.isValid)
          return pt.before(i, u);
      }
    }
    return pt.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(n = "milliseconds", t) {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(n, t);
    let s;
    return t != null && t.useLocaleWeeks ? s = this.end.reconfigure({ locale: a.locale }) : s = this.end, s = s.startOf(n, t), Math.floor(s.diff(a, n).get(n)) + (s.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: t } = {}) {
    return this.isValid ? pt.fromDateTimes(n || this.s, t || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const t = n.map(fs).filter((l) => this.contains(l)).sort((l, i) => l.toMillis() - i.toMillis()), a = [];
    let { s } = this, r = 0;
    for (; s < this.e; ) {
      const l = t[r] || this.e, i = +l > +this.e ? this.e : l;
      a.push(pt.fromDateTimes(s, i)), s = i, r += 1;
    }
    return a;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const t = Je.fromDurationLike(n);
    if (!this.isValid || !t.isValid || t.as("milliseconds") === 0)
      return [];
    let { s: a } = this, s = 1, r;
    const l = [];
    for (; a < this.e; ) {
      const i = this.start.plus(t.mapUnits((o) => o * s));
      r = +i > +this.e ? this.e : i, l.push(pt.fromDateTimes(a, r)), a = r, s += 1;
    }
    return l;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const t = this.s > n.s ? this.s : n.s, a = this.e < n.e ? this.e : n.e;
    return t >= a ? null : pt.fromDateTimes(t, a);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const t = this.s < n.s ? this.s : n.s, a = this.e > n.e ? this.e : n.e;
    return pt.fromDateTimes(t, a);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [t, a] = n.sort((s, r) => s.s - r.s).reduce(
      ([s, r], l) => r ? r.overlaps(l) || r.abutsStart(l) ? [s, r.union(l)] : [s.concat([r]), l] : [s, l],
      [[], null]
    );
    return a && t.push(a), t;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let t = null, a = 0;
    const s = [], r = n.map((o) => [
      { time: o.s, type: "s" },
      { time: o.e, type: "e" }
    ]), l = Array.prototype.concat(...r), i = l.sort((o, u) => o.time - u.time);
    for (const o of i)
      a += o.type === "s" ? 1 : -1, a === 1 ? t = o.time : (t && +t != +o.time && s.push(pt.fromDateTimes(t, o.time)), t = null);
    return pt.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return pt.xor([this].concat(n)).map((t) => this.intersection(t)).filter((t) => t && !t.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Ca;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(n = wr, t = {}) {
    return this.isValid ? At.create(this.s.loc.clone(t), n).formatInterval(this) : Ca;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : Ca;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Ca;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : Ca;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(n, { separator: t = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${t}${this.e.toFormat(n)}` : Ca;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, t) {
    return this.isValid ? this.e.diff(this.s, n, t) : Je.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return pt.fromDateTimes(n(this.s), n(this.e));
  }
}
class Qs {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = gt.defaultZone) {
    const t = Ie.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && t.offset !== t.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return Bn.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return Zn(n, gt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || rt.create(n)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || rt.create(n)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: n = null, locObj: t = null } = {}) {
    return (t || rt.create(n)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: r = "gregory" } = {}) {
    return (s || rt.create(t, a, r)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: r = "gregory" } = {}) {
    return (s || rt.create(t, a, r)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || rt.create(t, a, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || rt.create(t, a, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return rt.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: t = null } = {}) {
    return rt.create(t, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: nd(), localeWeek: ad() };
  }
}
function Lo(e, n) {
  const t = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), a = t(n) - t(e);
  return Math.floor(Je.fromMillis(a).as("days"));
}
function qb(e, n, t) {
  const a = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter + (u.year - o.year) * 4],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const c = Lo(o, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", Lo]
  ], s = {}, r = e;
  let l, i;
  for (const [o, u] of a)
    t.indexOf(o) >= 0 && (l = o, s[o] = u(e, n), i = r.plus(s), i > n ? (s[o]--, e = r.plus(s), e > n && (i = e, s[o]--, e = r.plus(s))) : e = i);
  return [e, s, i, l];
}
function jb(e, n, t, a) {
  let [s, r, l, i] = qb(e, n, t);
  const o = n - s, u = t.filter(
    (f) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(f) >= 0
  );
  u.length === 0 && (l < n && (l = s.plus({ [i]: 1 })), l !== s && (r[i] = (r[i] || 0) + o / (l - s)));
  const c = Je.fromObject(r, a);
  return u.length > 0 ? Je.fromMillis(o, a).shiftTo(...u).plus(c) : c;
}
const Gb = "missing Intl.DateTimeFormat.formatToParts support";
function et(e, n = (t) => t) {
  return { regex: e, deser: ([t]) => n(L0(t)) };
}
const Kb = " ", kd = `[ ${Kb}]`, xd = new RegExp(kd, "g");
function Zb(e) {
  return e.replace(/\./g, "\\.?").replace(xd, kd);
}
function No(e) {
  return e.replace(/\./g, "").replace(xd, " ").toLowerCase();
}
function cn(e, n) {
  return e === null ? null : {
    regex: RegExp(e.map(Zb).join("|")),
    deser: ([t]) => e.findIndex((a) => No(t) === No(a)) + n
  };
}
function Bo(e, n) {
  return { regex: e, deser: ([, t, a]) => Yr(t, a), groups: n };
}
function er(e) {
  return { regex: e, deser: ([n]) => n };
}
function Xb(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Jb(e, n) {
  const t = un(n), a = un(n, "{2}"), s = un(n, "{3}"), r = un(n, "{4}"), l = un(n, "{6}"), i = un(n, "{1,2}"), o = un(n, "{1,3}"), u = un(n, "{1,6}"), c = un(n, "{1,9}"), f = un(n, "{2,4}"), h = un(n, "{4,6}"), d = (k) => ({ regex: RegExp(Xb(k.val)), deser: ([m]) => m, literal: !0 }), y = ((k) => {
    if (e.literal)
      return d(k);
    switch (k.val) {
      // era
      case "G":
        return cn(n.eras("short"), 0);
      case "GG":
        return cn(n.eras("long"), 0);
      // years
      case "y":
        return et(u);
      case "yy":
        return et(f, ql);
      case "yyyy":
        return et(r);
      case "yyyyy":
        return et(h);
      case "yyyyyy":
        return et(l);
      // months
      case "M":
        return et(i);
      case "MM":
        return et(a);
      case "MMM":
        return cn(n.months("short", !0), 1);
      case "MMMM":
        return cn(n.months("long", !0), 1);
      case "L":
        return et(i);
      case "LL":
        return et(a);
      case "LLL":
        return cn(n.months("short", !1), 1);
      case "LLLL":
        return cn(n.months("long", !1), 1);
      // dates
      case "d":
        return et(i);
      case "dd":
        return et(a);
      // ordinals
      case "o":
        return et(o);
      case "ooo":
        return et(s);
      // time
      case "HH":
        return et(a);
      case "H":
        return et(i);
      case "hh":
        return et(a);
      case "h":
        return et(i);
      case "mm":
        return et(a);
      case "m":
        return et(i);
      case "q":
        return et(i);
      case "qq":
        return et(a);
      case "s":
        return et(i);
      case "ss":
        return et(a);
      case "S":
        return et(o);
      case "SSS":
        return et(s);
      case "u":
        return er(c);
      case "uu":
        return er(i);
      case "uuu":
        return et(t);
      // meridiem
      case "a":
        return cn(n.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return et(r);
      case "kk":
        return et(f, ql);
      // weekNumber (W)
      case "W":
        return et(i);
      case "WW":
        return et(a);
      // weekdays
      case "E":
      case "c":
        return et(t);
      case "EEE":
        return cn(n.weekdays("short", !1), 1);
      case "EEEE":
        return cn(n.weekdays("long", !1), 1);
      case "ccc":
        return cn(n.weekdays("short", !0), 1);
      case "cccc":
        return cn(n.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Bo(new RegExp(`([+-]${i.source})(?::(${a.source}))?`), 2);
      case "ZZZ":
        return Bo(new RegExp(`([+-]${i.source})(${a.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return er(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return er(/[^\S\n\r]/);
      default:
        return d(k);
    }
  })(e) || {
    invalidReason: Gb
  };
  return y.token = e, y;
}
const Qb = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function ew(e, n, t) {
  const { type: a, value: s } = e;
  if (a === "literal") {
    const o = /^\s+$/.test(s);
    return {
      literal: !o,
      val: o ? " " : s
    };
  }
  const r = n[a];
  let l = a;
  a === "hour" && (n.hour12 != null ? l = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? l = "hour12" : l = "hour24" : l = t.hour12 ? "hour12" : "hour24");
  let i = Qb[l];
  if (typeof i == "object" && (i = i[r]), i)
    return {
      literal: !1,
      val: i
    };
}
function tw(e) {
  return [`^${e.map((t) => t.regex).reduce((t, a) => `${t}(${a.source})`, "")}$`, e];
}
function nw(e, n, t) {
  const a = e.match(n);
  if (a) {
    const s = {};
    let r = 1;
    for (const l in t)
      if (Ga(t, l)) {
        const i = t[l], o = i.groups ? i.groups + 1 : 1;
        !i.literal && i.token && (s[i.token.val[0]] = i.deser(a.slice(r, r + o))), r += o;
      }
    return [a, s];
  } else
    return [a, {}];
}
function aw(e) {
  const n = (r) => {
    switch (r) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let t = null, a;
  return Ne(e.z) || (t = Bn.create(e.z)), Ne(e.Z) || (t || (t = new Lt(e.Z)), a = e.Z), Ne(e.q) || (e.M = (e.q - 1) * 3 + 1), Ne(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Ne(e.u) || (e.S = ki(e.u)), [Object.keys(e).reduce((r, l) => {
    const i = n(l);
    return i && (r[i] = e[l]), r;
  }, {}), t, a];
}
let ul = null;
function sw() {
  return ul || (ul = Ie.fromMillis(1555555555555)), ul;
}
function rw(e, n) {
  if (e.literal)
    return e;
  const t = At.macroTokenToFormatOpts(e.val), a = $d(t, n);
  return a == null || a.includes(void 0) ? e : a;
}
function Sd(e, n) {
  return Array.prototype.concat(...e.map((t) => rw(t, n)));
}
class Td {
  constructor(n, t) {
    if (this.locale = n, this.format = t, this.tokens = Sd(At.parseFormat(t), n), this.units = this.tokens.map((a) => Jb(a, n)), this.disqualifyingUnit = this.units.find((a) => a.invalidReason), !this.disqualifyingUnit) {
      const [a, s] = tw(this.units);
      this.regex = RegExp(a, "i"), this.handlers = s;
    }
  }
  explainFromTokens(n) {
    if (this.isValid) {
      const [t, a] = nw(n, this.regex, this.handlers), [s, r, l] = a ? aw(a) : [null, null, void 0];
      if (Ga(a, "a") && Ga(a, "H"))
        throw new Ra(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: n,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: t,
        matches: a,
        result: s,
        zone: r,
        specificOffset: l
      };
    } else
      return { input: n, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Md(e, n, t) {
  return new Td(e, t).explainFromTokens(n);
}
function lw(e, n, t) {
  const { result: a, zone: s, specificOffset: r, invalidReason: l } = Md(e, n, t);
  return [a, s, r, l];
}
function $d(e, n) {
  if (!e)
    return null;
  const a = At.create(n, e).dtFormatter(sw()), s = a.formatToParts(), r = a.resolvedOptions();
  return s.map((l) => ew(l, e, r));
}
const cl = "Invalid DateTime", zo = 864e13;
function gs(e) {
  return new pn("unsupported zone", `the zone "${e.name}" is not supported`);
}
function dl(e) {
  return e.weekData === null && (e.weekData = kr(e.c)), e.weekData;
}
function fl(e) {
  return e.localWeekData === null && (e.localWeekData = kr(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function la(e, n) {
  const t = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Ie({ ...t, ...n, old: t });
}
function Cd(e, n, t) {
  let a = e - n * 60 * 1e3;
  const s = t.offset(a);
  if (n === s)
    return [a, n];
  a -= (s - n) * 60 * 1e3;
  const r = t.offset(a);
  return s === r ? [a, s] : [e - Math.min(s, r) * 60 * 1e3, Math.max(s, r)];
}
function tr(e, n) {
  e += n * 60 * 1e3;
  const t = new Date(e);
  return {
    year: t.getUTCFullYear(),
    month: t.getUTCMonth() + 1,
    day: t.getUTCDate(),
    hour: t.getUTCHours(),
    minute: t.getUTCMinutes(),
    second: t.getUTCSeconds(),
    millisecond: t.getUTCMilliseconds()
  };
}
function cr(e, n, t) {
  return Cd(Wr(e), n, t);
}
function Wo(e, n) {
  const t = e.o, a = e.c.year + Math.trunc(n.years), s = e.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, r = {
    ...e.c,
    year: a,
    month: s,
    day: Math.min(e.c.day, xr(a, s)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, l = Je.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), i = Wr(r);
  let [o, u] = Cd(i, t, e.zone);
  return l !== 0 && (o += l, u = e.zone.offset(o)), { ts: o, o: u };
}
function Da(e, n, t, a, s, r) {
  const { setZone: l, zone: i } = t;
  if (e && Object.keys(e).length !== 0 || n) {
    const o = n || i, u = Ie.fromObject(e, {
      ...t,
      zone: o,
      specificOffset: r
    });
    return l ? u : u.setZone(i);
  } else
    return Ie.invalid(
      new pn("unparsable", `the input "${s}" can't be parsed as ${a}`)
    );
}
function nr(e, n, t = !0) {
  return e.isValid ? At.create(rt.create("en-US"), {
    allowZ: t,
    forceSimple: !0
  }).formatDateTimeFromString(e, n) : null;
}
function hl(e, n, t) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let s = "";
  if (a && e.c.year >= 0 && (s += "+"), s += Tt(e.c.year, a ? 6 : 4), t === "year") return s;
  if (n) {
    if (s += "-", s += Tt(e.c.month), t === "month") return s;
    s += "-";
  } else if (s += Tt(e.c.month), t === "month") return s;
  return s += Tt(e.c.day), s;
}
function Yo(e, n, t, a, s, r, l) {
  let i = !t || e.c.millisecond !== 0 || e.c.second !== 0, o = "";
  switch (l) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (o += Tt(e.c.hour), l === "hour") break;
      if (n) {
        if (o += ":", o += Tt(e.c.minute), l === "minute") break;
        i && (o += ":", o += Tt(e.c.second));
      } else {
        if (o += Tt(e.c.minute), l === "minute") break;
        i && (o += Tt(e.c.second));
      }
      if (l === "second") break;
      i && (!a || e.c.millisecond !== 0) && (o += ".", o += Tt(e.c.millisecond, 3));
  }
  return s && (e.isOffsetFixed && e.offset === 0 && !r ? o += "Z" : e.o < 0 ? (o += "-", o += Tt(Math.trunc(-e.o / 60)), o += ":", o += Tt(Math.trunc(-e.o % 60))) : (o += "+", o += Tt(Math.trunc(e.o / 60)), o += ":", o += Tt(Math.trunc(e.o % 60)))), r && (o += "[" + e.zone.ianaName + "]"), o;
}
const Dd = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, iw = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ow = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, dr = ["year", "month", "day", "hour", "minute", "second", "millisecond"], uw = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], cw = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function fr(e) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!n) throw new Dc(e);
  return n;
}
function Ho(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return fr(e);
  }
}
function dw(e) {
  if (ys === void 0 && (ys = gt.now()), e.type !== "iana")
    return e.offset(ys);
  const n = e.name;
  let t = jl.get(n);
  return t === void 0 && (t = e.offset(ys), jl.set(n, t)), t;
}
function Uo(e, n) {
  const t = Zn(n.zone, gt.defaultZone);
  if (!t.isValid)
    return Ie.invalid(gs(t));
  const a = rt.fromObject(n);
  let s, r;
  if (Ne(e.year))
    s = gt.now();
  else {
    for (const o of dr)
      Ne(e[o]) && (e[o] = Dd[o]);
    const l = ed(e) || td(e);
    if (l)
      return Ie.invalid(l);
    const i = dw(t);
    [s, r] = cr(e, i, t);
  }
  return new Ie({ ts: s, zone: t, loc: a, o: r });
}
function qo(e, n, t) {
  const a = Ne(t.round) ? !0 : t.round, s = Ne(t.rounding) ? "trunc" : t.rounding, r = (i, o) => (i = xi(i, a || t.calendary ? 0 : 2, t.calendary ? "round" : s), n.loc.clone(t).relFormatter(t).format(i, o)), l = (i) => t.calendary ? n.hasSame(e, i) ? 0 : n.startOf(i).diff(e.startOf(i), i).get(i) : n.diff(e, i).get(i);
  if (t.unit)
    return r(l(t.unit), t.unit);
  for (const i of t.units) {
    const o = l(i);
    if (Math.abs(o) >= 1)
      return r(o, i);
  }
  return r(e > n ? -0 : 0, t.units[t.units.length - 1]);
}
function jo(e) {
  let n = {}, t;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (n = e[e.length - 1], t = Array.from(e).slice(0, e.length - 1)) : t = Array.from(e), [n, t];
}
let ys;
const jl = /* @__PURE__ */ new Map();
class Ie {
  /**
   * @access private
   */
  constructor(n) {
    const t = n.zone || gt.defaultZone;
    let a = n.invalid || (Number.isNaN(n.ts) ? new pn("invalid input") : null) || (t.isValid ? null : gs(t));
    this.ts = Ne(n.ts) ? gt.now() : n.ts;
    let s = null, r = null;
    if (!a)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(t))
        [s, r] = [n.old.c, n.old.o];
      else {
        const i = Jn(n.o) && !n.old ? n.o : t.offset(this.ts);
        s = tr(this.ts, i), a = Number.isNaN(s.year) ? new pn("invalid input") : null, s = a ? null : s, r = a ? null : i;
      }
    this._zone = t, this.loc = n.loc || rt.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = s, this.o = r, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Ie({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, t] = jo(arguments), [a, s, r, l, i, o, u] = t;
    return Uo({ year: a, month: s, day: r, hour: l, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, t] = jo(arguments), [a, s, r, l, i, o, u] = t;
    return n.zone = Lt.utcInstance, Uo({ year: a, month: s, day: r, hour: l, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, t = {}) {
    const a = Y0(n) ? n.valueOf() : NaN;
    if (Number.isNaN(a))
      return Ie.invalid("invalid input");
    const s = Zn(t.zone, gt.defaultZone);
    return s.isValid ? new Ie({
      ts: a,
      zone: s,
      loc: rt.fromObject(t)
    }) : Ie.invalid(gs(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, t = {}) {
    if (Jn(n))
      return n < -zo || n > zo ? Ie.invalid("Timestamp out of range") : new Ie({
        ts: n,
        zone: Zn(t.zone, gt.defaultZone),
        loc: rt.fromObject(t)
      });
    throw new Pt(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, t = {}) {
    if (Jn(n))
      return new Ie({
        ts: n * 1e3,
        zone: Zn(t.zone, gt.defaultZone),
        loc: rt.fromObject(t)
      });
    throw new Pt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(n, t = {}) {
    n = n || {};
    const a = Zn(t.zone, gt.defaultZone);
    if (!a.isValid)
      return Ie.invalid(gs(a));
    const s = rt.fromObject(t), r = Sr(n, Ho), { minDaysInFirstWeek: l, startOfWeek: i } = _o(r, s), o = gt.now(), u = Ne(t.specificOffset) ? a.offset(o) : t.specificOffset, c = !Ne(r.ordinal), f = !Ne(r.year), h = !Ne(r.month) || !Ne(r.day), d = f || h, g = r.weekYear || r.weekNumber;
    if ((d || c) && g)
      throw new Ra(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (h && c)
      throw new Ra("Can't mix ordinal dates with month/day");
    const y = g || r.weekday && !d;
    let k, m, v = tr(o, u);
    y ? (k = uw, m = iw, v = kr(v, l, i)) : c ? (k = cw, m = ow, v = ol(v)) : (k = dr, m = Dd);
    let w = !1;
    for (const D of k) {
      const Y = r[D];
      Ne(Y) ? w ? r[D] = m[D] : r[D] = v[D] : w = !0;
    }
    const S = y ? B0(r, l, i) : c ? z0(r) : ed(r), x = S || td(r);
    if (x)
      return Ie.invalid(x);
    const $ = y ? Do(r, l, i) : c ? Oo(r) : r, [T, _] = cr($, u, a), A = new Ie({
      ts: T,
      zone: a,
      o: _,
      loc: s
    });
    return r.weekday && d && n.weekday !== A.weekday ? Ie.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${r.weekday} and a date of ${A.toISO()}`
    ) : A.isValid ? A : Ie.invalid(A.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, t = {}) {
    const [a, s] = Ib(n);
    return Da(a, s, t, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, t = {}) {
    const [a, s] = Pb(n);
    return Da(a, s, t, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, t = {}) {
    const [a, s] = Ab(n);
    return Da(a, s, t, "HTTP", t);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, t, a = {}) {
    if (Ne(n) || Ne(t))
      throw new Pt("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: r = null } = a, l = rt.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    }), [i, o, u, c] = lw(l, n, t);
    return c ? Ie.invalid(c) : Da(i, o, a, `format ${t}`, n, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, t, a = {}) {
    return Ie.fromFormat(n, t, a);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, t = {}) {
    const [a, s] = zb(n);
    return Da(a, s, t, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Pt("need to specify a reason the DateTime is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (gt.throwOnInvalid)
      throw new m0(a);
    return new Ie({ invalid: a });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(n, t = {}) {
    const a = $d(n, rt.fromObject(t));
    return a ? a.map((s) => s ? s.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(n, t = {}) {
    return Sd(At.parseFormat(n), rt.fromObject(t)).map((s) => s.val).join("");
  }
  static resetCache() {
    ys = void 0, jl.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? dl(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? dl(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? dl(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? fl(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? fl(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? fl(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? ol(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Qs.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Qs.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Qs.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Qs.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const n = 864e5, t = 6e4, a = Wr(this.c), s = this.zone.offset(a - n), r = this.zone.offset(a + n), l = this.zone.offset(a - s * t), i = this.zone.offset(a - r * t);
    if (l === i)
      return [this];
    const o = a - l * t, u = a - i * t, c = tr(o, l), f = tr(u, i);
    return c.hour === f.hour && c.minute === f.minute && c.second === f.second && c.millisecond === f.millisecond ? [la(this, { ts: o }), la(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ns(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return xr(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Ba(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? $s(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? $s(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: t, numberingSystem: a, calendar: s } = At.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: t, numberingSystem: a, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, t = {}) {
    return this.setZone(Lt.instance(n), t);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(gt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: t = !1, keepCalendarTime: a = !1 } = {}) {
    if (n = Zn(n, gt.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let s = this.ts;
      if (t || a) {
        const r = n.offset(this.ts), l = this.toObject();
        [s] = cr(l, r, n);
      }
      return la(this, { ts: s, zone: n });
    } else
      return Ie.invalid(gs(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: t, outputCalendar: a } = {}) {
    const s = this.loc.clone({ locale: n, numberingSystem: t, outputCalendar: a });
    return la(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = Sr(n, Ho), { minDaysInFirstWeek: a, startOfWeek: s } = _o(t, this.loc), r = !Ne(t.weekYear) || !Ne(t.weekNumber) || !Ne(t.weekday), l = !Ne(t.ordinal), i = !Ne(t.year), o = !Ne(t.month) || !Ne(t.day), u = i || o, c = t.weekYear || t.weekNumber;
    if ((u || l) && c)
      throw new Ra(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (o && l)
      throw new Ra("Can't mix ordinal dates with month/day");
    let f;
    r ? f = Do(
      { ...kr(this.c, a, s), ...t },
      a,
      s
    ) : Ne(t.ordinal) ? (f = { ...this.toObject(), ...t }, Ne(t.day) && (f.day = Math.min(xr(f.year, f.month), f.day))) : f = Oo({ ...ol(this.c), ...t });
    const [h, d] = cr(f, this.o, this.zone);
    return la(this, { ts: h, o: d });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return la(this, Wo(this, t));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n).negate();
    return la(this, Wo(this, t));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n, { useLocaleWeeks: t = !1 } = {}) {
    if (!this.isValid) return this;
    const a = {}, s = Je.normalizeUnit(n);
    switch (s) {
      case "years":
        a.month = 1;
      // falls through
      case "quarters":
      case "months":
        a.day = 1;
      // falls through
      case "weeks":
      case "days":
        a.hour = 0;
      // falls through
      case "hours":
        a.minute = 0;
      // falls through
      case "minutes":
        a.second = 0;
      // falls through
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (s === "weeks")
      if (t) {
        const r = this.loc.getStartOfWeek(), { weekday: l } = this;
        l < r && (a.weekNumber = this.weekNumber - 1), a.weekday = r;
      } else
        a.weekday = 1;
    if (s === "quarters") {
      const r = Math.ceil(this.month / 3);
      a.month = (r - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n, t) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n, t).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, t = {}) {
    return this.isValid ? At.create(this.loc.redefaultToEN(t)).formatDateTimeFromString(this, n) : cl;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = wr, t = {}) {
    return this.isValid ? At.create(this.loc.clone(t), n).formatDateTime(this) : cl;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? At.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: t = !1,
    suppressMilliseconds: a = !1,
    includeOffset: s = !0,
    extendedZone: r = !1,
    precision: l = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    l = fr(l);
    const i = n === "extended";
    let o = hl(this, i, l);
    return dr.indexOf(l) >= 3 && (o += "T"), o += Yo(
      this,
      i,
      t,
      a,
      s,
      r,
      l
    ), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: n = "extended", precision: t = "day" } = {}) {
    return this.isValid ? hl(this, n === "extended", fr(t)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return nr(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: t = !1,
    includeOffset: a = !0,
    includePrefix: s = !1,
    extendedZone: r = !1,
    format: l = "extended",
    precision: i = "milliseconds"
  } = {}) {
    return this.isValid ? (i = fr(i), (s && dr.indexOf(i) >= 3 ? "T" : "") + Yo(
      this,
      l === "extended",
      t,
      n,
      a,
      r,
      i
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return nr(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return nr(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? hl(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: t = !1, includeOffsetSpace: a = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (t || n) && (a && (s += " "), t ? s += "z" : n && (s += "ZZ")), nr(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : cl;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const t = { ...this.c };
    return n.includeConfig && (t.outputCalendar = this.outputCalendar, t.numberingSystem = this.loc.numberingSystem, t.locale = this.loc.locale), t;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, t = "milliseconds", a = {}) {
    if (!this.isValid || !n.isValid)
      return Je.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...a }, r = H0(t).map(Je.normalizeUnit), l = n.valueOf() > this.valueOf(), i = l ? this : n, o = l ? n : this, u = jb(i, o, r, s);
    return l ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", t = {}) {
    return this.diff(Ie.now(), n, t);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(n) {
    return this.isValid ? pt.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, t, a) {
    if (!this.isValid) return !1;
    const s = n.valueOf(), r = this.setZone(n.zone, { keepLocalTime: !0 });
    return r.startOf(t, a) <= s && s <= r.endOf(t, a);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const t = n.base || Ie.fromObject({}, { zone: this.zone }), a = n.padding ? this < t ? -n.padding : n.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], r = n.unit;
    return Array.isArray(n.unit) && (s = n.unit, r = void 0), qo(t, this.plus(a), {
      ...n,
      numeric: "always",
      units: s,
      unit: r
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? qo(n.base || Ie.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(Ie.isDateTime))
      throw new Pt("min requires all arguments be DateTimes");
    return Eo(n, (t) => t.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(Ie.isDateTime))
      throw new Pt("max requires all arguments be DateTimes");
    return Eo(n, (t) => t.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, t, a = {}) {
    const { locale: s = null, numberingSystem: r = null } = a, l = rt.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    return Md(l, n, t);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, t, a = {}) {
    return Ie.fromFormatExplain(n, t, a);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(n, t = {}) {
    const { locale: a = null, numberingSystem: s = null } = t, r = rt.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    return new Td(r, n);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(n, t, a = {}) {
    if (Ne(n) || Ne(t))
      throw new Pt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: s = null, numberingSystem: r = null } = a, l = rt.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    if (!l.equals(t.locale))
      throw new Pt(
        `fromFormatParser called with a locale of ${l}, but the format parser was created for ${t.locale}`
      );
    const { result: i, zone: o, specificOffset: u, invalidReason: c } = t.explainFromTokens(n);
    return c ? Ie.invalid(c) : Da(
      i,
      o,
      a,
      `format ${t.format}`,
      n,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return wr;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Oc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return g0;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return _c;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return Ec;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Ic;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Pc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Ac;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Rc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Vc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Fc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Lc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Nc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Bc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return zc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Wc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Yc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return y0;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Hc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Uc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return qc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return jc;
  }
}
function fs(e) {
  if (Ie.isDateTime(e))
    return e;
  if (e && e.valueOf && Jn(e.valueOf()))
    return Ie.fromJSDate(e);
  if (e && typeof e == "object")
    return Ie.fromObject(e);
  throw new Pt(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const Ws = (e) => e == null, Od = (e, n) => e.length <= n ? e : `${e.slice(0, n)}...`, xs = (e, n = 2) => {
  if (e === 0) return "0 Bytes";
  const t = 1024, a = n < 0 ? 0 : n, s = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], r = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, r)).toFixed(a))} ${s[r]}`;
}, _d = (e) => e.slice((e.lastIndexOf(".") - 1 >>> 0) + 2), G2 = (e) => {
  const n = _d(e).toLowerCase();
  return [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "bmp"
  ].includes(n);
}, fw = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  UAH: "₴",
  JPY: "¥",
  CNY: "¥"
}, Ss = (e, n = "USD") => {
  if (Ws(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  let a, s, r;
  typeof n == "string" ? n === "compact" || n === "chart" || n === "default" ? (r = n, a = "USD") : a = n : (a = n.code ?? "USD", s = n.decimals, r = n.format);
  const l = fw[a] || a, i = t < 0, o = Math.abs(t);
  if (r === "compact") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 0,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${l}${c}` : `${l}${c}`;
  }
  if (r === "chart") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 1,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${l}${c}` : `${l}${c}`;
  }
  const u = o.toLocaleString("en-US", {
    minimumFractionDigits: s ?? 0,
    maximumFractionDigits: s ?? 0
  });
  return i ? `-${l}${u}` : `${l}${u}`;
}, Ed = (e, n) => {
  if (Ws(e)) return { text: "" };
  const t = !!e, a = (n == null ? void 0 : n.trueText) ?? "Yes", s = (n == null ? void 0 : n.falseText) ?? "No", r = (n == null ? void 0 : n.colored) ?? !0, l = t ? a : s;
  return r ? { text: l, class: t ? "text-success" : "text-negative" } : { text: l };
}, $i = (e, n) => {
  if (Ws(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  return `${((typeof n == "object" ? n.multiplier ?? !1 : !1) ? t * 100 : t).toLocaleString("en-US", {
    minimumFractionDigits: a,
    maximumFractionDigits: a
  })}%`;
}, Wa = (e, n) => {
  if (Ws(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.type) ?? "default", s = typeof n == "object" ? n.decimals : void 0, r = typeof n == "object" ? n.multiply : void 0, l = r !== void 0 ? t * r : t;
  switch (a) {
    case "compact":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 1
      }).format(l);
    case "chart":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 1,
        maximumFractionDigits: s ?? 1
      }).format(l);
    case "percent":
      return `${l.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      })}%`;
    case "decimal":
      return l.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      });
    case "default":
    default:
      return l.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 0
      });
  }
}, Id = (e, n) => {
  if (!e) return "";
  let t;
  if (e instanceof Date)
    t = Ie.fromJSDate(e).toUTC();
  else if (typeof e == "string") {
    const s = Ie.fromISO(e, { zone: "utc" });
    if (s.isValid)
      t = s;
    else {
      const r = new Date(e);
      if (isNaN(r.getTime())) return String(e);
      t = Ie.fromJSDate(r).toUTC();
    }
  } else if (typeof e == "number")
    t = Ie.fromMillis(e).toUTC();
  else
    return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.format) ?? "short";
  switch (a) {
    case "short":
      return t.toFormat("MM/dd/yyyy");
    case "long":
      return t.toFormat("MMMM dd, yyyy");
    case "time":
      return t.toFormat("h:mm:ss a");
    case "datetime":
      return t.toFormat("MM/dd/yyyy h:mm:ss a");
    default:
      return t.toFormat(a);
  }
}, Pd = (e, n) => {
  if (Ws(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  if (t === 0) return "0 Bytes";
  const s = 1024, r = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], l = Math.floor(Math.log(t) / Math.log(s));
  return `${parseFloat((t / Math.pow(s, l)).toFixed(a))} ${r[l]}`;
}, K2 = (e) => typeof e != "string" ? String(e || "") : e.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().toLowerCase().split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" "), hw = {
  key: 0,
  class: "loader-message"
}, mw = /* @__PURE__ */ Te({
  __name: "VLoader",
  props: {
    size: { default: "medium" },
    message: { default: "" },
    fullscreen: { type: Boolean, default: !1 },
    variant: { default: "primary" }
  },
  setup(e) {
    const n = e, t = C(() => `loader-${n.size}`), a = C(() => `loader-${n.variant}`), s = C(() => ({
      "loader-fullscreen": n.fullscreen
    }));
    return (r, l) => (b(), M("div", {
      class: ne([s.value, "loader-container"]),
      role: "status"
    }, [
      E("div", {
        class: ne([[t.value, a.value], "loader"])
      }, [...l[0] || (l[0] = [
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1)
      ])], 2),
      e.message ? (b(), M("span", hw, ce(e.message), 1)) : P("", !0),
      l[1] || (l[1] = E("span", { class: "sr-only" }, "Loading...", -1))
    ], 2));
  }
}), Ur = /* @__PURE__ */ Ge(mw, [["__scopeId", "data-v-6ca9fde0"]]), vw = { class: "drag-n-drop" }, pw = ["id", "accept", "disabled", "multiple"], gw = {
  key: 0,
  class: "drag-n-drop__loading"
}, yw = {
  key: 1,
  class: "drag-n-drop__content"
}, bw = { class: "drag-n-drop__icon-wrapper" }, ww = { class: "drag-n-drop__text" }, kw = {
  key: 0,
  class: "text-primary font-medium text-base"
}, xw = { class: "text-secondaryText text-sm" }, Sw = { key: 0 }, Tw = { key: 1 }, Mw = { key: 2 }, $w = {
  key: 2,
  class: "drag-n-drop__preview"
}, Cw = { class: "drag-n-drop__preview-header" }, Dw = { class: "text-mainText font-medium" }, Ow = { class: "text-secondaryText text-xs mt-1" }, _w = { class: "drag-n-drop__file-icon" }, Ew = { class: "drag-n-drop__file-info" }, Iw = ["title"], Pw = { class: "drag-n-drop__file-size" }, Aw = ["disabled", "onClick"], Rw = {
  key: 1,
  class: "drag-n-drop__actions"
}, Vw = /* @__PURE__ */ Te({
  __name: "DragNDrop",
  props: {
    loading: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    id: { default: "drag-n-drop" },
    accept: { default: "" },
    maxSize: { default: 10 * 1024 * 1024 },
    maxFiles: { default: 10 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["upload", "submit", "error"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = te(!1), r = te([]), l = te(null), i = C(() => r.value.length > 0), o = C(() => !t.multiple || r.value.length < t.maxFiles), u = (S) => {
      const x = _d(S).toLowerCase();
      return {
        pdf: "mdi:file-pdf-box",
        doc: "mdi:file-word-box",
        docx: "mdi:file-word-box",
        xls: "mdi:file-excel-box",
        xlsx: "mdi:file-excel-box",
        ppt: "mdi:file-powerpoint-box",
        pptx: "mdi:file-powerpoint-box",
        zip: "mdi:folder-zip",
        rar: "mdi:folder-zip",
        jpg: "mdi:file-image",
        jpeg: "mdi:file-image",
        png: "mdi:file-image",
        gif: "mdi:file-image",
        svg: "mdi:file-image",
        txt: "mdi:file-document",
        csv: "mdi:file-delimited"
      }[x] || "mdi:file-document-outline";
    }, c = (S) => t.maxSize && S.size > t.maxSize ? `File "${S.name}" exceeds maximum size of ${xs(t.maxSize)}` : null, f = () => {
      r.value = [];
    }, h = (S) => {
      r.value.splice(S, 1), a("upload", r.value, () => {
      });
    }, d = (S) => {
      const x = [];
      for (const $ of S) {
        const T = c($);
        if (T) {
          a("error", T);
          continue;
        }
        x.push($);
      }
      if (x.length !== 0) {
        if (!t.multiple)
          r.value = [x[0]];
        else {
          const $ = t.maxFiles - r.value.length, T = x.slice(0, $);
          x.length > $ && a("error", `Maximum ${t.maxFiles} files allowed`), r.value = [...r.value, ...T];
        }
        console.log("Files added:", r.value), console.log("hasFiles:", i.value), a("upload", r.value, () => {
        });
      }
    }, g = (S) => {
      t.disabled || t.loading || (S.preventDefault(), s.value = !0);
    }, y = (S) => {
      S.preventDefault(), s.value = !1;
    }, k = (S) => {
      var $;
      if (S.preventDefault(), s.value = !1, t.disabled || t.loading || !o.value) return;
      const x = Array.from((($ = S.dataTransfer) == null ? void 0 : $.files) || []);
      d(x);
    }, m = (S) => {
      const x = S.target, $ = Array.from(x.files || []);
      d($), l.value && (l.value.value = "");
    }, v = () => {
      r.value.length !== 0 && a("submit", r.value, f);
    }, w = () => {
      var S;
      t.disabled || t.loading || !o.value || (S = l.value) == null || S.click();
    };
    return (S, x) => (b(), M("div", vw, [
      E("input", lt({
        id: `fileInput-${t.id}`,
        ref_key: "fileRef",
        ref: l,
        accept: t.accept,
        disabled: t.disabled || t.loading,
        multiple: t.multiple,
        class: "drag-n-drop__input",
        name: "file",
        type: "file"
      }, S.$attrs, { onChange: m }), null, 16, pw),
      E("div", {
        class: ne([{
          "drag-n-drop__dropzone--dragging": s.value,
          "drag-n-drop__dropzone--disabled": t.disabled || t.loading,
          "drag-n-drop__dropzone--has-files": i.value
        }, "drag-n-drop__dropzone"]),
        onClick: w,
        onDragleave: y,
        onDragover: g,
        onDrop: k
      }, [
        t.loading ? (b(), M("div", gw, [
          oe(Ur, { class: "w-8 h-8" }),
          x[0] || (x[0] = E("p", { class: "text-secondaryText text-sm mt-2" }, " Processing files... ", -1))
        ])) : i.value ? (b(), M("div", $w, [
          E("div", Cw, [
            oe(xe, {
              size: 24,
              class: "text-primary",
              icon: "mdi:file-multiple-outline"
            }),
            E("span", Dw, ce(r.value.length) + " file" + ce(r.value.length > 1 ? "s" : "") + " selected ", 1)
          ]),
          E("p", Ow, " Click to add " + ce(t.multiple ? "more" : "another") + " file" + ce(t.multiple ? "s" : ""), 1)
        ])) : (b(), M("div", yw, [
          E("div", bw, [
            oe(xe, {
              icon: s.value ? "mdi:cloud-download" : "mdi:cloud-upload-outline",
              size: 48,
              class: "drag-n-drop__icon"
            }, null, 8, ["icon"])
          ]),
          E("div", ww, [
            s.value ? (b(), M("p", kw, " Release to drop files here ")) : (b(), M(Se, { key: 1 }, [
              U(S.$slots, "title", {}, () => [
                x[1] || (x[1] = E("p", { class: "text-mainText font-medium text-base mb-1" }, " Drop files here or click to browse ", -1))
              ], !0),
              U(S.$slots, "subtitle", {}, () => [
                E("p", xw, [
                  t.accept ? (b(), M("span", Sw, "Supported: " + ce(t.accept), 1)) : P("", !0),
                  t.accept && t.maxSize ? (b(), M("span", Tw, " • ")) : P("", !0),
                  t.maxSize ? (b(), M("span", Mw, "Max: " + ce(p(xs)(t.maxSize)), 1)) : P("", !0)
                ])
              ], !0)
            ], 64))
          ]),
          U(S.$slots, "action", {}, () => [
            oe(qt, {
              class: "mt-2",
              icon: "mdi:folder-open-outline",
              text: "Browse Files",
              variant: "primary",
              onClick: Ve(w, ["stop"])
            })
          ], !0)
        ]))
      ], 34),
      i.value && !t.loading ? (b(), fe(Sl, {
        key: 0,
        class: "drag-n-drop__files",
        name: "file-list",
        tag: "div"
      }, {
        default: de(() => [
          (b(!0), M(Se, null, Pe(r.value, ($, T) => (b(), M("div", {
            key: `${$.name}-${$.size}-${T}`,
            class: "drag-n-drop__file-item"
          }, [
            E("div", _w, [
              oe(xe, {
                icon: u($.name),
                size: 20,
                class: "text-primary"
              }, null, 8, ["icon"])
            ]),
            E("div", Ew, [
              E("p", {
                title: $.name,
                class: "drag-n-drop__file-name"
              }, ce(p(Od)($.name, 40)), 9, Iw),
              E("p", Pw, ce(p(xs)($.size)), 1)
            ]),
            E("button", {
              disabled: t.loading,
              class: "drag-n-drop__file-remove",
              type: "button",
              onClick: Ve((_) => h(T), ["stop"])
            }, [
              oe(xe, {
                size: 20,
                icon: "mdi:close-circle"
              })
            ], 8, Aw)
          ]))), 128))
        ]),
        _: 1
      })) : P("", !0),
      i.value && t.button && !t.loading ? (b(), M("div", Rw, [
        oe(qt, {
          class: "w-full",
          icon: "mdi:check-circle-outline",
          text: "Submit Files",
          variant: "primary",
          onClick: v
        })
      ])) : P("", !0)
    ]));
  }
}), Z2 = /* @__PURE__ */ Ge(Vw, [["__scopeId", "data-v-3b9bd88e"]]), Fw = { class: "v-file-upload w-full" }, Lw = ["accept", "disabled", "multiple"], Nw = { class: "v-file-upload__icon-wrapper" }, Bw = { class: "v-file-upload__text-container" }, zw = {
  key: 0,
  class: "v-file-upload__loading"
}, Ww = {
  key: 0,
  class: "v-file-upload__list"
}, Yw = { class: "flex items-center gap-3 overflow-hidden" }, Hw = { class: "v-file-upload__item-icon" }, Uw = { class: "flex flex-col min-w-0" }, qw = ["title"], jw = { class: "text-xs text-secondaryText" }, Gw = ["disabled", "onClick"], Kw = /* @__PURE__ */ Te({
  __name: "VFileUpload",
  props: {
    modelValue: { default: () => [] },
    accept: { default: "*" },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 },
    label: { default: "Click to upload or drag and drop" },
    subLabel: { default: "SVG, PNG, JPG or GIF (max. 800x400px)" },
    showList: { type: Boolean, default: !0 },
    variant: { default: "default" },
    immediate: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "upload", "error", "file-select"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = te(!1), r = te(null), l = te(t.modelValue), i = C({
      get: () => t.modelValue.length ? t.modelValue : l.value,
      set: (g) => {
        l.value = g, a("update:modelValue", g);
      }
    }), o = () => {
      i.value = [], r.value && (r.value.value = "");
    }, u = (g) => {
      if (!(t.loading || t.disabled)) {
        if (t.maxSize && g.filter((k) => k.size > t.maxSize).length) {
          a("error", `File size exceeds limit of ${xs(t.maxSize)}`);
          return;
        }
        if (t.immediate) {
          const y = g[0] || null;
          a("file-select", y), a("upload", g, o);
          return;
        }
        t.multiple ? i.value = [...i.value, ...g] : i.value = g.slice(0, 1), a("change", i.value), a("upload", i.value, o);
      }
    }, c = (g) => {
      var k;
      s.value = !1;
      const y = Array.from(((k = g.dataTransfer) == null ? void 0 : k.files) || []);
      y.length && u(y);
    }, f = (g) => {
      const y = g.target, k = Array.from(y.files || []);
      k.length && u(k);
    }, h = (g) => {
      if (t.loading || t.disabled) return;
      const y = [...i.value];
      y.splice(g, 1), i.value = y, a("change", y);
    }, d = () => {
      var g;
      !t.loading && !t.disabled && ((g = r.value) == null || g.click());
    };
    return (g, y) => (b(), M("div", Fw, [
      E("div", {
        class: ne([{
          "v-file-upload__dropzone--dragging": s.value,
          "v-file-upload__dropzone--loading": e.loading,
          "v-file-upload__dropzone--disabled": e.disabled,
          "v-file-upload__dropzone--compact": e.variant === "compact"
        }, "v-file-upload__dropzone"]),
        onClick: d,
        onDragenter: y[0] || (y[0] = Ve((k) => s.value = !0, ["prevent"])),
        onDragleave: y[1] || (y[1] = Ve((k) => s.value = !1, ["prevent"])),
        onDragover: y[2] || (y[2] = Ve((k) => s.value = !0, ["prevent"])),
        onDrop: Ve(c, ["prevent"])
      }, [
        E("input", {
          ref_key: "inputRef",
          ref: r,
          accept: e.accept,
          disabled: e.disabled || e.loading,
          multiple: e.multiple,
          class: "hidden",
          type: "file",
          onChange: f
        }, null, 40, Lw),
        E("div", {
          class: ne([{ "v-file-upload__content--loading": e.loading }, "v-file-upload__content"])
        }, [
          E("div", Nw, [
            U(g.$slots, "icon", {}, () => [
              oe(xe, {
                size: e.variant === "compact" ? 20 : 28,
                class: "text-secondaryText",
                icon: "lucide:cloud-upload"
              }, null, 8, ["size"])
            ], !0)
          ]),
          E("div", Bw, [
            y[3] || (y[3] = E("div", { class: "v-file-upload__text" }, [
              E("span", { class: "font-medium text-primary hover:text-primary-dark transition-colors" }, " Click to upload "),
              E("span", { class: "text-secondaryText" }, " or drag and drop ")
            ], -1)),
            e.subLabel ? (b(), M("p", {
              key: 0,
              class: ne([{ "mt-1": e.variant !== "compact" }, "text-xs text-secondaryText"])
            }, ce(e.subLabel), 3)) : P("", !0)
          ])
        ], 2),
        e.loading ? (b(), M("div", zw, [
          oe(Ur, {
            size: e.variant === "compact" ? "small" : "medium",
            variant: "primary"
          }, null, 8, ["size"]),
          y[4] || (y[4] = E("p", { class: "text-secondaryText text-sm" }, " Uploading... ", -1))
        ])) : P("", !0)
      ], 34),
      e.showList && i.value.length > 0 && !e.immediate ? (b(), M("div", Ww, [
        (b(!0), M(Se, null, Pe(i.value, (k, m) => (b(), M("div", {
          key: m,
          class: "v-file-upload__item"
        }, [
          E("div", Yw, [
            E("div", Hw, [
              oe(xe, {
                class: "text-primary",
                icon: "lucide:file"
              })
            ]),
            E("div", Uw, [
              E("span", {
                title: k.name,
                class: "text-sm font-medium text-mainText truncate"
              }, ce(p(Od)(k.name, 30)), 9, qw),
              E("span", jw, ce(p(xs)(k.size)), 1)
            ])
          ]),
          E("button", {
            disabled: e.loading || e.disabled,
            class: "v-file-upload__remove",
            onClick: Ve((v) => h(m), ["stop"])
          }, [
            oe(xe, {
              icon: "lucide:trash-2",
              size: 20
            })
          ], 8, Gw)
        ]))), 128))
      ])) : P("", !0)
    ]));
  }
}), X2 = /* @__PURE__ */ Ge(Kw, [["__scopeId", "data-v-d0ec926d"]]);
function Ad(e) {
  return gu() ? (Dr(e), !0) : !1;
}
const ml = /* @__PURE__ */ new WeakMap(), Zw = (...e) => {
  var n;
  const t = e[0], a = (n = Jl()) == null ? void 0 : n.proxy;
  if (a == null && !bu())
    throw new Error("injectLocal must be called in setup");
  return a && ml.has(a) && t in ml.get(a) ? ml.get(a)[t] : Qn(...e);
}, Rd = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Xw = Object.prototype.toString, Jw = (e) => Xw.call(e) === "[object Object]", Go = () => {
};
function Qw(e, n) {
  function t(...a) {
    return new Promise((s, r) => {
      Promise.resolve(e(() => n.apply(this, a), { fn: n, thisArg: this, args: a })).then(s).catch(r);
    });
  }
  return t;
}
function e1(e, n = {}) {
  let t, a, s = Go;
  const r = (o) => {
    clearTimeout(o), s(), s = Go;
  };
  let l;
  return (o) => {
    const u = tt(e), c = tt(n.maxWait);
    return t && r(t), u <= 0 || c !== void 0 && c <= 0 ? (a && (r(a), a = null), Promise.resolve(o())) : new Promise((f, h) => {
      s = n.rejectOnCancel ? h : f, l = o, c && !a && (a = setTimeout(() => {
        t && r(t), a = null, f(l());
      }, c)), t = setTimeout(() => {
        a && r(a), a = null, f(o());
      }, u);
    });
  };
}
function Ko(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function t1(e) {
  return Jl();
}
function vl(e) {
  return Array.isArray(e) ? e : [e];
}
function n1(e, n = 200, t = {}) {
  return Qw(
    e1(n, t),
    e
  );
}
function a1(e, n = !0, t) {
  t1() ? nt(e, t) : n ? e() : Xe(e);
}
function Zo(e, n, t = {}) {
  const {
    immediate: a = !0,
    immediateCallback: s = !1
  } = t, r = Wt(!1);
  let l = null;
  function i() {
    l && (clearTimeout(l), l = null);
  }
  function o() {
    r.value = !1, i();
  }
  function u(...c) {
    s && e(), i(), r.value = !0, l = setTimeout(() => {
      r.value = !1, l = null, e(...c);
    }, tt(n));
  }
  return a && (r.value = !0, Rd && u()), Ad(o), {
    isPending: Xl(r),
    start: u,
    stop: o
  };
}
function s1(e, n, t) {
  return He(
    e,
    n,
    {
      ...t,
      immediate: !0
    }
  );
}
const Ci = Rd ? window : void 0;
function r1(e) {
  var n;
  const t = tt(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
function Gl(...e) {
  const n = [], t = () => {
    n.forEach((i) => i()), n.length = 0;
  }, a = (i, o, u, c) => (i.addEventListener(o, u, c), () => i.removeEventListener(o, u, c)), s = C(() => {
    const i = vl(tt(e[0])).filter((o) => o != null);
    return i.every((o) => typeof o != "string") ? i : void 0;
  }), r = s1(
    () => {
      var i, o;
      return [
        (o = (i = s.value) == null ? void 0 : i.map((u) => r1(u))) != null ? o : [Ci].filter((u) => u != null),
        vl(tt(s.value ? e[1] : e[0])),
        vl(p(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        tt(s.value ? e[3] : e[2])
      ];
    },
    ([i, o, u, c]) => {
      if (t(), !(i != null && i.length) || !(o != null && o.length) || !(u != null && u.length))
        return;
      const f = Jw(c) ? { ...c } : c;
      n.push(
        ...i.flatMap(
          (h) => o.flatMap(
            (d) => u.map((g) => a(h, d, g, f))
          )
        )
      );
    },
    { flush: "post" }
  ), l = () => {
    r(), t();
  };
  return Ad(t), l;
}
function l1() {
  const e = Wt(!1), n = Jl();
  return n && nt(() => {
    e.value = !0;
  }, n), e;
}
function i1(e) {
  const n = l1();
  return C(() => (n.value, !!e()));
}
const o1 = Symbol("vueuse-ssr-width");
function u1() {
  const e = bu() ? Zw(o1, null) : null;
  return typeof e == "number" ? e : void 0;
}
function c1(e, n = {}) {
  const { window: t = Ci, ssrWidth: a = u1() } = n, s = i1(() => t && "matchMedia" in t && typeof t.matchMedia == "function"), r = Wt(typeof a == "number"), l = Wt(), i = Wt(!1), o = (u) => {
    i.value = u.matches;
  };
  return Ut(() => {
    if (r.value) {
      r.value = !s.value;
      const u = tt(e).split(",");
      i.value = u.some((c) => {
        const f = c.includes("not all"), h = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), d = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let g = !!(h || d);
        return h && g && (g = a >= Ko(h[1])), d && g && (g = a <= Ko(d[1])), f ? !g : g;
      });
      return;
    }
    s.value && (l.value = t.matchMedia(tt(e)), i.value = l.value.matches);
  }), Gl(l, "change", o, { passive: !0 }), C(() => i.value);
}
function d1(e = {}) {
  const {
    window: n = Ci,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: r = !0,
    type: l = "inner"
  } = e, i = Wt(t), o = Wt(a), u = () => {
    if (n)
      if (l === "outer")
        i.value = n.outerWidth, o.value = n.outerHeight;
      else if (l === "visual" && n.visualViewport) {
        const { width: f, height: h, scale: d } = n.visualViewport;
        i.value = Math.round(f * d), o.value = Math.round(h * d);
      } else r ? (i.value = n.innerWidth, o.value = n.innerHeight) : (i.value = n.document.documentElement.clientWidth, o.value = n.document.documentElement.clientHeight);
  };
  u(), a1(u);
  const c = { passive: !0 };
  if (Gl("resize", u, c), n && l === "visual" && n.visualViewport && Gl(n.visualViewport, "resize", u, c), s) {
    const f = c1("(orientation: portrait)");
    He(f, () => u());
  }
  return { width: i, height: o };
}
const f1 = { class: "v-input-wrapper" }, h1 = { class: "v-input-container" }, m1 = ["for"], v1 = {
  key: 0,
  class: "v-input-helper-text"
}, p1 = {
  key: 0,
  class: "v-input-error-message"
}, g1 = /* @__PURE__ */ Te({
  __name: "VInput",
  props: /* @__PURE__ */ ea({
    name: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    helperText: { default: "" },
    validation: {},
    error: { default: void 0 },
    icon: { default: "" },
    size: { default: "md" },
    id: {},
    debounce: { type: [Boolean, Number], default: !1 },
    loading: { type: Boolean, default: !1 },
    textarea: { type: Boolean, default: !1 },
    rows: { default: 4 },
    showClearButton: { type: Boolean, default: !0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ea(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = C(() => {
      var L;
      return !!((L = t.validation) != null && L.$error || t.error);
    }), s = C(() => {
      var L, X;
      return ((X = (L = t.validation) == null ? void 0 : L.$errors[0]) == null ? void 0 : X.$message) ?? t.error ?? "";
    }), r = Ds(e, "modelValue"), l = n, i = Yt(), o = Cr(), u = te(!1), c = te(!1), f = te(null), h = C(() => t.id || `v-input-${o}`), d = typeof t.debounce == "number" ? t.debounce : t.debounce ? 800 : 0, g = te(r.value ?? "");
    He(r, (L) => {
      L !== g.value && (g.value = L ?? "");
    });
    const y = n1((L) => {
      r.value = L;
    }, d), k = (L) => {
      const X = L.target.value;
      g.value = X;
      let se = X;
      if (t.type === "number" && X !== "") {
        const ie = Number(X);
        isNaN(ie) || (se = ie);
      }
      y(se);
    }, m = () => {
      var L;
      g.value = "", r.value = t.type === "number" ? void 0 : "", l("clear"), (L = f.value) == null || L.focus();
    }, v = C(() => t.type === "password" ? u.value ? "text" : "password" : t.type), w = () => {
      u.value = !u.value;
    }, S = C(() => ({
      sm: "v-input-field--sm",
      md: "v-input-field--md",
      lg: "v-input-field--lg"
    })[t.size]), x = C(() => t.type === "search"), $ = C(() => t.icon || x.value || !!i["icon-left"] || t.loading), T = C(() => t.type === "password" || _.value || !!i["icon-right"]), _ = C(
      () => t.type !== "password" && g.value !== "" && t.showClearButton
    ), A = C(() => t.icon ? t.icon : x.value ? "mdi:search" : ""), D = C(
      () => g.value !== "" && g.value !== null && g.value !== void 0
    ), Y = C(() => t.name ? c.value ? t.placeholder : "" : t.placeholder);
    return (L, X) => (b(), M("div", f1, [
      E("div", h1, [
        t.name ? (b(), M("label", {
          key: 0,
          class: ne([
            "v-label",
            {
              "v-label--active": c.value || D.value,
              "v-label--error": a.value,
              "v-label--with-icon": $.value && !(c.value || D.value),
              "v-label--textarea": e.textarea
            }
          ]),
          for: h.value
        }, ce(t.name), 11, m1)) : P("", !0),
        $.value ? (b(), M("div", {
          key: 1,
          class: ne([
            "v-input-icon v-input-icon-left",
            {
              "v-input-icon-textarea": e.textarea,
              "v-input-icon--active": c.value && x.value || e.loading
            }
          ])
        }, [
          U(L.$slots, "icon-left", {}, () => [
            A.value || e.loading ? (b(), fe(xe, {
              key: 0,
              icon: A.value,
              loading: e.loading,
              class: "v-input-icon-svg"
            }, null, 8, ["icon", "loading"])) : P("", !0)
          ], !0)
        ], 2)) : P("", !0),
        (b(), fe(ht(e.textarea ? "textarea" : "input"), lt({
          id: h.value,
          key: `${e.textarea ? "textarea" : "input"}-${h.value}`,
          ref_key: "inputRef",
          ref: f,
          class: [
            "v-input-field",
            S.value,
            {
              "v-input-field--textarea": e.textarea,
              "v-input-field--with-left-icon": $.value,
              "v-input-field--with-right-icon": T.value,
              "v-input-field--date": e.type === "date" && !e.textarea,
              "v-input-field--disabled": e.disabled
            }
          ],
          disabled: e.disabled,
          placeholder: Y.value,
          value: g.value
        }, {
          ...L.$attrs,
          type: e.textarea ? void 0 : v.value,
          rows: e.textarea ? e.rows : void 0
        }, {
          onBlur: X[0] || (X[0] = (se) => c.value = !1),
          onFocus: X[1] || (X[1] = (se) => c.value = !0),
          onInput: k
        }), null, 16, ["id", "class", "disabled", "placeholder", "value"])),
        T.value ? (b(), M("div", {
          key: 2,
          class: ne([
            "v-input-icon v-input-icon-right",
            { "v-input-icon-textarea": e.textarea }
          ])
        }, [
          U(L.$slots, "icon-right", {}, () => [
            _.value ? (b(), M("button", {
              key: 0,
              class: "v-input-clear-btn",
              title: "Clear",
              type: "button",
              onClick: m
            }, [
              oe(xe, {
                class: "v-input-icon-svg v-input-icon-svg--sm",
                icon: "lucide:x"
              })
            ])) : t.type === "password" ? (b(), M("div", {
              key: 1,
              class: "v-input-password-toggle",
              role: "button",
              tabindex: "0",
              onClick: w,
              onKeydown: It(w, ["enter", "space"])
            }, [
              oe(xe, {
                icon: v.value === "text" ? "lucide:eye-off" : "lucide:eye",
                class: "v-input-icon-svg"
              }, null, 8, ["icon"])
            ], 32)) : P("", !0)
          ], !0)
        ], 2)) : P("", !0),
        E("fieldset", {
          class: ne([
            "v-fieldset",
            {
              "v-fieldset--active": c.value,
              "v-fieldset--error": a.value,
              "v-fieldset--disabled": e.disabled
            }
          ]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: ne(["v-legend", { "v-legend--visible": t.name && (D.value || c.value) }])
          }, [
            E("span", null, ce(t.name), 1)
          ], 2)
        ], 2)
      ]),
      U(L.$slots, "helper-text", {}, () => [
        e.helperText && !a.value ? (b(), M("p", v1, ce(e.helperText), 1)) : P("", !0)
      ], !0),
      oe(vt, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: de(() => [
          U(L.$slots, "error-message", {}, () => [
            a.value ? (b(), M("p", p1, ce(s.value), 1)) : P("", !0)
          ], !0)
        ]),
        _: 3
      })
    ]));
  }
}), Tr = /* @__PURE__ */ Ge(g1, [["__scopeId", "data-v-36ea8981"]]), y1 = ["innerHTML"], b1 = { key: 1 }, Vn = 12, jn = 8, w1 = 200, Cs = /* @__PURE__ */ Te({
  __name: "VTooltip",
  props: {
    text: {},
    allowHtml: { type: Boolean, default: !1 },
    placement: { default: "right" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    tooltipClass: { default: "" },
    wrapperClass: { default: "" },
    maxWidth: { default: "800px" }
  },
  setup(e) {
    const n = e, t = te(!1), a = te(null), s = te(null), r = te(null), l = te({ top: 0, left: 0 }), i = te(n.placement), o = te(null), u = (g, y, k, m, v, w) => {
      const S = g.top, x = v - g.bottom, $ = g.left, T = m - g.right, _ = S >= k + jn + Vn, A = x >= k + jn + Vn, D = $ >= y + jn + Vn, Y = T >= y + jn + Vn;
      if (w === "top" && _) return "top";
      if (w === "bottom" && A) return "bottom";
      if (w === "left" && D) return "left";
      if (w === "right" && Y) return "right";
      const L = [
        { placement: "right", fits: Y, space: T },
        { placement: "left", fits: D, space: $ },
        { placement: "bottom", fits: A, space: x },
        { placement: "top", fits: _, space: S }
      ], X = L.find((se) => se.fits);
      return X ? X.placement : (L.sort((se, ie) => ie.space - se.space), L[0].placement);
    }, c = async () => {
      if (!s.value) return;
      const g = s.value.getBoundingClientRect(), y = window.innerWidth, k = window.innerHeight;
      if (o.value = null, l.value = { top: -9999, left: -9999 }, i.value = n.placement, await Xe(), !r.value) return;
      const m = r.value.getBoundingClientRect(), v = Math.max(m.width, w1), w = m.height, S = u(
        g,
        v,
        w,
        y,
        k,
        n.placement
      );
      let x, $;
      switch (S) {
        case "top":
          x = g.top - jn - w, $ = g.left + g.width / 2 - v / 2;
          break;
        case "bottom":
          x = g.bottom + jn, $ = g.left + g.width / 2 - v / 2;
          break;
        case "left":
          x = g.top + g.height / 2 - w / 2, $ = g.left - jn - v;
          break;
        case "right":
        default:
          x = g.top + g.height / 2 - w / 2, $ = g.right + jn;
          break;
      }
      const T = y - v - Vn;
      $ = Math.max(Vn, Math.min($, T));
      const _ = k - w - Vn;
      x = Math.max(Vn, Math.min(x, _));
      const A = y - Vn * 2;
      v > A && (o.value = `${A}px`), l.value = { top: x, left: $ }, S && (i.value = S);
    }, f = () => {
      n.disabled || !n.text || (a.value = setTimeout(async () => {
        t.value = !0, await Xe(), c();
      }, n.delay));
    }, h = () => {
      a.value && (clearTimeout(a.value), a.value = null), t.value = !1, i.value = n.placement;
    }, d = C(() => ({
      top: `${l.value.top}px`,
      left: `${l.value.left}px`,
      maxWidth: o.value ?? n.maxWidth
    }));
    return (g, y) => (b(), M("div", {
      ref_key: "triggerRef",
      ref: s,
      class: ne(["relative inline-block cursor-pointer", e.wrapperClass]),
      onBlur: h,
      onFocus: f,
      onMouseenter: f,
      onMouseleave: h
    }, [
      U(g.$slots, "default"),
      (b(), fe(zn, { to: "body" }, [
        oe(vt, {
          "enter-active-class": "transition-opacity duration-200 ease-out",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity duration-150 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: de(() => [
            t.value && e.text ? (b(), M("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: r,
              style: Fe(d.value),
              class: "fixed z-[10001] pointer-events-none"
            }, [
              E("div", {
                class: ne([
                  "bg-base-100/100 text-mainText text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg break-words w-fit min-w-[200px] card",
                  e.tooltipClass
                ])
              }, [
                n.allowHtml ? (b(), M("span", {
                  key: 0,
                  innerHTML: e.text
                }, null, 8, y1)) : (b(), M("span", b1, ce(e.text), 1))
              ], 2)
            ], 4)) : P("", !0)
          ]),
          _: 1
        })
      ]))
    ], 34));
  }
}), k1 = (e) => e.map((n) => n.text.trim()).filter((n) => n.length > 0), J2 = (e) => e.map((n) => ({ text: n })), x1 = { class: "inline-flex items-center gap-1 bg-base-200 rounded-lg p-1 shadow-md border border-base-400" }, S1 = ["disabled", "onClick"], T1 = /* @__PURE__ */ Te({
  __name: "VToggleGroup",
  props: {
    modelValue: {},
    options: {},
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = {
      sm: "px-2 py-1 text-xs gap-1",
      md: "px-3 py-1.5 text-sm gap-1.5",
      lg: "px-4 py-2 text-base gap-2"
    }, s = {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    }, r = (l) => {
      l.disabled || t("update:modelValue", l.value);
    };
    return (l, i) => (b(), M("div", x1, [
      (b(!0), M(Se, null, Pe(e.options, (o) => (b(), fe(Cs, {
        key: String(o.value),
        "allow-html": !0,
        text: o.tooltip || "",
        class: "flex items-center"
      }, {
        default: de(() => [
          E("button", {
            class: ne([[
              a[e.size],
              e.modelValue === o.value ? "bg-primary text-white shadow-sm" : "text-secondaryText hover:text-mainText hover:bg-base-300",
              o.disabled && "opacity-50 cursor-not-allowed"
            ], "flex items-center rounded-md font-medium transition-all whitespace-nowrap"]),
            disabled: o.disabled,
            type: "button",
            onClick: (u) => r(o)
          }, [
            o.icon ? (b(), fe(xe, {
              key: 0,
              class: ne(s[e.size]),
              icon: o.icon
            }, null, 8, ["class", "icon"])) : P("", !0),
            E("span", null, ce(o.label), 1)
          ], 10, S1)
        ]),
        _: 2
      }, 1032, ["text"]))), 128))
    ]));
  }
}), M1 = { class: "v-list-editor" }, $1 = { class: "v-list-editor__header" }, C1 = {
  key: 0,
  class: "v-list-editor__label"
}, D1 = { class: "v-list-editor__tools" }, O1 = ["disabled"], _1 = {
  key: 0,
  class: "v-list-editor__manual"
}, E1 = ["onClick"], I1 = {
  key: 0,
  class: "v-list-editor__error"
}, P1 = {
  key: 1,
  class: "v-list-editor__bulk"
}, A1 = { class: "v-list-editor__hint" }, R1 = { class: "v-list-editor__hint-detected" }, V1 = { class: "v-list-editor__summary" }, F1 = { class: "v-list-editor__count" }, L1 = ["onClick"], N1 = /* @__PURE__ */ Te({
  __name: "VListEditor",
  props: /* @__PURE__ */ ea({
    label: { default: () => {
    } },
    itemLabel: { default: "Item" },
    placeholder: { default: () => {
    } },
    markerClass: { default: () => {
    } },
    maxItems: { default: () => {
    } },
    maxLength: { default: () => {
    } },
    modes: { default: "both" },
    validation: { default: () => {
    } },
    itemError: { type: Function, default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: n }) {
    const t = Ds(e, "modelValue"), a = Qe("inputs"), s = e.modes === "both", r = te(e.modes === "bulk" ? "bulk" : "manual"), l = te(""), i = [
      { value: "manual", label: "Manual", icon: "lucide:plus" },
      { value: "bulk", label: "Bulk", icon: "lucide:list" }
    ], o = /* @__PURE__ */ new WeakMap();
    let u = 0;
    const c = (q) => {
      const Z = of(q);
      let N = o.get(Z);
      return N || (N = `item-${++u}`, o.set(Z, N)), N;
    }, f = C(() => e.maxItems === void 0 || t.value.length < e.maxItems), h = C(() => `Add ${e.itemLabel.toLowerCase()}`), d = (q) => q === 0 ? e.placeholder ?? `${e.itemLabel} 1` : `${e.itemLabel} ${q + 1}`, g = C(() => {
      var q;
      return !!((q = e.validation) != null && q.$error);
    }), y = C(() => {
      var q, Z, N;
      return ((N = (Z = (q = e.validation) == null ? void 0 : q.$errors) == null ? void 0 : Z[0]) == null ? void 0 : N.$message) ?? "";
    }), k = () => {
      var q, Z;
      (Z = (q = e.validation) == null ? void 0 : q.$touch) == null || Z.call(q);
    }, m = (q, Z) => {
      var N;
      return ((N = e.itemError) == null ? void 0 : N.call(e, q, Z)) ?? void 0;
    }, v = async (q) => {
      var N, ae, me;
      await Xe();
      const Z = (N = a.value) == null ? void 0 : N[q];
      (me = (ae = Z == null ? void 0 : Z.$el) == null ? void 0 : ae.querySelector("textarea, input")) == null || me.focus();
    }, w = (q) => {
      if (!f.value) return;
      const Z = q === void 0 ? t.value.length : q + 1;
      t.value.splice(Z, 0, { text: "" }), v(Z);
    }, S = (q) => {
      t.value.length <= 1 || (t.value.splice(q, 1), k(), v(Math.max(0, q - 1)));
    }, x = (q) => {
      w(q);
    }, $ = (q, Z) => {
      Z.length > 0 || S(q);
    }, T = () => {
      w();
    }, _ = [
      { char: `
`, label: "newline", regex: /\n/ },
      { char: ",", label: "comma", regex: /,/ },
      { char: ";", label: "semicolon", regex: /;/ },
      { char: "|", label: "pipe", regex: /\|/ },
      { char: "/", label: "slash", regex: /\// },
      { char: "	", label: "tab", regex: /\t/ }
    ], A = C(() => _.filter((q) => q.regex.test(l.value))), D = C(() => {
      const q = l.value.trim();
      if (!q) return [];
      const Z = A.value.length ? new RegExp(A.value.map((ae) => ae.regex.source).join("|")) : /\s+/, N = [...new Set(q.split(Z).map((ae) => ae.trim()).filter(Boolean))].map((ae) => e.maxLength ? ae.slice(0, e.maxLength) : ae);
      return e.maxItems ? N.slice(0, e.maxItems) : N;
    }), Y = (q) => {
      const Z = [...t.value];
      return q.map((N) => {
        const ae = Z.findIndex((me) => me.text === N);
        if (ae !== -1) {
          const [me] = Z.splice(ae, 1);
          return me;
        }
        return { text: N };
      });
    }, L = C(() => {
      if (!e.itemError) return {};
      const q = {};
      return D.value.forEach((Z) => {
        const N = t.value.findIndex((ae) => ae.text === Z);
        N !== -1 && (q[Z] = e.itemError(t.value[N], N) ?? void 0);
      }), q;
    }), X = (q) => {
      l.value = q, t.value = Y(D.value);
    }, se = (q) => {
      X(String(q ?? ""));
    }, ie = () => {
      X("");
    }, ue = (q) => {
      X(D.value.filter((Z) => Z !== q).join(`
`));
    }, G = (q) => {
      if (q !== r.value) {
        if (q === "bulk")
          l.value = k1(t.value).join(`
`);
        else {
          const Z = Y(D.value);
          t.value = Z.length ? Z : [{ text: "" }], l.value = "";
        }
        r.value = q;
      }
    };
    return n({ focusRow: v }), (q, Z) => (b(), M("div", M1, [
      E("div", $1, [
        e.label ? (b(), M("span", C1, ce(e.label), 1)) : P("", !0),
        E("div", D1, [
          r.value === "manual" ? (b(), fe(Cs, {
            key: 0,
            placement: "top",
            text: f.value ? "" : `Up to ${e.maxItems} ${e.itemLabel.toLowerCase()}s`
          }, {
            default: de(() => [
              E("button", {
                disabled: !f.value,
                class: "v-list-editor__add",
                type: "button",
                onClick: T
              }, [
                oe(xe, {
                  icon: "lucide:plus",
                  size: "14"
                }),
                Ue(" " + ce(h.value), 1)
              ], 8, O1)
            ]),
            _: 1
          }, 8, ["text"])) : P("", !0),
          s ? (b(), fe(T1, {
            key: 1,
            "model-value": r.value,
            options: i,
            size: "sm",
            "onUpdate:modelValue": G
          }, null, 8, ["model-value"])) : P("", !0)
        ])
      ]),
      r.value === "manual" ? (b(), M("div", _1, [
        E("div", {
          class: ne([{ "v-list-editor__box--error": g.value }, "v-list-editor__box"])
        }, [
          oe(Sl, {
            class: "v-list-editor__rows",
            name: "v-list-editor-row",
            tag: "div"
          }, {
            default: de(() => [
              (b(!0), M(Se, null, Pe(t.value, (N, ae) => (b(), M("div", {
                key: c(N),
                class: "v-list-editor__row"
              }, [
                e.markerClass ? (b(), M("span", {
                  key: 0,
                  class: ne([e.markerClass, "v-list-editor__marker"])
                }, null, 2)) : P("", !0),
                oe(Tr, {
                  ref_for: !0,
                  ref: "inputs",
                  modelValue: N.text,
                  "onUpdate:modelValue": (me) => N.text = me,
                  error: m(N, ae),
                  maxlength: e.maxLength,
                  placeholder: d(ae),
                  "show-clear-button": !1,
                  class: "flex-1 min-w-0",
                  name: "",
                  onBlur: k,
                  onKeydown: [
                    It(Ve((me) => x(ae), ["exact", "prevent", "stop"]), ["enter"]),
                    It(Ve((me) => $(ae, N.text), ["stop"]), ["backspace"])
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "maxlength", "placeholder", "onKeydown"]),
                t.value.length > 1 ? (b(), M("button", {
                  key: 1,
                  "aria-label": "Remove",
                  class: "v-list-editor__remove",
                  type: "button",
                  onClick: (me) => S(ae)
                }, [
                  oe(xe, {
                    icon: "lucide:x",
                    size: "14"
                  })
                ], 8, E1)) : P("", !0)
              ]))), 128))
            ]),
            _: 1
          })
        ], 2),
        g.value ? (b(), M("p", I1, ce(y.value), 1)) : P("", !0)
      ])) : (b(), M("div", P1, [
        oe(Tr, {
          error: g.value ? y.value : void 0,
          "model-value": l.value,
          placeholder: `Enter ${e.itemLabel.toLowerCase()}s, one per line or comma-separated`,
          rows: 4,
          textarea: !0,
          name: "",
          onBlur: k,
          "onUpdate:modelValue": se
        }, null, 8, ["error", "model-value", "placeholder"]),
        E("p", A1, [
          Z[1] || (Z[1] = Ue(" Separate by: newline · , · ; · | · / · tab ", -1)),
          A.value.length ? (b(), M(Se, { key: 0 }, [
            Z[0] || (Z[0] = Ue(" · ", -1)),
            E("span", R1, " Detected: " + ce(A.value.map((N) => N.label).join(", ")), 1)
          ], 64)) : P("", !0)
        ]),
        D.value.length > 0 ? (b(), M(Se, { key: 0 }, [
          E("div", V1, [
            E("span", F1, ce(D.value.length) + " " + ce(D.value.length === 1 ? "item" : "items") + " detected ", 1),
            E("button", {
              class: "v-list-editor__clear",
              type: "button",
              onClick: ie
            }, " Clear all ")
          ]),
          oe(Sl, {
            class: "v-list-editor__preview",
            name: "v-list-editor-chip",
            tag: "div"
          }, {
            default: de(() => [
              (b(!0), M(Se, null, Pe(D.value, (N) => (b(), fe(Cs, {
                key: N,
                placement: "top",
                text: L.value[N] ?? ""
              }, {
                default: de(() => [
                  oe(Vu, {
                    color: L.value[N] ? "error" : "primary",
                    label: N,
                    class: "v-list-editor__chip",
                    size: "md",
                    variant: "outline"
                  }, {
                    "icon-right": de(() => [
                      E("button", {
                        class: "v-list-editor__chip-remove",
                        type: "button",
                        onClick: (ae) => ue(N)
                      }, [
                        oe(xe, {
                          class: "size-2.5",
                          icon: "lucide:x"
                        })
                      ], 8, L1)
                    ]),
                    _: 2
                  }, 1032, ["color", "label"])
                ]),
                _: 2
              }, 1032, ["text"]))), 128))
            ]),
            _: 1
          })
        ], 64)) : P("", !0)
      ]))
    ]));
  }
}), Q2 = /* @__PURE__ */ Ge(N1, [["__scopeId", "data-v-8c574eb8"]]), B1 = {
  ref: "pill",
  class: "sliding-pill absolute left-0 top-1 rounded-md pointer-events-none bg-primary/15 ring-1 ring-inset ring-primary/40 shadow-sm"
}, z1 = ["aria-label", "aria-pressed", "title", "disabled", "onClick"], W1 = { key: 1 }, Y1 = /* @__PURE__ */ Te({
  __name: "VSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Qe("container"), s = Qe("pill"), r = (c) => {
      const f = !!(c.icon && !c.label);
      switch (e.size) {
        case "sm":
          return f ? "p-1" : "text-xs px-2 py-1";
        case "lg":
          return f ? "p-2.5" : "text-base px-4 py-2.5";
        default:
          return f ? "p-2" : "text-sm px-3 py-2";
      }
    }, l = C(() => {
      switch (e.size) {
        case "sm":
          return 14;
        case "lg":
          return 20;
        default:
          return 16;
      }
    }), i = (c) => c.value === e.modelValue, o = () => {
      const c = a.value, f = s.value;
      if (!c || !f) return;
      const h = c.querySelectorAll("button"), d = e.options.findIndex((y) => y.value === e.modelValue), g = h[d];
      g && (f.style.transform = `translateX(${g.offsetLeft}px)`, f.style.width = `${g.offsetWidth}px`);
    }, u = (c) => {
      c.disabled || e.disabled || t("update:modelValue", c.value);
    };
    return nt(() => Xe(o)), uf(o), (c, f) => (b(), M("div", {
      ref: "container",
      class: ne([{ "w-full": e.fullWidth, "opacity-50 pointer-events-none": e.disabled }, "v-segmented-control relative inline-flex items-center rounded-lg bg-base-200 p-1 border-[1px] border-base-400 shadow-md gap-1"])
    }, [
      E("span", B1, null, 512),
      (b(!0), M(Se, null, Pe(e.options, (h) => (b(), M("button", {
        key: h.value,
        "aria-label": h.ariaLabel,
        "aria-pressed": i(h),
        title: h.ariaLabel,
        class: ne([[
          r(h),
          e.fullWidth ? "flex-1" : "",
          i(h) ? "text-primary" : "text-secondaryText hover:text-mainText",
          h.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        ], "relative z-10 flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-base-200"]),
        disabled: h.disabled || e.disabled,
        type: "button",
        onClick: (d) => u(h)
      }, [
        h.icon ? (b(), fe(xe, {
          key: 0,
          icon: h.icon,
          size: l.value
        }, null, 8, ["icon", "size"])) : P("", !0),
        h.label ? (b(), M("span", W1, ce(h.label), 1)) : P("", !0)
      ], 10, z1))), 128))
    ], 2));
  }
}), eC = /* @__PURE__ */ Ge(Y1, [["__scopeId", "data-v-17ac3d6e"]]);
function pl(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function H1(e) {
  return (...n) => !e(...n);
}
function U1(e, n) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(n.trim()) !== -1;
}
function q1(e) {
  return e.filter((n) => !n.$isLabel);
}
function gl(e, n) {
  return (t) => t.reduce((a, s) => s[e] && s[e].length ? (a.push({
    $groupLabel: s[n],
    $isLabel: !0
  }), a.concat(s[e])) : a, []);
}
const Xo = (...e) => (n) => e.reduce((t, a) => a(t), n);
var j1 = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, n) {
        return pl(e) ? "" : n ? e[n] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", n = e.toLowerCase().trim();
      let t = this.options.concat();
      return this.internalSearch ? t = this.groupValues ? this.filterAndFlat(t, n, this.label) : this.filterOptions(t, n, this.label, this.customLabel) : t = this.groupValues ? gl(this.groupValues, this.groupLabel)(t) : t, t = this.hideSelected ? t.filter(H1(this.isSelected)) : t, this.taggable && n.length && !this.isExistingOption(n) && (this.tagPosition === "bottom" ? t.push({ isTag: !0, label: e }) : t.unshift({ isTag: !0, label: e })), t.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((n) => this.customLabel(n, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, n, t) {
      return Xo(
        this.filterGroups(n, t, this.groupValues, this.groupLabel, this.customLabel),
        gl(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return Xo(
        gl(this.groupValues, this.groupLabel),
        q1
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const n = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(n) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (pl(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const n = this.customLabel(e, this.label);
      return pl(n) ? "" : n;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, n) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(n) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(n === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            n !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const n = this.options.find((t) => t[this.groupLabel] === e.$groupLabel);
      if (n) {
        if (this.wholeGroupSelected(n)) {
          this.$emit("remove", n[this.groupValues], this.id);
          const t = this.trackBy ? n[this.groupValues].map((s) => s[this.trackBy]) : n[this.groupValues], a = this.internalValue.filter(
            (s) => t.indexOf(this.trackBy ? s[this.trackBy] : s) === -1
          );
          this.$emit("update:modelValue", a);
        } else {
          const t = n[this.groupValues].filter(
            (a) => !(this.isOptionDisabled(a) || this.isSelected(a))
          );
          this.max && t.splice(this.max - this.internalValue.length), this.$emit("select", t, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(t)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (n) => this.isSelected(n) || this.isOptionDisabled(n)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, n = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const t = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const a = this.internalValue.slice(0, t).concat(this.internalValue.slice(t + 1));
        this.$emit("update:modelValue", a);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && n && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, n = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      n > this.maxHeight || n > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(n - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, n, t, a) {
      return n ? e.filter((s) => U1(a(s, t), n)).sort((s, r) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(s, r) : a(s, t).length - a(r, t).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, n, t, a, s) {
      return (r) => r.map((l) => {
        if (!l[t])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const i = this.filterOptions(l[t], e, n, s);
        return i.length ? {
          [a]: l[a],
          [t]: i
        } : [];
      });
    }
  }
}, G1 = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, n) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(n)
      };
    },
    groupHighlight(e, n) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": n.$isLabel }
        ];
      const t = this.options.find((a) => a[this.groupLabel] === n.$groupLabel);
      return t && !this.wholeGroupDisabled(t) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(t) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      var e;
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      var e;
      this.pointer > 0 ? (this.pointer--, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, Vd = {
  name: "vue-multiselect",
  mixins: [j1, G1],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Uses Vue Teleport's feature. Teleports the open dropdown to the bottom of the body element
     * @default false
     * @type {Boolean}
     */
    useTeleport: {
      type: Boolean,
      default: !1
    },
    /**
     * Classes to apply to the `multiselect__content-wrapper` element. This element is a teleport element (when enabled), so can be used to specifically target
     * the teleported element
     */
    contentWrapperClass: {
      type: [String, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dropdownStyles: {},
      ready: !1
    };
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  },
  watch: {
    isOpen(e) {
      e && (this.useTeleport ? (this.ready = !1, this.$nextTick(() => {
        const n = this.$el.getBoundingClientRect();
        this.dropdownStyles = {
          position: "absolute",
          top: `${n.bottom + window.scrollY}px`,
          left: `${n.left + window.scrollX}px`,
          width: `${n.width}px`,
          zIndex: 9999
        }, this.ready = !0;
      })) : this.ready = !0);
    }
  }
};
const K1 = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], Z1 = {
  ref: "tags",
  class: "multiselect__tags"
}, X1 = { class: "multiselect__tags-wrap" }, J1 = ["textContent"], Q1 = ["onKeydown", "onMousedown"], ek = ["textContent"], tk = { class: "multiselect__spinner" }, nk = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], ak = ["id", "aria-multiselectable"], sk = { key: 0 }, rk = { class: "multiselect__option" }, lk = ["aria-selected", "id", "role"], ik = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], ok = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], uk = { class: "multiselect__option" }, ck = { class: "multiselect__option" };
function dk(e, n, t, a, s, r) {
  return b(), M("div", {
    tabindex: e.searchable ? -1 : t.tabindex,
    class: ne([{ "multiselect--active": e.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": r.isAbove, "multiselect--has-options-group": r.hasOptionGroup }, "multiselect"]),
    onFocus: n[14] || (n[14] = (l) => e.activate()),
    onBlur: n[15] || (n[15] = (l) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      n[16] || (n[16] = It(Ve((l) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      n[17] || (n[17] = It(Ve((l) => e.pointerBackward(), ["self", "prevent"]), ["up"])),
      n[18] || (n[18] = It(Ve((l) => e.addPointerElement(l), ["stop", "self"]), ["enter", "tab"]))
    ],
    onKeyup: n[19] || (n[19] = It((l) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    U(e.$slots, "caret", { toggle: e.toggle }, () => [
      E(
        "div",
        {
          onMousedown: n[0] || (n[0] = Ve((l) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    U(e.$slots, "clear", { search: e.search }),
    E(
      "div",
      Z1,
      [
        U(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: r.visibleValues,
          isOpen: e.isOpen
        }, () => [
          mn(E(
            "div",
            X1,
            [
              (b(!0), M(
                Se,
                null,
                Pe(r.visibleValues, (l, i) => U(e.$slots, "tag", {
                  option: l,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (b(), M(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: i,
                      onMousedown: n[1] || (n[1] = Ve(() => {
                      }, ["prevent"]))
                    },
                    [
                      E("span", {
                        textContent: ce(e.getOptionLabel(l))
                      }, null, 8, J1),
                      E("i", {
                        tabindex: "1",
                        onKeydown: It(Ve((o) => e.removeElement(l), ["prevent"]), ["enter"]),
                        onMousedown: Ve((o) => e.removeElement(l), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, Q1)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [Fn, r.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > t.limit ? U(e.$slots, "limit", { key: 0 }, () => [
            E("strong", {
              class: "multiselect__strong",
              textContent: ce(t.limitText(e.internalValue.length - t.limit))
            }, null, 8, ek)
          ]) : P("v-if", !0)
        ]),
        oe(vt, { name: "multiselect__loading" }, {
          default: de(() => [
            U(e.$slots, "loading", {}, () => [
              mn(E(
                "div",
                tk,
                null,
                512
                /* NEED_PATCH */
              ), [
                [Fn, t.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (b(), M("input", {
          key: 0,
          ref: "search",
          name: t.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: t.spellcheck,
          placeholder: e.placeholder,
          required: r.isRequired,
          style: Fe(r.inputStyle),
          value: e.search,
          disabled: t.disabled,
          tabindex: t.tabindex,
          "aria-label": t.name + "-searchbox",
          onInput: n[2] || (n[2] = (l) => e.updateSearch(l.target.value)),
          onFocus: n[3] || (n[3] = Ve((l) => e.activate(), ["prevent"])),
          onBlur: n[4] || (n[4] = Ve((l) => e.deactivate(), ["prevent"])),
          onKeyup: n[5] || (n[5] = It((l) => e.deactivate(), ["esc"])),
          onKeydown: [
            n[6] || (n[6] = It(Ve((l) => e.pointerForward(), ["prevent"]), ["down"])),
            n[7] || (n[7] = It(Ve((l) => e.pointerBackward(), ["prevent"]), ["up"])),
            n[8] || (n[8] = It(Ve((l) => e.addPointerElement(l), ["prevent", "stop", "self"]), ["enter"])),
            n[9] || (n[9] = It(Ve((l) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, nk)) : P("v-if", !0),
        r.isSingleLabelVisible ? (b(), M(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: n[10] || (n[10] = Ve((...l) => e.toggle && e.toggle(...l), ["prevent"]))
          },
          [
            U(e.$slots, "singleLabel", { option: r.singleValue }, () => [
              Ue(
                ce(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : P("v-if", !0),
        r.isPlaceholderVisible ? (b(), M(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: n[11] || (n[11] = Ve((...l) => e.toggle && e.toggle(...l), ["prevent"]))
          },
          [
            U(e.$slots, "placeholder", {}, () => [
              Ue(
                ce(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : P("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    (b(), fe(zn, {
      to: "body",
      disabled: !t.useTeleport
    }, [
      oe(vt, { name: "multiselect" }, {
        default: de(() => [
          e.isOpen && s.ready ? (b(), M(
            "div",
            {
              key: 0,
              class: ne(["multiselect__content-wrapper", t.contentWrapperClass]),
              onFocus: n[12] || (n[12] = (...l) => e.activate && e.activate(...l)),
              tabindex: "-1",
              onMousedown: n[13] || (n[13] = Ve(() => {
              }, ["prevent"])),
              style: Fe([s.dropdownStyles, { maxHeight: e.optimizedHeight + "px" }]),
              ref: "list"
            },
            [
              E("ul", {
                class: "multiselect__content",
                style: Fe(r.contentStyle),
                role: "listbox",
                id: "listbox-" + e.id,
                "aria-multiselectable": e.multiple
              }, [
                U(e.$slots, "beforeList"),
                e.multiple && e.max === e.internalValue.length ? (b(), M("li", sk, [
                  E("span", rk, [
                    U(e.$slots, "maxElements", {}, () => [
                      Ue(
                        "Maximum of " + ce(e.max) + " options selected. First remove a selected option to select another.",
                        1
                        /* TEXT */
                      )
                    ])
                  ])
                ])) : P("v-if", !0),
                !e.max || e.internalValue.length < e.max ? (b(!0), M(
                  Se,
                  { key: 1 },
                  Pe(e.filteredOptions, (l, i) => (b(), M("li", {
                    class: "multiselect__element",
                    key: i,
                    "aria-selected": e.isSelected(l),
                    id: e.id + "-" + i,
                    role: l && (l.$isLabel || l.$isDisabled) ? null : "option"
                  }, [
                    l && (l.$isLabel || l.$isDisabled) ? P("v-if", !0) : (b(), M("span", {
                      key: 0,
                      class: ne([e.optionHighlight(i, l), "multiselect__option"]),
                      onClick: Ve((o) => e.select(l), ["stop"]),
                      onMouseenter: Ve((o) => e.pointerSet(i), ["self"]),
                      "data-select": l && l.isTag ? e.tagPlaceholder : r.selectLabelText,
                      "data-selected": r.selectedLabelText,
                      "data-deselect": r.deselectLabelText
                    }, [
                      U(e.$slots, "option", {
                        option: l,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          ce(e.getOptionLabel(l)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, ik)),
                    l && (l.$isLabel || l.$isDisabled) ? (b(), M("span", {
                      key: 1,
                      "data-select": e.groupSelect && r.selectGroupLabelText,
                      "data-deselect": e.groupSelect && r.deselectGroupLabelText,
                      class: ne([e.groupHighlight(i, l), "multiselect__option"]),
                      onMouseenter: Ve((o) => e.groupSelect && e.pointerSet(i), ["self"]),
                      onMousedown: Ve((o) => e.selectGroup(l), ["prevent"])
                    }, [
                      U(e.$slots, "option", {
                        option: l,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          ce(e.getOptionLabel(l)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, ok)) : P("v-if", !0)
                  ], 8, lk))),
                  128
                  /* KEYED_FRAGMENT */
                )) : P("v-if", !0),
                mn(E(
                  "li",
                  null,
                  [
                    E("span", uk, [
                      U(e.$slots, "noResult", { search: e.search }, () => [
                        n[20] || (n[20] = Ue("No elements found. Consider changing the search query."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Fn, t.showNoResults && e.filteredOptions.length === 0 && e.search && !t.loading]
                ]),
                mn(E(
                  "li",
                  null,
                  [
                    E("span", ck, [
                      U(e.$slots, "noOptions", {}, () => [
                        n[21] || (n[21] = Ue("List is empty."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Fn, t.showNoOptions && (e.options.length === 0 || r.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !t.loading]
                ]),
                U(e.$slots, "afterList")
              ], 12, ak)
            ],
            38
            /* CLASS, STYLE, NEED_HYDRATION */
          )) : P("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ], 8, ["disabled"]))
  ], 42, K1);
}
Vd.render = dk;
const fk = { class: "v-select" }, hk = { class: "multiselect__select" }, mk = /* @__PURE__ */ Te({
  __name: "VSelect",
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Select option" },
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !0 },
    clearOnSelect: { type: Boolean, default: !0 },
    closeOnSelect: { type: Boolean, default: !0 },
    label: { default: "label" },
    trackBy: { default: "value" },
    loading: { type: Boolean, default: !1 },
    taggable: { type: Boolean, default: !1 },
    maxHeight: { default: 300 },
    optionsLimit: { default: 1e3 },
    teleportToBody: { type: Boolean, default: !0 },
    name: { default: "" },
    allowEmpty: { type: Boolean, default: !1 },
    noResultsText: { default: "No results found" }
  },
  emits: ["update:modelValue", "select", "remove", "search-change", "open", "close"],
  setup(e, { emit: n }) {
    const t = e, a = C(() => t.name ? s.value ? t.placeholder : "" : t.placeholder), s = te(!1), r = C(() => Array.isArray(t.modelValue) ? t.modelValue.length > 0 : t.modelValue && typeof t.modelValue == "object" ? !0 : t.modelValue !== null && t.modelValue !== void 0), l = n, i = (x) => {
      l("update:modelValue", x);
    }, o = (x) => {
      l("select", x);
    }, u = (x) => {
      l("remove", x);
    }, c = (x) => {
      l("search-change", x);
    }, f = te(null);
    let h = null, d = null, g = null;
    const y = () => {
      var Y;
      if (!h || !f.value) return;
      const x = (Y = f.value.$el) == null ? void 0 : Y.querySelector(".multiselect__tags");
      if (!x) return;
      const $ = x.getBoundingClientRect(), T = window.innerHeight - $.bottom, _ = Math.min(h.scrollHeight, t.maxHeight), A = T < _ && $.top > T, D = A ? Math.max(4, $.top - _ - 4) : Math.min(window.innerHeight - _ - 4, $.bottom + 4);
      Object.assign(h.style, {
        position: "fixed",
        top: `${D}px`,
        left: `${$.left}px`,
        width: `${$.width}px`,
        maxHeight: `${t.maxHeight}px`,
        zIndex: "10000"
      }), h.classList.toggle("opened-above", A);
    }, k = () => requestAnimationFrame(y), m = () => {
      t.teleportToBody && Xe(() => {
        var x, $;
        h = ($ = (x = f.value) == null ? void 0 : x.$el) == null ? void 0 : $.querySelector(".multiselect__content-wrapper"), h && (d || (g = h.parentElement, d = document.createComment("v-multiselect-anchor"), g == null || g.replaceChild(d, h), document.body.appendChild(h)), h.classList.add("v-ms-floating"), y(), window.addEventListener("scroll", k, { passive: !0 }), window.addEventListener("resize", k, { passive: !0 }));
      });
    }, v = () => {
      h && (window.removeEventListener("scroll", k), window.removeEventListener("resize", k), h.classList.remove("v-ms-floating", "opened-above"), h.removeAttribute("style"), d && g && g.replaceChild(h, d), d = null, g = null, h = null);
    }, w = () => {
      m(), s.value = !0, l("open");
    }, S = () => {
      v(), s.value = !1, l("close");
    };
    return Os(() => v()), (x, $) => (b(), M("div", fk, [
      t.name ? (b(), M("label", {
        key: 0,
        class: ne([{ "v-select__label--active": s.value || r.value }, "v-select__label"])
      }, ce(t.name), 3)) : P("", !0),
      oe(p(Vd), lt({
        ref_key: "msRef",
        ref: f,
        "allow-empty": t.allowEmpty,
        "clear-on-select": t.clearOnSelect,
        "close-on-select": t.closeOnSelect,
        disabled: t.disabled,
        label: t.label,
        loading: t.loading,
        "max-height": t.maxHeight,
        "model-value": t.modelValue,
        multiple: t.multiple,
        options: t.options,
        "options-limit": t.optionsLimit,
        placeholder: a.value,
        searchable: t.searchable,
        "show-labels": !1,
        taggable: t.taggable,
        "track-by": t.trackBy
      }, x.$attrs, {
        onClose: S,
        onOpen: w,
        onRemove: u,
        onSelect: o,
        "onUpdate:modelValue": i,
        onSearchChange: c
      }), ft({
        caret: de(() => [
          E("div", hk, [
            oe(xe, {
              loading: t.loading,
              class: "v-select__caret-icon",
              icon: "mdi:chevron-down"
            }, null, 8, ["loading"])
          ])
        ]),
        noResult: de(() => [
          U(x.$slots, "noResult", {}, () => [
            Ue(ce(t.noResultsText || "No results found"), 1)
          ], !0)
        ]),
        _: 2
      }, [
        Pe(Object.keys(x.$slots).filter((T) => T !== "noResult"), (T, _) => ({
          name: T,
          fn: de((A) => [
            U(x.$slots, T, Mt(Ft(A)), void 0, !0)
          ])
        }))
      ]), 1040, ["allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "loading", "max-height", "model-value", "multiple", "options", "options-limit", "placeholder", "searchable", "taggable", "track-by"]),
      E("fieldset", {
        class: ne([{ "v-select__fieldset--active": s.value }, "v-select__fieldset"]),
        "aria-hidden": "true"
      }, [
        E("legend", {
          class: ne([{ "v-select__legend--visible": t.name && (r.value || s.value) }, "v-select__legend"])
        }, [
          E("span", null, ce(t.name), 1)
        ], 2)
      ], 2)
    ]));
  }
}), vk = /* @__PURE__ */ Ge(mk, [["__scopeId", "data-v-9bb5c30c"]]), pk = ["for"], gk = { class: "v-switch__container" }, yk = ["id", "checked", "disabled"], bk = { class: "v-switch__label" }, wk = /* @__PURE__ */ Te({
  __name: "VSwitch",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    trueIcon: {},
    falseIcon: {},
    trueLabel: {},
    falseLabel: {},
    color: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Ql(), r = C(() => t.id || `v-switch-${Cr()}`), l = C({
      get: () => !!t.modelValue,
      set: (c) => a("update:modelValue", c)
    }), i = {
      positive: "success",
      negative: "error"
    }, o = (c) => /^#|^rgb|^hsl|^oklch|^color/.test(c) ? c : `rgb(var(--color-${i[c] ?? c}) / 1)`, u = C(() => {
      if (t.disabled)
        return {
          backgroundColor: "#d1d5db",
          borderColor: "#d1d5db"
        };
      if (t.color && l.value) {
        const c = o(t.color);
        return {
          backgroundColor: c,
          borderColor: c
        };
      }
      return {};
    });
    return (c, f) => (b(), M("label", {
      class: ne([{ "v-switch--disabled": t.disabled }, "v-switch"]),
      for: r.value
    }, [
      E("span", gk, [
        E("input", lt({
          id: r.value,
          checked: l.value,
          disabled: t.disabled,
          class: "v-switch__input",
          type: "checkbox"
        }, p(s), {
          onChange: f[0] || (f[0] = (h) => l.value = h.target.checked)
        }), null, 16, yk),
        E("span", {
          class: ne([
            "v-switch__track",
            { "v-switch__track--checked": l.value },
            { "v-switch__track--disabled": t.disabled },
            { "v-switch__track--custom-color": t.color && l.value }
          ]),
          style: Fe(u.value)
        }, [
          E("span", {
            class: ne(["v-switch__thumb", { "v-switch__thumb--checked": l.value }])
          }, [
            c.$slots.icon ? U(c.$slots, "icon", { key: 0 }, () => [
              U(c.$slots, l.value ? "true-icon" : "false-icon", {}, void 0, !0)
            ], !0) : (b(), M(Se, { key: 1 }, [
              l.value && t.trueIcon ? (b(), fe(xe, {
                key: 0,
                icon: t.trueIcon,
                size: 16
              }, null, 8, ["icon"])) : !l.value && t.falseIcon ? (b(), fe(xe, {
                key: 1,
                icon: t.falseIcon,
                size: 16
              }, null, 8, ["icon"])) : P("", !0)
            ], 64))
          ], 2)
        ], 6)
      ]),
      E("span", bk, [
        U(c.$slots, "default", {}, () => [
          Ue(ce(l.value ? t.trueLabel : t.falseLabel), 1)
        ], !0)
      ])
    ], 10, pk));
  }
}), tC = /* @__PURE__ */ Ge(wk, [["__scopeId", "data-v-76a7fbe9"]]), Jt = te(/* @__PURE__ */ new Map());
let Jo = 1e3;
const Fd = () => {
  const e = C(() => (f) => Jt.value.get(f)), n = C(() => (f) => {
    const h = Jt.value.get(f);
    return h ? h.isOpen : !1;
  }), t = C(() => (f) => {
    const h = Jt.value.get(f);
    return h ? h.zIndex : 1e3;
  }), a = C(() => Array.from(Jt.value.values()).filter((f) => f.isOpen)), s = C(() => a.value.length > 0), r = (f) => {
    Jt.value.has(f) || Jt.value.set(f, {
      id: f,
      isOpen: !1,
      zIndex: 1e3
    });
  }, l = (f) => {
    Jt.value.delete(f);
  }, i = (f) => {
    r(f);
    const h = Jt.value.get(f);
    h && (Jo += 10, h.zIndex = Jo, h.isOpen = !0);
  }, o = (f) => {
    const h = Jt.value.get(f);
    h && (h.isOpen = !1);
  };
  return {
    modals: Jt,
    getModal: e,
    isOpen: n,
    getZIndex: t,
    openModals: a,
    hasOpenModals: s,
    register: r,
    unregister: l,
    open: i,
    close: o,
    toggle: (f) => {
      const h = Jt.value.get(f);
      h && (h.isOpen ? o(f) : i(f));
    },
    closeAll: () => {
      Jt.value.forEach((f) => {
        f.isOpen = !1;
      });
    }
  };
}, Di = (e, n = !0) => {
  const t = Fd();
  t.register(e);
  const a = C(() => t.isOpen.value(e)), s = C(() => t.getZIndex.value(e)), r = C(() => t.getModal.value(e)), l = () => t.open(e), i = () => t.close(e), o = () => t.toggle(e);
  return n && Os(() => {
    t.unregister(e);
  }), {
    isOpen: a,
    zIndex: s,
    modal: r,
    open: l,
    close: i,
    toggle: o
  };
}, kk = {
  key: 0,
  class: "v-drawer__header"
}, xk = {
  key: 0,
  class: "v-drawer__title"
}, Sk = { class: "v-drawer__content" }, Tk = {
  key: 1,
  class: "v-drawer__footer"
}, Mk = /* @__PURE__ */ Te({
  __name: "VDrawer",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    position: { default: "right" },
    width: { default: "md" },
    backdropBlur: { default: "xs" },
    keepAlive: { type: Boolean, default: !1 }
  },
  emits: ["close", "open"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: r, zIndex: l } = Di(t.id), i = C(() => `v-drawer__container--width-${t.width}`), o = C(() => `v-drawer__container--${t.position}`), u = C(() => t.backdropBlur === "none" ? "" : `v-drawer__backdrop--blur-${t.backdropBlur}`), c = () => {
      r(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, h = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, g) => (b(), fe(zn, { to: "body" }, [
      oe(vt, {
        name: "v-drawer",
        onAfterEnter: g[1] || (g[1] = (y) => a("open"))
      }, {
        default: de(() => [
          e.keepAlive || p(s) ? mn((b(), M("div", {
            key: 0,
            class: ne([u.value, "v-drawer__backdrop"]),
            style: Fe({ zIndex: p(l) }),
            onClick: f,
            onKeydown: h
          }, [
            E("div", {
              class: ne([[i.value, o.value], "v-drawer__container"]),
              onClick: g[0] || (g[0] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (b(), M("div", kk, [
                U(d.$slots, "header", {}, () => [
                  e.title ? (b(), M("h3", xk, ce(e.title), 1)) : P("", !0)
                ], !0),
                e.showCloseButton ? (b(), M("button", {
                  key: 0,
                  "aria-label": "Close drawer",
                  class: "v-drawer__close-btn",
                  type: "button",
                  onClick: c
                }, [...g[2] || (g[2] = [
                  E("svg", {
                    fill: "none",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    })
                  ], -1)
                ])])) : P("", !0)
              ])) : P("", !0),
              E("div", Sk, [
                U(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer ? (b(), M("div", Tk, [
                U(d.$slots, "footer", {}, void 0, !0)
              ])) : P("", !0)
            ], 2)
          ], 38)), [
            [Fn, e.keepAlive ? p(s) : !0]
          ]) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), nC = /* @__PURE__ */ Ge(Mk, [["__scopeId", "data-v-df9c8e66"]]), $k = { class: "v-floating" }, Ck = ["disabled", "onClick"], Dk = {
  key: 0,
  class: "v-floating-item-icon"
}, Ok = { class: "v-floating-item-label" }, _k = 120, Ek = /* @__PURE__ */ Te({
  __name: "VFloating",
  props: {
    placement: { default: "bottom-right" },
    teleport: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    offset: { default: 8 },
    openOnHover: { type: Boolean, default: !1 },
    hoverDelay: { default: 200 },
    items: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    closeOnSelect: { type: Boolean, default: !0 },
    unstyled: { type: Boolean, default: !1 },
    contentClass: { default: "" }
  },
  emits: ["select"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, r = te(!1), l = te(null), i = te(null), o = te({ top: 0, left: 0, right: 0 }), u = te(!1);
    let c = !1, f = null;
    function h() {
      !r.value || !i.value || c || (c = !0, requestAnimationFrame(() => {
        c = !1, m();
      }));
    }
    const d = C(() => a.items.length > 0), g = C(() => a.disabled), y = C(() => {
      const ge = a.placement, K = {
        "v-floating--bottom-left": ge === "bottom-left",
        "v-floating--bottom-right": ge === "bottom-right",
        "v-floating--top-left": ge === "top-left",
        "v-floating--top-right": ge === "top-right",
        "v-floating--teleported": a.teleport
      };
      return a.unstyled ? {
        ...K,
        "v-floating--unstyled": !0,
        [a.contentClass]: !!a.contentClass
      } : {
        ...K,
        "v-floating--dropdown": d.value,
        "v-floating--popover": !d.value,
        "v-floating--styled": !0,
        [a.contentClass]: !!a.contentClass
      };
    }), k = C(() => a.teleport ? u.value ? {
      position: "fixed",
      zIndex: "9999",
      top: `${o.value.top}px`,
      left: o.value.left !== void 0 ? `${o.value.left}px` : void 0,
      right: o.value.right !== void 0 ? `${o.value.right}px` : void 0
      // Prevent following scroll by using fixed positioning as-is
      // The dropdown will stay in place relative to viewport, not following the trigger
    } : {} : {}), m = () => {
      if (!(!l.value || !i.value)) {
        if (a.teleport) {
          const ge = l.value.getBoundingClientRect(), K = i.value.offsetWidth, ye = i.value.offsetHeight, [Me, V] = a.placement.split("-"), j = a.offset;
          let H;
          Me === "bottom" ? H = ge.bottom + j : H = ge.top - ye - j;
          let I;
          V === "left" ? I = ge.left : I = ge.right - K, o.value.top = H, o.value.left = I, o.value.right = void 0;
        } else
          o.value.top = 0, o.value.left = 0;
        u.value = !0;
      }
    }, v = () => {
      g.value || (r.value = !r.value, r.value ? (u.value = !1, Xe(() => {
        i.value && l.value && (m(), pe());
      })) : De());
    }, w = () => {
      r.value && (r.value = !1, u.value = !1, De());
    }, S = () => {
      g.value || r.value || (r.value = !0, u.value = !1, Xe(() => {
        i.value && l.value && (m(), pe());
      }));
    }, x = typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    let $ = null, T = null;
    const _ = () => {
      $ && (clearTimeout($), $ = null);
    }, A = () => {
      T && (clearTimeout(T), T = null);
    }, D = () => {
      _(), A();
    }, Y = () => {
      A(), !r.value && (_(), $ = setTimeout(() => {
        $ = null, S();
      }, a.hoverDelay));
    }, L = () => {
      D(), T = setTimeout(() => {
        T = null, w();
      }, _k);
    }, X = () => {
      !a.openOnHover || !x || Y();
    }, se = () => {
      !a.openOnHover || !x || L();
    }, ie = () => {
      !a.openOnHover || !x || A();
    }, ue = () => {
      !a.openOnHover || !x || L();
    }, G = () => {
      a.openOnHover && (D(), S());
    }, q = () => {
      a.openOnHover && (D(), w());
    }, Z = (ge) => {
      ge.disabled || ge.loading || (s("select", ge.value), a.closeOnSelect && !ge.loading && w());
    }, N = (ge) => {
      ge.key === "Escape" && r.value && w();
    }, ae = (ge) => {
      if (!a.closeOnClickOutside || !r.value) return;
      const K = ge.composedPath(), ye = l.value && K.includes(l.value), Me = i.value && K.includes(i.value);
      !ye && !Me && w();
    };
    nt(() => {
      document.addEventListener("click", ae, !0);
    }), Os(() => {
      document.removeEventListener("click", ae, !0), De(), D();
    });
    const me = () => {
      !r.value || !a.teleport || h();
    }, be = () => {
      !r.value || !a.teleport || h();
    };
    function pe() {
      a.teleport && (window.addEventListener("scroll", me, {
        passive: !0,
        capture: !0
      }), window.addEventListener("resize", be, { passive: !0 }), l.value && (f = new ResizeObserver(() => h()), f.observe(l.value)), document.addEventListener("keydown", N));
    }
    function De() {
      window.removeEventListener("scroll", me, { capture: !0 }), window.removeEventListener("resize", be), document.removeEventListener("keydown", N), f && (f.disconnect(), f = null);
    }
    return n({
      isOpen: r,
      open: S,
      close: w,
      toggle: v
    }), (ge, K) => (b(), M("div", $k, [
      E("div", {
        ref_key: "triggerRef",
        ref: l,
        class: ne([{ "v-floating-trigger--disabled": g.value }, "v-floating-trigger"]),
        onClick: v,
        onFocusin: G,
        onFocusout: q,
        onMouseenter: X,
        onMouseleave: se
      }, [
        U(ge.$slots, "trigger", {
          isDisabled: g.value,
          isOpen: r.value
        }, void 0, !0)
      ], 34),
      (b(), fe(zn, {
        disabled: !e.teleport,
        to: "body"
      }, [
        r.value ? (b(), M("div", {
          key: 0,
          ref_key: "floatingRef",
          ref: i,
          class: ne([[
            y.value,
            { "v-floating--positioning": !u.value }
          ], "v-floating-content"]),
          style: Fe(k.value),
          onMouseenter: ie,
          onMouseleave: ue
        }, [
          U(ge.$slots, "content", { close: w }, () => [
            d.value ? (b(!0), M(Se, { key: 0 }, Pe(e.items, (ye) => (b(), M("button", {
              key: ye.value,
              class: ne([{
                "v-floating-item--loading": ye.loading,
                "v-floating-item--active": ye.active,
                "v-floating-item--disabled": ye.disabled
              }, "v-floating-item"]),
              disabled: ye.disabled || ye.loading,
              onClick: (Me) => Z(ye)
            }, [
              U(ge.$slots, "item-icon", { item: ye }, () => [
                ye.icon ? (b(), M("span", Dk, [
                  oe(xe, {
                    icon: ye.icon,
                    loading: ye.loading,
                    size: 16
                  }, null, 8, ["icon", "loading"])
                ])) : P("", !0)
              ], !0),
              E("span", Ok, ce(ye.label), 1)
            ], 10, Ck))), 128)) : P("", !0)
          ], !0)
        ], 38)) : P("", !0)
      ], 8, ["disabled"]))
    ]));
  }
}), Mr = /* @__PURE__ */ Ge(Ek, [["__scopeId", "data-v-66563b51"]]), Ik = {
  key: 0,
  class: "modal-header"
}, Pk = {
  key: 0,
  class: "modal-title"
}, Ak = { class: "modal-content" }, Rk = {
  key: 1,
  class: "modal-footer"
}, Vk = {
  key: 0,
  class: "modal-footer-actions"
}, Fk = /* @__PURE__ */ Te({
  __name: "VModal",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    maxWidth: { default: "md" },
    footerActions: { type: [Boolean, Object], default: void 0 },
    loading: { type: Boolean }
  },
  emits: ["close", "open", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: r, zIndex: l } = Di(t.id), i = C(() => `modal-container--${t.maxWidth}`), o = {
      confirmText: "Confirm",
      cancelText: "Cancel",
      confirmVariant: "primary",
      cancelVariant: "default",
      showConfirm: !0,
      showCancel: !0
    }, u = C(() => t.footerActions ? t.footerActions === !0 ? o : { ...o, ...t.footerActions } : null), c = () => {
      r(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, h = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, g) => (b(), fe(zn, { to: "body" }, [
      oe(vt, {
        name: "modal",
        onAfterEnter: g[2] || (g[2] = (y) => a("open"))
      }, {
        default: de(() => [
          p(s) ? (b(), M("div", {
            key: 0,
            style: Fe({ zIndex: p(l) }),
            class: "modal-backdrop",
            onClick: f,
            onKeydown: h
          }, [
            E("div", {
              class: ne([i.value, "modal-container"]),
              onClick: g[1] || (g[1] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (b(), M("div", Ik, [
                U(d.$slots, "header", {}, () => [
                  e.title ? (b(), M("h3", Pk, ce(e.title), 1)) : P("", !0)
                ], !0),
                e.showCloseButton ? (b(), M("button", {
                  key: 0,
                  "aria-label": "Close modal",
                  class: "modal-close-btn",
                  type: "button",
                  onClick: c
                }, [...g[3] || (g[3] = [
                  E("svg", {
                    fill: "none",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    })
                  ], -1)
                ])])) : P("", !0)
              ])) : P("", !0),
              E("div", Ak, [
                U(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer || u.value ? (b(), M("div", Rk, [
                U(d.$slots, "footer", {}, () => [
                  u.value ? (b(), M("div", Vk, [
                    u.value.showCancel ? (b(), fe(qt, {
                      key: 0,
                      disabled: t.loading,
                      variant: u.value.cancelVariant,
                      type: "button",
                      onClick: c
                    }, {
                      default: de(() => [
                        Ue(ce(u.value.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "variant"])) : P("", !0),
                    u.value.showConfirm ? (b(), fe(qt, {
                      key: 1,
                      loading: t.loading,
                      variant: u.value.confirmVariant,
                      type: "button",
                      onClick: g[0] || (g[0] = (y) => a("confirm"))
                    }, {
                      default: de(() => [
                        Ue(ce(u.value.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "variant"])) : P("", !0)
                  ])) : P("", !0)
                ], !0)
              ])) : P("", !0)
            ], 2)
          ], 36)) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), aC = /* @__PURE__ */ Ge(Fk, [["__scopeId", "data-v-e7e67538"]]), Lk = (e) => {
  const n = Tu(), t = te(!0), a = te(!1), s = te(null), r = () => t.value && tt((e == null ? void 0 : e.when) ?? !0);
  mf((c) => c.meta.requiresAuth === !1 || !r() ? !0 : (a.value = !0, s.value = c, !1)), He(
    [() => tt((e == null ? void 0 : e.when) ?? !0), t],
    ([c, f]) => {
      (!c || !f) && a.value && i();
    }
  );
  const l = () => {
    if (!s.value) return;
    const c = s.value;
    t.value = !1, a.value = !1, s.value = null, n.push(c).finally(() => {
      t.value = !0;
    });
  }, i = () => {
    a.value = !1, s.value = null;
  };
  return { isPending: a, pendingTo: s, isEnabled: t, confirm: l, cancel: i, enable: () => {
    t.value = !0;
  }, disable: () => {
    t.value = !1;
  } };
}, Nk = ["aria-label"], Bk = {
  key: 0,
  class: "unsaved-changes__card mx-4 flex w-full max-w-sm overflow-hidden rounded-xl"
}, zk = { class: "flex flex-1 flex-col p-5" }, Wk = { class: "flex items-start gap-3" }, Yk = { class: "min-w-0 flex-1" }, Hk = { class: "mb-1 text-sm font-semibold leading-snug text-mainText" }, Uk = { class: "text-xs leading-relaxed text-secondaryText" }, qk = { class: "mt-4 flex items-center justify-end gap-2 border-t border-base-300 pt-4" }, jk = /* @__PURE__ */ Te({
  __name: "VUnsavedChangesModal",
  props: {
    open: { type: Boolean, default: !1 },
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" },
    zIndex: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = n, a = Qe("dialog");
    return He(() => e.open, (s) => {
      s && Xe(() => {
        var r;
        return (r = a.value) == null ? void 0 : r.focus();
      });
    }), (s, r) => (b(), fe(zn, { to: "body" }, [
      oe(vt, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: de(() => [
          e.open ? (b(), M("div", {
            key: 0,
            ref: "dialog",
            "aria-label": e.title,
            style: Fe({ "--_z-index": e.zIndex }),
            "aria-modal": "true",
            class: "unsaved-changes__backdrop fixed inset-0 flex items-center justify-center",
            role: "dialog",
            tabindex: "-1",
            onClick: r[3] || (r[3] = Ve((l) => t("cancel"), ["self"])),
            onKeydown: r[4] || (r[4] = It((l) => t("cancel"), ["esc"]))
          }, [
            oe(vt, {
              appear: "",
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95 -translate-y-2",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 -translate-y-2"
            }, {
              default: de(() => [
                e.open ? (b(), M("div", Bk, [
                  r[7] || (r[7] = E("div", { class: "w-1 flex-shrink-0 bg-gradient-to-b from-warning via-warning/60 to-warning/10" }, null, -1)),
                  E("div", zk, [
                    E("div", Wk, [
                      r[6] || (r[6] = E("div", { class: "mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-warning-200 bg-warning-50" }, [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-4 w-4 text-warning",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.2",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }),
                          E("path", { d: "M12 9v4" }),
                          E("path", { d: "M12 17h.01" })
                        ])
                      ], -1)),
                      E("div", Yk, [
                        E("h2", Hk, ce(e.title), 1),
                        E("div", Uk, [
                          U(s.$slots, "description", {}, () => [
                            Ue(ce(e.description), 1)
                          ], !0)
                        ])
                      ]),
                      E("button", {
                        "aria-label": "Cancel and keep editing",
                        class: "-mr-1 -mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-secondaryText transition-colors hover:bg-base-200",
                        type: "button",
                        onClick: r[0] || (r[0] = (l) => t("cancel"))
                      }, [...r[5] || (r[5] = [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-3.5 w-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "M18 6 6 18M6 6l12 12" })
                        ], -1)
                      ])])
                    ]),
                    E("div", qk, [
                      E("button", {
                        class: "h-8 rounded-md border border-error/25 bg-transparent px-3 text-xs text-error transition-all hover:border-error/40 hover:bg-error/5 active:scale-95",
                        type: "button",
                        onClick: r[1] || (r[1] = (l) => t("confirm"))
                      }, ce(e.leaveLabel), 1),
                      E("button", {
                        class: "h-8 rounded-md border-2 border-primary bg-primary px-4 text-xs text-white shadow-sm transition-all hover:border-primary-dark hover:bg-primary-dark active:scale-95",
                        type: "button",
                        onClick: r[2] || (r[2] = (l) => t("cancel"))
                      }, ce(e.confirmLabel), 1)
                    ])
                  ])
                ])) : P("", !0)
              ]),
              _: 3
            })
          ], 44, Nk)) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Gk = /* @__PURE__ */ Ge(jk, [["__scopeId", "data-v-4050f9cd"]]), sC = /* @__PURE__ */ Te({
  __name: "NavigationGuardModal",
  props: {
    when: {},
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" }
  },
  setup(e) {
    const { isPending: n, confirm: t, cancel: a } = Lk({ when: () => tt(e.when) });
    return (s, r) => (b(), fe(Gk, {
      "confirm-label": e.confirmLabel,
      description: e.description,
      "leave-label": e.leaveLabel,
      open: p(n),
      title: e.title,
      onCancel: p(a),
      onConfirm: p(t)
    }, ft({ _: 2 }, [
      s.$slots.description ? {
        name: "description",
        fn: de(() => [
          U(s.$slots, "description")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["confirm-label", "description", "leave-label", "open", "title", "onCancel", "onConfirm"]));
  }
}), Kk = { class: "v-progress-bar" }, Zk = {
  key: 0,
  class: "v-progress-bar__header"
}, Xk = {
  key: 0,
  class: "v-progress-bar__step"
}, Jk = { key: 1 }, Qk = {
  key: 2,
  class: "v-progress-bar__percentage"
}, ex = {
  key: 0,
  class: "v-progress-bar__shine"
}, tx = /* @__PURE__ */ Te({
  __name: "VProgressBar",
  props: {
    percentage: {},
    step: { default: null },
    size: { default: "md" },
    showPercentage: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = C(() => Math.max(0, Math.min(100, n.percentage))), a = C(() => t.value >= 100), s = C(() => ({ sm: "4px", md: "6px", lg: "8px" })[n.size]);
    return (r, l) => (b(), M("div", Kk, [
      e.step || e.showPercentage ? (b(), M("div", Zk, [
        e.step ? (b(), M("span", Xk, ce(e.step), 1)) : (b(), M("span", Jk)),
        e.showPercentage ? (b(), M("div", Qk, [
          E("span", {
            class: ne({ "text-success": a.value })
          }, ce(Math.round(t.value)) + "% ", 3),
          a.value ? (b(), fe(xe, {
            key: 0,
            size: 14,
            class: "text-success ml-1",
            icon: "lucide:check-circle"
          })) : P("", !0)
        ])) : P("", !0)
      ])) : P("", !0),
      E("div", {
        style: Fe({ height: s.value }),
        class: "v-progress-bar__track"
      }, [
        E("div", {
          class: ne([{ "v-progress-bar__fill--completed": a.value }, "v-progress-bar__fill"]),
          style: Fe({ width: `${t.value}%` })
        }, [
          a.value ? P("", !0) : (b(), M("div", ex))
        ], 6)
      ], 4)
    ]));
  }
}), rC = /* @__PURE__ */ Ge(tx, [["__scopeId", "data-v-d74c8912"]]), nx = ["aria-label", "title"], ax = { class: "theme-toggle__icon-container" }, sx = {
  key: 0,
  class: "theme-toggle__icon theme-toggle__icon--light",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, rx = {
  key: 0,
  class: "theme-toggle__icon theme-toggle__icon--dark",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, lx = {
  key: 0,
  class: "theme-toggle__icon theme-toggle__icon--auto",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, ix = {
  key: 0,
  class: "theme-toggle__label"
}, ox = /* @__PURE__ */ Te({
  __name: "VThemeToggle",
  props: {
    modelValue: {},
    showLabel: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = C(() => ({
      light: "Light",
      dark: "Dark",
      auto: "Auto"
    })[t.modelValue]), r = C(() => `Switch to ${t.modelValue === "light" ? "dark" : t.modelValue === "dark" ? "auto" : "light"} mode`), l = () => {
      const i = t.modelValue === "light" ? "dark" : t.modelValue === "dark" ? "auto" : "light";
      a("update:modelValue", i);
    };
    return (i, o) => (b(), M("button", {
      "aria-label": r.value,
      class: ne([
        "theme-toggle",
        { "theme-toggle--full": !e.compact },
        { "theme-toggle--compact": e.compact }
      ]),
      title: r.value,
      onClick: l
    }, [
      E("div", ax, [
        oe(vt, {
          "enter-active-class": "transition-all duration-300",
          "enter-from-class": "opacity-0 rotate-90 scale-0",
          "enter-to-class": "opacity-100 rotate-0 scale-100",
          "leave-active-class": "transition-all duration-300",
          "leave-from-class": "opacity-100 rotate-0 scale-100",
          "leave-to-class": "opacity-0 -rotate-90 scale-0"
        }, {
          default: de(() => [
            e.modelValue === "light" ? (b(), M("svg", sx, [...o[0] || (o[0] = [
              E("path", {
                "clip-rule": "evenodd",
                d: `M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0z
            m-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414z
            m2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0z
            M17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1z
            M5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707z
            m1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414z
            M4 11a1 1 0 100-2H3a1 1 0 000 2h1z`,
                fill: "currentColor",
                "fill-rule": "evenodd"
              }, null, -1)
            ])])) : P("", !0)
          ]),
          _: 1
        }),
        oe(vt, {
          "enter-active-class": "transition-all duration-300",
          "enter-from-class": "opacity-0 rotate-90 scale-0",
          "enter-to-class": "opacity-100 rotate-0 scale-100",
          "leave-active-class": "transition-all duration-300",
          "leave-from-class": "opacity-100 rotate-0 scale-100",
          "leave-to-class": "opacity-0 -rotate-90 scale-0"
        }, {
          default: de(() => [
            e.modelValue === "dark" ? (b(), M("svg", rx, [...o[1] || (o[1] = [
              E("path", {
                d: "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z",
                fill: "currentColor"
              }, null, -1)
            ])])) : P("", !0)
          ]),
          _: 1
        }),
        oe(vt, {
          "enter-active-class": "transition-all duration-300",
          "enter-from-class": "opacity-0 rotate-90 scale-0",
          "enter-to-class": "opacity-100 rotate-0 scale-100",
          "leave-active-class": "transition-all duration-300",
          "leave-from-class": "opacity-100 rotate-0 scale-100",
          "leave-to-class": "opacity-0 -rotate-90 scale-0"
        }, {
          default: de(() => [
            e.modelValue === "auto" ? (b(), M("svg", lx, [...o[2] || (o[2] = [
              E("path", {
                "clip-rule": "evenodd",
                d: `M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7
            a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z`,
                fill: "currentColor",
                "fill-rule": "evenodd"
              }, null, -1)
            ])])) : P("", !0)
          ]),
          _: 1
        })
      ]),
      oe(vt, {
        "enter-active-class": "transition-all duration-200",
        "enter-from-class": "opacity-0 w-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition-all duration-200",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0 w-0"
      }, {
        default: de(() => [
          e.showLabel ? (b(), M("span", ix, ce(s.value), 1)) : P("", !0)
        ]),
        _: 1
      }),
      E("div", {
        class: ne([
          "theme-toggle__indicator",
          {
            "theme-toggle__indicator--light": e.modelValue === "light",
            "theme-toggle__indicator--dark": e.modelValue === "dark",
            "theme-toggle__indicator--auto": e.modelValue === "auto"
          }
        ])
      }, null, 2)
    ], 10, nx));
  }
}), lC = /* @__PURE__ */ Ge(ox, [["__scopeId", "data-v-84613b69"]]);
let Kl = 1;
var ux = class {
  constructor() {
    we(this, "subscribers");
    we(this, "toasts");
    we(this, "dismissedToasts");
    we(this, "subscribe", (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }));
    we(this, "publish", (e) => {
      this.subscribers.forEach((n) => n(e));
    });
    we(this, "addToast", (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    });
    we(this, "create", (e) => {
      var l;
      const { message: n, ...t } = e, a = typeof e.id == "number" || e.id && ((l = e.id) == null ? void 0 : l.length) > 0 ? e.id : Kl++, s = this.toasts.find((i) => i.id === a), r = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((i) => i.id === a ? (this.publish({
        ...i,
        ...e,
        id: a,
        title: n
      }), {
        ...i,
        ...e,
        id: a,
        dismissible: r,
        title: n
      }) : i) : this.addToast({
        title: n,
        ...t,
        dismissible: r,
        id: a
      }), a;
    });
    we(this, "dismiss", (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((t) => t({
        id: n.id,
        dismiss: !0
      }));
    }), e));
    we(this, "message", (e, n) => this.create({
      ...n,
      message: e,
      type: "default"
    }));
    we(this, "error", (e, n) => this.create({
      ...n,
      type: "error",
      message: e
    }));
    we(this, "success", (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }));
    we(this, "info", (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }));
    we(this, "warning", (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }));
    we(this, "loading", (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }));
    we(this, "promise", (e, n) => {
      if (!n) return;
      let t;
      n.loading !== void 0 && (t = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const a = Promise.resolve(e instanceof Function ? e() : e);
      let s = t !== void 0, r;
      const l = a.then(async (o) => {
        if (r = ["resolve", o], rs(o))
          s = !1, this.create({
            id: t,
            type: "default",
            message: o
          });
        else if (dx(o) && !o.ok) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${o.status}`) : n.error, f = typeof n.description == "function" ? await n.description(`HTTP error! status: ${o.status}`) : n.description, d = typeof c == "object" && !rs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (o instanceof Error) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(o) : n.error, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !rs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (n.success !== void 0) {
          s = !1;
          const c = typeof n.success == "function" ? await n.success(o) : n.success, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !rs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "success",
            description: f,
            ...d
          });
        }
      }).catch(async (o) => {
        if (r = ["reject", o], n.error !== void 0) {
          s = !1;
          const u = typeof n.error == "function" ? await n.error(o) : n.error, c = typeof n.description == "function" ? await n.description(o) : n.description, h = typeof u == "object" && !rs(u) ? u : {
            message: u || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: c,
            ...h
          });
        }
      }).finally(() => {
        var o;
        s && (this.dismiss(t), t = void 0), (o = n.finally) == null || o.call(n);
      }), i = () => new Promise((o, u) => l.then(() => r[0] === "reject" ? u(r[1]) : o(r[1])).catch(u));
      return typeof t != "string" && typeof t != "number" ? { unwrap: i } : Object.assign(t, { unwrap: i });
    });
    we(this, "custom", (e, n) => {
      const t = (n == null ? void 0 : n.id) || Kl++, a = this.toasts.find((r) => r.id === t), s = (n == null ? void 0 : n.dismissible) === void 0 ? !0 : n.dismissible;
      return this.dismissedToasts.has(t) && this.dismissedToasts.delete(t), a ? this.toasts = this.toasts.map((r) => r.id === t ? (this.publish({
        ...r,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), {
        ...r,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }) : r) : this.addToast({
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), t;
    });
    we(this, "getActiveToasts", () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)));
    this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
};
const zt = new ux();
function cx(e, n) {
  const t = (n == null ? void 0 : n.id) || Kl++;
  return zt.create({
    message: e,
    id: t,
    type: "default",
    ...n
  }), t;
}
const dx = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", fx = cx, hx = () => zt.toasts, mx = () => zt.getActiveToasts(), ia = Object.assign(fx, {
  success: zt.success,
  info: zt.info,
  warning: zt.warning,
  error: zt.error,
  custom: zt.custom,
  message: zt.message,
  promise: zt.promise,
  dismiss: zt.dismiss,
  loading: zt.loading
}, {
  getHistory: hx,
  getToasts: mx
});
function ar(e) {
  return e.label !== void 0;
}
const vx = 3, Ld = "24px", Nd = "16px", Qo = 4e3, px = 356, gx = 14, yx = 45, Bd = 200;
function bx() {
  const e = te(!1);
  return Ut(() => {
    const n = () => {
      e.value = document.hidden;
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }), { isDocumentHidden: e };
}
function Gn(...e) {
  return e.filter(Boolean).join(" ");
}
function wx(e) {
  const [n, t] = e.split("-"), a = [];
  return n && a.push(n), t && a.push(t), a;
}
function kx(e, n) {
  const t = {};
  return [e, n].forEach((a, s) => {
    const r = s === 1, l = r ? "--mobile-offset" : "--offset", i = r ? Nd : Ld;
    function o(u) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((c) => {
        t[`${l}-${c}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof a == "number" || typeof a == "string" ? o(a) : typeof a == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((u) => {
      a[u] === void 0 ? t[`${l}-${u}`] = i : t[`${l}-${u}`] = typeof a[u] == "number" ? `${a[u]}px` : a[u];
    }) : o(i);
  }), t;
}
const xx = [
  "data-rich-colors",
  "data-styled",
  "data-mounted",
  "data-promise",
  "data-swiped",
  "data-removed",
  "data-visible",
  "data-y-position",
  "data-x-position",
  "data-index",
  "data-front",
  "data-swiping",
  "data-dismissible",
  "data-type",
  "data-invert",
  "data-swipe-out",
  "data-swipe-direction",
  "data-expanded",
  "data-testid"
], Sx = [
  "aria-label",
  "data-disabled",
  "data-close-button-position"
];
var Tx = /* @__PURE__ */ Te({
  __name: "Toast",
  props: {
    toast: {},
    toasts: {},
    index: {},
    swipeDirections: {},
    expanded: { type: Boolean },
    invert: { type: Boolean },
    heights: {},
    gap: {},
    position: {},
    closeButtonPosition: {},
    visibleToasts: {},
    expandByDefault: { type: Boolean },
    closeButton: { type: Boolean },
    interacting: { type: Boolean },
    style: {},
    cancelButtonStyle: {},
    actionButtonStyle: {},
    duration: {},
    class: {},
    unstyled: { type: Boolean },
    descriptionClass: {},
    loadingIcon: {},
    classes: {},
    icons: {},
    closeButtonAriaLabel: {},
    defaultRichColors: { type: Boolean }
  },
  emits: [
    "update:heights",
    "update:height",
    "removeToast"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, s = te(null), r = te(null), l = te(!1), i = te(!1), o = te(!1), u = te(!1), c = te(!1), f = te(0), h = te(0), d = te(t.toast.duration || t.duration || Qo), g = te(null), y = te(null), k = C(() => t.index === 0), m = C(() => t.index + 1 <= t.visibleToasts), v = C(() => t.toast.type), w = C(() => t.toast.dismissible !== !1), S = C(() => t.toast.class || ""), x = C(() => t.descriptionClass || ""), $ = C(() => {
      const K = t.toast.position || t.position, Me = t.heights.filter((V) => V.position === K).findIndex((V) => V.toastId === t.toast.id);
      return Me >= 0 ? Me : 0;
    }), T = C(() => {
      const K = t.toast.position || t.position;
      return t.heights.filter((Me) => Me.position === K).reduce((Me, V, j) => j >= $.value ? Me : Me + V.height, 0);
    }), _ = C(() => $.value * t.gap + T.value || 0), A = C(() => t.toast.closeButton ?? t.closeButton), D = C(() => t.toast.duration || t.duration || Qo), Y = te(0), L = te(0), X = te(null), se = C(() => t.position.split("-")), ie = C(() => se.value[0]), ue = C(() => se.value[1]), G = C(() => typeof t.toast.title != "string"), q = C(() => typeof t.toast.description != "string"), { isDocumentHidden: Z } = bx(), N = C(() => v.value && v.value === "loading");
    nt(() => {
      l.value = !0, d.value = D.value;
    }), Ut(async () => {
      if (!l.value || !y.value) return;
      await Xe();
      const K = y.value, ye = K.style.height;
      K.style.height = "auto";
      const Me = K.getBoundingClientRect().height;
      K.style.height = ye, h.value = Me, a("update:height", {
        toastId: t.toast.id,
        height: Me,
        position: t.toast.position || t.position
      });
    });
    function ae() {
      i.value = !0, f.value = _.value, setTimeout(() => {
        a("removeToast", t.toast);
      }, Bd);
    }
    function me() {
      var K, ye;
      if (N.value || !w.value) return {};
      ae(), (ye = (K = t.toast).onDismiss) == null || ye.call(K, t.toast);
    }
    function be(K) {
      K.button !== 2 && (N.value || !w.value || (g.value = /* @__PURE__ */ new Date(), f.value = _.value, K.target.setPointerCapture(K.pointerId), K.target.tagName !== "BUTTON" && (o.value = !0, X.value = {
        x: K.clientX,
        y: K.clientY
      })));
    }
    function pe() {
      var H, I, B, J, R, ee, O;
      if (u.value || !w.value) return;
      X.value = null;
      const K = Number(((H = y.value) == null ? void 0 : H.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), ye = Number(((I = y.value) == null ? void 0 : I.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Me = (/* @__PURE__ */ new Date()).getTime() - (((B = g.value) == null ? void 0 : B.getTime()) || 0), V = s.value === "x" ? K : ye, j = Math.abs(V) / Me;
      if (Math.abs(V) >= yx || j > 0.11) {
        f.value = _.value, (R = (J = t.toast).onDismiss) == null || R.call(J, t.toast), s.value === "x" ? r.value = K > 0 ? "right" : "left" : r.value = ye > 0 ? "down" : "up", ae(), u.value = !0;
        return;
      } else
        (ee = y.value) == null || ee.style.setProperty("--swipe-amount-x", "0px"), (O = y.value) == null || O.style.setProperty("--swipe-amount-y", "0px");
      c.value = !1, o.value = !1, s.value = null;
    }
    function De(K) {
      var B, J, R, ee;
      if (!X.value || !w.value || (((J = (B = window == null ? void 0 : window.getSelection()) == null ? void 0 : B.toString()) == null ? void 0 : J.length) ?? !1)) return;
      const Me = K.clientY - X.value.y, V = K.clientX - X.value.x, j = t.swipeDirections ?? wx(t.position);
      !s.value && (Math.abs(V) > 1 || Math.abs(Me) > 1) && (s.value = Math.abs(V) > Math.abs(Me) ? "x" : "y");
      let H = {
        x: 0,
        y: 0
      };
      const I = (O) => 1 / (1.5 + Math.abs(O) / 20);
      if (s.value === "y") {
        if (j.includes("top") || j.includes("bottom")) if (j.includes("top") && Me < 0 || j.includes("bottom") && Me > 0) H.y = Me;
        else {
          const O = Me * I(Me);
          H.y = Math.abs(O) < Math.abs(Me) ? O : Me;
        }
      } else if (s.value === "x" && (j.includes("left") || j.includes("right")))
        if (j.includes("left") && V < 0 || j.includes("right") && V > 0) H.x = V;
        else {
          const O = V * I(V);
          H.x = Math.abs(O) < Math.abs(V) ? O : V;
        }
      (Math.abs(H.x) > 0 || Math.abs(H.y) > 0) && (c.value = !0), (R = y.value) == null || R.style.setProperty("--swipe-amount-x", `${H.x}px`), (ee = y.value) == null || ee.style.setProperty("--swipe-amount-y", `${H.y}px`);
    }
    nt(() => {
      if (l.value = !0, !y.value) return;
      const K = y.value.getBoundingClientRect().height;
      h.value = K;
      const ye = [{
        toastId: t.toast.id,
        height: K,
        position: t.toast.position
      }, ...t.heights];
      a("update:heights", ye);
    }), Os(() => {
      y.value && a("removeToast", t.toast);
    }), Ut((K) => {
      if (t.toast.promise && v.value === "loading" || t.toast.duration === 1 / 0 || t.toast.type === "loading") return;
      let ye;
      const Me = () => {
        if (L.value < Y.value) {
          const j = (/* @__PURE__ */ new Date()).getTime() - Y.value;
          d.value = d.value - j;
        }
        L.value = (/* @__PURE__ */ new Date()).getTime();
      }, V = () => {
        d.value !== 1 / 0 && (Y.value = (/* @__PURE__ */ new Date()).getTime(), ye = setTimeout(() => {
          var j, H;
          (H = (j = t.toast).onAutoClose) == null || H.call(j, t.toast), ae();
        }, d.value));
      };
      t.expanded || t.interacting || Z.value ? Me() : V(), K(() => {
        clearTimeout(ye);
      });
    }), He(() => t.toast.delete, (K) => {
      var ye, Me;
      K !== void 0 && K && (ae(), (Me = (ye = t.toast).onDismiss) == null || Me.call(ye, t.toast));
    }, { deep: !0 });
    function ge() {
      o.value = !1, s.value = null, X.value = null;
    }
    return (K, ye) => {
      var Me, V, j, H, I, B, J, R, ee, O, z, F, le, W, he, Oe, Re, _e, ze, Nt, Ot, Bt, kn, Wn, _t, Et, $t;
      return b(), M("li", {
        tabindex: "0",
        ref_key: "toastRef",
        ref: y,
        class: ne(p(Gn)(t.class, S.value, (Me = K.classes) == null ? void 0 : Me.toast, (V = K.toast.classes) == null ? void 0 : V.toast, (j = K.classes) == null ? void 0 : j[v.value], (I = (H = K.toast) == null ? void 0 : H.classes) == null ? void 0 : I[v.value])),
        "data-sonner-toast": "",
        "data-rich-colors": K.toast.richColors ?? K.defaultRichColors,
        "data-styled": !(K.toast.component || (B = K.toast) != null && B.unstyled || K.unstyled),
        "data-mounted": l.value,
        "data-promise": !!K.toast.promise,
        "data-swiped": c.value,
        "data-removed": i.value,
        "data-visible": m.value,
        "data-y-position": ie.value,
        "data-x-position": ue.value,
        "data-index": K.index,
        "data-front": k.value,
        "data-swiping": o.value,
        "data-dismissible": w.value,
        "data-type": v.value,
        "data-invert": K.toast.invert || K.invert,
        "data-swipe-out": u.value,
        "data-swipe-direction": r.value,
        "data-expanded": !!(K.expanded || K.expandByDefault && l.value),
        "data-testid": K.toast.testId,
        style: Fe({
          "--index": K.index,
          "--toasts-before": K.index,
          "--z-index": K.toasts.length - K.index,
          "--offset": `${i.value ? f.value : _.value}px`,
          "--initial-height": K.expandByDefault ? "auto" : `${h.value}px`,
          ...K.style,
          ...t.toast.style
        }),
        onDragend: ge,
        onPointerdown: be,
        onPointerup: pe,
        onPointermove: De
      }, [A.value && !K.toast.component && v.value !== "loading" ? (b(), M("button", {
        key: 0,
        "aria-label": K.closeButtonAriaLabel || "Close toast",
        "data-disabled": N.value,
        "data-close-button": "true",
        "data-close-button-position": K.closeButtonPosition,
        class: ne(p(Gn)((J = K.classes) == null ? void 0 : J.closeButton, (ee = (R = K.toast) == null ? void 0 : R.classes) == null ? void 0 : ee.closeButton)),
        onClick: me
      }, [(O = K.icons) != null && O.close ? (b(), fe(ht((z = K.icons) == null ? void 0 : z.close), { key: 0 })) : U(K.$slots, "close-icon", { key: 1 })], 10, Sx)) : P("v-if", !0), K.toast.component ? (b(), fe(ht(K.toast.component), lt({ key: 1 }, K.toast.componentProps, {
        onCloseToast: me,
        isPaused: K.$props.expanded || K.$props.interacting || p(Z)
      }), null, 16, ["isPaused"])) : (b(), M(Se, { key: 2 }, [
        v.value !== "default" || K.toast.icon || K.toast.promise ? (b(), M("div", {
          key: 0,
          "data-icon": "",
          class: ne(p(Gn)((F = K.classes) == null ? void 0 : F.icon, (W = (le = K.toast) == null ? void 0 : le.classes) == null ? void 0 : W.icon))
        }, [K.toast.icon ? (b(), fe(ht(K.toast.icon), { key: 0 })) : (b(), M(Se, { key: 1 }, [v.value === "loading" ? U(K.$slots, "loading-icon", { key: 0 }) : v.value === "success" ? U(K.$slots, "success-icon", { key: 1 }) : v.value === "error" ? U(K.$slots, "error-icon", { key: 2 }) : v.value === "warning" ? U(K.$slots, "warning-icon", { key: 3 }) : v.value === "info" ? U(K.$slots, "info-icon", { key: 4 }) : P("v-if", !0)], 64))], 2)) : P("v-if", !0),
        E("div", {
          "data-content": "",
          class: ne(p(Gn)((he = K.classes) == null ? void 0 : he.content, (Re = (Oe = K.toast) == null ? void 0 : Oe.classes) == null ? void 0 : Re.content))
        }, [E("div", {
          "data-title": "",
          class: ne(p(Gn)((_e = K.classes) == null ? void 0 : _e.title, (ze = K.toast.classes) == null ? void 0 : ze.title))
        }, [G.value ? (b(), fe(ht(K.toast.title), Mt(lt({ key: 0 }, K.toast.componentProps)), null, 16)) : (b(), M(Se, { key: 1 }, [Ue(ce(K.toast.title), 1)], 64))], 2), K.toast.description ? (b(), M("div", {
          key: 0,
          "data-description": "",
          class: ne(p(Gn)(K.descriptionClass, x.value, (Nt = K.classes) == null ? void 0 : Nt.description, (Ot = K.toast.classes) == null ? void 0 : Ot.description))
        }, [q.value ? (b(), fe(ht(K.toast.description), Mt(lt({ key: 0 }, K.toast.componentProps)), null, 16)) : (b(), M(Se, { key: 1 }, [Ue(ce(K.toast.description), 1)], 64))], 2)) : P("v-if", !0)], 2),
        K.toast.cancel ? (b(), M("button", {
          key: 1,
          style: Fe(K.toast.cancelButtonStyle || K.cancelButtonStyle),
          class: ne(p(Gn)((Bt = K.classes) == null ? void 0 : Bt.cancelButton, (kn = K.toast.classes) == null ? void 0 : kn.cancelButton)),
          "data-button": "",
          "data-cancel": "",
          onClick: ye[0] || (ye[0] = (xn) => {
            var ln, Zt;
            p(ar)(K.toast.cancel) && w.value && ((Zt = (ln = K.toast.cancel).onClick) == null || Zt.call(ln, xn), ae());
          })
        }, ce(p(ar)(K.toast.cancel) ? (Wn = K.toast.cancel) == null ? void 0 : Wn.label : K.toast.cancel), 7)) : P("v-if", !0),
        K.toast.action ? (b(), M("button", {
          key: 2,
          style: Fe(K.toast.actionButtonStyle || K.actionButtonStyle),
          class: ne(p(Gn)((_t = K.classes) == null ? void 0 : _t.actionButton, (Et = K.toast.classes) == null ? void 0 : Et.actionButton)),
          "data-button": "",
          "data-action": "",
          onClick: ye[1] || (ye[1] = (xn) => {
            var ln, Zt;
            p(ar)(K.toast.action) && ((Zt = (ln = K.toast.action).onClick) == null || Zt.call(ln, xn), !xn.defaultPrevented && ae());
          })
        }, ce(p(ar)(K.toast.action) ? ($t = K.toast.action) == null ? void 0 : $t.label : K.toast.action), 7)) : P("v-if", !0)
      ], 64))], 46, xx);
    };
  }
}), Mx = Tx, Ys = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n) t[a] = s;
  return t;
};
const $x = {}, Cx = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Dx(e, n) {
  return b(), M("svg", Cx, n[0] || (n[0] = [E("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }, null, -1), E("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }, null, -1)]));
}
var Ox = /* @__PURE__ */ Ys($x, [["render", Dx]]);
const _x = ["data-visible"], Ex = { class: "sonner-spinner" };
var Ix = /* @__PURE__ */ Te({
  __name: "Loader",
  props: { visible: { type: Boolean } },
  setup(e) {
    const n = Array(12).fill(0);
    return (t, a) => (b(), M("div", {
      class: "sonner-loading-wrapper",
      "data-visible": t.visible
    }, [E("div", Ex, [(b(!0), M(Se, null, Pe(p(n), (s) => (b(), M("div", {
      key: `spinner-bar-${s}`,
      class: "sonner-loading-bar"
    }))), 128))])], 8, _x));
  }
}), Px = Ix;
const Ax = {}, Rx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function Vx(e, n) {
  return b(), M("svg", Rx, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var Fx = /* @__PURE__ */ Ys(Ax, [["render", Vx]]);
const Lx = {}, Nx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function Bx(e, n) {
  return b(), M("svg", Nx, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var zx = /* @__PURE__ */ Ys(Lx, [["render", Bx]]);
const Wx = {}, Yx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function Hx(e, n) {
  return b(), M("svg", Yx, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var Ux = /* @__PURE__ */ Ys(Wx, [["render", Hx]]);
const qx = {}, jx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function Gx(e, n) {
  return b(), M("svg", jx, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var Kx = /* @__PURE__ */ Ys(qx, [["render", Gx]]);
const Zx = ["aria-label"], Xx = [
  "data-sonner-theme",
  "dir",
  "data-theme",
  "data-rich-colors",
  "data-y-position",
  "data-x-position"
], Jx = typeof window < "u" && typeof document < "u";
function Qx() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
var eS = /* @__PURE__ */ Te({
  name: "Toaster",
  inheritAttrs: !1,
  __name: "Toaster",
  props: {
    id: {},
    invert: {
      type: Boolean,
      default: !1
    },
    theme: { default: "light" },
    position: { default: "bottom-right" },
    closeButtonPosition: { default: "top-left" },
    hotkey: { default: () => ["altKey", "KeyT"] },
    richColors: {
      type: Boolean,
      default: !1
    },
    expand: {
      type: Boolean,
      default: !1
    },
    duration: {},
    gap: { default: gx },
    visibleToasts: { default: vx },
    closeButton: {
      type: Boolean,
      default: !1
    },
    toastOptions: { default: () => ({}) },
    class: { default: "" },
    style: {},
    offset: { default: Ld },
    mobileOffset: { default: Nd },
    dir: { default: "auto" },
    swipeDirections: {},
    icons: {},
    containerAriaLabel: { default: "Notifications" }
  },
  setup(e) {
    const n = e, t = Ql(), a = te([]), s = C(() => n.id ? a.value.filter((D) => D.toasterId === n.id) : a.value.filter((D) => !D.toasterId));
    function r(D, Y) {
      return s.value.filter((L) => !L.position && Y === 0 || L.position === D);
    }
    const l = C(() => {
      const D = s.value.filter((Y) => Y.position).map((Y) => Y.position);
      return D.length > 0 ? Array.from(new Set([n.position].concat(D))) : [n.position];
    }), i = C(() => {
      const D = {};
      return l.value.forEach((Y) => {
        D[Y] = a.value.filter((L) => L.position === Y);
      }), D;
    }), o = te([]), u = te({}), c = te(!1);
    Ut(() => {
      l.value.forEach((D) => {
        D in u.value || (u.value[D] = !1);
      });
    });
    const f = te(n.theme !== "system" ? n.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), h = te(null), d = te(null), g = te(!1), y = n.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function k(D) {
      var Y;
      (Y = a.value.find((L) => L.id === D.id)) != null && Y.delete || zt.dismiss(D.id), a.value = a.value.filter(({ id: L }) => L !== D.id), setTimeout(() => {
        a.value.find((L) => L.id === D.id) || (o.value = o.value.filter((L) => L.toastId !== D.id));
      }, Bd + 50);
    }
    function m(D) {
      var Y, L;
      g.value && !((L = (Y = D.currentTarget) == null ? void 0 : Y.contains) != null && L.call(Y, D.relatedTarget)) && (g.value = !1, d.value && (d.value.focus({ preventScroll: !0 }), d.value = null));
    }
    function v(D) {
      D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || g.value || (g.value = !0, d.value = D.relatedTarget);
    }
    function w(D) {
      D.target && D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || (c.value = !0);
    }
    Ut((D) => {
      const Y = zt.subscribe((L) => {
        if (L.dismiss) {
          requestAnimationFrame(() => {
            a.value = a.value.map((X) => X.id === L.id ? {
              ...X,
              delete: !0
            } : X);
          });
          return;
        }
        Xe(() => {
          const X = a.value.findIndex((se) => se.id === L.id);
          X !== -1 ? a.value = [
            ...a.value.slice(0, X),
            {
              ...a.value[X],
              ...L
            },
            ...a.value.slice(X + 1)
          ] : a.value = [L, ...a.value];
        });
      });
      D(Y);
    }), Ut((D) => {
      if (typeof window > "u") return;
      if (n.theme !== "system") {
        f.value = n.theme;
        return;
      }
      const Y = window.matchMedia("(prefers-color-scheme: dark)"), L = (se) => {
        f.value = se ? "dark" : "light";
      };
      L(Y.matches);
      const X = (se) => {
        L(se.matches);
      };
      try {
        Y.addEventListener("change", X);
      } catch {
        Y.addListener(X);
      }
      D(() => {
        try {
          Y.removeEventListener("change", X);
        } catch {
          Y.removeListener(X);
        }
      });
    }), Ut(() => {
      h.value && d.value && (d.value.focus({ preventScroll: !0 }), d.value = null, g.value = !1);
    }), Ut(() => {
      a.value.length <= 1 && Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }), Ut((D) => {
      function Y(L) {
        const X = n.hotkey.every((ue) => L[ue] || L.code === ue), se = Array.isArray(h.value) ? h.value[0] : h.value;
        X && (l.value.forEach((ue) => {
          u.value[ue] = !0;
        }), se == null || se.focus());
        const ie = document.activeElement === h.value || (se == null ? void 0 : se.contains(document.activeElement));
        L.code === "Escape" && ie && l.value.forEach((ue) => {
          u.value[ue] = !1;
        });
      }
      Jx && (document.addEventListener("keydown", Y), D(() => {
        document.removeEventListener("keydown", Y);
      }));
    });
    function S(D) {
      const Y = D.currentTarget, L = Y.getAttribute("data-y-position") + "-" + Y.getAttribute("data-x-position");
      u.value[L] = !0;
    }
    function x(D) {
      if (!c.value) {
        const Y = D.currentTarget, L = Y.getAttribute("data-y-position") + "-" + Y.getAttribute("data-x-position");
        u.value[L] = !1;
      }
    }
    function $() {
      Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }
    function T() {
      c.value = !1;
    }
    function _(D) {
      o.value = D;
    }
    function A(D) {
      const Y = o.value.findIndex((L) => L.toastId === D.toastId);
      if (Y !== -1) o.value[Y] = D;
      else {
        const L = o.value.findIndex((X) => X.position === D.position);
        L !== -1 ? o.value.splice(L, 0, D) : o.value.unshift(D);
      }
    }
    return (D, Y) => (b(), M(Se, null, [P(" Remove item from normal navigation flow, only available via hotkey "), E("section", {
      "aria-label": `${D.containerAriaLabel} ${p(y)}`,
      tabIndex: -1,
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "false"
    }, [(b(!0), M(Se, null, Pe(l.value, (L, X) => {
      var se;
      return b(), M("ol", lt({
        key: L,
        ref_for: !0,
        ref_key: "listRef",
        ref: h,
        "data-sonner-toaster": "",
        "data-sonner-theme": f.value,
        class: n.class,
        dir: D.dir === "auto" ? Qx() : D.dir,
        tabIndex: -1,
        "data-theme": D.theme,
        "data-rich-colors": D.richColors,
        "data-y-position": L.split("-")[0],
        "data-x-position": L.split("-")[1],
        style: {
          "--front-toast-height": `${((se = o.value[0]) == null ? void 0 : se.height) || 0}px`,
          "--width": `${p(px)}px`,
          "--gap": `${D.gap}px`,
          ...D.style,
          ...p(t).style,
          ...p(kx)(D.offset, D.mobileOffset)
        }
      }, { ref_for: !0 }, D.$attrs, {
        onBlur: m,
        onFocus: v,
        onMouseenter: S,
        onMousemove: S,
        onMouseleave: x,
        onDragend: $,
        onPointerdown: w,
        onPointerup: T
      }), [(b(!0), M(Se, null, Pe(r(L, X), (ie, ue) => {
        var G, q, Z, N, ae, me, be, pe, De, ge, K;
        return b(), fe(Mx, {
          key: ie.id,
          heights: o.value,
          icons: D.icons,
          index: ue,
          toast: ie,
          defaultRichColors: D.richColors,
          duration: ((G = D.toastOptions) == null ? void 0 : G.duration) ?? D.duration,
          class: ne(((q = D.toastOptions) == null ? void 0 : q.class) ?? ""),
          descriptionClass: (Z = D.toastOptions) == null ? void 0 : Z.descriptionClass,
          invert: D.invert,
          visibleToasts: D.visibleToasts,
          closeButton: ((N = D.toastOptions) == null ? void 0 : N.closeButton) ?? D.closeButton,
          interacting: c.value,
          position: L,
          closeButtonPosition: ((ae = D.toastOptions) == null ? void 0 : ae.closeButtonPosition) ?? D.closeButtonPosition,
          style: Fe((me = D.toastOptions) == null ? void 0 : me.style),
          unstyled: (be = D.toastOptions) == null ? void 0 : be.unstyled,
          classes: (pe = D.toastOptions) == null ? void 0 : pe.classes,
          cancelButtonStyle: (De = D.toastOptions) == null ? void 0 : De.cancelButtonStyle,
          actionButtonStyle: (ge = D.toastOptions) == null ? void 0 : ge.actionButtonStyle,
          "close-button-aria-label": (K = D.toastOptions) == null ? void 0 : K.closeButtonAriaLabel,
          toasts: i.value[L],
          expandByDefault: D.expand,
          gap: D.gap,
          expanded: u.value[L] || !1,
          swipeDirections: n.swipeDirections,
          "onUpdate:heights": _,
          "onUpdate:height": A,
          onRemoveToast: k
        }, {
          "close-icon": de(() => [U(D.$slots, "close-icon", {}, () => [oe(Ox)])]),
          "loading-icon": de(() => [U(D.$slots, "loading-icon", {}, () => [oe(Px, { visible: ie.type === "loading" }, null, 8, ["visible"])])]),
          "success-icon": de(() => [U(D.$slots, "success-icon", {}, () => [oe(Fx)])]),
          "error-icon": de(() => [U(D.$slots, "error-icon", {}, () => [oe(Kx)])]),
          "warning-icon": de(() => [U(D.$slots, "warning-icon", {}, () => [oe(Ux)])]),
          "info-icon": de(() => [U(D.$slots, "info-icon", {}, () => [oe(zx)])]),
          _: 2
        }, 1032, [
          "heights",
          "icons",
          "index",
          "toast",
          "defaultRichColors",
          "duration",
          "class",
          "descriptionClass",
          "invert",
          "visibleToasts",
          "closeButton",
          "interacting",
          "position",
          "closeButtonPosition",
          "style",
          "unstyled",
          "classes",
          "cancelButtonStyle",
          "actionButtonStyle",
          "close-button-aria-label",
          "toasts",
          "expandByDefault",
          "gap",
          "expanded",
          "swipeDirections"
        ]);
      }), 128))], 16, Xx);
    }), 128))], 8, Zx)], 2112));
  }
}), tS = eS;
const nS = /* @__PURE__ */ Te({
  __name: "VToaster",
  setup(e) {
    const n = Cc(), t = C(() => n.resolvedTheme);
    return (a, s) => (b(), fe(p(tS), {
      duration: 4e3,
      theme: t.value,
      "toast-options": {
        unstyled: !0,
        classes: {
          toast: "toast-custom",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action",
          cancelButton: "toast-cancel",
          closeButton: "toast-close",
          error: "toast-error",
          success: "toast-success",
          warning: "toast-warning",
          info: "toast-info"
        }
      },
      "close-button": "",
      position: "top-right"
    }, null, 8, ["theme"]));
  }
}), iC = /* @__PURE__ */ Ge(nS, [["__scopeId", "data-v-9305e752"]]), aS = ["id"], sS = ["id", "aria-controls", "aria-expanded", "disabled", "onClick"], rS = { class: "v-expansion-panel-header__content" }, lS = { class: "v-expansion-panel-title" }, iS = {
  key: 0,
  class: "v-expansion-panel-subtitle"
}, oS = { class: "v-expansion-panel-header__icon-wrapper" }, uS = ["id", "aria-hidden", "aria-labelledby"], cS = { class: "v-expansion-panel-content__wrap" }, dS = { class: "v-expansion-panel-content__inner" }, fS = { class: "v-expansion-panel-text" }, hS = /* @__PURE__ */ Te({
  __name: "VAccordion",
  props: /* @__PURE__ */ ea({
    items: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    accordion: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ea(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = Cr(), r = Ds(e, "modelValue"), l = (u) => r.value.includes(u), i = (u) => {
      r.value = u, a("change", u);
    }, o = (u, c) => {
      if (t.disabled || c) return;
      const f = l(u);
      if (t.accordion || !t.multiple) {
        i(f ? [] : [u]);
        return;
      }
      i(
        f ? r.value.filter((h) => h !== u) : [...r.value, u]
      );
    };
    return (u, c) => (b(), M("div", {
      id: p(s),
      class: ne([[
        `v-expansion-panels--${e.variant}`,
        {
          "v-expansion-panels--flat": e.flat,
          "v-expansion-panels--disabled": e.disabled
        }
      ], "v-expansion-panels"])
    }, [
      (b(!0), M(Se, null, Pe(e.items, (f, h) => (b(), M("div", {
        key: f.id,
        class: ne([{
          "v-expansion-panel--active": l(f.id),
          "v-expansion-panel--disabled": f.disabled || e.disabled
        }, "v-expansion-panel"])
      }, [
        E("button", {
          id: `${p(s)}-header-${f.id}`,
          "aria-controls": `${p(s)}-content-${f.id}`,
          "aria-expanded": l(f.id),
          disabled: f.disabled || e.disabled,
          class: "v-expansion-panel-header",
          type: "button",
          onClick: (d) => o(f.id, f.disabled)
        }, [
          U(u.$slots, `header-${f.id}`, {
            index: h,
            isOpen: l(f.id),
            item: f
          }, () => [
            U(u.$slots, "header", {
              index: h,
              isOpen: l(f.id),
              item: f
            }, () => [
              f.icon ? (b(), fe(xe, {
                key: 0,
                icon: f.icon,
                class: "v-expansion-panel-header__icon"
              }, null, 8, ["icon"])) : P("", !0),
              E("div", rS, [
                E("div", lS, ce(f.title), 1),
                f.subtitle ? (b(), M("div", iS, ce(f.subtitle), 1)) : P("", !0)
              ]),
              E("div", oS, [
                oe(xe, {
                  class: ne(
                    l(f.id) ? "v-expansion-panel-header__expand-icon v-expansion-panel-header__expand-icon--active" : "v-expansion-panel-header__expand-icon"
                  ),
                  icon: "mdi:chevron-down"
                }, null, 8, ["class"])
              ])
            ], !0)
          ], !0)
        ], 8, sS),
        E("div", {
          id: `${p(s)}-content-${f.id}`,
          "aria-hidden": !l(f.id),
          "aria-labelledby": `${p(s)}-header-${f.id}`,
          class: "v-expansion-panel-content",
          role: "region"
        }, [
          E("div", cS, [
            E("div", dS, [
              U(u.$slots, `content-${f.id}`, {
                index: h,
                item: f
              }, () => [
                U(u.$slots, "content", {
                  index: h,
                  item: f
                }, () => [
                  E("div", fS, ce(f.content), 1)
                ], !0)
              ], !0)
            ])
          ])
        ], 8, uS)
      ], 2))), 128))
    ], 10, aS));
  }
}), oC = /* @__PURE__ */ Ge(hS, [["__scopeId", "data-v-32f9e364"]]), uC = /* @__PURE__ */ Te({
  __name: "VAnimatedBackground",
  setup(e) {
    const n = te(null);
    let t, a = null;
    const s = [], r = (i) => {
      s.length = 0;
      const o = [
        "rgba(37, 99, 235, 0.3)",
        // primary
        "rgba(251, 191, 36, 0.3)",
        // accent
        "rgba(14, 165, 233, 0.3)",
        // info
        "rgba(34, 197, 94, 0.3)"
        // success
      ];
      for (let u = 0; u < 15; u++)
        s.push({
          x: Math.random() * i.width,
          y: Math.random() * i.height,
          radius: Math.random() * 200 + 100,
          vx: Math.random() - 0.5,
          vy: Math.random() - 0.5,
          color: o[u % o.length]
        });
    }, l = (i, o) => {
      o.clearRect(0, 0, i.width, i.height), s.forEach((u) => {
        u.x += u.vx, u.y += u.vy, (u.x < -u.radius || u.x > i.width + u.radius) && (u.vx *= -1), (u.y < -u.radius || u.y > i.height + u.radius) && (u.vy *= -1);
        const c = o.createRadialGradient(
          u.x,
          u.y,
          0,
          u.x,
          u.y,
          u.radius * 0.7
        ), f = u.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (f) {
          const [, h, d, g] = f;
          c.addColorStop(0, `rgba(${h}, ${d}, ${g}, 0.5)`), c.addColorStop(0.5, `rgba(${h}, ${d}, ${g}, 0.25)`), c.addColorStop(1, `rgba(${h}, ${d}, ${g}, 0)`);
        }
        o.fillStyle = c, o.beginPath(), o.arc(u.x, u.y, u.radius, 0, Math.PI * 2), o.fill();
      }), t = requestAnimationFrame(() => l(i, o));
    };
    return nt(() => {
      const i = n.value;
      if (!i) return;
      const o = i.getContext("2d");
      if (!o) return;
      const u = () => {
        i && (i.width = window.innerWidth, i.height = window.innerHeight, s.length === 0 && r(i));
      };
      a = u, u(), window.addEventListener("resize", u), l(i, o);
    }), sn(() => {
      a && window.removeEventListener("resize", a), t && cancelAnimationFrame(t), s.length = 0;
    }), (i, o) => (b(), M(Se, null, [
      E("canvas", {
        ref_key: "canvasRef",
        ref: n,
        class: "fixed inset-0 z-10 pointer-events-none"
      }, null, 512),
      o[0] || (o[0] = E("div", { class: "fixed inset-0 z-10 bg-gradient-to-br from-primary/5 via-accent/5 to-info/5" }, null, -1))
    ], 64));
  }
}), mS = {
  key: 0,
  class: "v-card__loading"
}, vS = {
  key: 0,
  class: "v-card__header"
}, pS = { class: "v-card__header-content" }, gS = {
  key: 2,
  class: "v-card__header-text"
}, yS = {
  key: 0,
  class: "v-card__title"
}, bS = {
  key: 1,
  class: "v-card__subtitle"
}, wS = {
  key: 0,
  class: "v-card__description"
}, kS = { class: "v-card__content" }, xS = {
  key: 1,
  class: "v-card__footer"
}, SS = /* @__PURE__ */ Te({
  __name: "VCard",
  props: {
    title: { default: "" },
    subtitle: { default: "" },
    description: { default: "" },
    variant: { default: "default" },
    size: { default: "full" },
    radius: { default: "xl" },
    padding: { default: "sm" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    clickable: { type: Boolean },
    icon: { default: "" },
    as: { default: "div" },
    href: { default: "" },
    target: { default: "_self" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = C(() => t.title || t.subtitle || t.icon || !!c.header), r = C(() => !!c.footer), l = C(() => t.clickable || t.href || t.as === "button"), i = C(() => t.href ? "a" : t.as), o = C(() => {
      const h = ["v-card"];
      return h.push(`v-card--${t.variant}`), h.push(`v-card--${t.size}`), h.push(`v-card--radius-${t.radius}`), t.padding && h.push(`v-card--padding-${t.padding}`), t.disabled && h.push("v-card--disabled"), t.loading && h.push("v-card--loading"), l.value && h.push("v-card--interactive"), h;
    }), u = C(() => t.href ? {
      href: t.href,
      target: t.target,
      rel: t.target === "_blank" ? "noopener noreferrer" : void 0
    } : {}), c = Yt(), f = (h) => {
      if (t.disabled || t.loading) {
        h.preventDefault();
        return;
      }
      a("click", h);
    };
    return (h, d) => (b(), fe(ht(i.value), lt({ class: o.value }, u.value, { onClick: f }), {
      default: de(() => [
        e.loading ? (b(), M("div", mS, [
          U(h.$slots, "loading", {}, () => [
            oe(Ur)
          ], !0)
        ])) : (b(), M(Se, { key: 1 }, [
          s.value ? (b(), M("header", vS, [
            U(h.$slots, "header", {}, () => [
              E("div", pS, [
                t.icon ? (b(), fe(xe, {
                  key: 0,
                  icon: t.icon,
                  class: "v-card__icon"
                }, null, 8, ["icon"])) : e.icon && typeof e.icon != "string" ? (b(), fe(ht(e.icon), {
                  key: 1,
                  class: "v-card__icon"
                })) : P("", !0),
                e.title || e.subtitle ? (b(), M("div", gS, [
                  e.title ? (b(), M("h3", yS, ce(e.title), 1)) : P("", !0),
                  e.subtitle ? (b(), M("p", bS, ce(e.subtitle), 1)) : P("", !0)
                ])) : P("", !0)
              ]),
              e.description ? (b(), M("p", wS, ce(e.description), 1)) : P("", !0)
            ], !0)
          ])) : P("", !0),
          E("main", kS, [
            U(h.$slots, "default", {}, void 0, !0)
          ]),
          r.value ? (b(), M("footer", xS, [
            U(h.$slots, "footer", {}, void 0, !0)
          ])) : P("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), TS = /* @__PURE__ */ Ge(SS, [["__scopeId", "data-v-6a462504"]]), MS = {
  key: 0,
  class: "space-y-4"
}, $S = {
  key: 0,
  class: "flex gap-3 items-start"
}, CS = { class: "flex-1" }, DS = {
  key: 0,
  class: "font-semibold text-mainText"
}, OS = {
  key: 1,
  class: "text-sm text-secondaryText mt-0.5"
}, _S = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }, ES = { class: "min-w-0" }, IS = { class: "font-medium text-sm text-mainText truncate" }, PS = {
  key: 0,
  class: "text-xs text-secondaryText truncate"
}, AS = {
  key: 1,
  class: "flex items-center gap-2 text-sm text-secondaryText pt-2 border-t border-base-400/30"
}, RS = {
  key: 1,
  class: "flex gap-3 items-start"
}, VS = { class: "flex-1 text-sm leading-relaxed" }, FS = {
  key: 0,
  class: "font-semibold mb-1 text-mainText"
}, LS = {
  key: 1,
  class: "text-secondaryText"
}, NS = {
  key: 2,
  class: "text-secondaryText"
}, BS = {
  key: 0,
  class: "flex-shrink-0"
}, cC = /* @__PURE__ */ Te({
  __name: "VInfoNotice",
  props: {
    icon: { default: "lucide:info" },
    iconColor: { default: "primary" },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    card: { type: Boolean, default: !0 },
    size: { default: "50px" },
    features: { default: void 0 },
    hint: { default: void 0 }
  },
  setup(e) {
    const n = e, t = C(() => {
      const l = {
        primary: "text-primary",
        success: "text-success",
        warning: "text-warning",
        error: "text-error",
        info: "text-info",
        muted: "text-secondaryText"
      };
      return l[n.iconColor] || l.primary;
    }), a = (l) => ({
      primary: "bg-primary/10",
      success: "bg-success/10",
      warning: "bg-warning/10",
      error: "bg-error/10",
      info: "bg-info/10",
      muted: "bg-muted/10"
    })[l || "primary"], s = (l) => ({
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      info: "text-info",
      muted: "text-secondaryText"
    })[l || "primary"], r = C(() => n.features && n.features.length > 0);
    return (l, i) => (b(), fe(ht(e.card ? TS : "div"), {
      class: ne({ "p-4": !e.card })
    }, {
      default: de(() => [
        r.value ? (b(), M("div", MS, [
          e.title || e.subtitle || l.$slots.title || l.$slots.subtitle ? (b(), M("div", $S, [
            U(l.$slots, "icon", {}, () => [
              oe(xe, {
                class: ne(t.value),
                icon: e.icon,
                size: 24
              }, null, 8, ["class", "icon"])
            ]),
            E("div", CS, [
              e.title || l.$slots.title ? (b(), M("p", DS, [
                U(l.$slots, "title", {}, () => [
                  Ue(ce(e.title), 1)
                ])
              ])) : P("", !0),
              e.subtitle || l.$slots.subtitle ? (b(), M("p", OS, [
                U(l.$slots, "subtitle", {}, () => [
                  Ue(ce(e.subtitle), 1)
                ])
              ])) : P("", !0)
            ])
          ])) : P("", !0),
          E("div", _S, [
            (b(!0), M(Se, null, Pe(e.features, (o, u) => (b(), M("div", {
              key: u,
              class: "flex items-center gap-3 p-3 rounded-lg bg-cardBg/50 border border-base-400/50"
            }, [
              E("div", {
                class: ne([a(o.color), "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"])
              }, [
                oe(xe, {
                  class: ne(s(o.color)),
                  icon: o.icon,
                  size: 20
                }, null, 8, ["class", "icon"])
              ], 2),
              E("div", ES, [
                E("p", IS, ce(o.title), 1),
                o.description ? (b(), M("p", PS, ce(o.description), 1)) : P("", !0)
              ])
            ]))), 128))
          ]),
          e.hint || l.$slots.hint ? (b(), M("div", AS, [
            oe(xe, {
              size: 16,
              class: "text-secondaryText flex-shrink-0",
              icon: "lucide:info"
            }),
            E("span", null, [
              U(l.$slots, "hint", {}, () => [
                Ue(ce(e.hint), 1)
              ])
            ])
          ])) : P("", !0)
        ])) : (b(), M("div", RS, [
          U(l.$slots, "icon", {}, () => [
            oe(xe, {
              class: ne(t.value),
              icon: e.icon,
              size: e.size
            }, null, 8, ["class", "icon", "size"])
          ]),
          E("div", VS, [
            e.title || l.$slots.title ? (b(), M("p", FS, [
              U(l.$slots, "title", {}, () => [
                Ue(ce(e.title), 1)
              ])
            ])) : P("", !0),
            e.subtitle || l.$slots.subtitle ? (b(), M("p", LS, [
              U(l.$slots, "subtitle", {}, () => [
                Ue(ce(e.subtitle), 1)
              ])
            ])) : P("", !0),
            l.$slots.default ? (b(), M("div", NS, [
              U(l.$slots, "default")
            ])) : P("", !0)
          ]),
          l.$slots.actions ? (b(), M("div", BS, [
            U(l.$slots, "actions")
          ])) : P("", !0)
        ]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), zS = {}, WS = { class: "scroll-panel overflow-y-auto p-2.5" };
function YS(e, n) {
  return b(), M("div", WS, [
    U(e.$slots, "default", {}, void 0, !0)
  ]);
}
const dC = /* @__PURE__ */ Ge(zS, [["render", YS], ["__scopeId", "data-v-383460c9"]]), HS = { class: "v-tabs" }, US = {
  key: 0,
  class: "v-tabs__header"
}, qS = {
  key: 0,
  "aria-busy": "true",
  class: "v-tabs__skeleton"
}, jS = { class: "v-tabs__list" }, GS = {
  "aria-label": "Tabs navigation",
  class: "v-tabs__nav",
  role: "tablist"
}, KS = ["aria-disabled", "aria-selected", "data-tab-id", "tabindex", "onClick", "onKeydown"], ZS = { class: "v-tabs__tab-label" }, XS = {
  key: 0,
  class: "v-tabs__more"
}, JS = {
  key: 1,
  class: "v-tabs__actions"
}, QS = ["aria-labelledby"], eT = { class: "v-tabs__panel" }, tT = 70, nT = /* @__PURE__ */ Te({
  __name: "VTabs",
  props: {
    tabs: {},
    loading: { type: Boolean },
    reset: { type: Boolean },
    useHash: { type: Boolean, default: !0 },
    tabSelectionMode: { default: "auto" }
  },
  emits: ["tabSelected"],
  setup(e, { expose: n, emit: t }) {
    const a = Tu(), s = ei(), r = e, l = t, o = te((() => {
      var $;
      if (r.useHash && (s != null && s.hash)) {
        const T = s.hash.replace("#tab-", ""), _ = r.tabs.find((A) => String(A.id) === T);
        if (_)
          return _.id;
      }
      const x = r.tabs.find((T) => T.activeByDefault);
      return (x == null ? void 0 : x.id) || (($ = r.tabs[0]) == null ? void 0 : $.id);
    })()), u = C(() => r.tabs.find((x) => x.id === o.value)), c = (x, $ = !0) => {
      const T = r.tabs.find((A) => A.id === x);
      if (!T || T.disabled) return;
      const _ = () => {
        o.value = x, r.useHash && $ && s && a && s.hash !== `#tab-${x}` && a.push({
          hash: `#tab-${x}`,
          query: s.query
        });
      };
      r.tabSelectionMode === "controlled" ? l("tabSelected", {
        tabId: x,
        callback: _,
        tab: T
      }) : (_(), l("tabSelected", {
        tabId: x,
        callback: () => {
        },
        // Already switched, callback is no-op
        tab: T
      }));
    };
    He(
      () => r.reset,
      (x) => {
        x && r.tabs.length > 0 && c(r.tabs[0].id);
      }
    ), nt(() => {
      const x = () => {
        r.useHash && s && a && s.hash !== `#tab-${o.value}` && a.replace({
          hash: `#tab-${o.value}`,
          query: s.query
        });
      }, $ = r.tabs.find((T) => T.id === o.value);
      x(), l("tabSelected", {
        tabId: o.value,
        callback: () => {
        },
        // Already initialized, callback is no-op
        tab: $
      });
    });
    const f = (x) => o.value === x, h = te(null), d = te([...r.tabs]), g = te([]), y = te(/* @__PURE__ */ new Map()), k = () => {
      if (!h.value || r.tabs.length === 0) return;
      const x = h.value, $ = x.offsetWidth;
      if ($ === 0) return;
      x.querySelectorAll(".tab-button:not(.more-button)").forEach((X) => {
        const se = X.getAttribute("data-tab-id");
        if (!se) return;
        const ie = r.tabs.find((ue) => String(ue.id) === se);
        ie && X && y.value.set(ie.id, X.offsetWidth);
      });
      let _ = 0;
      const A = [];
      for (const X of r.tabs) {
        const se = y.value.get(X.id) || 150;
        A.push(se), _ += se;
      }
      if (_ <= $) {
        d.value = [...r.tabs], g.value = [];
        return;
      }
      const D = $ - tT;
      let Y = 0, L = 0;
      for (let X = 0; X < r.tabs.length; X++) {
        const se = A[X];
        if (Y + se <= D)
          Y += se, L = X + 1;
        else
          break;
      }
      d.value = r.tabs.slice(0, L), g.value = r.tabs.slice(L);
    }, m = C(() => g.value.map((x) => ({
      label: x.label,
      value: x.id,
      icon: x.icon,
      disabled: x.disabled,
      active: x.id === o.value
    }))), v = (x) => {
      c(x);
    };
    let w = null, S = null;
    return nt(async () => {
      await Xe(), await Xe(), h.value && (k(), w = new ResizeObserver(() => {
        S && clearTimeout(S), S = setTimeout(() => {
          k();
        }, 100);
      }), w.observe(h.value));
    }), Os(() => {
      S && clearTimeout(S), w && h.value && (w.unobserve(h.value), w.disconnect());
    }), He(() => r.tabs, async () => {
      await Xe(), k();
    }, { deep: !0 }), n({
      currentTabId: o,
      selectTab: c
    }), (x, $) => (b(), M("div", HS, [
      r.tabs.length > 0 ? (b(), M("div", US, [
        r.loading ? (b(), M("section", qS, [
          (b(!0), M(Se, null, Pe(r.tabs.length, (T) => (b(), M("div", {
            key: T,
            class: "v-tabs__skeleton-item"
          }))), 128))
        ])) : P("", !0),
        E("div", jS, [
          E("div", {
            ref_key: "tabsContainerRef",
            ref: h,
            class: "v-tabs__scroll"
          }, [
            E("nav", GS, [
              (b(!0), M(Se, null, Pe(d.value, (T) => (b(), M("button", {
                key: T.id,
                "aria-disabled": T.disabled,
                "aria-selected": f(T.id),
                class: ne([
                  "v-tabs__tab",
                  {
                    "v-tabs__tab--active": f(T.id),
                    "v-tabs__tab--disabled": T.disabled
                  },
                  T.styles
                ]),
                "data-tab-id": T.id,
                tabindex: T.disabled ? -1 : 0,
                role: "tab",
                type: "button",
                onClick: (_) => c(T.id),
                onKeydown: [
                  It((_) => c(T.id), ["enter"]),
                  It(Ve((_) => c(T.id), ["prevent"]), ["space"])
                ]
              }, [
                T.icon ? (b(), fe(xe, {
                  key: 1,
                  icon: T.icon,
                  class: "v-tabs__tab-icon"
                }, null, 8, ["icon"])) : U(x.$slots, `tab-icon-${T.id}`, { key: 0 }, void 0, !0),
                E("span", ZS, ce(T.label), 1)
              ], 42, KS))), 128))
            ])
          ], 512),
          g.value.length > 0 ? (b(), M("div", XS, [
            oe(Mr, {
              items: m.value,
              placement: "bottom-right",
              onSelect: v
            }, {
              trigger: de(() => [
                oe(qt, { icon: "mdi:dots-horizontal" })
              ]),
              _: 1
            }, 8, ["items"])
          ])) : P("", !0)
        ]),
        x.$slots["tabs-right"] ? (b(), M("div", JS, [
          U(x.$slots, "tabs-right", { currentTabId: o.value }, void 0, !0)
        ])) : P("", !0)
      ])) : P("", !0),
      r.loading ? P("", !0) : (b(), M("div", {
        key: 1,
        "aria-labelledby": `tab-${o.value}`,
        class: "v-tabs__content",
        role: "tabpanel"
      }, [
        E("div", eT, [
          U(x.$slots, `${o.value}`, {}, () => {
            var T;
            return [
              (T = u.value) != null && T.component ? (b(), fe(ht(u.value.component), { key: 0 })) : P("", !0)
            ];
          }, !0)
        ])
      ], 8, QS))
    ]));
  }
}), fC = /* @__PURE__ */ Ge(nT, [["__scopeId", "data-v-786aa739"]]), aT = ["title"], eu = /* @__PURE__ */ Te({
  __name: "TableCell",
  props: {
    value: {},
    align: { default: "left" },
    depth: { default: 0 },
    isFirstColumn: { type: Boolean, default: !1 },
    row: {},
    column: {},
    colIndex: {},
    rowIndex: {},
    interactive: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 }
  },
  emits: ["toggle-expand"],
  setup(e, { emit: n }) {
    const t = n, a = Yt(), s = Qn("tableCellMetadata", void 0), r = C(() => !e.row || !e.column || e.colIndex === void 0 || e.rowIndex === void 0 || !s ? null : s(e.row, e.column, e.colIndex, e.rowIndex)), l = C(() => {
      if (e.isFirstColumn && e.depth > 0)
        return `${e.depth * 24 + 16}px`;
    }), i = C(
      () => r.value ? r.value.formattedValue : e.value
    ), o = () => {
      if (!(e.interactive || a.default))
        return String(i.value);
    }, u = C(() => {
      var g;
      return !!((g = r.value) != null && g.isExpandable);
    }), c = C(() => !!e.row && !!e.column), f = C(() => {
      var g;
      return [
        {
          "v-table-cell--left": e.align === "left",
          "v-table-cell--center": e.align === "center",
          "v-table-cell--right": e.align === "right",
          "v-table-cell--indented": e.isFirstColumn && e.depth > 0
        },
        (g = r.value) == null ? void 0 : g.cssClass
      ];
    }), h = C(() => {
      var y, k;
      const g = (y = r.value) == null ? void 0 : y.indentStyle;
      return {
        paddingLeft: l.value,
        ...g ? { "--cell-indent": g.paddingLeft } : {},
        ...(k = r.value) == null ? void 0 : k.customStyle
      };
    }), d = () => {
      t("toggle-expand");
    };
    return (g, y) => (b(), M("div", {
      class: ne([f.value, "v-table-cell"]),
      style: Fe(h.value)
    }, [
      c.value ? (b(), M(Se, { key: 0 }, [
        U(g.$slots, "pin"),
        u.value ? (b(), M("button", {
          key: 0,
          class: "v-table-cell-expand-btn",
          onClick: Ve(d, ["stop"])
        }, [
          oe(p(xe), {
            icon: e.isExpanded ? "lucide:chevron-down" : "lucide:chevron-right",
            size: 18
          }, null, 8, ["icon"])
        ])) : P("", !0),
        E("span", {
          title: o(),
          class: ne([{ "v-table-cell-text--truncate": !e.interactive }, "v-table-cell-text"])
        }, [
          U(g.$slots, "default", {}, () => [
            Ue(ce(i.value), 1)
          ])
        ], 10, aT)
      ], 64)) : U(g.$slots, "default", { key: 1 })
    ], 6));
  }
}), sT = ["title"], rT = /* @__PURE__ */ Te({
  __name: "TableCellValue",
  props: {
    value: {},
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = C(() => e.interactive ? void 0 : String(e.value));
    return (t, a) => (b(), M("span", { title: n.value }, ce(e.value), 9, sT));
  }
}), lT = /* @__PURE__ */ Te({
  __name: "TableCheckboxCell",
  props: {
    checked: { type: Boolean },
    indeterminate: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = () => {
      t("toggle");
    };
    return (s, r) => (b(), M("div", {
      class: "v-table-checkbox-cell",
      onClick: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      oe(p(Fu), {
        disabled: e.disabled,
        indeterminate: e.indeterminate,
        "model-value": e.checked,
        "onUpdate:modelValue": a
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), iT = /* @__PURE__ */ Ge(lT, [["__scopeId", "data-v-499acbc1"]]);
function ts(e) {
  return new Promise((n, t) => {
    e.oncomplete = e.onsuccess = () => n(e.result), e.onabort = e.onerror = () => t(e.error);
  });
}
function zd(e, n) {
  let t;
  const a = () => {
    if (t)
      return t;
    const s = indexedDB.open(e);
    return s.onupgradeneeded = () => s.result.createObjectStore(n), t = ts(s), t.then((r) => {
      r.onclose = () => t = void 0;
    }, () => {
    }), t;
  };
  return (s, r) => a().then((l) => r(l.transaction(n, s).objectStore(n)));
}
let yl;
function qr() {
  return yl || (yl = zd("keyval-store", "keyval")), yl;
}
function tu(e, n = qr()) {
  return n("readonly", (t) => ts(t.get(e)));
}
function oT(e, n, t = qr()) {
  return t("readwrite", (a) => (a.put(n, e), ts(a.transaction)));
}
function nu(e, n = qr()) {
  return n("readwrite", (t) => (t.delete(e), ts(t.transaction)));
}
function uT(e, n) {
  return e.openCursor().onsuccess = function() {
    this.result && (n(this.result), this.result.continue());
  }, ts(e.transaction);
}
function au(e = qr()) {
  return e("readonly", (n) => {
    if (n.getAllKeys)
      return ts(n.getAllKeys());
    const t = [];
    return uT(n, (a) => t.push(a.key)).then(() => t);
  });
}
const cT = {
  deserialize: JSON.parse,
  dialect: "redis",
  serialize: JSON.stringify,
  dbName: "keyv",
  storeName: "keyv"
};
class dT {
  constructor(n) {
    this.ttlSupport = !1, this.namespace = "", this.opts = Object.assign({}, cT, n), this.store = zd(this.opts.dbName, this.opts.storeName);
  }
  _getKey(n) {
    return this.namespace ? `${this.namespace}${n}` : n;
  }
  _innerKeyToKey(n) {
    return this.namespace && n.startsWith(this.namespace) ? n.slice(this.namespace.length) : n;
  }
  on(n, t) {
    return this;
  }
  async get(n) {
    try {
      const t = await tu(this._getKey(n), this.store);
      return t ?? void 0;
    } catch {
    }
  }
  async getMany(n) {
    return Promise.all(n.map((t) => this.get(t)));
  }
  /**
   * Note: `await kv.set()` will wait <options.writeDelay> millseconds to save to disk, it would be slow. Please remove `await` if you find performance issues.
   * @param key
   * @param value
   * @param ttl
   * @returns
   */
  async set(n, t, a) {
    return oT(this._getKey(n), t, this.store);
  }
  async delete(n) {
    let t = await this.has(n);
    return await nu(this._getKey(n), this.store), t;
  }
  async deleteMany(n) {
    return (await Promise.all(n.map((a) => this.delete(a)))).every((a) => a);
  }
  async clear() {
    let n = await au(this.store), t = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a];
      typeof s == "string" && s.startsWith(this.namespace) && t.push(nu(s, this.store));
    }
    await Promise.all(t);
  }
  async has(n) {
    return await this.get(n) !== void 0;
  }
  disconnect() {
    return Promise.resolve();
  }
  async *iterator(n = this.namespace) {
    let t = await au(this.store);
    for (let a = 0; a < t.length; a++) {
      let s = t[a];
      typeof s == "string" && (!n || s.startsWith(n)) && (yield [s, await tu(s, this.store)]);
    }
  }
}
class fT {
  constructor(n = "table-configs") {
    we(this, "keyv");
    this.keyv = new dT({
      dbName: n,
      storeName: "keyv",
      namespace: n
    });
  }
  async get(n) {
    try {
      return await this.keyv.get(n) ?? null;
    } catch (t) {
      return console.error("IndexedDB get error:", t), null;
    }
  }
  async set(n, t) {
    try {
      await this.keyv.set(n, t);
    } catch (a) {
      throw console.error("IndexedDB set error:", a), a;
    }
  }
  async delete(n) {
    try {
      await this.keyv.delete(n);
    } catch (t) {
      throw console.error("IndexedDB delete error:", t), t;
    }
  }
  async clear() {
    try {
      await this.keyv.clear();
    } catch (n) {
      throw console.error("IndexedDB clear error:", n), n;
    }
  }
}
class su {
  constructor(n = "localStorage") {
    we(this, "storage");
    this.storage = n === "sessionStorage" ? sessionStorage : localStorage;
  }
  get(n) {
    try {
      const t = this.storage.getItem(n);
      return Promise.resolve(t ? JSON.parse(t) : null);
    } catch (t) {
      return console.error("WebStorage get error:", t), Promise.resolve(null);
    }
  }
  set(n, t) {
    try {
      return this.storage.setItem(n, JSON.stringify(t)), Promise.resolve();
    } catch (a) {
      return console.error("WebStorage set error:", a), a instanceof DOMException && a.name === "QuotaExceededError" && console.warn("Storage quota exceeded, consider using IndexedDB"), Promise.reject(a);
    }
  }
  delete(n) {
    try {
      return this.storage.removeItem(n), Promise.resolve();
    } catch (t) {
      return console.error("WebStorage delete error:", t), Promise.reject(t);
    }
  }
  clear() {
    try {
      return this.storage.clear(), Promise.resolve();
    } catch (n) {
      return console.error("WebStorage clear error:", n), Promise.reject(n);
    }
  }
}
function ru(e = "indexedDB", n) {
  switch (e) {
    case "indexedDB":
      return new fT(n);
    case "localStorage":
      return new su("localStorage");
    case "sessionStorage":
      return new su("sessionStorage");
    default:
      throw new Error(`Unknown storage type: ${e}`);
  }
}
const ca = class ca {
  constructor() {
    we(this, "adapter");
    we(this, "storageType");
    this.storageType = "indexedDB", this.adapter = ru(this.storageType, "table-configs");
  }
  static getInstance() {
    return ca.instance || (ca.instance = new ca()), ca.instance;
  }
  /**
     * Change storage type globally
     * Useful for testing or fallback scenarios
     */
  setStorageType(n, t) {
    this.storageType = n, this.adapter = ru(n, t);
  }
  getStorageType() {
    return this.storageType;
  }
  getAdapter() {
    return this.adapter;
  }
  /**
     * Get table configuration
     */
  getTableConfig(n) {
    return this.adapter.get(n);
  }
  /**
     * Save table configuration
     */
  async setTableConfig(n, t) {
    await this.adapter.set(n, t);
  }
  /**
     * Delete table configuration
     */
  async deleteTableConfig(n) {
    await this.adapter.delete(n);
  }
  /**
     * Clear all table configurations
     */
  async clearAllConfigs() {
    await this.adapter.clear();
  }
};
we(ca, "instance");
let Zl = ca;
const Ka = Zl.getInstance(), $r = (e, n) => (n && Ka.setStorageType(n), Ka.getTableConfig(e)), Wd = async (e, n, t) => {
  t && Ka.setStorageType(t), await Ka.setTableConfig(e, n);
}, hT = { class: "column-picker" }, mT = { class: "column-picker-header" }, vT = { class: "column-picker-header-title" }, pT = { class: "column-picker-body" }, gT = { class: "column-picker-panel column-picker-panel--left" }, yT = { class: "column-picker-panel-header" }, bT = { class: "column-picker-panel-count" }, wT = { class: "cp-toolbar" }, kT = { class: "cp-search" }, xT = { class: "cp-sort-group" }, ST = { class: "column-picker-panel-list" }, TT = ["onClick"], MT = ["onClick"], $T = {
  key: 0,
  class: "cp-type-group-header"
}, CT = { class: "cp-type-group-label" }, DT = ["onClick"], OT = {
  key: 0,
  class: "cp-type-icon"
}, _T = { class: "cp-available-item-label" }, ET = {
  class: "cp-available-item-toggle",
  "aria-hidden": "true"
}, IT = ["onClick"], PT = {
  key: 0,
  class: "column-picker-empty"
}, AT = { class: "column-picker-panel column-picker-panel--right" }, RT = { class: "column-picker-panel-header" }, VT = { class: "column-picker-panel-search" }, FT = { class: "column-picker-panel-list" }, LT = ["draggable", "onDragover", "onDragstart", "onDrop"], NT = { class: "cp-selected-item-drag" }, BT = {
  key: 0,
  class: "cp-type-icon"
}, zT = { class: "cp-selected-item-label" }, WT = ["title", "onClick"], YT = ["onClick"], HT = {
  key: 0,
  class: "column-picker-empty"
}, UT = { class: "column-picker-footer" }, qT = {
  key: 0,
  class: "column-picker-footer-hint column-picker-footer-hint--limit"
}, jT = {
  key: 1,
  class: "column-picker-footer-hint"
}, sr = 6, bl = 40, GT = /* @__PURE__ */ Te({
  __name: "TableColumnPicker",
  props: {
    groups: {},
    columns: {},
    originalColumns: {},
    loading: { type: Boolean, default: !1 },
    storageKey: {},
    storageType: {}
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = te(""), r = te("alpha"), l = te(/* @__PURE__ */ new Set()), i = te(/* @__PURE__ */ new Set());
    He(r, () => {
      i.value = /* @__PURE__ */ new Set();
    });
    const o = (H) => {
      if (l.value.has(H)) {
        l.value.delete(H);
        const I = new Set(i.value);
        I.delete(H), i.value = I;
      } else
        l.value.add(H);
      l.value = new Set(l.value);
    }, u = C(() => {
      const H = s.value.trim().toLowerCase();
      return H ? t.groups.map((I) => ({
        ...I,
        items: I.items.filter((B) => B.label.toLowerCase().includes(H))
      })).filter((I) => I.items.length > 0) : t.groups;
    });
    He(s, (H) => {
      H.trim() ? l.value = new Set(u.value.map((I) => I.key)) : l.value = /* @__PURE__ */ new Set();
    });
    const c = ["text", "number", "boolean", "date", "sys"];
    function f(H) {
      const I = new Set(i.value);
      I.add(H), i.value = I;
    }
    function h(H) {
      const I = [...H.items];
      return r.value === "alpha" ? I.sort((B, J) => {
        const R = B.label.toLowerCase().trim(), ee = J.label.toLowerCase().trim();
        return R < ee ? -1 : R > ee ? 1 : 0;
      }) : I.sort((B, J) => {
        const R = c.indexOf(B.icon ?? ""), ee = c.indexOf(J.icon ?? "");
        return R - ee;
      });
    }
    function d(H) {
      const I = h(H);
      return !s.value.trim() && !i.value.has(H.key) && I.length > sr ? I.slice(0, sr) : I;
    }
    function g(H) {
      return !s.value.trim() && !i.value.has(H.key) && h(H).length > sr;
    }
    const y = {
      text: "Text",
      number: "Number",
      boolean: "Boolean",
      date: "Date",
      sys: "File"
    };
    function k(H) {
      if (r.value !== "by-type")
        return H.map((J) => ({ isHeader: !1, key: J.key, item: J }));
      const I = [];
      let B;
      for (const J of H) {
        const R = J.icon ?? "";
        R !== B && (I.push({ isHeader: !0, key: `hdr-${R}`, typeKey: R }), B = R), I.push({ isHeader: !1, key: J.key, item: J });
      }
      return I;
    }
    const m = te([]), v = te([]), w = (H, I = !1) => {
      if (H) {
        const B = /* @__PURE__ */ new Map();
        t.groups.forEach((R) => R.items.forEach((ee) => B.set(ee.key, ee)));
        const J = H.order.filter((R) => H.visible.includes(R)).map((R) => {
          var W, he;
          const ee = t.columns.find((Oe) => Oe.key === R), O = B.get(R), z = (ee == null ? void 0 : ee.label) ?? (O == null ? void 0 : O.label) ?? ((W = H.labels) == null ? void 0 : W[R]) ?? R, F = (O == null ? void 0 : O.icon) ?? (ee == null ? void 0 : ee.icon), le = (he = H.fixed) == null ? void 0 : he[R];
          return { key: R, label: z, icon: F, fixed: le };
        }).filter((R) => R !== null);
        m.value = J;
      } else {
        const B = I ? t.originalColumns ?? t.columns : t.columns;
        m.value = B.map((J) => ({
          key: J.key,
          label: J.label,
          icon: J.icon,
          fixed: J.fixed
        }));
      }
      v.value = JSON.parse(JSON.stringify(m.value));
    };
    nt(async () => {
      if (t.storageKey)
        try {
          const H = await $r(t.storageKey, t.storageType);
          w(H);
          return;
        } catch (H) {
          console.error("[TableColumnPicker] Failed to load from storage:", H);
        }
      w();
    });
    const S = te(""), x = C(() => {
      const H = S.value.trim().toLowerCase();
      return H ? m.value.filter((I) => I.label.toLowerCase().includes(H)) : m.value;
    }), $ = C(() => new Set(m.value.map((H) => H.key))), T = C(() => m.value.length >= bl), _ = C(
      () => t.groups.reduce((H, I) => H + I.items.length, 0)
    );
    function A(H) {
      return H.items.filter((I) => $.value.has(I.key)).length;
    }
    function D(H) {
      return H.items.length > 0 && H.items.every((I) => $.value.has(I.key));
    }
    function Y(H) {
      if (D(H)) {
        const I = new Set(H.items.map((B) => B.key));
        m.value = m.value.filter((B) => I.has(B.key) ? !!B.fixed : !0);
      } else {
        const I = H.items.filter((J) => !$.value.has(J.key)), B = bl - m.value.length;
        m.value = [
          ...m.value,
          ...I.slice(0, B).map((J) => ({ key: J.key, label: J.label, icon: J.icon }))
        ];
      }
    }
    const L = (H) => {
      !$.value.has(H.key) && !T.value && (m.value = [...m.value, { key: H.key, label: H.label, icon: H.icon }]);
    }, X = (H) => {
      const I = m.value.find((B) => B.key === H);
      I != null && I.fixed || (m.value = m.value.filter((B) => B.key !== H));
    }, se = (H) => {
      $.value.has(H.key) ? X(H.key) : L(H);
    }, ie = async () => {
      if (t.storageKey)
        try {
          await Ka.deleteTableConfig(t.storageKey);
        } catch (R) {
          console.error("[TableColumnPicker] Failed to clear storage:", R);
        }
      w(null, !0);
      const H = t.originalColumns ?? t.columns, I = new Map(H.map((R) => [R.key, R])), B = /* @__PURE__ */ new Map();
      t.groups.forEach((R) => R.items.forEach((ee) => B.set(ee.key, ee)));
      const J = m.value.map((R) => {
        const ee = I.get(R.key);
        if (ee) return { ...ee, fixed: R.fixed };
        const O = B.get(R.key);
        return { key: R.key, label: R.label, fixed: R.fixed, sortable: O == null ? void 0 : O.sortable, format: O == null ? void 0 : O.format };
      });
      a("update:visible-columns", J), a("close");
    }, ue = (H) => H === 0 || H === 1, G = (H) => H.fixed === "left", q = (H) => {
      !ue(H) || !m.value[H] || (m.value = m.value.map(
        (B, J) => J === H ? { ...B, fixed: B.fixed === "left" ? void 0 : "left" } : B
      ));
    }, Z = () => {
      m.value = m.value.map(
        (H, I) => H.fixed === "left" && !ue(I) ? { ...H, fixed: void 0 } : H
      );
    }, N = te(null), ae = te(null), me = (H, I) => {
      S.value.trim() || (N.value = H, I.dataTransfer && (I.dataTransfer.effectAllowed = "move", I.dataTransfer.setData("text/html", "")));
    }, be = (H, I) => {
      I.preventDefault(), I.dataTransfer && (I.dataTransfer.dropEffect = "move"), ae.value = H;
    }, pe = (H, I) => {
      if (I.preventDefault(), N.value === null || N.value === H) {
        N.value = null, ae.value = null;
        return;
      }
      const B = [...m.value], [J] = B.splice(N.value, 1);
      B.splice(H, 0, J), m.value = B, Z(), N.value = null, ae.value = null;
    }, De = () => {
      N.value = null, ae.value = null;
    }, ge = async (H) => {
      if (!t.storageKey) return;
      const I = {}, B = {};
      H.forEach((R) => {
        R.fixed && (I[R.key] = R.fixed), B[R.key] = R.label;
      });
      const J = {
        visible: H.map((R) => R.key),
        order: H.map((R) => R.key),
        fixed: Object.keys(I).length > 0 ? I : void 0,
        labels: B
      };
      try {
        await Wd(t.storageKey, J, t.storageType);
      } catch (R) {
        console.error("[TableColumnPicker] Failed to save to storage:", R);
      }
    }, K = C(
      () => JSON.stringify(m.value) !== JSON.stringify(v.value)
    ), ye = async () => {
      const H = new Map(t.columns.map((J) => [J.key, J])), I = /* @__PURE__ */ new Map();
      t.groups.forEach((J) => J.items.forEach((R) => I.set(R.key, R)));
      const B = m.value.map((J) => {
        const R = H.get(J.key);
        if (R) return { ...R, fixed: J.fixed };
        const ee = I.get(J.key);
        return {
          key: J.key,
          label: J.label,
          fixed: J.fixed,
          sortable: ee == null ? void 0 : ee.sortable,
          format: ee == null ? void 0 : ee.format
        };
      });
      await ge(m.value), a("update:visible-columns", B), v.value = JSON.parse(JSON.stringify(m.value)), a("close");
    }, Me = () => {
      m.value = JSON.parse(JSON.stringify(v.value)), a("close");
    }, V = {
      text: { colorVar: "--color-secondaryText", lucideIcon: "lucide:align-left" },
      "multi-text": { colorVar: "--color-secondaryText", lucideIcon: "lucide:align-justify" },
      number: { colorVar: "--color-primary", lucideIcon: "lucide:hash" },
      decimal: { colorVar: "--color-primary", lucideIcon: "lucide:percent" },
      boolean: { colorVar: "--color-success", lucideIcon: "lucide:toggle-right" },
      date: { colorVar: "--color-warning", lucideIcon: "lucide:calendar" },
      datetime: { colorVar: "--color-warning", lucideIcon: "lucide:calendar-clock" },
      color: { colorVar: "--color-error", lucideIcon: "lucide:palette" },
      json: { colorVar: "--color-error", lucideIcon: "lucide:braces" },
      url: { colorVar: "--color-secondaryText", lucideIcon: "lucide:link" },
      link: { colorVar: "--color-secondaryText", lucideIcon: "lucide:external-link" },
      select: { colorVar: "--color-primary", lucideIcon: "lucide:list" },
      "multi-select": { colorVar: "--color-primary", lucideIcon: "lucide:list-checks" },
      asset: { colorVar: "--color-info", lucideIcon: "lucide:image" },
      "multi-asset": { colorVar: "--color-info", lucideIcon: "lucide:images" },
      sys: { colorVar: "--color-info", lucideIcon: "lucide:file" }
    };
    function j(H) {
      const I = H ? V[H] : void 0;
      return I ? { "--cp-type-color-raw": `var(${I.colorVar})` } : {};
    }
    return (H, I) => (b(), M("div", hT, [
      E("div", mT, [
        E("div", vT, [
          oe(p(xe), {
            size: 24,
            icon: "lucide:columns",
            variant: "link"
          }),
          I[5] || (I[5] = E("span", null, "Edit columns", -1))
        ]),
        E("button", {
          class: "column-picker-close-btn",
          title: "Close",
          onClick: Me
        }, [
          oe(p(xe), {
            size: 16,
            icon: "lucide:x"
          })
        ])
      ]),
      E("div", pT, [
        E("div", gT, [
          E("div", yT, [
            E("span", bT, ce(_.value) + " columns available ", 1)
          ]),
          E("div", wT, [
            E("div", kT, [
              oe(p(xe), {
                size: 11,
                icon: "lucide:search"
              }),
              mn(E("input", {
                "onUpdate:modelValue": I[0] || (I[0] = (B) => s.value = B),
                placeholder: "Search…"
              }, null, 512), [
                [cf, s.value]
              ])
            ]),
            E("div", xT, [
              E("button", {
                class: ne([{ "cp-sort-btn--active": r.value === "by-type" }, "cp-sort-btn"]),
                title: "Group by type",
                type: "button",
                onClick: I[1] || (I[1] = (B) => r.value = "by-type")
              }, [
                oe(p(xe), {
                  size: 10,
                  icon: "lucide:group"
                })
              ], 2),
              I[6] || (I[6] = E("div", { class: "cp-sort-divider" }, null, -1)),
              E("button", {
                class: ne([{ "cp-sort-btn--active": r.value === "alpha" }, "cp-sort-btn"]),
                title: "Sort alphabetically",
                type: "button",
                onClick: I[2] || (I[2] = (B) => r.value = "alpha")
              }, " A→Z ", 2)
            ])
          ]),
          E("div", ST, [
            e.loading ? (b(), M(Se, { key: 0 }, Pe(6, (B) => E("div", {
              key: B,
              class: "column-picker-skeleton"
            })), 64)) : (b(), M(Se, { key: 1 }, [
              (b(!0), M(Se, null, Pe(u.value, (B) => (b(), M("div", {
                key: B.key
              }, [
                E("div", {
                  class: "cp-group-header",
                  onClick: (J) => o(B.key)
                }, [
                  E("span", {
                    class: ne([{ "cp-group-label--has-selection": A(B) > 0 }, "cp-group-label"])
                  }, ce(B.label), 3),
                  E("button", {
                    class: "cp-group-select-btn",
                    type: "button",
                    onClick: Ve((J) => Y(B), ["stop"])
                  }, ce(D(B) ? "Deselect all" : "Select all"), 9, MT),
                  E("span", {
                    class: ne([A(B) > 0 ? "cp-group-badge--selected" : "cp-group-badge--empty", "cp-group-badge"])
                  }, ce(A(B)) + "/" + ce(B.items.length), 3),
                  oe(p(xe), {
                    class: ne([{ "cp-group-chevron--open": l.value.has(B.key) }, "cp-group-chevron"]),
                    size: 10,
                    icon: "lucide:chevron-right"
                  }, null, 8, ["class"])
                ], 8, TT),
                l.value.has(B.key) ? (b(), M(Se, { key: 0 }, [
                  (b(!0), M(Se, null, Pe(k(d(B)), (J) => {
                    var R;
                    return b(), M(Se, {
                      key: J.key
                    }, [
                      J.isHeader && J.typeKey ? (b(), M("div", $T, [
                        E("div", {
                          style: Fe({
                            background: V[J.typeKey] ? `rgb(var(${V[J.typeKey].colorVar}))` : "rgb(var(--color-secondaryText))"
                          }),
                          class: "cp-type-group-dot"
                        }, null, 4),
                        E("span", CT, ce(y[J.typeKey] ?? J.typeKey), 1)
                      ])) : J.item ? (b(), M("div", {
                        key: 1,
                        class: ne([{ "cp-available-item--selected": $.value.has(J.item.key) }, "cp-available-item"]),
                        style: Fe(j(J.item.icon)),
                        onClick: (ee) => se(J.item)
                      }, [
                        J.item.icon ? (b(), M("div", OT, [
                          oe(p(xe), {
                            icon: ((R = V[J.item.icon]) == null ? void 0 : R.lucideIcon) ?? "lucide:help-circle",
                            size: 9
                          }, null, 8, ["icon"])
                        ])) : P("", !0),
                        E("span", _T, ce(J.item.label), 1),
                        E("span", ET, [
                          oe(p(xe), {
                            icon: $.value.has(J.item.key) ? "lucide:check" : "lucide:plus",
                            size: $.value.has(J.item.key) ? 10 : 9
                          }, null, 8, ["icon", "size"])
                        ])
                      ], 14, DT)) : P("", !0)
                    ], 64);
                  }), 128)),
                  g(B) ? (b(), M("button", {
                    key: 0,
                    class: "cp-show-more-btn",
                    type: "button",
                    onClick: Ve((J) => f(B.key), ["stop"])
                  }, " Show " + ce(h(B).length - sr) + " more ", 9, IT)) : P("", !0)
                ], 64)) : P("", !0)
              ]))), 128)),
              u.value.length === 0 ? (b(), M("div", PT, " No columns match your search ")) : P("", !0)
            ], 64))
          ])
        ]),
        I[8] || (I[8] = E("div", { class: "column-picker-divider" }, null, -1)),
        E("div", AT, [
          E("div", RT, [
            E("span", {
              class: ne([{ "column-picker-panel-count--limit": T.value }, "column-picker-panel-count"])
            }, ce(m.value.length) + " selected ", 3),
            E("button", {
              class: "column-picker-text-btn",
              onClick: ie
            }, [
              oe(p(xe), {
                size: 12,
                icon: "lucide:rotate-ccw"
              }),
              I[7] || (I[7] = Ue(" Reset to default ", -1))
            ])
          ]),
          E("div", VT, [
            oe(p(Tr), {
              modelValue: S.value,
              "onUpdate:modelValue": I[3] || (I[3] = (B) => S.value = B),
              name: "Search",
              placeholder: "Search by column name",
              type: "search"
            }, null, 8, ["modelValue"])
          ]),
          E("div", FT, [
            (b(!0), M(Se, null, Pe(x.value, (B, J) => {
              var R;
              return b(), M("div", {
                key: B.key,
                class: ne([{
                  "cp-selected-item--dragging": N.value === J,
                  "cp-selected-item--drag-over": ae.value === J,
                  "cp-selected-item--locked": !!B.fixed
                }, "cp-selected-item"]),
                draggable: !B.fixed && !S.value,
                style: Fe(j(B.icon)),
                onDragend: De,
                onDragleave: I[4] || (I[4] = (ee) => ae.value = null),
                onDragover: (ee) => be(J, ee),
                onDragstart: (ee) => me(J, ee),
                onDrop: (ee) => pe(J, ee)
              }, [
                E("div", NT, [
                  oe(p(xe), {
                    size: 14,
                    icon: B.fixed ? "lucide:lock" : "lucide:grip-vertical"
                  }, null, 8, ["icon"])
                ]),
                B.icon ? (b(), M("div", BT, [
                  oe(p(xe), {
                    icon: ((R = V[B.icon]) == null ? void 0 : R.lucideIcon) ?? "lucide:help-circle",
                    size: 9
                  }, null, 8, ["icon"])
                ])) : P("", !0),
                E("span", zT, ce(B.label), 1),
                ue(J) && !S.value ? (b(), M("button", {
                  key: 1,
                  class: ne([{ "cp-selected-item-pin--active": G(B) }, "cp-selected-item-pin"]),
                  title: G(B) ? "Unpin column" : "Pin column to left",
                  onClick: Ve((ee) => q(J), ["stop"])
                }, [
                  oe(p(xe), {
                    icon: G(B) ? "lucide:pin" : "lucide:pin-off",
                    size: 12
                  }, null, 8, ["icon"])
                ], 10, WT)) : P("", !0),
                B.fixed ? P("", !0) : (b(), M("button", {
                  key: 2,
                  class: "cp-selected-item-remove",
                  title: "Remove column",
                  onClick: (ee) => X(B.key)
                }, [
                  oe(p(xe), {
                    size: 12,
                    icon: "lucide:x"
                  })
                ], 8, YT))
              ], 46, LT);
            }), 128)),
            m.value.length === 0 ? (b(), M("div", HT, " No columns selected. Use the left panel to add columns. ")) : P("", !0)
          ])
        ])
      ]),
      E("div", UT, [
        T.value ? (b(), M("span", qT, [
          oe(p(xe), {
            size: 24,
            icon: "lucide:alert-circle"
          }),
          Ue(" Max " + ce(bl) + " columns reached ")
        ])) : (b(), M("span", jT, [
          oe(p(xe), {
            size: 24,
            icon: "lucide:info"
          }),
          I[9] || (I[9] = Ue(" Drag to reorder · Pin first 2 columns ", -1))
        ])),
        oe(p(qt), {
          disabled: !K.value,
          class: "h-[30px]",
          text: "Apply",
          variant: "primary",
          onClick: ye
        }, null, 8, ["disabled"])
      ])
    ]));
  }
}), KT = { class: "column-setup" }, ZT = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, XT = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, JT = {
  key: 2,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, QT = { class: "column-setup-toggle-count" }, eM = ["draggable", "onDragover", "onDragstart", "onDrop"], tM = {
  key: 0,
  class: "column-setup-item-drag"
}, nM = ["title", "onClick"], aM = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, sM = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, rM = ["title", "onClick"], lM = {
  key: 2,
  class: "column-setup-item-badge column-setup-item-badge--warning",
  title: "Fixed will be removed — move to top 2 positions"
}, iM = { class: "column-setup-footer" }, oM = {
  key: 0,
  class: "column-setup-hint"
}, uM = /* @__PURE__ */ Te({
  __name: "TableColumnSetup",
  props: {
    columns: {},
    config: { default: () => ({}) }
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = async () => {
      var Z;
      if (!((Z = t.config) != null && Z.key)) return null;
      try {
        return await $r(t.config.key, t.config.type);
      } catch (N) {
        return console.error("Failed to load column setup from storage:", N), null;
      }
    }, r = async (Z) => {
      var N;
      if ((N = t.config) != null && N.key)
        try {
          const ae = {};
          Z.forEach((be) => {
            be.fixed && (ae[be.key] = be.fixed);
          });
          const me = {
            visible: Z.filter((be) => be.visible).map((be) => be.key),
            order: Z.map((be) => be.key),
            fixed: Object.keys(ae).length > 0 ? ae : void 0
            // Only save if there are fixed columns
          };
          await Wd(t.config.key, me, t.config.type);
        } catch (ae) {
          console.error("Failed to save column setup to storage:", ae);
        }
    }, l = (Z) => Z.reduce((N, ae) => ae.children && ae.children.length > 0 ? [...N, ...l(ae.children)] : [...N, ae], []), i = (Z) => {
      var me;
      const N = l(t.columns);
      if (Z) {
        const { visible: be, order: pe, fixed: De } = Z, ge = new Map(N.map((ye) => [ye.key, ye])), K = [];
        return pe.forEach((ye, Me) => {
          const V = ge.get(ye);
          V && (K.push({
            key: V.key,
            label: V.label,
            visible: be.includes(ye),
            order: Me,
            fixed: (De == null ? void 0 : De[ye]) || V.fixed
            // Use saved fixed state, fallback to column's fixed
          }), ge.delete(ye));
        }), ge.forEach((ye) => {
          K.push({
            key: ye.key,
            label: ye.label,
            visible: !0,
            order: K.length,
            fixed: ye.fixed
          });
        }), K;
      }
      const ae = (me = t.config) == null ? void 0 : me.initialVisible;
      return N.map((be, pe) => ({
        key: be.key,
        label: be.label,
        // If initialVisible is provided, check if column is in the list
        // If not provided, all columns are visible by default
        visible: ae ? ae.includes(be.key) : !0,
        order: pe,
        fixed: be.fixed
      }));
    }, o = te(i()), u = te(JSON.parse(JSON.stringify(i())));
    s().then((Z) => {
      if (Z) {
        const N = i(Z);
        o.value = N, u.value = JSON.parse(JSON.stringify(N));
      }
    });
    const c = C(() => JSON.stringify(o.value) !== JSON.stringify(u.value)), f = () => {
      const Z = l(t.columns), ae = o.value.filter((me) => me.visible).sort((me, be) => me.order - be.order).map((me) => {
        const be = Z.find((pe) => pe.key === me.key);
        return be ? {
          ...be,
          fixed: me.fixed
        } : null;
      }).filter(Boolean);
      a("update:visible-columns", ae);
    };
    He(
      o,
      () => {
      },
      { deep: !0 }
    );
    const h = () => {
      r(o.value), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    }, d = C(() => o.value.every((Z) => Z.visible)), g = C(() => o.value.every((Z) => !Z.visible)), y = C(() => !d.value && !g.value), k = C(() => o.value.filter((Z) => Z.visible).length), m = te(null), v = te(null), w = te(null), S = te(null), x = (Z) => {
      if (!w.value) return;
      const N = w.value.getBoundingClientRect(), ae = Z.clientY, me = 50, be = 10;
      ae < N.top + me && ae > N.top ? S.value || (S.value = window.setInterval(() => {
        w.value && w.value.scrollTop > 0 && (w.value.scrollTop -= be);
      }, 16)) : ae > N.bottom - me && ae < N.bottom ? S.value || (S.value = window.setInterval(() => {
        if (w.value) {
          const pe = w.value.scrollHeight - w.value.clientHeight;
          w.value.scrollTop < pe && (w.value.scrollTop += be);
        }
      }, 16)) : $();
    }, $ = () => {
      S.value && (clearInterval(S.value), S.value = null);
    }, T = (Z, N) => {
      var ae;
      ((ae = t.config) == null ? void 0 : ae.allowReorder) !== !1 && (m.value = Z, N.dataTransfer && (N.dataTransfer.effectAllowed = "move", N.dataTransfer.setData("text/html", "")));
    }, _ = (Z, N) => {
      var ae;
      ((ae = t.config) == null ? void 0 : ae.allowReorder) !== !1 && (N.preventDefault(), N.dataTransfer && (N.dataTransfer.dropEffect = "move"), v.value = Z, x(N));
    }, A = () => {
      v.value = null;
    }, D = (Z, N) => {
      var be;
      if (((be = t.config) == null ? void 0 : be.allowReorder) === !1) return;
      if (N.preventDefault(), $(), m.value === null || m.value === Z) {
        m.value = null, v.value = null;
        return;
      }
      const ae = [...o.value], [me] = ae.splice(m.value, 1);
      ae.splice(Z, 0, me), ae.forEach((pe, De) => {
        pe.order = De;
      }), o.value = ae, G(), m.value = null, v.value = null;
    }, Y = () => {
      m.value = null, v.value = null, $();
    }, L = (Z) => {
      const N = o.value.find((ae) => ae.key === Z);
      N && (N.visible = !N.visible);
    }, X = () => {
      const Z = !d.value;
      o.value.forEach((N) => {
        N.visible = Z;
      });
    }, se = (Z) => Z === 0 || Z === 1, ie = (Z) => Z.fixed === "left", ue = (Z) => {
      if (!se(Z)) return;
      const N = o.value[Z];
      N && (N.fixed === "left" ? N.fixed = void 0 : N.fixed = "left");
    }, G = () => {
      o.value.forEach((Z, N) => {
        Z.fixed === "left" && !se(N) && (Z.fixed = void 0);
      });
    }, q = async () => {
      var Z;
      if ((Z = t.config) != null && Z.key)
        try {
          await Ka.deleteTableConfig(t.config.key);
        } catch (N) {
          console.error("Failed to clear storage:", N);
        }
      o.value = i(), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    };
    return (Z, N) => {
      var ae;
      return b(), M("div", KT, [
        E("div", { class: "column-setup-header" }, [
          N[1] || (N[1] = E("span", { class: "column-setup-title" }, "Column Settings", -1)),
          E("button", {
            class: "column-setup-reset-btn",
            title: "Reset to default",
            onClick: q
          }, [...N[0] || (N[0] = [
            E("svg", {
              fill: "none",
              height: "13",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.3",
              viewBox: "0 0 24 24",
              width: "13"
            }, [
              E("polyline", { points: "1 4 1 10 7 10" }),
              E("path", { d: "M3.51 15a9 9 0 1 0 .49-4.5" })
            ], -1)
          ])])
        ]),
        E("div", {
          class: "column-setup-toggle-all",
          onClick: X
        }, [
          E("div", {
            class: ne([{
              "column-setup-toggle-eye--none": g.value
            }, "column-setup-toggle-eye"])
          }, [
            d.value ? (b(), M("svg", ZT, [...N[2] || (N[2] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }, null, -1)
            ])])) : y.value ? (b(), M("svg", XT, [...N[3] || (N[3] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("line", {
                x1: "9",
                x2: "15",
                y1: "12",
                y2: "12"
              }, null, -1)
            ])])) : (b(), M("svg", JT, [...N[4] || (N[4] = [
              E("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
              E("line", {
                x1: "1",
                x2: "23",
                y1: "1",
                y2: "23"
              }, null, -1)
            ])]))
          ], 2),
          N[5] || (N[5] = E("span", { class: "column-setup-toggle-label" }, "Show all columns", -1)),
          E("span", QT, ce(k.value) + " / " + ce(o.value.length), 1)
        ]),
        E("div", {
          ref_key: "listRef",
          ref: w,
          class: "column-setup-list"
        }, [
          (b(!0), M(Se, null, Pe(o.value, (me, be) => {
            var pe, De, ge;
            return b(), M("div", {
              key: me.key,
              class: ne([{
                "column-setup-item--dragging": m.value === be,
                "column-setup-item--drag-over": v.value === be,
                "column-setup-item--no-reorder": ((pe = e.config) == null ? void 0 : pe.allowReorder) === !1
              }, "column-setup-item"]),
              draggable: ((De = e.config) == null ? void 0 : De.allowReorder) !== !1,
              onDragend: Y,
              onDragleave: A,
              onDragover: (K) => _(be, K),
              onDragstart: (K) => T(be, K),
              onDrop: (K) => D(be, K)
            }, [
              ((ge = e.config) == null ? void 0 : ge.allowReorder) !== !1 ? (b(), M("div", tM, [
                oe(p(xe), {
                  size: 16,
                  icon: "lucide:grip-vertical"
                })
              ])) : P("", !0),
              E("button", {
                class: ne([me.visible ? "column-setup-item-eye--visible" : "column-setup-item-eye--hidden", "column-setup-item-eye"]),
                title: me.visible ? "Hide column" : "Show column",
                onClick: Ve((K) => L(me.key), ["stop"])
              }, [
                me.visible ? (b(), M("svg", aM, [...N[6] || (N[6] = [
                  E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                  E("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  }, null, -1)
                ])])) : (b(), M("svg", sM, [...N[7] || (N[7] = [
                  E("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
                  E("line", {
                    x1: "1",
                    x2: "23",
                    y1: "1",
                    y2: "23"
                  }, null, -1)
                ])]))
              ], 10, nM),
              E("div", {
                class: ne([{ "column-setup-item-label--hidden": !me.visible }, "column-setup-item-label"])
              }, ce(me.label), 3),
              se(be) ? (b(), M("button", {
                key: 1,
                class: ne([{ "column-setup-item-fixed-btn--active": ie(me) }, "column-setup-item-fixed-btn"]),
                title: ie(me) ? "Unpin column" : "Pin column to left",
                onClick: Ve((K) => ue(be), ["stop"])
              }, [
                oe(p(xe), {
                  icon: ie(me) ? "lucide:pin" : "lucide:pin-off",
                  size: 16
                }, null, 8, ["icon"])
              ], 10, rM)) : P("", !0),
              me.fixed && !se(be) ? (b(), M("div", lM, [
                oe(p(xe), {
                  size: 16,
                  icon: "lucide:triangle-alert"
                })
              ])) : P("", !0)
            ], 42, eM);
          }), 128))
        ], 512),
        E("div", iM, [
          ((ae = e.config) == null ? void 0 : ae.allowReorder) !== !1 ? (b(), M("span", oM, [
            oe(p(xe), {
              size: 11,
              icon: "lucide:grip-vertical"
            }),
            N[8] || (N[8] = Ue(" Drag to reorder ", -1))
          ])) : P("", !0),
          oe(p(qt), {
            disabled: !c.value,
            text: "Apply",
            variant: "primary",
            class: "h-[30px]",
            onClick: h
          }, null, 8, ["disabled"])
        ])
      ]);
    };
  }
}), cM = /* @__PURE__ */ Ge(uM, [["__scopeId", "data-v-4fee774a"]]), dM = { class: "v-table-empty-state" }, fM = { class: "v-table-empty-state-content" }, hM = {
  key: 0,
  class: "v-table-empty-state-icon"
}, mM = {
  key: 1,
  class: "v-table-empty-state-title"
}, vM = {
  key: 2,
  class: "v-table-empty-state-description"
}, pM = {
  key: 3,
  class: "v-table-empty-state-slot"
}, gM = /* @__PURE__ */ Te({
  __name: "TableEmptyState",
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(e) {
    return (n, t) => (b(), M("div", dM, [
      E("div", fM, [
        e.icon ? (b(), M("div", hM, [
          oe(p(xe), {
            icon: e.icon,
            size: 48
          }, null, 8, ["icon"])
        ])) : P("", !0),
        e.title ? (b(), M("h3", mM, ce(e.title), 1)) : P("", !0),
        e.description ? (b(), M("p", vM, ce(e.description), 1)) : P("", !0),
        n.$slots.default ? (b(), M("div", pM, [
          U(n.$slots, "default", {}, void 0, !0)
        ])) : P("", !0)
      ])
    ]));
  }
}), yM = /* @__PURE__ */ Ge(gM, [["__scopeId", "data-v-0cf402c5"]]), bM = ["aria-label", "title"], wM = /* @__PURE__ */ Te({
  __name: "TableFullscreenToggle",
  props: {
    isFullscreen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = C(() => e.isFullscreen ? "Collapse table" : "Expand table"), s = C(() => e.isFullscreen ? "lucide:minimize-2" : "lucide:maximize-2");
    return (r, l) => (b(), M("button", {
      "aria-label": a.value,
      class: ne([{ "v-table-fullscreen-toggle--active": e.isFullscreen }, "v-table-fullscreen-toggle"]),
      title: a.value,
      type: "button",
      onClick: l[0] || (l[0] = (i) => t("toggle"))
    }, [
      oe(p(xe), {
        icon: s.value,
        size: 15
      }, null, 8, ["icon"])
    ], 10, bM));
  }
}), kM = /* @__PURE__ */ Te({
  __name: "TableHeaderCheckbox",
  props: {
    state: {},
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = () => {
      t.disabled || a("toggle");
    };
    return (r, l) => (b(), M("div", {
      class: "v-table-header-checkbox-cell",
      onClick: l[0] || (l[0] = Ve(() => {
      }, ["stop"]))
    }, [
      oe(p(Fu), {
        disabled: e.disabled,
        indeterminate: e.state === "indeterminate",
        "model-value": e.state === "checked",
        "onUpdate:modelValue": s
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), xM = /* @__PURE__ */ Ge(kM, [["__scopeId", "data-v-6525801e"]]), SM = ["aria-label", "aria-pressed"], Yd = /* @__PURE__ */ Te({
  __name: "TablePinButton",
  props: {
    pinned: { type: Boolean },
    label: {}
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = C(() => e.pinned ? `Unpin ${e.label}` : `Pin ${e.label}`), s = (r) => {
      r.stopPropagation(), t("toggle");
    };
    return (r, l) => (b(), M("button", {
      "aria-label": a.value,
      "aria-pressed": e.pinned,
      class: ne([{ "v-table-pin-button--active": e.pinned }, "v-table-pin-button"]),
      type: "button",
      onClick: s,
      onMousedown: l[0] || (l[0] = Ve(() => {
      }, ["stop"]))
    }, [
      oe(p(xe), {
        icon: e.pinned ? "lucide:x" : "lucide:pin",
        size: 13
      }, null, 8, ["icon"])
    ], 42, SM));
  }
}), TM = { class: "v-table-header-content" }, MM = ["title"], $M = { class: "items-center justify-center flex p-0 w-[16px]" }, CM = ["title"], DM = ["aria-label"], OM = /* @__PURE__ */ Te({
  __name: "TableHeader",
  props: {
    column: {},
    label: {},
    align: { default: "left" },
    columnKey: {},
    resizable: { type: Boolean, default: !0 },
    isSorted: { type: Boolean, default: !1 },
    sortOrder: { default: null },
    sortIndex: { default: -1 }
  },
  emits: ["sort-click", "resize-start", "resize-dblclick"],
  setup(e, { emit: n }) {
    const t = Qn("tableSlots", {}), a = Qn("tableHighlight", null), s = e, r = n, l = C(() => !s.isSorted || !s.sortOrder ? "lucide:arrow-up-down" : s.sortOrder === "asc" ? "lucide:arrow-up" : "lucide:arrow-down"), i = C(() => s.isSorted ? "v-sort-icon v-sort-icon--active" : "v-sort-icon"), o = (d) => {
      s.column.sortable && (d.stopPropagation(), r("sort-click"));
    }, u = (d) => {
      s.column.onHeaderClick && (d.stopPropagation(), s.column.onHeaderClick({
        column: s.column,
        columnKey: s.columnKey,
        event: d
      }));
    }, c = (d) => {
      r("resize-start", s.columnKey, d);
    }, f = () => {
      r("resize-dblclick", s.columnKey);
    }, h = (d) => {
      s.column.sortable && (d.key === "Enter" || d.key === " ") && (d.preventDefault(), r("sort-click"));
    };
    return (d, g) => {
      var y;
      return b(), M("div", {
        class: ne([{
          "v-table-header-cell--left": e.align === "left",
          "v-table-header-cell--center": e.align === "center",
          "v-table-header-cell--right": e.align === "right",
          "v-table-header-cell--sortable": e.column.sortable,
          "v-table-header-cell--clickable": e.column.onHeaderClick
        }, "v-table-header-cell"])
      }, [
        E("div", TM, [
          E("div", {
            class: ne([{ "v-table-header-label-wrapper--clickable": e.column.onHeaderClick }, "v-table-header-label-wrapper"]),
            onClick: u
          }, [
            U(d.$slots, "default", {
              column: e.column,
              isSorted: e.isSorted,
              sortOrder: e.sortOrder
            }, () => [
              E("span", {
                title: e.label,
                class: "v-table-header-label"
              }, ce(e.label), 9, MM)
            ], !0),
            U(d.$slots, "icon", { column: e.column }, void 0, !0),
            e.column.tooltip ? (b(), fe(p(Cs), {
              key: 0,
              text: e.column.tooltip,
              placement: "top",
              "tooltip-class": "bg-cardBg opacity-1 w-[300px]"
            }, {
              default: de(() => [
                E("div", $M, [
                  oe(p(xe), {
                    size: 14,
                    class: "v-table-header-info-icon",
                    icon: "lucide:info"
                  })
                ])
              ]),
              _: 1
            }, 8, ["text"])) : P("", !0),
            e.column.onHeaderClick ? (b(), M("div", {
              key: 1,
              title: `Click to interact with ${e.label}`,
              class: "v-table-header-click-indicator"
            }, [
              oe(p(xe), {
                size: 14,
                class: "click-indicator-icon",
                icon: "lucide:mouse-pointer-click"
              })
            ], 8, CM)) : P("", !0)
          ], 2),
          e.column.sortable ? (b(), M("div", {
            key: 0,
            "aria-label": `Sort by ${e.label}`,
            tabindex: 0,
            class: "v-table-header-sort",
            role: "button",
            onClick: o,
            onKeydown: h
          }, [
            oe(p(xe), {
              class: ne(i.value),
              icon: l.value,
              size: 16
            }, null, 8, ["class", "icon"])
          ], 40, DM)) : P("", !0),
          p(t).headerCellCustomAction ? (b(), fe(ht(p(t).headerCellCustomAction), {
            key: 1,
            column: e.column
          }, null, 8, ["column"])) : P("", !0),
          (y = p(a)) != null && y.columnEnabled.value ? (b(), fe(Yd, {
            key: 2,
            label: e.label,
            pinned: p(a).isColumnPinned(e.columnKey),
            onToggle: g[0] || (g[0] = (k) => p(a).toggleColumn(e.columnKey))
          }, null, 8, ["label", "pinned"])) : P("", !0)
        ]),
        e.resizable ? (b(), M("div", {
          key: 0,
          class: "v-table-resize-handle",
          onMousedown: Ve(c, ["stop"]),
          onDblclick: Ve(f, ["stop"])
        }, [...g[1] || (g[1] = [
          E("div", { class: "v-table-resize-indicator" }, [
            E("div", { class: "v-table-resize-line" }),
            E("div", { class: "v-table-resize-line" })
          ], -1),
          E("div", { class: "v-table-resize-divider" }, null, -1)
        ])], 32)) : P("", !0)
      ], 2);
    };
  }
}), Hd = /* @__PURE__ */ Ge(OM, [["__scopeId", "data-v-bd73d8e9"]]), _M = { class: "v-table-header-group-label" }, EM = /* @__PURE__ */ Te({
  __name: "TableHeaderGroup",
  props: {
    cell: {},
    groupWidth: {}
  },
  setup(e) {
    return (n, t) => (b(), M("div", {
      class: ne([{
        "v-table-header-group--left": e.cell.column.align === "left",
        "v-table-header-group--center": e.cell.column.align === "center",
        "v-table-header-group--right": e.cell.column.align === "right"
      }, "v-table-header-group"])
    }, [
      E("span", _M, ce(e.cell.label), 1)
    ], 2));
  }
}), IM = /* @__PURE__ */ Te({
  __name: "TableHeaderGrouped",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getGroupWidth: { type: Function },
    getGroupFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, r = (i) => {
      a("resize-dblclick", i);
    }, l = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (b(!0), M(Se, null, Pe(e.columns, (u, c) => (b(), M("div", {
      key: `header-level-${c}`,
      class: ne([`v-table-header-row-level-${c}`, "v-table-header-row"])
    }, [
      c === 0 ? U(i.$slots, "checkbox-header", { key: 0 }) : P("", !0),
      (b(!0), M(Se, null, Pe(u, (f) => (b(), M(Se, {
        key: f.key
      }, [
        f.isGroup ? (b(), fe(EM, {
          key: 0,
          cell: f,
          class: ne(e.getColumnClasses(f.column)),
          "group-width": e.getGroupWidth(f.column),
          style: Fe({
            gridColumn: `span ${f.colspan}`,
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getGroupFixedStyles(f.column)
          })
        }, null, 8, ["cell", "class", "group-width", "style"])) : (b(), fe(Hd, {
          key: 1,
          align: f.column.align,
          class: ne([
            e.getColumnClasses(f.column),
            {
              "v-table-header-cell--grouped": c > 0,
              "v-table-header-cell--rowspan": f.rowspan > 1
            }
          ]),
          column: f.column,
          "column-key": f.column.key,
          "is-sorted": e.getSortState(f.column.key).isSorted,
          label: f.label,
          resizable: t.isColumnResizable(f.column),
          "sort-index": e.getSortState(f.column.key).index,
          "sort-order": e.getSortState(f.column.key).order,
          style: Fe({
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getFixedStyles(f.column)
          }),
          onSortClick: (h) => l(f.column),
          onResizeStart: s,
          onResizeDblclick: r
        }, ft({ _: 2 }, [
          i.$slots[`header-icon-${f.column.key}`] ? {
            name: "icon",
            fn: de((h) => [
              U(i.$slots, `header-icon-${f.column.key}`, lt({ ref_for: !0 }, h))
            ]),
            key: "0"
          } : void 0,
          i.$slots[`header-${f.column.key}`] ? {
            name: "default",
            fn: de((h) => [
              U(i.$slots, `header-${f.column.key}`, lt({ ref_for: !0 }, h))
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))
      ], 64))), 128))
    ], 2))), 128));
  }
}), PM = { class: "v-table-header-row" }, AM = /* @__PURE__ */ Te({
  __name: "TableHeaderSimple",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, r = (i) => {
      a("resize-dblclick", i);
    }, l = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (b(), M("div", PM, [
      U(i.$slots, "checkbox-header"),
      (b(!0), M(Se, null, Pe(e.columns, (u) => (b(), fe(Hd, {
        key: u.key,
        align: u.align,
        class: ne(e.getColumnClasses(u)),
        column: u,
        "column-key": u.key,
        "is-sorted": e.getSortState(u.key).isSorted,
        label: u.label,
        resizable: t.isColumnResizable(u),
        "sort-index": e.getSortState(u.key).index,
        "sort-order": e.getSortState(u.key).order,
        style: Fe(e.getFixedStyles(u)),
        onSortClick: (c) => l(u),
        onResizeStart: s,
        onResizeDblclick: r
      }, ft({ _: 2 }, [
        i.$slots[`header-icon-${u.key}`] ? {
          name: "icon",
          fn: de((c) => [
            U(i.$slots, `header-icon-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "0"
        } : void 0,
        i.$slots[`header-${u.key}`] ? {
          name: "default",
          fn: de((c) => [
            U(i.$slots, `header-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))), 128))
    ]));
  }
}), RM = {
  key: 0,
  class: "v-table-loading-overlay"
}, VM = { class: "v-table-loading-spinner" }, FM = /* @__PURE__ */ Te({
  __name: "TableLoadingOverlay",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (b(), fe(vt, { name: "fade" }, {
      default: de(() => [
        e.loading ? (b(), M("div", RM, [
          t[0] || (t[0] = E("div", { class: "v-table-loading-backdrop" }, null, -1)),
          E("div", VM, [
            oe(p(Ur), {
              size: "large",
              variant: "primary"
            })
          ])
        ])) : P("", !0)
      ]),
      _: 1
    }));
  }
}), LM = { class: "v-table-pagination" }, NM = { class: "v-table-pagination-info" }, BM = { class: "v-table-pagination-info-highlight" }, zM = { class: "v-table-pagination-info-highlight" }, WM = { class: "v-table-pagination-controls" }, YM = ["disabled"], HM = ["disabled", "onClick"], UM = {
  key: 1,
  class: "v-table-pagination-ellipsis"
}, qM = ["disabled"], jM = {
  key: 0,
  class: "v-table-pagination-size"
}, GM = ["disabled", "value"], KM = ["value"], ZM = /* @__PURE__ */ Te({
  __name: "TablePagination",
  props: {
    page: {},
    pageSize: {},
    total: {},
    pageSizeOptions: { default: () => [10, 25, 50, 100] },
    showSizeChanger: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = C(() => Math.ceil(t.total / t.pageSize)), r = C(() => t.total === 0 ? 0 : Wa((t.page - 1) * t.pageSize + 1)), l = C(() => {
      const g = t.page * t.pageSize;
      return Wa(Math.min(g, t.total));
    }), i = C(() => {
      const g = [], y = s.value, k = t.page;
      if (y <= 7) {
        for (let m = 1; m <= y; m++)
          g.push(m);
        return g;
      }
      return g.push(1), k <= 3 ? (g.push(2, 3, 4), g.push("ellipsis"), g.push(y)) : k >= y - 2 ? (g.push("ellipsis"), g.push(y - 3, y - 2, y - 1, y)) : (g.push("ellipsis"), g.push(k - 1, k, k + 1), g.push("ellipsis"), g.push(y)), g;
    }), o = (g) => {
      t.loading || g !== t.page && (g < 1 || g > s.value || a("page-change", { page: g, pageSize: t.pageSize }));
    }, u = () => {
      t.page > 1 && o(t.page - 1);
    }, c = () => {
      t.page < s.value && o(t.page + 1);
    }, f = (g) => {
      t.loading || g !== t.pageSize && a("page-change", { page: 1, pageSize: g });
    }, h = C(() => t.loading || t.page <= 1), d = C(() => t.loading || t.page >= s.value);
    return (g, y) => (b(), M("div", LM, [
      E("div", NM, [
        y[1] || (y[1] = Ue(" Showing ", -1)),
        E("span", BM, ce(r.value) + "–" + ce(l.value), 1),
        y[2] || (y[2] = Ue(" of ", -1)),
        E("span", zM, ce(p(Wa)(e.total)), 1)
      ]),
      E("div", WM, [
        E("button", {
          disabled: h.value,
          "aria-label": "Previous page",
          class: "v-table-pagination-btn",
          onClick: u
        }, [
          oe(p(xe), {
            size: 18,
            icon: "lucide:chevron-left"
          })
        ], 8, YM),
        (b(!0), M(Se, null, Pe(i.value, (k, m) => (b(), M(Se, { key: m }, [
          k !== "ellipsis" ? (b(), M("button", {
            key: 0,
            class: ne([{ "v-table-pagination-btn--active": k === e.page }, "v-table-pagination-btn"]),
            disabled: e.loading,
            onClick: (v) => o(k)
          }, ce(k), 11, HM)) : (b(), M("span", UM, " ... "))
        ], 64))), 128)),
        E("button", {
          disabled: d.value,
          "aria-label": "Next page",
          class: "v-table-pagination-btn",
          onClick: c
        }, [
          oe(p(xe), {
            size: 18,
            icon: "lucide:chevron-right"
          })
        ], 8, qM)
      ]),
      e.showSizeChanger ? (b(), M("div", jM, [
        y[3] || (y[3] = E("label", { for: "pagination-size" }, "Rows:", -1)),
        E("select", {
          id: "pagination-size",
          disabled: e.loading,
          value: e.pageSize,
          onChange: y[0] || (y[0] = (k) => f(Number(k.target.value)))
        }, [
          (b(!0), M(Se, null, Pe(e.pageSizeOptions, (k) => (b(), M("option", {
            key: k,
            value: k
          }, ce(k), 9, KM))), 128))
        ], 40, GM)
      ])) : P("", !0)
    ]));
  }
}), XM = /* @__PURE__ */ Ge(ZM, [["__scopeId", "data-v-d308e929"]]), JM = { class: "v-toolbar v-toolbar--split" }, QM = { class: "v-toolbar-split-left" }, e$ = { key: 0 }, t$ = { class: "v-toolbar-title" }, n$ = {
  key: 0,
  class: "v-toolbar-subtitle"
}, a$ = {
  key: 0,
  class: "v-toolbar-search-split flex h-full items-center"
}, s$ = { class: "v-toolbar-split-right" }, r$ = /* @__PURE__ */ Te({
  __name: "TableToolbar",
  props: {
    config: { default: void 0 },
    search: { default: "" }
  },
  emits: ["update:search", "refresh", "reset-sort", "export"],
  setup(e, { emit: n }) {
    const t = Qn("tableSlots", {}), a = e, s = n, r = C({
      get: () => a.search,
      set: (m) => s("update:search", m)
    }), l = C(() => {
      var m;
      return (m = a.config) != null && m.search ? typeof a.config.search == "boolean" ? { placeholder: "Search..." } : a.config.search : null;
    }), i = C(() => {
      var v, w;
      const m = (w = (v = a.config) == null ? void 0 : v.actions) == null ? void 0 : w.export;
      return !m || !m ? null : typeof m == "object" ? {
        mode: m.mode,
        formats: m.formats || [],
        selectedOnly: m.selectedOnly ?? !1,
        loading: m.loading ?? !1
      } : {
        mode: m,
        formats: [],
        selectedOnly: !1,
        loading: !1
      };
    }), o = C(() => i.value !== null), u = C(() => {
      var m;
      return ((m = i.value) == null ? void 0 : m.loading) || !1;
    }), c = C(() => {
      var m;
      return ((m = i.value) == null ? void 0 : m.formats) || [];
    }), f = C(() => c.value.some((m) => m.loading)), h = C(() => {
      var m;
      return (m = i.value) == null ? void 0 : m.mode;
    }), d = () => {
      s("refresh");
    }, g = () => {
      s("reset-sort");
    }, y = (m) => {
      var v;
      s("export", String(m), (v = i.value) == null ? void 0 : v.selectedOnly);
    }, k = () => {
      var m;
      s("export", "csv", (m = i.value) == null ? void 0 : m.selectedOnly);
    };
    return (m, v) => {
      var w, S, x, $, T, _, A, D;
      return b(), M("div", JM, [
        E("div", QM, [
          p(t).toolbarTitle ? (b(), fe(ht(p(t).toolbarTitle), { key: 0 })) : U(m.$slots, "title", { key: 1 }, () => {
            var Y;
            return [
              (Y = e.config) != null && Y.title ? (b(), M("div", e$, [
                E("h3", t$, ce(e.config.title), 1),
                e.config.subtitle ? (b(), M("p", n$, ce(e.config.subtitle), 1)) : P("", !0)
              ])) : P("", !0)
            ];
          }),
          p(t).toolbarSearch ? (b(), fe(ht(p(t).toolbarSearch), { key: 2 })) : U(m.$slots, "search", { key: 3 }, () => [
            l.value ? (b(), M("div", a$, [
              v[1] || (v[1] = E("span", { class: "w-px h-5 bg-base-300 ml-[1px] mr-4" }, null, -1)),
              oe(p(Tr), {
                modelValue: r.value,
                "onUpdate:modelValue": v[0] || (v[0] = (Y) => r.value = Y),
                name: l.value.placeholder,
                placeholder: l.value.placeholder,
                class: "min-w-[300px]",
                debounce: "",
                type: "search"
              }, null, 8, ["modelValue", "name", "placeholder"])
            ])) : P("", !0)
          ]),
          p(t).toolbarFilters ? (b(), fe(ht(p(t).toolbarFilters), { key: 4 })) : U(m.$slots, "filters", { key: 5 })
        ]),
        E("div", s$, [
          p(t).toolbarActions ? (b(), fe(ht(p(t).toolbarActions), { key: 0 })) : U(m.$slots, "actions", { key: 1 }),
          (S = (w = e.config) == null ? void 0 : w.actions) != null && S.refresh ? (b(), fe(p(qt), {
            key: 2,
            icon: "lucide:refresh-cw",
            variant: "default",
            onClick: d
          })) : P("", !0),
          ($ = (x = e.config) == null ? void 0 : x.actions) != null && $.resetSort ? (b(), fe(p(qt), {
            key: 3,
            icon: "lucide:arrow-up-down",
            text: "Reset Sort",
            variant: "default",
            onClick: g
          })) : P("", !0),
          o.value && h.value === "single" ? (b(), fe(p(qt), {
            key: 4,
            disabled: u.value,
            loading: u.value,
            icon: "lucide:file-down",
            text: "Export",
            variant: "primary",
            onClick: k
          }, null, 8, ["disabled", "loading"])) : P("", !0),
          o.value && h.value === "multi" ? (b(), fe(p(Mr), {
            key: 5,
            items: c.value,
            placement: "bottom-right",
            onSelect: y
          }, {
            trigger: de(() => [
              oe(p(qt), {
                loading: f.value,
                icon: "lucide:file-down",
                text: "Export",
                variant: "primary"
              }, null, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["items"])) : P("", !0),
          p(t).toolbarColumnActions ? (b(), fe(ht(p(t).toolbarColumnActions), { key: 6 })) : P("", !0),
          (_ = (T = e.config) == null ? void 0 : T.actions) != null && _.columnSetup || (D = (A = e.config) == null ? void 0 : A.actions) != null && D.columnPicker ? U(m.$slots, "column-setup", { key: 7 }) : P("", !0)
        ])
      ]);
    };
  }
}), it = {
  SM: 640,
  // Tailwind sm
  MD: 768,
  // Tailwind md
  LG: 1024,
  // Tailwind lg
  XL: 1280,
  // Tailwind xl
  "2XL": 1536,
  // Tailwind 2xl
  "3XL": 1920,
  // custom 3xl
  ULTRA: 2560,
  // custom ultra
  "4K": 3440
  // custom 4k
}, Oi = typeof window < "u" ? window.innerWidth : 1920;
function Ud(e = Oi) {
  return e < it.SM || e < it.MD ? "sm" : e < it.LG ? "md" : e < it.XL ? "lg" : e < it["2XL"] ? "xl" : e < it["3XL"] ? "2xl" : e < it.ULTRA ? "3xl" : e < it["4K"] ? "ultra" : "4k";
}
function wl(e, n = Oi) {
  const t = Ud(n), a = ["4k", "ultra", "3xl", "2xl", "xl", "lg", "md", "sm"], s = a.indexOf(t);
  for (let r = s; r < a.length; r++) {
    const l = e[a[r]];
    if (l !== void 0) return l;
  }
  return e.default;
}
function hC(e, n = 1920, t, a, s = Oi) {
  const r = s / n;
  let l = Math.round(e * r);
  return t !== void 0 && (l = Math.max(l, t)), a !== void 0 && (l = Math.min(l, a)), l;
}
const sa = Ud(), _i = sa === "sm", Ei = sa === "md", qd = sa === "lg", jd = sa === "xl", Gd = sa === "2xl", Ii = sa === "3xl", jr = sa === "ultra", Gr = sa === "4k", l$ = _i || Ei, mC = _i || Ei || qd, i$ = jd || Gd || Ii || jr || Gr, o$ = Ii || jr || Gr, u$ = jr || Gr, vC = {
  sm: _i,
  md: Ei,
  lg: qd,
  xl: jd,
  "2xl": Gd,
  "3xl": Ii,
  ultra: jr,
  "4k": Gr,
  // Grouped checks
  isMobileOrTablet: l$,
  isDesktopOrLarger: i$,
  isLargeOrBigger: o$,
  isUltraOrBigger: u$
}, pC = {
  sm: `(max-width: ${it.SM - 1}px)`,
  md: `(min-width: ${it.SM}px) and (max-width: ${it.MD - 1}px)`,
  lg: `(min-width: ${it.MD}px) and (max-width: ${it.LG - 1}px)`,
  xl: `(min-width: ${it.LG}px) and (max-width: ${it.XL - 1}px)`,
  "2xl": `(min-width: ${it.XL}px) and (max-width: ${it["2XL"] - 1}px)`,
  "3xl": `(min-width: ${it["2XL"]}px) and (max-width: ${it["3XL"] - 1}px)`,
  ultra: `(min-width: ${it["3XL"]}px) and (max-width: ${it.ULTRA - 1}px)`,
  "4k": `(min-width: ${it.ULTRA}px)`,
  // Range queries (min-width)
  minMd: `(min-width: ${it.SM}px)`,
  minLg: `(min-width: ${it.MD}px)`,
  minXl: `(min-width: ${it.LG}px)`,
  min2Xl: `(min-width: ${it.XL}px)`,
  min3Xl: `(min-width: ${it["2XL"]}px)`,
  minUltra: `(min-width: ${it["3XL"]}px)`,
  min4K: `(min-width: ${it.ULTRA}px)`
}, Kd = {
  MIN_COLUMN_WIDTH: wl({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 110,
    ultra: 120,
    default: 100
  }),
  DEFAULT_MIN_WIDTH: wl({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 120,
    ultra: 190,
    default: 100
  }),
  DEFAULT_COLUMN_WIDTH: wl({
    sm: 100,
    md: 120,
    lg: 140,
    xl: 150,
    "3xl": 180,
    ultra: 270,
    default: 150
  })
}, {
  MIN_COLUMN_WIDTH: c$,
  DEFAULT_MIN_WIDTH: lu,
  DEFAULT_COLUMN_WIDTH: hs
} = Kd;
function d$(e) {
  const n = te(/* @__PURE__ */ new Map()), t = te({
    isResizing: !1,
    columnKey: null,
    startX: 0,
    startWidth: 0
  });
  let a = null, s = null, r = 0;
  const l = (m) => m.width !== "flex", i = (m) => {
    const v = n.value.get(m.key);
    return v !== void 0 ? `${v}px` : m.width === "flex" ? `minmax(${lu}px, 1fr)` : m.width ? m.width : `${hs}px`;
  }, o = C(() => e.value.map((m) => i(m)).join(" ")), u = (m = 50) => `${m}px ${o.value}`, c = (m, v) => {
    v.preventDefault(), v.stopPropagation();
    const w = e.value.find(($) => $.key === m);
    if (!w || !l(w))
      return;
    let S;
    const x = n.value.get(m);
    if (x !== void 0)
      S = x;
    else if (w.width && w.width !== "flex" && w.width.endsWith("px"))
      S = parseInt(w.width, 10);
    else if (!w.width)
      S = hs;
    else {
      const $ = v.target.closest('[role="columnheader"]');
      S = $ ? $.offsetWidth : hs;
    }
    t.value = {
      isResizing: !0,
      columnKey: m,
      startX: v.clientX,
      startWidth: S
    }, document.addEventListener("mousemove", h), document.addEventListener("mouseup", d), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }, f = () => {
    if (a = null, s === null) return;
    const m = new Map(n.value);
    m.set(s, r), n.value = m;
  }, h = (m) => {
    if (!t.value.isResizing || !t.value.columnKey)
      return;
    const v = m.clientX - t.value.startX, w = Math.max(
      c$,
      t.value.startWidth + v
    );
    s = t.value.columnKey, r = w, a === null && (a = requestAnimationFrame(f));
  }, d = () => {
    a !== null && (cancelAnimationFrame(a), a = null), f(), s = null, t.value = {
      isResizing: !1,
      columnKey: null,
      startX: 0,
      startWidth: 0
    }, document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", d), document.body.style.cursor = "", document.body.style.userSelect = "";
  }, g = (m) => {
    const v = new Map(n.value);
    v.delete(m), n.value = v;
  }, y = () => {
    n.value = /* @__PURE__ */ new Map();
  }, k = (m) => {
    const v = n.value.get(m);
    if (v !== void 0)
      return v;
    const w = e.value.find((S) => S.key === m);
    return w ? w.width === "flex" ? `minmax(${lu}px, 1fr)` : w.width ? w.width : hs : hs;
  };
  return {
    gridTemplateColumns: o,
    getGridTemplateWithCheckbox: u,
    resizedWidths: n,
    isResizing: C(() => t.value.isResizing),
    isColumnResizable: l,
    startResize: c,
    autoFitColumn: g,
    getColumnWidth: k,
    resetWidths: y
  };
}
function f$(e) {
  const n = te(/* @__PURE__ */ new Set());
  return {
    flattenedData: C(() => {
      const i = [], o = (u, c = 0, f) => {
        u.forEach((h) => {
          var y, k;
          const d = !!((y = h.children) != null && y.length || h.expandable && h.expandedContent), g = n.value.has(h.id);
          i.push({
            ...h,
            depth: c,
            parentId: f,
            hasChildren: d,
            isExpanded: g
          }), g && ((k = h.children) != null && k.length) && o(h.children, c + 1, h.id);
        });
      };
      return o(e.value), i;
    }),
    // For passing to virtualizer
    expandedRows: n,
    // For UI indicators
    toggleRow: (i) => {
      n.value.has(i) ? n.value.delete(i) : n.value.add(i), n.value = new Set(n.value);
    },
    // For click handlers
    expandAll: () => {
      const i = (o) => {
        const u = [];
        return o.forEach((c) => {
          var f;
          ((f = c.children) != null && f.length || c.expandable) && (u.push(c.id), c.children && u.push(...i(c.children)));
        }), u;
      };
      n.value = new Set(i(e.value));
    },
    collapseAll: () => {
      n.value.clear(), n.value = /* @__PURE__ */ new Set();
    },
    isExpandable: (i) => {
      var o;
      return !!((o = i.children) != null && o.length || i.expandable);
    }
  };
}
const { DEFAULT_COLUMN_WIDTH: Oa } = Kd;
function h$(e, n) {
  const t = C(
    () => e.value.filter((y) => y.fixed === "left")
  ), a = C(
    () => e.value.filter((y) => y.fixed === "right")
  ), s = C(
    () => e.value.filter((y) => !y.fixed)
  ), r = C(() => {
    const y = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map();
    let m = 0;
    for (const v of e.value)
      if (v.fixed === "left") {
        k.set(v.key, m);
        let w = Oa;
        if (y) {
          const S = y.get(v.key);
          S !== void 0 ? w = S : w = rr(v.width) || Oa;
        } else
          w = rr(v.width) || Oa;
        m += w;
      }
    return k;
  }), l = C(() => {
    const y = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map(), m = e.value.filter((w) => w.fixed === "right");
    let v = 0;
    for (let w = m.length - 1; w >= 0; w--) {
      const S = m[w];
      k.set(S.key, v);
      let x = Oa;
      if (y) {
        const $ = y.get(S.key);
        $ !== void 0 ? x = $ : x = rr(S.width) || Oa;
      } else
        x = rr(S.width) || Oa;
      v += x;
    }
    return k;
  }), i = (y, k) => {
    if (k.fixed === "left") {
      const v = e.value.findIndex((S) => S.key === y);
      let w = 0;
      for (let S = 0; S < v; S++)
        e.value[S].fixed === "left" && w++;
      return 50 + (t.value.length - w);
    }
    if (k.fixed === "right") {
      const v = e.value.findIndex((S) => S.key === y);
      let w = 0;
      for (let S = v + 1; S < e.value.length; S++)
        e.value[S].fixed === "right" && w++;
      return 50 + w + 1;
    }
    return 1;
  }, o = C(() => {
    const y = /* @__PURE__ */ new Map();
    return e.value.forEach((k) => {
      if (!k.fixed) {
        y.set(k.key, {});
        return;
      }
      const m = {
        // position: sticky added through CSS classes!
        // zIndex also controlled through CSS for proper hierarchy
      };
      if (k.fixed === "left") {
        const v = r.value.get(k.key) || 0;
        m.left = `${v}px`;
      } else if (k.fixed === "right") {
        const v = l.value.get(k.key) || 0;
        m.right = `${v}px`;
      }
      y.set(k.key, m);
    }), y;
  }), u = (y) => o.value.get(y.key) || {}, c = (y) => !!y.fixed, f = C(() => {
    let y = null;
    for (const k of e.value)
      k.fixed === "left" && (y = k.key);
    return y;
  }), h = C(() => {
    for (const y of e.value)
      if (y.fixed === "right")
        return y.key;
    return null;
  });
  return {
    leftFixedColumns: t,
    rightFixedColumns: a,
    normalColumns: s,
    getFixedStyles: u,
    isFixed: c,
    isLastLeftFixed: (y) => f.value === y,
    isFirstRightFixed: (y) => h.value === y,
    getZIndex: i
  };
}
function rr(e) {
  return e && e.endsWith("px") ? Number.parseInt(e, 10) : null;
}
function m$(e, n) {
  const a = C(() => ((g) => g.some((y) => !!(y.children && y.children.length > 0)))(e.value)), s = (d, g = 1) => {
    let y = g;
    return d.forEach((k) => {
      if (k.children && k.children.length > 0) {
        const m = s(k.children, g + 1);
        y = Math.max(y, m);
      }
    }), y;
  }, r = C(() => {
    const d = [], g = (y) => {
      y.forEach((k) => {
        k.children && k.children.length > 0 ? g(k.children) : d.push(k);
      });
    };
    return g(e.value), d;
  }), l = (d) => !d.children || d.children.length === 0 ? 1 : d.children.reduce((g, y) => g + l(y), 0), i = (d) => d && d.endsWith("px") ? parseInt(d, 10) : 150, o = (d) => {
    const g = n.value.get(d.key);
    return g !== void 0 ? g : i(d.width);
  }, u = (d) => !d.children || d.children.length === 0 ? o(d) : d.children.reduce((g, y) => g + u(y), 0), c = (d, g, y = 0, k = 1) => {
    const m = [];
    return d.forEach((v) => {
      if (!!(v.children && v.children.length > 0))
        y === g && m.push({
          key: v.key,
          label: v.label,
          column: v,
          colspan: l(v),
          rowspan: 1,
          isGroup: !0,
          level: y
        }), y < g && m.push(...c(v.children, g, y + 1, k));
      else if (y === g) {
        const S = y === 0;
        m.push({
          key: v.key,
          label: v.label,
          column: v,
          colspan: 1,
          rowspan: S ? k : 1,
          // Root level spans all, others just 1
          isGroup: !1,
          level: y
        });
      }
    }), m;
  }, f = C(() => {
    if (!a.value)
      return [
        e.value.map((y) => ({
          key: y.key,
          label: y.label,
          column: y,
          colspan: 1,
          rowspan: 1,
          isGroup: !1,
          level: 0
        }))
      ];
    const d = s(e.value), g = [];
    for (let y = 0; y < d; y++)
      g.push(c(e.value, y, 0, d));
    return g;
  });
  return {
    hasGroups: a,
    // Boolean - do we have grouped headers?
    flatColumns: r,
    // Flat list of leaf columns for data rows
    headerLevels: f,
    // Array of header rows (one per level)
    getGroupWidth: u,
    // Calculate width of group dynamically
    getColspan: l,
    // Get colspan for any column
    isGroupFixed: (d) => {
      if (!d.children || d.children.length === 0)
        return d.fixed || null;
      const g = (v) => !v.children || v.children.length === 0 ? [v.fixed] : v.children.flatMap((w) => g(w)), y = g(d), k = y.every((v) => v === "left"), m = y.every((v) => v === "right");
      return k ? "left" : m ? "right" : null;
    }
    // Check if group should be sticky
  };
}
const v$ = (e, n, t) => {
  if (!n.format)
    return e;
  const a = n.format;
  if (a.formatter)
    return a.formatter(e, t);
  if (a.currency !== void 0 && a.currency !== !1) {
    const s = a.currency === !0 ? "USD" : a.currency;
    return Ss(e, s);
  }
  return a.percentage !== void 0 ? $i(e, a.percentage) : a.number ? Wa(e, a.number) : a.date ? Id(e, a.date) : a.boolean ? Ed(e, a.boolean) : a.fileSize !== void 0 ? Pd(e, a.fileSize) : e;
}, p$ = () => ({
  formatCellValue: v$,
  // Export individual formatters for custom use
  formatCurrency: Ss,
  formatPercentage: $i,
  formatNumber: Wa,
  formatDate: Id,
  formatBoolean: Ed,
  formatFileSize: Pd
}), g$ = (e) => {
  const { isExpandable: n, isRowExpandable: t } = e, { formatCellValue: a } = p$(), s = (o, u, c) => {
    if (!u.format)
      return o;
    const f = a(o, u, c);
    return f && typeof f == "object" && !Array.isArray(f) && "text" in f && typeof f.text < "u" ? f.text : f;
  }, r = (o, u, c) => {
    if (!u.format)
      return;
    const f = a(o, u, c);
    if (f && typeof f == "object" && !Array.isArray(f) && "class" in f && typeof f.class == "string")
      return f.class;
  }, l = /* @__PURE__ */ new WeakMap();
  return { getCellValue: s, getCellClass: r, getCellMetadata: (o, u, c, f) => {
    let h = l.get(o);
    h || (h = /* @__PURE__ */ new WeakMap(), l.set(o, h));
    const d = h.get(u);
    if (d) return d;
    const g = u.format ? a(o[u.key], u, o) : o[u.key];
    let y = g, k;
    if (g && typeof g == "object" && !Array.isArray(g) && "text" in g && (y = g.text, k = g.class), u.cellClass) {
      const $ = u.cellClass({ value: o[u.key], row: o, rowIndex: f });
      $ && (k = k ? `${k} ${$}` : $);
    }
    const m = u.cellStyle ? u.cellStyle({ value: o[u.key], row: o, rowIndex: f }) : void 0, v = o.depth || 0, w = c === 0 && v ? { paddingLeft: `${v * 24 + 16}px` } : null, S = c === 0 && tt(n) ? t(o) : !1, x = {
      formattedValue: y,
      cssClass: k,
      indentStyle: w,
      customStyle: m,
      isExpandable: S
    };
    return h.set(u, x), x;
  } };
}, y$ = (e) => {
  const n = C(() => tt(e.columns)), t = C(() => {
    const k = tt(e.columnSetup);
    return typeof k == "string" || typeof k == "object";
  }), a = C(() => {
    const k = tt(e.columnSetup);
    return typeof k == "string" ? {
      key: k,
      type: "indexedDB",
      allowReorder: !0
    } : typeof k == "object" ? {
      ...k,
      type: k.type || "indexedDB"
      // Default to indexedDB
    } : {};
  }), s = (k, m, v) => {
    const w = (_) => _.flatMap((A) => A.children && A.children.length ? w(A.children) : [A]), S = new Map(w(n.value).map((_) => [_.key, _])), x = [], $ = k.fixed, T = (_) => {
      var L;
      if (!k.visible.includes(_)) return;
      const A = S.get(_);
      if (A) {
        x.push({ ...A, fixed: ($ == null ? void 0 : $[_]) || A.fixed });
        return;
      }
      const D = m == null ? void 0 : m.get(_);
      if (D) {
        x.push({
          key: D.key,
          label: D.label,
          fixed: $ == null ? void 0 : $[_],
          sortable: D.sortable ?? v
        });
        return;
      }
      const Y = (L = k.labels) == null ? void 0 : L[_];
      Y && x.push({
        key: _,
        label: Y,
        fixed: $ == null ? void 0 : $[_],
        sortable: v
      });
    };
    return k.order.forEach(T), !x.length && k.visible.length && k.visible.forEach(T), x.length ? x : null;
  }, r = async () => {
    const k = t.value, m = tt(e.columnPicker), v = !!m && typeof m == "object";
    if (!k && !v) return null;
    if (k) {
      const w = a.value;
      if (w.key)
        try {
          const x = await $r(w.key, w.type);
          if (x) return s(x);
        } catch (x) {
          console.warn("[VTable] Failed to load stored column setup", x);
        }
      const S = Array.isArray(w.initialVisible) ? w.initialVisible : null;
      if (S) {
        const x = n.value.filter(($) => S.includes($.key));
        return S.length === 0 ? [] : x.length ? x : null;
      }
    }
    if (v && typeof m == "object") {
      const w = m.key, S = m.type;
      if (w)
        try {
          const x = await $r(w, S);
          if (x) {
            const $ = /* @__PURE__ */ new Map();
            return m.groups.forEach((T) => T.items.forEach((_) => $.set(_.key, _))), s(x, $, m.defaultSortable);
          }
        } catch (x) {
          console.warn("[VTable] Failed to load stored column picker state", x);
        }
    }
    return null;
  }, l = te(null), i = te(null), o = te(null);
  r().then((k) => {
    k !== null && (l.value = k);
  });
  const u = (k) => {
    l.value = [...k];
  }, c = () => {
    var k;
    (k = i.value) == null || k.close();
  }, f = () => {
    var k;
    (k = o.value) == null || k.close();
  }, h = C(() => {
    const k = tt(e.columnPicker);
    return !!k && typeof k == "object";
  }), d = C(() => {
    const k = tt(e.columnPicker);
    return !k || typeof k != "object" ? null : k;
  }), g = (k) => {
    const m = k.filter((S) => S.fixed === "left"), v = k.filter((S) => !S.fixed), w = k.filter((S) => S.fixed === "right");
    return !m.length && !w.length ? k : [...m, ...v, ...w];
  }, y = C(() => !t.value && !h.value ? g(n.value) : g(l.value ?? n.value));
  return {
    columnSetupEnabledBasic: t,
    columnSetupConfig: a,
    columnSetupPopoverRef: i,
    columnPickerPopoverRef: o,
    handleVisibleColumnsUpdate: u,
    handleColumnSetupClose: c,
    handleColumnPickerClose: f,
    columnPickerEnabled: h,
    columnPickerConfig: d,
    effectiveColumns: y
  };
}, iu = { duration: 200, easing: "cubic-bezier(0, 0, 0.2, 1)" }, ou = { duration: 160, easing: "cubic-bezier(0.4, 0, 1, 1)" }, lr = 0, kl = () => {
  const { innerWidth: e, innerHeight: n } = window;
  return {
    top: n * lr,
    left: e * lr,
    width: e * (1 - 2 * lr),
    height: n * (1 - 2 * lr)
  };
}, uu = (e) => e instanceof HTMLElement ? e : void 0, b$ = (e) => {
  var t;
  const n = uu(e);
  return n ? n.offsetHeight : ((t = uu(e == null ? void 0 : e.$el)) == null ? void 0 : t.offsetHeight) ?? 0;
}, cu = "v-table-fullscreen", ms = te(!1);
let xl = null;
const du = (e, n, t) => {
  const a = n.width / t.width, s = n.height / t.height, r = n.left - t.left, l = n.top - t.top;
  e.style.transformOrigin = "top left", e.style.transform = `translate(${r}px, ${l}px) scale(${a}, ${s})`;
}, w$ = (e) => {
  const { wrapperRef: n, placeholderRef: t } = e, a = te(!1), s = te(null), r = te(null), l = te(0);
  let i = null, o = null, u = 0, c = !1;
  const { zIndex: f, open: h, close: d } = Di(cu, !1), g = Fd(), y = () => {
    l.value = (e.chromeRefs ?? []).reduce((D, Y) => D + b$(Y.value), 0);
  }, k = async () => {
    const D = n.value;
    if (!D) return;
    const Y = ++u, L = D.getBoundingClientRect();
    s.value = L, r.value = kl(), y();
    const X = window.scrollX, se = window.scrollY;
    if (a.value = !0, await Xe(), Y !== u) return;
    (window.scrollX !== X || window.scrollY !== se) && window.scrollTo({ left: X, top: se, behavior: "instant" }), D.style.transition = "none";
    const ie = D.getBoundingClientRect();
    du(D, L, ie), D.offsetHeight, D.style.transition = `transform ${iu.duration}ms ${iu.easing}`, D.style.transform = "translate(0, 0) scale(1, 1)";
    const ue = (G) => {
      G.target !== D || G.propertyName !== "transform" || (D.removeEventListener("transitionend", ue), o = null, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    o = { el: D, handler: ue }, D.addEventListener("transitionend", ue);
  }, m = async () => {
    var G;
    const D = n.value;
    if (!D) return;
    const Y = ++u, L = window.scrollX, X = window.scrollY;
    if (await Xe(), Y !== u) return;
    (window.scrollX !== L || window.scrollY !== X) && window.scrollTo({ left: L, top: X, behavior: "instant" }), o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null);
    const se = D.getBoundingClientRect(), ie = ((G = t == null ? void 0 : t.value) == null ? void 0 : G.getBoundingClientRect()) ?? s.value ?? se;
    D.style.transition = `transform ${ou.duration}ms ${ou.easing}`, du(D, ie, se);
    const ue = (q) => {
      q.target !== D || q.propertyName !== "transform" || (D.removeEventListener("transitionend", ue), i = null, a.value = !1, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    i = { el: D, handler: ue }, D.addEventListener("transitionend", ue);
  }, v = () => {
    a.value ? m() : k();
  }, w = () => {
    a.value && m();
  };
  He(a, (D) => {
    D ? h() : c || d();
  });
  const S = (D) => {
    D.key !== "Escape" || !a.value || Math.max(
      0,
      ...g.openModals.value.filter((L) => L.id !== cu).map((L) => L.zIndex)
    ) > f.value || v();
  };
  He(a, (D) => {
    D ? window.addEventListener("keydown", S) : window.removeEventListener("keydown", S);
  });
  const x = () => {
    a.value && (r.value = kl(), y());
  };
  He(a, (D) => {
    D ? window.addEventListener("resize", x) : window.removeEventListener("resize", x);
  }), He(a, async (D) => {
    var Y;
    await Xe(), await ((Y = e.onToggle) == null ? void 0 : Y.call(e, D));
  });
  const $ = () => {
    y(), s.value = xl, r.value = kl(), a.value = !0;
  };
  wu(() => {
    a.value && (c = !0, r.value = null, a.value = !1, u += 1, o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null), ms.value = !0, xl = s.value, Xe().then(() => {
      c = !1, ms.value && (ms.value = !1, xl = null, d());
    }));
  }), ku(() => {
    ms.value && tt(e.isEnabled) && (ms.value = !1, $());
  }), sn(() => {
    a.value && d(), window.removeEventListener("keydown", S), window.removeEventListener("resize", x), i && (i.el.removeEventListener("transitionend", i.handler), i = null), o && (o.el.removeEventListener("transitionend", o.handler), o = null);
  });
  const T = C(() => !a.value || !s.value ? null : {
    width: `${s.value.width}px`,
    height: `${s.value.height}px`
  }), _ = C(() => {
    if (!a.value || !r.value) return null;
    const { top: D, left: Y, width: L, height: X } = r.value;
    return {
      top: `${D}px`,
      left: `${Y}px`,
      width: `${L}px`,
      height: `${X}px`
    };
  }), A = C(() => !a.value || !r.value ? 0 : r.value.height - l.value);
  return {
    isFullscreen: Xl(a),
    isEnabled: C(() => tt(e.isEnabled)),
    zIndex: f,
    placeholderStyle: T,
    panelStyle: _,
    contentHeight: A,
    toggle: v,
    close: w
  };
}, k$ = (e) => e ? e === !0 ? { enabled: !0, row: !0, column: !0 } : {
  enabled: !0,
  row: e.row ?? !0,
  column: e.column ?? !0
} : { enabled: !1, row: !1, column: !1 }, x$ = (e) => {
  const n = te(null), t = te(null), a = () => tt(e.config), s = C(() => n.value !== null || t.value !== null), r = (y) => n.value === null ? !1 : y !== void 0 && n.value === y, l = (y) => t.value === null ? !1 : t.value === y, i = () => {
    var y;
    (y = e.onChange) == null || y.call(e, {
      rowId: n.value,
      columnKey: t.value
    });
  };
  return {
    pinnedRowId: n,
    pinnedColumnKey: t,
    hasPin: s,
    isRowPinned: r,
    isColumnPinned: l,
    toggleRow: (y) => {
      const { enabled: k, row: m } = a();
      !k || !m || (n.value = n.value === y ? null : y, i());
    },
    toggleColumn: (y) => {
      const { enabled: k, column: m } = a();
      !k || !m || (t.value = t.value === y ? null : y, i());
    },
    unpinRow: () => {
      n.value !== null && (n.value = null, i());
    },
    unpinColumn: () => {
      t.value !== null && (t.value = null, i());
    },
    clear: () => {
      s.value && (n.value = null, t.value = null, i());
    },
    applyRemote: (y) => {
      const { enabled: k, row: m, column: v } = a();
      k && (n.value = m ? y.rowId : null, t.value = v ? y.columnKey : null);
    },
    setPin: (y) => {
      const { enabled: k, row: m, column: v } = a();
      k && (n.value = m ? y.rowId : null, t.value = v ? y.columnKey : null, i());
    }
  };
}, Zd = Symbol("tablePageKey");
function gC(e = []) {
  const n = te(1);
  return e.length && He(e, () => {
    n.value === 1 ? Tl(n) : n.value = 1;
  }, { flush: "pre", deep: !0 }), Va(Zd, n), n;
}
function S$(e) {
  const { config: n, flattenedData: t, selectedRows: a, onSelectionChange: s } = e, r = te(/* @__PURE__ */ new Set()), l = (x) => x.id;
  He(
    a,
    (x) => {
      r.value = new Set(x.map(($) => l($)));
    },
    { immediate: !0 }
  );
  const i = C(() => {
    var x;
    return ((x = n.value) == null ? void 0 : x.enabled) ?? !1;
  }), o = C(
    () => {
      var x;
      return ((x = n.value) == null ? void 0 : x.selectionMode) === "dependent";
    }
  ), u = (x) => r.value.has(x), c = (x) => {
    var $;
    return ($ = n.value) != null && $.isRowSelectable ? n.value.isRowSelectable(x) : !0;
  }, f = (x) => {
    if (!x.children || x.children.length === 0) return [];
    const $ = [], T = (_) => {
      _.forEach((A) => {
        $.push(l(A)), A.children && T(A.children);
      });
    };
    return T(x.children), $;
  }, h = (x) => {
    if (!x.children || x.children.length === 0) return [];
    const $ = [], T = t.value.filter((D) => D.isExpanded), _ = new Set(T.map((D) => l(D))), A = (D, Y) => {
      D.forEach((L) => {
        if (Y) {
          $.push(l(L));
          const X = _.has(l(L));
          L.children && A(L.children, X);
        }
      });
    };
    return A(x.children, !0), $;
  }, d = (x) => t.value.find(
    ($) => {
      var T;
      return (T = $.children) == null ? void 0 : T.some((_) => _.id === x);
    }
  ), g = (x) => {
    var _;
    if (!x.children || x.children.length === 0)
      return u(l(x)) ? "checked" : "unchecked";
    const $ = (_ = n.value) != null && _.selectOnlyVisible ? h(x) : f(x);
    if ($.length === 0)
      return u(l(x)) ? "checked" : "unchecked";
    const T = $.filter(
      (A) => r.value.has(A)
    ).length;
    return T === 0 && !u(l(x)) ? "unchecked" : T === $.length && u(l(x)) ? "checked" : "indeterminate";
  }, y = (x) => {
    var A, D, Y, L, X, se;
    if (!i.value || !c(x)) return;
    const $ = l(x), T = u($), _ = new Set(r.value);
    if (T ? (_.delete($), o.value && ((A = n.value) != null && A.selectChildren) && ((D = n.value) != null && D.selectOnlyVisible ? h(x) : f(x)).forEach((ue) => _.delete(ue))) : (_.add($), o.value && ((Y = n.value) != null && Y.selectChildren) && ((L = n.value) != null && L.selectOnlyVisible ? h(x) : f(x)).forEach((ue) => _.add(ue))), o.value && ((X = n.value) != null && X.selectParent)) {
      const ie = d($);
      ie && ((((se = ie.children) == null ? void 0 : se.map((q) => l(q))) || []).every(
        (q) => _.has(q)
      ) ? _.add(l(ie)) : _.delete(l(ie)));
    }
    r.value = _, v();
  }, k = () => {
    const x = t.value.filter(
      (T) => c(T)
    );
    if (x.length === 0) return "unchecked";
    const $ = x.filter(
      (T) => u(l(T))
    ).length;
    return $ === 0 ? "unchecked" : $ === x.length ? "checked" : "indeterminate";
  }, m = () => {
    if (!i.value) return;
    const x = k(), $ = new Set(r.value), T = t.value.filter(
      (_) => c(_)
    );
    x === "checked" ? T.forEach((_) => {
      $.delete(l(_));
    }) : T.forEach((_) => {
      $.add(l(_));
    }), r.value = $, v();
  }, v = () => {
    const x = (_, A) => {
      for (const D of A) {
        if (D.id === _) return D;
        if (D.children) {
          const Y = x(_, D.children);
          if (Y) return Y;
        }
      }
    }, $ = t.value.map((_) => {
      const { depth: A, parentId: D, hasChildren: Y, isExpanded: L, ...X } = _;
      return X;
    }), T = Array.from(r.value).map((_) => x(_, $)).filter((_) => _ !== void 0);
    s(T);
  };
  return {
    // State
    isEnabled: i,
    isDependentMode: o,
    selectedIds: r,
    // Methods
    isRowSelected: u,
    isRowSelectable: c,
    toggleRow: y,
    toggleAllRows: m,
    getParentCheckboxState: g,
    getHeaderCheckboxState: k,
    clearSelection: () => {
      r.value = /* @__PURE__ */ new Set(), v();
    },
    selectRows: (x) => {
      r.value = new Set(x), v();
    }
  };
}
const T$ = (e) => {
  const {
    sort: n = {},
    sortState: t,
    columns: a,
    page: s,
    pageSize: r,
    data: l,
    onRequest: i,
    onSort: o,
    onUpdateSortState: u
  } = e, c = C(() => ({
    type: n.type || "server",
    multiple: n.multiple !== void 0 ? n.multiple : !0
  })), f = te((t == null ? void 0 : t.value) || []);
  t && He(t, (x) => {
    f.value = x || [];
  });
  const h = (x, $) => {
    const T = a.value.find((D) => D.key === $);
    if (T != null && T.sortValue)
      return T.sortValue(x, $);
    const _ = $.split(".");
    let A = x;
    for (const D of _) {
      if (A == null) return null;
      A = A[D];
    }
    return A;
  }, d = (x, $, T) => {
    if (x == null && $ == null) return 0;
    if (x == null) return 1;
    if ($ == null) return -1;
    const _ = typeof x == "string" ? parseFloat(x) : x, A = typeof $ == "string" ? parseFloat($) : $;
    if (typeof _ == "number" && typeof A == "number" && !Number.isNaN(_) && !Number.isNaN(A))
      return T === "asc" ? _ - A : A - _;
    const D = String(x).toLowerCase(), Y = String($).toLowerCase();
    return T === "asc" ? D.localeCompare(Y, void 0, { numeric: !0 }) : Y.localeCompare(D, void 0, { numeric: !0 });
  }, g = (x, $) => $.length === 0 ? [...x] : [...x].sort((T, _) => {
    for (const A of $) {
      const D = h(T, A.field), Y = h(_, A.field), L = d(D, Y, A.order);
      if (L !== 0)
        return L;
    }
    return 0;
  }), y = C(() => c.value.type !== "front" || !l ? (l == null ? void 0 : l.value) || [] : g(l.value, f.value)), k = (x) => {
    const $ = f.value.find((T) => T.field === x);
    return {
      isSorted: !!$,
      order: ($ == null ? void 0 : $.order) || null,
      index: $ ? f.value.indexOf($) : -1
      // For multi-sort indicator
    };
  }, m = (x) => x ? x === "asc" ? "desc" : null : "asc", v = (x) => {
    if (!x.sortable) return;
    const $ = x.key, T = k($), _ = m(T.order);
    let A;
    if (c.value.multiple ? _ === null ? A = f.value.filter((D) => D.field !== $) : T.isSorted ? A = f.value.map(
      (D) => D.field === $ ? { field: $, order: _ } : D
    ) : A = [...f.value, { field: $, order: _ }] : _ === null ? A = [] : A = [{ field: $, order: _ }], f.value = A, u == null || u(A), c.value.type === "front") {
      if (A.length > 0) {
        const D = A.find((Y) => Y.field === $);
        D && (o == null || o({
          field: $,
          order: D.order,
          sortState: A
        }));
      }
    } else {
      const D = {
        // page: page?.value ?? 1,
        page: 1,
        pageSize: (r == null ? void 0 : r.value) ?? 10,
        sort: A
      };
      i == null || i(D);
    }
  }, w = C(() => f.value.length > 0);
  return {
    sortState: f,
    sortConfig: c,
    getSortState: k,
    handleSortClick: v,
    hasSortedColumns: w,
    resetSort: () => {
      if (f.value = [], u == null || u([]), c.value.type === "server") {
        const x = {
          page: (s == null ? void 0 : s.value) ?? 1,
          pageSize: (r == null ? void 0 : r.value) ?? 10,
          sort: []
        };
        i == null || i(x);
      }
    },
    // Frontend sorting
    sortedData: y
    // Reactive sorted data for frontend sorting
  };
};
function _a(e, n, t) {
  let a = t.initialDeps ?? [], s, r = !0;
  function l() {
    var i, o, u;
    let c;
    t.key && ((i = t.debug) != null && i.call(t)) && (c = Date.now());
    const f = e();
    if (!(f.length !== a.length || f.some((g, y) => a[y] !== g)))
      return s;
    a = f;
    let d;
    if (t.key && ((o = t.debug) != null && o.call(t)) && (d = Date.now()), s = n(...f), t.key && ((u = t.debug) != null && u.call(t))) {
      const g = Math.round((Date.now() - c) * 100) / 100, y = Math.round((Date.now() - d) * 100) / 100, k = y / 16, m = (v, w) => {
        for (v = String(v); v.length < w; )
          v = " " + v;
        return v;
      };
      console.info(
        `%c⏱ ${m(y, 5)} /${m(g, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * k, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(r && t.skipInitialOnChange) && t.onChange(s), r = !1, s;
  }
  return l.updateDeps = (i) => {
    a = i;
  }, l;
}
function fu(e, n) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const M$ = (e, n) => Math.abs(e - n) < 1.01, $$ = (e, n, t) => {
  let a;
  return function(...s) {
    e.clearTimeout(a), a = e.setTimeout(() => n.apply(this, s), t);
  };
}, hu = (e) => {
  const { offsetWidth: n, offsetHeight: t } = e;
  return { width: n, height: t };
}, C$ = (e) => e, D$ = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let s = n; s <= t; s++)
    a.push(s);
  return a;
}, O$ = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  const s = (l) => {
    const { width: i, height: o } = l;
    n({ width: Math.round(i), height: Math.round(o) });
  };
  if (s(hu(t)), !a.ResizeObserver)
    return () => {
    };
  const r = new a.ResizeObserver((l) => {
    const i = () => {
      const o = l[0];
      if (o != null && o.borderBoxSize) {
        const u = o.borderBoxSize[0];
        if (u) {
          s({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      s(hu(t));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(i) : i();
  });
  return r.observe(t, { box: "border-box" }), () => {
    r.unobserve(t);
  };
}, mu = {
  passive: !0
}, vu = typeof window > "u" ? !0 : "onscrollend" in window, _$ = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  let s = 0;
  const r = e.options.useScrollendEvent && vu ? () => {
  } : $$(
    a,
    () => {
      n(s, !1);
    },
    e.options.isScrollingResetDelay
  ), l = (c) => () => {
    const { horizontal: f, isRtl: h } = e.options;
    s = f ? t.scrollLeft * (h && -1 || 1) : t.scrollTop, r(), n(s, c);
  }, i = l(!0), o = l(!1);
  t.addEventListener("scroll", i, mu);
  const u = e.options.useScrollendEvent && vu;
  return u && t.addEventListener("scrollend", o, mu), () => {
    t.removeEventListener("scroll", i), u && t.removeEventListener("scrollend", o);
  };
}, E$ = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const a = n.borderBoxSize[0];
    if (a)
      return Math.round(
        a[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, I$ = (e, {
  adjustments: n = 0,
  behavior: t
}, a) => {
  var s, r;
  const l = e + n;
  (r = (s = a.scrollElement) == null ? void 0 : s.scrollTo) == null || r.call(s, {
    [a.options.horizontal ? "left" : "top"]: l,
    behavior: t
  });
};
class P$ {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.currentScrollToIndex = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const a = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((r) => {
          const l = () => {
            this._measureElement(r.target, r);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(l) : l();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = a()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var r;
          return (r = a()) == null ? void 0 : r.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var r;
          return (r = a()) == null ? void 0 : r.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([a, s]) => {
        typeof s > "u" && delete t[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: C$,
        rangeExtractor: D$,
        onChange: () => {
        },
        measureElement: E$,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var a, s;
      (s = (a = this.options).onChange) == null || s.call(a, this, t);
    }, this.maybeNotify = _a(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const a = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== a) {
        if (this.cleanup(), !a) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = a, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, r) => {
            this.scrollAdjustments = 0, this.scrollDirection = r ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = r, this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, a) => {
      const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
      for (let l = a - 1; l >= 0; l--) {
        const i = t[l];
        if (s.has(i.lane))
          continue;
        const o = r.get(
          i.lane
        );
        if (o == null || i.end > o.end ? r.set(i.lane, i) : i.end < o.end && s.set(i.lane, !0), s.size === this.options.lanes)
          break;
      }
      return r.size === this.options.lanes ? Array.from(r.values()).sort((l, i) => l.end === i.end ? l.index - i.index : l.end - i.end)[0] : void 0;
    }, this.getMeasurementOptions = _a(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, a, s, r, l, i) => (this.prevLanes !== void 0 && this.prevLanes !== i && (this.lanesChangedFlag = !0), this.prevLanes = i, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: a,
        scrollMargin: s,
        getItemKey: r,
        enabled: l,
        lanes: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = _a(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: a, scrollMargin: s, getItemKey: r, enabled: l, lanes: i }, o) => {
        if (!l)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const h of this.laneAssignments.keys())
            h >= t && this.laneAssignments.delete(h);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((h) => {
          this.itemSizeCache.set(h.key, h.size);
        }));
        const u = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, u), f = new Array(i).fill(
          void 0
        );
        for (let h = 0; h < u; h++) {
          const d = c[h];
          d && (f[d.lane] = h);
        }
        for (let h = u; h < t; h++) {
          const d = r(h), g = this.laneAssignments.get(h);
          let y, k;
          if (g !== void 0 && this.options.lanes > 1) {
            y = g;
            const S = f[y], x = S !== void 0 ? c[S] : void 0;
            k = x ? x.end + this.options.gap : a + s;
          } else {
            const S = this.options.lanes === 1 ? c[h - 1] : this.getFurthestMeasurement(c, h);
            k = S ? S.end + this.options.gap : a + s, y = S ? S.lane : h % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(h, y);
          }
          const m = o.get(d), v = typeof m == "number" ? m : this.options.estimateSize(h), w = k + v;
          c[h] = {
            index: h,
            start: k,
            size: v,
            end: w,
            key: d,
            lane: y
          }, f[y] = h;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = _a(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, a, s, r) => this.range = t.length > 0 && a > 0 ? A$({
        measurements: t,
        outerSize: a,
        scrollOffset: s,
        lanes: r
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = _a(
      () => {
        let t = null, a = null;
        const s = this.calculateRange();
        return s && (t = s.startIndex, a = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, a]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          a
        ];
      },
      (t, a, s, r, l) => r === null || l === null ? [] : t({
        startIndex: r,
        endIndex: l,
        overscan: a,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const a = this.options.indexAttribute, s = t.getAttribute(a);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, a) => {
      const s = this.indexFromElement(t), r = this.measurementsCache[s];
      if (!r)
        return;
      const l = r.key, i = this.elementsCache.get(l);
      i !== t && (i && this.observer.unobserve(i), this.observer.observe(t), this.elementsCache.set(l, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, a, this));
    }, this.resizeItem = (t, a) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const r = this.itemSizeCache.get(s.key) ?? s.size, l = a - r;
      l !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, l, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", l), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += l,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, a)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((a, s) => {
          a.isConnected || (this.observer.unobserve(a), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = _a(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, a) => {
        const s = [];
        for (let r = 0, l = t.length; r < l; r++) {
          const i = t[r], o = a[i];
          s.push(o);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const a = this.getMeasurements();
      if (a.length !== 0)
        return fu(
          a[Xd(
            0,
            a.length - 1,
            (s) => fu(a[s]).start,
            t
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const t = this.scrollElement.document.documentElement;
        return this.options.horizontal ? t.scrollWidth - this.scrollElement.innerWidth : t.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (t, a, s = 0) => {
      if (!this.scrollElement) return 0;
      const r = this.getSize(), l = this.getScrollOffset();
      a === "auto" && (a = t >= l + r ? "end" : "start"), a === "center" ? t += (s - r) / 2 : a === "end" && (t -= r);
      const i = this.getMaxScrollOffset();
      return Math.max(Math.min(i, t), 0);
    }, this.getOffsetForIndex = (t, a = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const r = this.getSize(), l = this.getScrollOffset();
      if (a === "auto")
        if (s.end >= l + r - this.options.scrollPaddingEnd)
          a = "end";
        else if (s.start <= l + this.options.scrollPaddingStart)
          a = "start";
        else
          return [l, a];
      if (a === "end" && t === this.options.count - 1)
        return [this.getMaxScrollOffset(), a];
      const i = a === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(i, a, s.size),
        a
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: a = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, a), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: a = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1)), this.currentScrollToIndex = t;
      let r = 0;
      const l = 10, i = (u) => {
        if (!this.targetWindow) return;
        const c = this.getOffsetForIndex(t, u);
        if (!c) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [f, h] = c;
        this._scrollToOffset(f, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const d = () => {
            if (this.currentScrollToIndex !== t) return;
            const g = this.getScrollOffset(), y = this.getOffsetForIndex(t, h);
            if (!y) {
              console.warn("Failed to get offset for index:", t);
              return;
            }
            M$(y[0], g) || o(h);
          };
          this.isDynamicMode() ? this.targetWindow.requestAnimationFrame(d) : d();
        });
      }, o = (u) => {
        this.targetWindow && this.currentScrollToIndex === t && (r++, r < l ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", r, l), this.targetWindow.requestAnimationFrame(() => i(u))) : console.warn(
          `Failed to scroll to index ${t} after ${l} attempts.`
        ));
      };
      i(a);
    }, this.scrollBy = (t, { behavior: a } = {}) => {
      a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var t;
      const a = this.getMeasurements();
      let s;
      if (a.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((t = a[a.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const r = Array(this.options.lanes).fill(null);
        let l = a.length - 1;
        for (; l >= 0 && r.some((i) => i === null); ) {
          const i = a[l];
          r[i.lane] === null && (r[i.lane] = i.end), l--;
        }
        s = Math.max(...r.filter((i) => i !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: a,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const Xd = (e, n, t, a) => {
  for (; e <= n; ) {
    const s = (e + n) / 2 | 0, r = t(s);
    if (r < a)
      e = s + 1;
    else if (r > a)
      n = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function A$({
  measurements: e,
  outerSize: n,
  scrollOffset: t,
  lanes: a
}) {
  const s = e.length - 1, r = (o) => e[o].start;
  if (e.length <= a)
    return {
      startIndex: 0,
      endIndex: s
    };
  let l = Xd(
    0,
    s,
    r,
    t
  ), i = l;
  if (a === 1)
    for (; i < s && e[i].end < t + n; )
      i++;
  else if (a > 1) {
    const o = Array(a).fill(0);
    for (; i < s && o.some((c) => c < t + n); ) {
      const c = e[i];
      o[c.lane] = c.end, i++;
    }
    const u = Array(a).fill(t + n);
    for (; l >= 0 && u.some((c) => c >= t); ) {
      const c = e[l];
      u[c.lane] = c.start, l--;
    }
    l = Math.max(0, l - l % a), i = Math.min(s, i + (a - 1 - i % a));
  }
  return { startIndex: l, endIndex: i };
}
function R$(e) {
  const n = new P$(p(e)), t = Wt(n), a = n._didMount();
  return He(
    () => p(e).getScrollElement(),
    (s) => {
      s && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), He(
    () => p(e),
    (s) => {
      n.setOptions({
        ...s,
        onChange: (r, l) => {
          var i;
          Tl(t), (i = s.onChange) == null || i.call(s, r, l);
        }
      }), n._willUpdate(), Tl(t);
    },
    {
      immediate: !0
    }
  ), Dr(a), t;
}
function V$(e) {
  return R$(
    C(() => ({
      observeElementRect: O$,
      observeElementOffset: _$,
      scrollToFn: I$,
      ...p(e)
    }))
  );
}
function F$(e, n, t = {}) {
  const {
    estimateSize: a = 50,
    overscan: s = 3,
    measureElement: r = !1
  } = t, l = Wt(!1);
  let i = null, o = !1;
  const u = {
    get count() {
      return n.value.length;
    },
    getScrollElement: () => e.value,
    estimateSize: () => a,
    overscan: s,
    scrollingDelay: 150
  };
  r && (u.measureElement = (v) => !v || l.value ? a : v.getBoundingClientRect().height || a);
  const c = V$(u), f = C(() => c.value.getVirtualItems()), h = C(() => c.value.getTotalSize()), d = () => {
    l.value = !0, i && clearTimeout(i), i = setTimeout(() => {
      l.value = !1;
    }, 150);
  }, g = () => {
    const v = e.value;
    !v || !c.value || (c.value.measure(), v.dispatchEvent(new Event("scroll", { bubbles: !0 })));
  }, y = () => {
    const v = e.value;
    v && !o && (v.addEventListener("scroll", d, { passive: !0 }), o = !0);
  }, k = () => {
    const v = e.value;
    v && o && (v.removeEventListener("scroll", d), o = !1);
  }, m = () => {
    i && (clearTimeout(i), i = null);
  };
  return nt(() => {
    requestAnimationFrame(() => {
      y();
    });
  }), ku(() => {
    requestAnimationFrame(() => {
      g(), y();
    });
  }), wu(() => {
    m();
  }), sn(() => {
    k(), m();
  }), {
    virtualizer: c,
    virtualItems: f,
    totalSize: h,
    remeasure: g
  };
}
const L$ = {
  key: 1,
  ref: "toolbarSlot",
  class: "v-table-toolbar-slot"
}, N$ = { class: "v-table-container-wrapper" }, B$ = {
  key: 1,
  class: "v-table-header-checkbox-cell v-table-header-checkbox-cell--empty"
}, z$ = ["onClick"], W$ = {
  key: 0,
  class: "v-table-total-cell v-table-checkbox-cell"
}, Y$ = { class: "v-table-total-content" }, H$ = {
  key: 0,
  class: "v-table-total-spacer"
}, yC = /* @__PURE__ */ Te({
  inheritAttrs: !1,
  __name: "VTable",
  props: /* @__PURE__ */ ea({
    columns: {},
    data: {},
    loading: { type: Boolean, default: !1 },
    virtualized: { type: Boolean, default: !0 },
    rowHeight: { default: 50 },
    height: {},
    totalRow: {},
    selectedRows: {},
    multiSelect: {},
    expandMode: { default: "auto" },
    sort: { default: () => ({ type: "server", multiple: !0 }) },
    sortState: {},
    pagination: {},
    page: {},
    toolbar: { default: void 0 },
    search: { default: "" },
    rowClassName: {},
    scrollSync: {},
    highlight: { type: [Boolean, Object] },
    highlightState: {},
    highlightSync: {}
  }, {
    search: {},
    searchModifiers: {}
  }),
  emits: /* @__PURE__ */ ea(["row-click", "update:selected-rows", "expand-click", "update:sort-state", "update:highlight-state", "update:page", "request", "sort", "update:search", "toolbar:refresh", "toolbar:reset-sort", "toolbar:export"], ["update:search"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = Yt(), r = Ql(), l = Qe("wrapper"), i = Qe("fullscreenPlaceholder"), o = Qe("toolbarSlot"), u = Qe("pagination");
    Va("tableSlots", {
      headerCellCustomAction: s["header-cell-custom-action"],
      toolbarTitle: s["toolbar-title"],
      toolbarSearch: s["toolbar-search"],
      toolbarFilters: s["toolbar-filters"],
      toolbarActions: s["toolbar-actions"],
      toolbarColumnActions: s["toolbar-column-actions"]
    });
    const c = Ds(e, "search"), f = C(() => {
      var re;
      return ((re = t.toolbar) == null ? void 0 : re.enabled) || s.toolbar;
    }), h = C(() => {
      var re, ke;
      return !!f.value && ((ke = (re = t.toolbar) == null ? void 0 : re.actions) == null ? void 0 : ke.fullscreen) !== !1;
    }), {
      isFullscreen: d,
      zIndex: g,
      placeholderStyle: y,
      panelStyle: k,
      contentHeight: m,
      toggle: v
    } = w$({
      wrapperRef: l,
      placeholderRef: i,
      // The toolbar/pagination chrome is already rendered and is the same size in
      // both fullscreen and normal mode — the composable measures it before the
      // fullscreen flag flips (see useTableFullScreen's enter()) so
      // fullscreenContentHeight is a final px value on the very first fullscreen
      // render (see scrollContainerStyle below).
      chromeRefs: [o, u],
      isEnabled: h,
      // The scroll container's own height changed the instant the fullscreen class
      // applied — the virtualizer's cached scroll element rect is now stale. We
      // don't preserve scroll position across the toggle, so reset to top and
      // force a remeasure (delegated to useVirtualTable's own remeasure()) instead
      // of waiting for the user's next real scroll to reveal any rows.
      onToggle: () => {
        const re = Et.value;
        re && (re.scrollTop = 0, re.scrollLeft = 0), ln();
      }
    }), w = C(() => r.class), S = C(() => {
      const re = r.style, ke = typeof re == "object" && re !== null ? re : {};
      if (y.value)
        return { ...ke, ...y.value };
    }), x = () => {
      var ke, Ye, $e, je;
      a("toolbar:refresh"), ((Ye = (ke = t.toolbar) == null ? void 0 : ke.actions) == null ? void 0 : Ye.refresh) !== "custom" && (z.value = [], le.value = 1, Ot.collapseAll(), bt.clear(), a("request", {
        page: (($e = t.pagination) == null ? void 0 : $e.page) ?? 1,
        pageSize: ((je = t.pagination) == null ? void 0 : je.pageSize) ?? 10,
        sort: []
      }));
    }, $ = () => {
      var ke, Ye, $e, je;
      a("toolbar:reset-sort"), ((Ye = (ke = t.toolbar) == null ? void 0 : ke.actions) == null ? void 0 : Ye.resetSort) !== "custom" && (z.value = [], le.value = 1, Ot.collapseAll(), bt.clear(), a("request", {
        page: (($e = t.pagination) == null ? void 0 : $e.page) ?? 1,
        pageSize: ((je = t.pagination) == null ? void 0 : je.pageSize) ?? 10,
        sort: []
      }));
    }, T = (re, ke) => {
      a("toolbar:export", re, ke);
    }, {
      columnSetupEnabledBasic: _,
      columnSetupConfig: A,
      columnSetupPopoverRef: D,
      columnPickerPopoverRef: Y,
      handleVisibleColumnsUpdate: L,
      handleColumnSetupClose: X,
      handleColumnPickerClose: se,
      columnPickerEnabled: ie,
      columnPickerConfig: ue,
      effectiveColumns: G
    } = y$({
      columns: () => t.columns,
      columnSetup: () => {
        var re, ke;
        return (ke = (re = t.toolbar) == null ? void 0 : re.actions) == null ? void 0 : ke.columnSetup;
      },
      columnPicker: () => {
        var re, ke;
        return (ke = (re = t.toolbar) == null ? void 0 : re.actions) == null ? void 0 : ke.columnPicker;
      }
    }), q = C(() => t.totalRow !== void 0), Z = te(/* @__PURE__ */ new Map()), {
      hasGroups: N,
      flatColumns: ae,
      headerLevels: me,
      getGroupWidth: be,
      isGroupFixed: pe
    } = m$(G, Z), De = C(() => _.value ? N.value ? (console.warn("Column Setup is not supported with grouped headers yet"), !1) : !0 : !1), ge = C(() => N.value ? ae.value : G.value), {
      gridTemplateColumns: K,
      getGridTemplateWithCheckbox: ye,
      startResize: Me,
      autoFitColumn: V,
      isResizing: j,
      resizedWidths: H,
      isColumnResizable: I
    } = d$(ge);
    He(H, () => {
      const re = /* @__PURE__ */ new Map();
      ge.value.forEach((ke) => {
        var $e;
        const Ye = H.value.get(ke.key);
        Ye !== void 0 ? re.set(ke.key, Ye) : ($e = ke.width) != null && $e.endsWith("px") && re.set(ke.key, parseInt(ke.width, 10));
      }), Z.value = re;
    }, { immediate: !0 });
    const {
      getFixedStyles: B,
      isLastLeftFixed: J,
      isFirstRightFixed: R
    } = h$(ge, Z), ee = C(() => t.height ? typeof t.height == "number" ? `${t.height}px` : t.height : "600px"), O = C(() => d.value ? {
      height: `${m.value}px`,
      overscrollBehavior: "contain"
    } : { height: ee.value, overscrollBehavior: "contain" }), z = C({
      get: () => t.sortState || [],
      set: (re) => a("update:sort-state", re)
    }), F = Qn(Zd, null), le = C({
      get: () => {
        var re;
        return t.page ?? (F == null ? void 0 : F.value) ?? ((re = t.pagination) == null ? void 0 : re.page) ?? 1;
      },
      set: (re) => {
        t.page !== void 0 ? a("update:page", re) : F && (F.value = re);
      }
    }), {
      getSortState: W,
      handleSortClick: he,
      sortedData: Oe
    } = T$({
      sort: t.sort,
      sortState: z,
      columns: G,
      page: C(() => {
        var re;
        return (re = t.pagination) == null ? void 0 : re.page;
      }),
      pageSize: C(() => {
        var re;
        return (re = t.pagination) == null ? void 0 : re.pageSize;
      }),
      data: C(() => t.data),
      // Pass data for frontend sorting
      onRequest: (re) => {
        le.value = re.page, Ot.collapseAll(), bt.clear(), a("request", re);
      },
      onSort: (re) => a("sort", re),
      onUpdateSortState: (re) => a("update:sort-state", re)
    }), Re = (re) => {
      he(re);
    }, _e = C(() => {
      var Ye;
      const re = ((Ye = t.sort) == null ? void 0 : Ye.type) === "front" ? Oe.value : t.data, ke = ($e, je = "") => $e.map((St, An) => {
        var Gs;
        const ss = St.id ?? `${je}row-${An}`, Hn = (Gs = St.children) != null && Gs.length ? ke(St.children, `${ss}-`) : St.children;
        return St.id !== void 0 && Hn === St.children ? St : { ...St, id: ss, children: Hn };
      });
      return ke(re);
    }), ze = C(
      () => _e.value.some((re) => re.children && re.children.length > 0)
    ), Nt = C(() => _e.value), Ot = f$(Nt), Bt = C(() => ze.value ? Ot.flattenedData.value : _e.value), kn = C(() => t.multiSelect), Wn = C({
      get: () => t.selectedRows || [],
      set: (re) => a("update:selected-rows", re)
    }), _t = S$({
      config: kn,
      flattenedData: Bt,
      selectedRows: Wn,
      onSelectionChange: (re) => {
        a("update:selected-rows", re);
      }
    }), Et = te(null), {
      virtualItems: $t,
      totalSize: xn,
      remeasure: ln
    } = F$(
      Et,
      Bt,
      {
        estimateSize: t.rowHeight,
        overscan: 2,
        // Reduced from 5 for better performance
        // PERFORMANCE: Disable measureElement to prevent memory leaks
        // Using fixed height improves performance dramatically for large datasets
        // Trade-off: scroll bar may be slightly inaccurate with expanded rows
        measureElement: !1
      }
    ), Zt = C(() => ({
      display: "grid",
      gridTemplateColumns: _t.isEnabled.value ? ye(50) : K.value,
      gridAutoRows: "auto"
      // All rows auto-sized (headers get height from CSS)
    })), Ee = (re) => {
      a("row-click", re);
    }, ct = ({ page: re, pageSize: ke }) => {
      !t.pagination || t.loading || (Et.value && Et.value.scrollTop > 0 && Et.value.scrollTo({
        top: 0,
        behavior: "smooth"
      }), le.value = re, Ot.collapseAll(), bt.clear(), a("request", {
        page: re,
        pageSize: ke,
        sort: z.value
      }));
    }, Ct = (re) => {
      const ke = re.target;
      t.scrollSync && t.scrollSync.onScroll(ke.scrollLeft, ke.scrollTop);
    }, Sn = (re, ke, Ye) => {
      ze.value && (t.expandMode === "controlled" ? a("expand-click", {
        row: ke,
        column: Ye,
        callback: () => Ot.toggleRow(re),
        expanded: Tn(ke)
      }) : (Ot.toggleRow(re), a("expand-click", {
        row: ke,
        column: Ye,
        callback: () => {
        },
        // Already toggled, callback is no-op
        expanded: !Tn(ke)
        // New state after toggle
      })));
    }, Tn = (re) => re.isExpanded || !1, xa = (re) => re.hasChildren || !1, { getCellValue: as, getCellClass: Kr, getCellMetadata: Hs } = g$({
      isExpandable: ze,
      isRowExpandable: (re) => Ot.isExpandable(re)
    });
    Va("tableCellMetadata", Hs);
    const Yn = C(() => k$(t.highlight)), Us = () => {
      const re = bt.pinnedRowId.value, ke = bt.pinnedColumnKey.value;
      if (re === null && ke === null) return null;
      const Ye = re === null ? -1 : Bt.value.findIndex((Hn) => Hn.id === re), $e = Ye >= 0 ? Bt.value[Ye] : void 0, je = ke === null ? void 0 : ge.value.find((Hn) => Hn.key === ke), St = $e && re !== null ? { rowId: re, rowIndex: Ye, row: $e } : null, An = je && ke !== null ? { columnKey: ke, column: je } : null;
      let ss = null;
      if (St && An) {
        const Hn = ge.value.indexOf(An.column), Gs = Hs(St.row, An.column, Hn, St.rowIndex);
        ss = {
          value: St.row[An.columnKey],
          formattedValue: String(Gs.formattedValue ?? "")
        };
      }
      return { row: St, column: An, cell: ss };
    }, bt = x$({
      config: Yn,
      onChange: (re) => {
        var ke;
        a("update:highlight-state", Us()), (ke = t.highlightSync) == null || ke.broadcast(re);
      }
    }), Zr = (re) => {
      bt.applyRemote(re), a("update:highlight-state", Us());
    }, qs = (re) => bt.isRowPinned(re);
    Va("tableHighlight", {
      columnEnabled: C(() => Yn.value.column),
      isColumnPinned: bt.isColumnPinned,
      toggleColumn: bt.toggleColumn
    });
    const js = (re, ke) => t.rowClassName ? typeof t.rowClassName == "string" ? t.rowClassName : typeof t.rowClassName == "function" ? t.rowClassName(re, ke) : "" : "", Xr = C(() => t.virtualized ? Et.value ? $t.value.length === 0 ? [] : $t.value.map((re) => {
      const ke = Bt.value[re.index], Ye = ke ? js(ke, re.index) : "";
      return {
        row: ke,
        index: re.index,
        // CRITICAL: Use row.id as key, not index! Index causes memory leaks
        // because Vue reuses components for different data at same index
        key: (ke == null ? void 0 : ke.id) || `row-${re.index}`,
        isVirtual: !0,
        virtualRow: re,
        rowClass: Ye,
        isCustomRow: !!Ye
      };
    }) : [] : Bt.value.map((re, ke) => {
      const Ye = js(re, ke);
      return {
        row: re,
        index: ke,
        key: re.id || ke,
        isVirtual: !1,
        rowClass: Ye,
        isCustomRow: !!Ye
      };
    })), Q = (re) => re.isVirtual ? {
      height: `${t.rowHeight}px`,
      minHeight: `${t.rowHeight}px`
    } : {}, ve = (re) => {
      const ke = [], Ye = re.fixed || (N.value ? pe(re) : null);
      return Ye && (ke.push("v-table-fixed-column"), Ye === "left" ? ke.push("v-table-fixed-left") : Ye === "right" && ke.push("v-table-fixed-right"), J(re.key) && ke.push("v-table-fixed-left-last"), R(re.key) && ke.push("v-table-fixed-right-first")), bt.isColumnPinned(re.key) && ke.push("v-table-cell--pinned-col"), ke;
    }, Ae = C(() => {
      const re = /* @__PURE__ */ new Map();
      return ge.value.forEach((ke) => {
        re.set(ke.key, ve(ke));
      }), N.value && me.value.forEach((ke) => {
        ke.forEach((Ye) => {
          re.has(Ye.column.key) || re.set(Ye.column.key, ve(Ye.column));
        });
      }), re;
    }), We = (re) => Ae.value.get(re.key) ?? [], st = (re) => pe(re) ? B(re) : {}, Ht = C(() => N.value ? IM : AM), on = C(() => N.value ? me.value : ge.value);
    return sn(() => {
      var re, ke;
      Ot && Ot.collapseAll(), Et.value = null, (re = t.scrollSync) == null || re.unregister(), (ke = t.highlightSync) == null || ke.unregister();
    }), nt(() => {
      var re;
      (re = t.highlightSync) == null || re.register(Zr), t.scrollSync && Et.value && t.scrollSync.register(Et.value);
    }), Yn.value.enabled && (He(() => t.highlightState, (re) => {
      var $e, je;
      const ke = (($e = re == null ? void 0 : re.row) == null ? void 0 : $e.rowId) ?? null, Ye = ((je = re == null ? void 0 : re.column) == null ? void 0 : je.columnKey) ?? null;
      ke === bt.pinnedRowId.value && Ye === bt.pinnedColumnKey.value || bt.setPin({ rowId: ke, columnKey: Ye });
    }), He(Yn, (re) => {
      if (!re.enabled) {
        bt.clear();
        return;
      }
      re.row || bt.unpinRow(), re.column || bt.unpinColumn();
    })), (re, ke) => {
      var Ye;
      return b(), M(Se, null, [
        (b(), fe(zn, {
          disabled: !p(d),
          to: "body"
        }, [
          E("div", lt({
            ref: "wrapper",
            class: [{
              "v-table-wrapper--with-toolbar": f.value,
              "v-table-wrapper--fullscreen": p(d)
            }, "v-table-wrapper"],
            style: p(d) ? { ...p(k), zIndex: p(g) + 1 } : void 0
          }, p(r)), [
            h.value ? (b(), fe(wM, {
              key: 0,
              "is-fullscreen": p(d),
              onToggle: p(v)
            }, null, 8, ["is-fullscreen", "onToggle"])) : P("", !0),
            f.value ? (b(), M("div", L$, [
              p(s).toolbar ? U(re.$slots, "toolbar", { key: 0 }) : (Ye = e.toolbar) != null && Ye.enabled ? (b(), fe(r$, {
                key: 1,
                search: c.value,
                "onUpdate:search": ke[0] || (ke[0] = ($e) => c.value = $e),
                config: e.toolbar,
                onExport: T,
                onRefresh: x,
                onResetSort: $
              }, ft({ _: 2 }, [
                De.value || p(ie) ? {
                  name: "column-setup",
                  fn: de(() => [
                    p(ie) ? (b(), fe(p(Mr), {
                      key: 0,
                      ref_key: "columnPickerPopoverRef",
                      ref: Y,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: de(() => [
                        oe(p(qt), {
                          icon: "lucide:columns",
                          variant: "default"
                        })
                      ]),
                      content: de(() => [
                        oe(GT, {
                          columns: p(G),
                          groups: p(ue).groups,
                          loading: p(ue).loading,
                          "original-columns": t.columns,
                          "storage-key": p(ue).key,
                          "storage-type": p(ue).type,
                          onClose: p(se),
                          "onUpdate:visibleColumns": p(L)
                        }, null, 8, ["columns", "groups", "loading", "original-columns", "storage-key", "storage-type", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : P("", !0),
                    De.value ? (b(), fe(p(Mr), {
                      key: 1,
                      ref_key: "columnSetupPopoverRef",
                      ref: D,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: de(() => [
                        oe(p(qt), {
                          icon: "lucide:table-2",
                          variant: "default"
                        })
                      ]),
                      content: de(() => [
                        oe(cM, {
                          columns: e.columns,
                          config: p(A),
                          onClose: p(X),
                          "onUpdate:visibleColumns": p(L)
                        }, null, 8, ["columns", "config", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : P("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["search", "config"])) : P("", !0)
            ], 512)) : P("", !0),
            E("div", N$, [
              Bt.value.length === 0 ? (b(), fe(yM, {
                key: 0,
                description: "Try adjusting your filters or search criteria",
                icon: "lucide:inbox",
                title: "No data to display"
              }, {
                default: de(() => [
                  U(re.$slots, "empty-state")
                ]),
                _: 3
              })) : P("", !0),
              oe(FM, { loading: e.loading }, null, 8, ["loading"]),
              E("div", {
                ref_key: "scrollContainerRef",
                ref: Et,
                class: ne([{ "v-table-scroll-container--loading": e.loading }, "v-table-scroll-container v-table-scrollbar-styled"]),
                style: Fe(O.value),
                onScrollPassive: Ct
              }, [
                E("div", {
                  class: ne([{
                    "v-is-resizing": p(j),
                    "v-table-grid--highlight": p(bt).hasPin.value
                  }, "v-table-grid"]),
                  style: Fe(Zt.value)
                }, [
                  (b(), fe(ht(Ht.value), {
                    columns: on.value,
                    "get-column-classes": We,
                    "get-fixed-styles": p(B),
                    "get-group-fixed-styles": st,
                    "get-group-width": p(be),
                    "get-sort-state": p(W),
                    "is-column-resizable": p(I),
                    onResizeStart: p(Me),
                    onResizeDblclick: p(V),
                    onSortClick: Re
                  }, ft({ _: 2 }, [
                    p(_t).isEnabled.value ? {
                      name: "checkbox-header",
                      fn: de(() => {
                        var $e;
                        return [
                          (($e = kn.value) == null ? void 0 : $e.showHeaderCheckbox) !== !1 ? (b(), fe(xM, {
                            key: 0,
                            state: p(_t).getHeaderCheckboxState(),
                            onToggle: p(_t).toggleAllRows
                          }, null, 8, ["state", "onToggle"])) : (b(), M("div", B$))
                        ];
                      }),
                      key: "0"
                    } : void 0,
                    Pe(ge.value, ($e) => ({
                      name: `header-icon-${$e.key}`,
                      fn: de((je) => [
                        U(re.$slots, `header-icon-${$e.key}`, Mt(Ft(je)))
                      ])
                    })),
                    Pe(ge.value, ($e) => ({
                      name: `header-${$e.key}`,
                      fn: de((je) => [
                        U(re.$slots, `header-${$e.key}`, Mt(Ft(je)))
                      ])
                    }))
                  ]), 1064, ["columns", "get-fixed-styles", "get-group-width", "get-sort-state", "is-column-resizable", "onResizeStart", "onResizeDblclick"])),
                  t.virtualized && p($t).length > 0 && p($t)[0] ? (b(), M("div", {
                    key: 0,
                    style: Fe({ height: `${p($t)[0].start}px` }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : P("", !0),
                  (b(!0), M(Se, null, Pe(Xr.value, ($e) => (b(), M("div", {
                    key: $e.key,
                    class: ne([{ "v-table-row-wrapper--pinned": qs($e.row.id) }, "v-table-row-wrapper"]),
                    style: Fe(Q($e)),
                    onClick: (je) => Ee($e.row)
                  }, [
                    p(_t).isEnabled.value ? (b(), fe(iT, {
                      key: 0,
                      checked: p(_t).isRowSelected($e.row.id),
                      class: ne($e.rowClass),
                      "data-custom-row": $e.isCustomRow ? "true" : void 0,
                      disabled: !p(_t).isRowSelectable($e.row),
                      indeterminate: p(_t).isDependentMode.value && xa($e.row) && p(_t).getParentCheckboxState($e.row) === "indeterminate",
                      onToggle: (je) => p(_t).toggleRow($e.row)
                    }, null, 8, ["checked", "class", "data-custom-row", "disabled", "indeterminate", "onToggle"])) : P("", !0),
                    (b(!0), M(Se, null, Pe(ge.value, (je, St) => (b(), fe(eu, {
                      key: je.key,
                      align: je.align,
                      class: ne([
                        We(je),
                        $e.rowClass,
                        { "v-table-cell--pin-host": Yn.value.row && St === 0 }
                      ]),
                      "col-index": St,
                      column: je,
                      "data-custom-row": $e.isCustomRow ? "true" : void 0,
                      interactive: je.interactive,
                      "is-expanded": !!$e.row.isExpanded,
                      row: $e.row,
                      "row-index": $e.index,
                      style: Fe(p(B)(je)),
                      onToggleExpand: (An) => Sn($e.row.id, $e.row, je)
                    }, ft({ _: 2 }, [
                      Yn.value.row && St === 0 ? {
                        name: "pin",
                        fn: de(() => [
                          oe(Yd, {
                            pinned: qs($e.row.id),
                            label: "row",
                            onToggle: (An) => p(bt).toggleRow($e.row.id)
                          }, null, 8, ["pinned", "onToggle"])
                        ]),
                        key: "0"
                      } : void 0,
                      p(s)[`cell-${je.key}`] ? {
                        name: "default",
                        fn: de(() => [
                          U(re.$slots, `cell-${je.key}`, {
                            column: je,
                            depth: $e.row.depth || 0,
                            index: $e.index,
                            row: $e.row,
                            value: $e.row[je.key]
                          })
                        ]),
                        key: "1"
                      } : void 0
                    ]), 1032, ["align", "class", "col-index", "column", "data-custom-row", "interactive", "is-expanded", "row", "row-index", "style", "onToggleExpand"]))), 128))
                  ], 14, z$))), 128)),
                  t.virtualized && p($t).length > 0 && p($t)[p($t).length - 1] ? (b(), M("div", {
                    key: 1,
                    style: Fe({
                      height: `${p(xn) - p($t)[p($t).length - 1].end}px`
                    }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : P("", !0),
                  q.value && e.totalRow ? (b(), M(Se, { key: 2 }, [
                    p(_t).isEnabled.value ? (b(), M("div", W$)) : P("", !0),
                    (b(!0), M(Se, null, Pe(ge.value, ($e, je) => (b(), fe(eu, {
                      key: $e.key,
                      align: $e.align,
                      class: ne([We($e), "v-table-total-cell"]),
                      style: Fe(p(B)($e))
                    }, {
                      default: de(() => [
                        E("div", Y$, [
                          je === 0 && ze.value ? (b(), M("div", H$)) : P("", !0),
                          E("div", {
                            class: ne([{ "v-table-total-text--truncate": !$e.interactive }, "v-table-total-text"])
                          }, [
                            U(re.$slots, `total-cell-${$e.key}`, {
                              column: $e,
                              row: e.totalRow,
                              value: e.totalRow[$e.key]
                            }, () => [
                              oe(rT, {
                                class: ne(p(Kr)(e.totalRow[$e.key], $e, e.totalRow)),
                                interactive: $e.interactive,
                                value: p(as)(e.totalRow[$e.key], $e, e.totalRow)
                              }, null, 8, ["class", "interactive", "value"])
                            ])
                          ], 2)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["align", "class", "style"]))), 128))
                  ], 64)) : P("", !0)
                ], 6)
              ], 38)
            ]),
            e.pagination ? (b(), fe(XM, {
              key: 2,
              ref: "pagination",
              loading: e.loading,
              page: le.value,
              "page-size": e.pagination.pageSize,
              "page-size-options": e.pagination.pageSizeOptions || [10, 25, 50, 100],
              "show-size-changer": e.pagination.showSizeChanger,
              total: e.pagination.total,
              onPageChange: ct
            }, null, 8, ["loading", "page", "page-size", "page-size-options", "show-size-changer", "total"])) : P("", !0)
          ], 16)
        ], 8, ["disabled"])),
        p(y) ? (b(), M("div", {
          key: 0,
          ref: "fullscreenPlaceholder",
          class: ne(w.value),
          style: Fe(S.value),
          "aria-hidden": "true"
        }, null, 6)) : P("", !0)
      ], 64);
    };
  }
}), U$ = { class: "delta-value flex flex-col" }, bC = /* @__PURE__ */ Te({
  __name: "DeltaValue",
  props: {
    value: { default: void 0 },
    delta: { default: void 0 },
    format: { default: void 0 },
    deltaFormat: { default: void 0 },
    deltaAsPercentage: { type: Boolean, default: !0 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showZeroDelta: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = C(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta < 0 : n.delta > 0), a = C(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta > 0 : n.delta < 0), s = C(() => n.delta === 0), r = C(() => n.delta === null || n.delta === void 0 ? !1 : n.showZeroDelta || n.delta !== 0), l = C(() => {
      var f;
      if (n.delta === null || n.delta === void 0) return "";
      const u = Math.abs(n.delta);
      if (n.deltaFormat) {
        const { type: h = "number", decimals: d = 0, currencyCode: g = "USD" } = n.deltaFormat;
        switch (h) {
          case "currency":
            return new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: g,
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u);
          case "percentage":
            return `${new Intl.NumberFormat("en-US", {
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u)}%`;
          default:
            return new Intl.NumberFormat("en-US", {
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u);
        }
      }
      const c = u.toFixed(((f = n.format) == null ? void 0 : f.decimals) ?? 0);
      return n.deltaAsPercentage ? `${c}%` : c;
    }), i = C(() => {
      if (n.value === null || n.value === void 0) return null;
      if (typeof n.value == "string") return n.value;
      const { type: u = "number", decimals: c = 0, currencyCode: f = "USD" } = n.format || {};
      switch (u) {
        case "currency":
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: f,
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value);
        case "percentage":
          return `${new Intl.NumberFormat("en-US", {
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value)}%`;
        default:
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value);
      }
    }), o = C(() => {
      switch (n.size) {
        case "sm":
          return {
            value: "text-sm",
            delta: "text-xs",
            icon: 14
          };
        case "lg":
          return {
            value: "text-lg font-semibold",
            delta: "text-sm",
            icon: 20
          };
        default:
          return {
            value: "text-base",
            delta: "text-sm",
            icon: 16
          };
      }
    });
    return (u, c) => (b(), M("div", U$, [
      i.value !== null ? (b(), M("span", {
        key: 0,
        class: ne([o.value.value, "text-mainText"])
      }, ce(i.value), 3)) : P("", !0),
      r.value ? (b(), M("div", {
        key: 1,
        class: ne([o.value.delta, "flex items-center gap-0.5"])
      }, [
        t.value ? (b(), fe(p(xe), {
          key: 0,
          size: o.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : a.value ? (b(), fe(p(xe), {
          key: 1,
          size: o.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : s.value ? (b(), fe(p(xe), {
          key: 2,
          size: o.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : P("", !0),
        E("span", {
          class: ne({
            "text-success": t.value,
            "text-negative": a.value,
            "text-secondaryText": s.value
          })
        }, ce(l.value), 3)
      ], 2)) : P("", !0)
    ]));
  }
}), wC = /* @__PURE__ */ Te({
  __name: "DeltaIndicator",
  props: {
    value: { default: 0 },
    format: { default: () => {
    } },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showIcon: { type: Boolean, default: !0 },
    showZero: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = C(
      () => e.value !== null && e.value !== void 0
    ), t = C(
      () => n.value && (e.showZero || e.value !== 0)
    ), a = C(() => n.value ? e.reverse ? e.value < 0 : e.value > 0 : null), s = C(() => n.value ? e.reverse ? e.value > 0 : e.value < 0 : null), r = C(() => e.value === 0), l = C(() => {
      if (!n.value) return "";
      const o = e.format;
      if (!o) return String(e.value);
      if (o.currency !== void 0) {
        if (typeof o.currency == "object") {
          const { code: u, decimals: c } = o.currency;
          return Ss(e.value, { code: u, decimals: c });
        }
        return typeof o.currency == "string" ? Ss(e.value, o.currency) : Ss(e.value);
      }
      return o.percentage !== void 0 ? $i(e.value, o.percentage === !0 ? void 0 : o.percentage) : o.number !== void 0 ? Wa(e.value, o.number) : String(e.value);
    }), i = C(() => {
      switch (e.size) {
        case "sm":
          return { text: "text-xs", icon: 12 };
        case "lg":
          return { text: "text-sm font-semibold", icon: 18 };
        default:
          return { text: "text-sm", icon: 14 };
      }
    });
    return (o, u) => t.value ? (b(), M("div", {
      key: 0,
      class: ne([i.value.text, "flex items-center gap-0.5"])
    }, [
      e.showIcon ? (b(), M(Se, { key: 0 }, [
        a.value ? (b(), fe(p(xe), {
          key: 0,
          size: i.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : s.value ? (b(), fe(p(xe), {
          key: 1,
          size: i.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : r.value ? (b(), fe(p(xe), {
          key: 2,
          size: i.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : P("", !0)
      ], 64)) : P("", !0),
      E("span", {
        class: ne({
          "text-success": a.value,
          "text-negative": s.value,
          "text-secondaryText": r.value
        })
      }, ce(l.value), 3)
    ], 2)) : P("", !0);
  }
}), q$ = { class: "v-table-title-block" }, j$ = { class: "v-table-title-block__title-section" }, G$ = {
  key: 1,
  class: "v-table-title-block__title"
}, K$ = {
  key: 2,
  class: "v-table-title-block__separator"
}, Z$ = {
  key: 0,
  class: "v-table-title-block__actions"
}, X$ = /* @__PURE__ */ Te({
  __name: "TableTitleBlock",
  props: {
    title: { default: "" },
    icon: { default: "" }
  },
  setup(e) {
    return (n, t) => (b(), M("div", q$, [
      E("div", j$, [
        e.icon ? (b(), fe(p(xe), {
          key: 0,
          icon: e.icon,
          size: 20,
          class: "v-table-title-block__icon"
        }, null, 8, ["icon"])) : P("", !0),
        e.title ? (b(), M("h3", G$, ce(e.title), 1)) : P("", !0),
        e.title && n.$slots.default ? (b(), M("span", K$)) : P("", !0)
      ]),
      n.$slots.default ? (b(), M("div", Z$, [
        U(n.$slots, "default", {}, void 0, !0)
      ])) : P("", !0)
    ]));
  }
}), kC = /* @__PURE__ */ Ge(X$, [["__scopeId", "data-v-c3a3c2e6"]]);
function J$(e) {
  var k;
  const {
    granularity: n,
    dateRange: t,
    includeSummary: a = !1,
    defaultPeriodValue: s,
    onPeriodChange: r
  } = e, l = te(null), i = te(!0), o = C(() => {
    const m = n.value, v = [], w = m === "MONTH" ? "All Months" : m === "WEEK" ? "All Weeks" : "All Days";
    return v.push({ label: w, value: "all" }), a && v.push({ label: "Summary", value: "summary" }), m === "MONTH" ? v.push(...c()) : m === "WEEK" ? v.push(...f()) : m === "DAY" && v.push(...h()), v;
  }), u = C(
    () => o.value.find((m) => m.value === s) ?? o.value[0]
  );
  function c() {
    const { since: m, until: v } = t.value, w = Ie.fromISO(m, { zone: "utc" }), S = Ie.fromISO(v, { zone: "utc" }), x = [];
    let $ = w.startOf("month");
    for (; $ <= S; )
      x.push({
        label: $.toFormat("MMMM yyyy"),
        value: $.toISODate()
      }), $ = $.plus({ months: 1 });
    return x.sort(
      (T, _) => Ie.fromISO(_.value).toMillis() - Ie.fromISO(T.value).toMillis()
    );
  }
  function f() {
    const { since: m, until: v } = t.value, w = Ie.fromISO(m, { zone: "utc" }), S = Ie.fromISO(v, { zone: "utc" }), x = Ie.utc().startOf("day"), $ = [];
    let T = w.startOf("week").plus({ days: 6 });
    for (; T <= S && T < x; )
      $.push({
        label: T.toFormat("MM/dd/yyyy"),
        value: T.toISODate()
      }), T = T.plus({ weeks: 1 });
    return $.sort(
      (_, A) => Ie.fromISO(A.value).toMillis() - Ie.fromISO(_.value).toMillis()
    );
  }
  function h() {
    const { since: m, until: v } = t.value, w = Ie.fromISO(m, { zone: "utc" }), S = Ie.fromISO(v, { zone: "utc" }), x = Ie.utc().startOf("day"), $ = [];
    let T = w;
    for (; T <= S && T < x; )
      $.push({
        label: T.toFormat("MM/dd/yyyy"),
        value: T.toISODate()
      }), T = T.plus({ days: 1 });
    return $.sort(
      (_, A) => Ie.fromISO(A.value).toMillis() - Ie.fromISO(_.value).toMillis()
    );
  }
  const d = C(() => {
    var w;
    const m = (w = l.value) == null ? void 0 : w.value;
    if (!m || m === "all" || m === "summary")
      return {};
    const v = n.value;
    if (v === "MONTH") {
      const x = Ie.fromISO(m, { zone: "utc" }).endOf("month");
      return {
        period: {
          since: m,
          until: x.toISODate()
        }
      };
    }
    if (v === "WEEK") {
      const S = Ie.fromISO(m, { zone: "utc" });
      return {
        period: {
          since: m,
          until: S.plus({ days: 6 }).toISODate()
        }
      };
    }
    return v === "DAY" ? {
      period: {
        since: m,
        until: m
      }
    } : {};
  }), g = (m) => {
    l.value = m, i.value = m.value !== "summary", r && r(d.value, i.value);
  }, y = async () => {
    var m;
    l.value = u.value, i.value = ((m = u.value) == null ? void 0 : m.value) !== "summary", r && r(d.value, i.value);
  };
  return He(
    () => [n.value, t.value],
    () => {
      y();
    },
    { flush: "pre", deep: !0 }
  ), l.value || (l.value = u.value, i.value = ((k = u.value) == null ? void 0 : k.value) !== "summary"), {
    /** Currently selected period */
    selectedPeriod: l,
    /** Available period options for dropdown */
    periodOptions: o,
    /** Default period option */
    defaultPeriod: u,
    /** Request params to spread into API call */
    periodRequestParams: d,
    /** Whether to group by date (false when "Summary" is selected) */
    isGroupByDate: i,
    /** Handle period selection change */
    handlePeriodChange: g,
    /** Reset to default period */
    resetPeriod: y
  };
}
const Q$ = { class: "w-[160px]" }, xC = /* @__PURE__ */ Te({
  __name: "TablePeriodSelect",
  props: {
    granularity: {},
    dateRange: {},
    includeSummary: { type: Boolean, default: !1 },
    defaultPeriodValue: { default: void 0 },
    widthClass: { default: "w-40" },
    placeholder: { default: "Select period" }
  },
  emits: ["change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, {
      selectedPeriod: r,
      periodOptions: l,
      periodRequestParams: i,
      isGroupByDate: o,
      handlePeriodChange: u
    } = J$({
      granularity: hr(a, "granularity"),
      dateRange: hr(a, "dateRange"),
      includeSummary: a.includeSummary,
      defaultPeriodValue: a.defaultPeriodValue,
      onPeriodChange: () => {
        c();
      }
    }), c = () => {
      s("change", {
        selected: r.value,
        requestParams: i.value,
        isGroupByDate: o.value
      });
    }, f = (h) => {
      u(h);
    };
    return n({
      selectedPeriod: r,
      periodRequestParams: i,
      isGroupByDate: o
    }), (h, d) => (b(), M("div", Q$, [
      oe(p(vk), lt({
        modelValue: p(r),
        "onUpdate:modelValue": d[0] || (d[0] = (g) => xu(r) ? r.value = g : null),
        class: e.widthClass,
        "close-on-select": !0,
        options: p(l),
        placeholder: e.placeholder,
        searchable: !1
      }, h.$attrs, { onSelect: f }), null, 16, ["modelValue", "class", "options", "placeholder"])
    ]));
  }
}), e2 = /* @__PURE__ */ Te({
  __name: "TableExpandAdditionalHeadersButton",
  props: {
    isExpanded: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, s) => (b(), M("button", {
      class: ne([{ "is-expanded": e.isExpanded }, "expand-button"]),
      type: "button",
      onClick: s[0] || (s[0] = Ve((r) => t("click"), ["stop"]))
    }, [
      oe(p(xe), {
        size: 16,
        class: "expand-icon",
        icon: "lucide:chevron-right"
      })
    ], 2));
  }
}), SC = /* @__PURE__ */ Ge(e2, [["__scopeId", "data-v-41dc3668"]]), oa = /* @__PURE__ */ new Map(), TC = (e, n, t) => {
  const a = (t == null ? void 0 : t.paginationMode) === "sync" ? t.totalPages : void 0, s = (t == null ? void 0 : t.paginationMode) ?? "independent", r = (t == null ? void 0 : t.initialPage) ?? 1, l = t == null ? void 0 : t.namespace, i = l ? `${l}:${e}` : e, o = n.filter((v) => v !== e), u = te(r), c = te(null), f = {
    scrollEl: null,
    scrollPosition: c,
    isReceivingScroll: !1,
    pendingScrollX: 0,
    pendingScrollY: 0,
    scrollRafId: null,
    page: u,
    paginationMode: s,
    totalPages: a,
    receiveHighlight: null,
    isReceivingHighlight: !1
  };
  oa.set(i, f);
  const h = (v) => l ? `${l}:${v}` : v, d = {
    register: (v) => {
      f.scrollEl = v;
      for (const w of o) {
        const S = oa.get(h(w));
        if (S != null && S.scrollEl) {
          v.scrollLeft = S.scrollEl.scrollLeft, v.scrollTop = S.scrollEl.scrollTop;
          break;
        }
      }
    },
    unregister: () => {
      f.scrollEl = null;
    },
    onScroll: (v, w) => {
      f.isReceivingScroll || o.forEach((S) => {
        const x = oa.get(h(S));
        !x || !x.scrollEl || x.scrollEl.scrollLeft === v && x.scrollEl.scrollTop === w || (x.pendingScrollX = v, x.pendingScrollY = w, x.scrollRafId === null && (x.scrollRafId = requestAnimationFrame(() => {
          x.scrollRafId = null, x.scrollEl && (x.isReceivingScroll = !0, x.scrollEl.scrollLeft = x.pendingScrollX, x.scrollEl.scrollTop = x.pendingScrollY, requestAnimationFrame(() => {
            x.isReceivingScroll = !1;
          }));
        })));
      });
    },
    scrollPosition: c
  }, g = {
    register: (v) => {
      f.receiveHighlight = v;
    },
    unregister: () => {
      f.receiveHighlight = null;
    },
    // No rAF throttling here, unlike onScroll: this fires once per click.
    broadcast: (v) => {
      f.isReceivingHighlight || o.forEach((w) => {
        const S = oa.get(h(w));
        S != null && S.receiveHighlight && (S.isReceivingHighlight = !0, S.receiveHighlight(v), S.isReceivingHighlight = !1);
      });
    }
  }, y = (v) => {
    u.value = v, o.forEach((w) => {
      const S = oa.get(h(w));
      if (!(!S || S.paginationMode === "independent")) {
        if (S.paginationMode === "reset") {
          S.page.value = 1;
          return;
        }
        S.totalPages && (S.page.value = Math.min(v, S.totalPages.value));
      }
    });
  }, k = (v = 1) => {
    var w;
    f.page.value = v, f.scrollPosition.value = null, (w = f.receiveHighlight) == null || w.call(f, { rowId: null, columnKey: null }), f.scrollEl && (f.scrollEl.scrollLeft = 0, f.scrollEl.scrollTop = 0), o.forEach((S) => {
      var $;
      const x = oa.get(h(S));
      x && (x.page.value = v, x.scrollPosition.value = null, ($ = x.receiveHighlight) == null || $.call(x, { rowId: null, columnKey: null }), x.scrollEl && (x.scrollEl.scrollLeft = 0, x.scrollEl.scrollTop = 0));
    });
  }, m = t == null ? void 0 : t.resetOn;
  return m !== void 0 && He(() => tt(m), () => k()), Dr(() => {
    oa.delete(i);
  }), {
    // markRaw prevents reactive() from deep-wrapping the controllers
    link: pa({
      scrollSync: Ai(d),
      highlightSync: Ai(g),
      page: u,
      "onUpdate:page": y
    }),
    resetState: k
  };
};
function MC(e, n = 100, t = !1) {
  const a = Math.max(0, Math.min(1, e / n)), s = Math.round(t ? 255 * a : 255 * (1 - a)), r = Math.round(t ? 255 * (1 - a) : 255 * a);
  return `rgba(${s}, ${r}, 0, 0.4)`;
}
function $C(e) {
  const n = Math.max(0, Math.min(100, e)), t = Math.round(255 * (100 - n) / 100), a = Math.round(255 * n / 100);
  return `bg-[rgb(${t},${a},0)]`;
}
const CC = () => ({
  success: (i, o) => {
    ia.success(i, {
      description: o,
      duration: 4e3
    });
  },
  error: (i, o) => {
    ia.error(i, {
      description: o,
      duration: 5e3
    });
  },
  warning: (i, o) => {
    ia.warning(i, {
      description: o,
      duration: 4e3
    });
  },
  info: (i, o) => {
    ia.info(i, {
      description: o,
      duration: 4e3
    });
  },
  promise: (i, o) => ia.promise(i, o),
  custom: (i, o) => ia(i, o),
  dismiss: (i) => {
    ia.dismiss(i);
  }
}), Jd = Symbol("SidebarState");
function t2(e) {
  const n = C(
    () => xu(e.items) ? e.items.value : e.items
  ), t = () => {
    e.isCollapsed.value = !e.isCollapsed.value;
  }, a = (o) => {
    const u = e.expandedItems.value;
    u.has(o) ? u.delete(o) : u.add(o), e.expandedItems.value = new Set(u);
  }, s = (o) => e.expandedItems.value.has(o), r = () => {
    e.isMobileOpen.value = !0;
  }, l = () => {
    e.isMobileOpen.value = !1;
  }, i = () => {
    e.isMobileOpen.value = !e.isMobileOpen.value;
  };
  return {
    isCollapsed: e.isCollapsed,
    isMobileOpen: e.isMobileOpen,
    expandedItems: e.expandedItems,
    resolvedItems: n,
    options: e.options,
    toggleCollapse: t,
    toggleExpanded: a,
    isExpanded: s,
    openMobile: r,
    closeMobile: l,
    toggleMobile: i
  };
}
function ns() {
  const e = Qn(Jd);
  if (!e)
    throw new Error(
      '[NavigationSidebar] useSidebarState() called outside of <NavigationSidebar>. Make sure the component is wrapped in <NavigationSidebar :sidebar="...">.'
    );
  return e;
}
function Qd(e, n = []) {
  const t = ei();
  return { resolvedTo: C(() => {
    const s = e.to;
    if (!s) return;
    if (!n.length) return s;
    const r = {};
    for (const l of n) {
      const i = t.query[l];
      i != null && (r[l] = Array.isArray(i) ? i[0] ?? "" : i);
    }
    return Object.keys(r).length ? typeof s == "string" ? { path: s, query: r } : {
      ...s,
      query: {
        ...r,
        ...s.query ?? {}
      }
    } : s;
  }) };
}
const n2 = { class: "sidebar-flyout__item-label" }, a2 = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, s2 = /* @__PURE__ */ Te({
  __name: "SidebarMenuFlyoutItem",
  props: {
    item: {}
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, { isActive: a, onPrefetch: s, options: r } = ns(), { resolvedTo: l } = Qd(e.item, r.persistentQueryParams), i = C(() => a(e.item.id)), o = C(() => ({
      "sidebar-flyout__item--active": i.value,
      "sidebar-flyout__item--disabled": e.item.disabled
    })), u = () => {
      e.item.disabled || !l.value || s(l.value);
    }, c = () => {
      e.item.disabled || t("click", e.item);
    };
    return (f, h) => {
      const d = Su("router-link");
      return e.item.to ? (b(), fe(d, {
        key: 0,
        "aria-current": i.value ? "page" : void 0,
        class: ne([o.value, "sidebar-flyout__item"]),
        style: Fe(`--depth: ${e.item.level}`),
        to: p(l),
        onClick: c,
        onMouseenter: u
      }, {
        default: de(() => [
          e.item.icon ? (b(), fe(xe, {
            key: 0,
            icon: e.item.icon,
            size: 16,
            class: "sidebar-flyout__item-icon"
          }, null, 8, ["icon"])) : P("", !0),
          E("span", n2, ce(e.item.label), 1),
          e.item.badge ? (b(), M("span", a2, ce(e.item.badge), 1)) : P("", !0)
        ]),
        _: 1
      }, 8, ["aria-current", "class", "style", "to"])) : P("", !0);
    };
  }
}), r2 = { class: "sidebar-flyout__item-label" }, l2 = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, i2 = /* @__PURE__ */ Te({
  __name: "SidebarMenuFlyoutParent",
  props: {
    item: {}
  },
  setup(e) {
    return (n, t) => (b(), M("div", {
      style: Fe(`--depth: ${e.item.level}`),
      class: "sidebar-flyout__item sidebar-flyout__item--parent"
    }, [
      e.item.icon ? (b(), fe(xe, {
        key: 0,
        icon: e.item.icon,
        size: 16,
        class: "sidebar-flyout__item-icon"
      }, null, 8, ["icon"])) : P("", !0),
      E("span", r2, ce(e.item.label), 1),
      e.item.badge ? (b(), M("span", l2, ce(e.item.badge), 1)) : P("", !0)
    ], 4));
  }
}), o2 = { class: "sidebar-flyout" }, u2 = { class: "sidebar-flyout__title" }, c2 = { class: "sidebar-flyout__list" }, pu = 16, d2 = /* @__PURE__ */ Te({
  __name: "SidebarMenuFlyout",
  props: {
    item: {}
  },
  setup(e) {
    const { closeMobile: n } = ns(), t = te(!1), a = te(null), s = te(null), r = te({ top: 0, left: 0, right: 0 }), l = te(!1), { width: i, height: o } = d1(), u = () => {
      if (!a.value || !s.value) return;
      const v = a.value.getBoundingClientRect(), w = s.value.getBoundingClientRect(), S = v.right + 8, x = s.value.offsetHeight, $ = Math.max(
        pu,
        Math.min(v.top, o.value - pu - x)
      );
      S + w.width > i.value - 20 ? (l.value = !0, r.value = {
        top: $,
        right: i.value - v.left + 8,
        left: 0
      }) : (l.value = !1, r.value = { top: $, left: S, right: 0 });
    };
    He([i, o], () => {
      t.value && u();
    });
    const { start: c, stop: f } = Zo(async () => {
      t.value = !0, await Xe(), requestAnimationFrame(u);
    }, 150, { immediate: !1 }), { start: h, stop: d } = Zo(() => {
      t.value = !1;
    }, 100, { immediate: !1 }), g = () => {
      if (d(), !t.value) {
        if (a.value) {
          const v = a.value.getBoundingClientRect();
          r.value = { top: v.top, left: v.right + 8, right: 0 };
        }
        c();
      }
    }, y = () => {
      f(), h();
    }, k = C(() => {
      const v = (w, S = 0) => {
        var $;
        const x = [];
        for (const T of w)
          x.push({ ...T, level: S }), ($ = T.children) != null && $.length && x.push(...v(T.children, S + 1));
        return x;
      };
      return e.item.children ? v(e.item.children) : [];
    }), m = (v) => {
      v.disabled || (n(), t.value = !1);
    };
    return (v, w) => (b(), M("div", {
      ref_key: "buttonRef",
      ref: a,
      class: "sidebar-flyout-trigger",
      onMouseenter: g,
      onMouseleave: y
    }, [
      U(v.$slots, "default", {}, void 0, !0),
      (b(), fe(zn, { to: "body" }, [
        oe(vt, {
          "enter-active-class": "sidebar-flyout-enter-active",
          "enter-from-class": "sidebar-flyout-enter-from",
          "enter-to-class": "sidebar-flyout-enter-to",
          "leave-active-class": "sidebar-flyout-leave-active",
          "leave-from-class": "sidebar-flyout-leave-from",
          "leave-to-class": "sidebar-flyout-leave-to"
        }, {
          default: de(() => {
            var S;
            return [
              t.value && ((S = e.item.children) != null && S.length) ? (b(), M("div", {
                key: 0,
                style: Fe({
                  top: `${r.value.top}px`,
                  ...l.value ? { right: `${r.value.right - 8}px` } : { left: `${r.value.left - 8}px` }
                }),
                class: "sidebar-flyout-portal",
                onMouseenter: g,
                onMouseleave: y
              }, [
                E("div", {
                  class: ne([l.value ? "sidebar-flyout-bridge--left" : "sidebar-flyout-bridge--right", "sidebar-flyout-bridge"])
                }, null, 2),
                E("div", {
                  ref_key: "flyoutRef",
                  ref: s,
                  class: "sidebar-flyout-content"
                }, [
                  E("div", o2, [
                    E("div", u2, ce(e.item.label), 1),
                    E("div", c2, [
                      (b(!0), M(Se, null, Pe(k.value, (x) => (b(), M(Se, {
                        key: x.id
                      }, [
                        x.to ? (b(), fe(s2, {
                          key: 0,
                          item: x,
                          onClick: m
                        }, null, 8, ["item"])) : (b(), fe(i2, {
                          key: 1,
                          item: x
                        }, null, 8, ["item"]))
                      ], 64))), 128))
                    ])
                  ])
                ], 512)
              ], 36)) : P("", !0)
            ];
          }),
          _: 1
        })
      ]))
    ], 544));
  }
}), f2 = /* @__PURE__ */ Ge(d2, [["__scopeId", "data-v-c6f7104b"]]), h2 = ["aria-label"], m2 = {
  key: 0,
  class: "sidebar-item__label"
}, v2 = {
  key: 1,
  class: "sidebar-item__badge"
}, p2 = { class: "sidebar-item-children__inner" }, g2 = /* @__PURE__ */ Te({
  __name: "SidebarNavItem",
  props: {
    item: {},
    level: { default: 0 }
  },
  setup(e) {
    const {
      isCollapsed: n,
      isExpanded: t,
      toggleExpanded: a,
      closeMobile: s,
      isActive: r,
      isOnActivePath: l,
      onPrefetch: i,
      options: o
    } = ns(), { resolvedTo: u } = Qd(e.item, o.persistentQueryParams), c = C(() => {
      var m;
      return !!((m = e.item.children) != null && m.length);
    }), f = C(() => c.value && t(e.item.id)), h = C(() => r(e.item.id)), d = C(
      () => !h.value && c.value && l(e.item.id)
    ), g = () => {
      c.value || e.item.disabled || !u.value || i(u.value);
    }, y = () => {
      if (!e.item.disabled) {
        if (e.item.onClick) {
          e.item.onClick(), s();
          return;
        }
        c.value ? a(e.item.id) : s();
      }
    }, k = C(() => ({
      "sidebar-item--active": h.value,
      "sidebar-item--has-active-child": d.value,
      "sidebar-item--disabled": e.item.disabled,
      "sidebar-item--collapsed": n.value
    }));
    return (m, v) => {
      const w = Su("SidebarNavItem", !0);
      return b(), M("div", {
        style: Fe(`--depth: ${e.level}`),
        class: "sidebar-item-wrapper"
      }, [
        p(n) && c.value && !e.item.disabled ? (b(), fe(f2, {
          key: 0,
          item: e.item
        }, {
          default: de(() => [
            E("button", {
              "aria-label": e.item.label,
              class: ne([{
                "sidebar-item--active": h.value,
                "sidebar-item--has-active-child": d.value
              }, "sidebar-item sidebar-item--collapsed"]),
              type: "button",
              onClick: y
            }, [
              e.item.icon ? (b(), fe(xe, {
                key: 0,
                icon: e.item.icon,
                size: 20,
                class: "sidebar-item__icon"
              }, null, 8, ["icon"])) : P("", !0)
            ], 10, h2)
          ]),
          _: 1
        }, 8, ["item"])) : p(n) && !e.item.disabled ? (b(), fe(Cs, {
          key: 1,
          delay: 200,
          text: e.item.label,
          placement: "right"
        }, {
          default: de(() => [
            (b(), fe(ht(e.item.to ? "router-link" : "button"), {
              "aria-label": e.item.label,
              class: ne([{ "sidebar-item--active": h.value }, "sidebar-item sidebar-item--collapsed"]),
              disabled: e.item.disabled || void 0,
              to: e.item.to ? p(u) : void 0,
              type: e.item.to ? void 0 : "button",
              onClick: y,
              onMouseenter: g
            }, {
              default: de(() => [
                e.item.icon ? (b(), fe(xe, {
                  key: 0,
                  icon: e.item.icon,
                  size: 20,
                  class: "sidebar-item__icon"
                }, null, 8, ["icon"])) : P("", !0)
              ]),
              _: 1
            }, 40, ["aria-label", "class", "disabled", "to", "type"]))
          ]),
          _: 1
        }, 8, ["text"])) : (b(), fe(ht(c.value || !e.item.to ? "button" : "router-link"), {
          key: 2,
          "aria-current": h.value ? "page" : void 0,
          "aria-expanded": c.value ? f.value : void 0,
          "aria-label": e.item.label,
          class: ne([k.value, "sidebar-item"]),
          disabled: e.item.disabled || void 0,
          to: !c.value && e.item.to ? p(u) : void 0,
          type: c.value || !e.item.to ? "button" : void 0,
          onClick: y,
          onMouseenter: g
        }, {
          default: de(() => [
            e.item.icon ? (b(), fe(xe, {
              key: 0,
              icon: e.item.icon,
              size: 20,
              class: "sidebar-item__icon"
            }, null, 8, ["icon"])) : P("", !0),
            oe(vt, {
              "enter-active-class": "sidebar-label-enter-active",
              "enter-from-class": "sidebar-label-enter-from",
              "enter-to-class": "sidebar-label-enter-to",
              "leave-active-class": "sidebar-label-leave-active",
              "leave-from-class": "sidebar-label-leave-from",
              "leave-to-class": "sidebar-label-leave-to"
            }, {
              default: de(() => [
                p(n) ? P("", !0) : (b(), M("span", m2, ce(e.item.label), 1))
              ]),
              _: 1
            }),
            e.item.badge && !p(n) ? (b(), M("span", v2, ce(e.item.badge), 1)) : P("", !0),
            c.value && !p(n) ? (b(), fe(xe, {
              key: 2,
              icon: f.value ? "mdi:chevron-up" : "mdi:chevron-down",
              size: 16,
              class: "sidebar-item__chevron"
            }, null, 8, ["icon"])) : P("", !0)
          ]),
          _: 1
        }, 40, ["aria-current", "aria-expanded", "aria-label", "class", "disabled", "to", "type"])),
        c.value && !p(n) ? (b(), M("div", {
          key: 3,
          class: ne([{ "sidebar-item-children--expanded": f.value }, "sidebar-item-children"])
        }, [
          E("div", p2, [
            (b(!0), M(Se, null, Pe(e.item.children, (S, x) => (b(), fe(w, {
              key: S.id,
              item: S,
              level: e.level + 1,
              style: Fe({ transitionDelay: f.value ? `${x * 30}ms` : "0ms" })
            }, null, 8, ["item", "level", "style"]))), 128))
          ])
        ], 2)) : P("", !0)
      ], 4);
    };
  }
}), ef = /* @__PURE__ */ Ge(g2, [["__scopeId", "data-v-6783180b"]]), y2 = {
  key: 0,
  class: "v-sidebar-footer__slot"
}, b2 = {
  key: 1,
  class: "v-sidebar-footer__nav"
}, w2 = {
  key: 2,
  class: "sidebar-footer__slot"
}, k2 = /* @__PURE__ */ Te({
  __name: "SidebarFooter",
  props: {
    items: { default: () => [] }
  },
  setup(e) {
    const { isCollapsed: n } = ns();
    return (t, a) => (b(), M("div", {
      class: ne([{ "v-sidebar-footer--collapsed": p(n) }, "v-sidebar-footer"])
    }, [
      t.$slots.start ? (b(), M("div", y2, [
        U(t.$slots, "start")
      ])) : P("", !0),
      e.items.length ? (b(), M("nav", b2, [
        (b(!0), M(Se, null, Pe(e.items, (s) => (b(), fe(ef, {
          key: s.id,
          item: s,
          level: 0
        }, null, 8, ["item"]))), 128))
      ])) : P("", !0),
      t.$slots.end ? (b(), M("div", w2, [
        U(t.$slots, "end")
      ])) : P("", !0)
    ], 2));
  }
}), x2 = {
  key: 0,
  class: "sidebar-header__brand"
}, S2 = {
  key: 0,
  class: "sidebar-header__logo"
}, T2 = ["alt", "src"], M2 = { class: "sidebar-header__name" }, $2 = { class: "sidebar-header__controls" }, C2 = ["aria-label"], D2 = { class: "sidebar-header__toggle-icons" }, O2 = /* @__PURE__ */ Te({
  __name: "SidebarHeader",
  setup(e) {
    const { isCollapsed: n, toggleCollapse: t, options: a } = ns();
    return (s, r) => (b(), M("div", {
      class: ne([{ "sidebar-header--collapsed": p(n) }, "sidebar-header"])
    }, [
      oe(vt, {
        "enter-active-class": "sidebar-label-enter-active",
        "enter-from-class": "sidebar-label-enter-from",
        "enter-to-class": "sidebar-label-enter-to",
        "leave-active-class": "sidebar-label-leave-active",
        "leave-from-class": "sidebar-label-leave-from",
        "leave-to-class": "sidebar-label-leave-to"
      }, {
        default: de(() => [
          p(n) ? P("", !0) : (b(), M("div", x2, [
            U(s.$slots, "start", {}, () => [
              p(a).logoUrl ? (b(), M("div", S2, [
                E("img", {
                  alt: p(a).brandName,
                  src: p(a).logoUrl
                }, null, 8, T2)
              ])) : P("", !0),
              E("span", M2, ce(p(a).brandName), 1)
            ], !0)
          ]))
        ]),
        _: 3
      }),
      E("div", $2, [
        U(s.$slots, "end", {}, void 0, !0),
        E("button", {
          "aria-label": p(n) ? "Expand sidebar" : "Collapse sidebar",
          class: ne([{ "sidebar-header__toggle--collapsed": p(n) }, "sidebar-header__toggle"]),
          type: "button",
          onClick: r[0] || (r[0] = //@ts-ignore
          (...l) => p(t) && p(t)(...l))
        }, [
          E("span", D2, [
            oe(xe, {
              size: 20,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--close",
              icon: "lucide:panel-left-close"
            }),
            oe(xe, {
              size: 20,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--open",
              icon: "lucide:panel-left-open"
            })
          ])
        ], 10, C2)
      ])
    ], 2));
  }
}), _2 = /* @__PURE__ */ Ge(O2, [["__scopeId", "data-v-ef54c1d6"]]), E2 = { class: "sidebar-nav__list" }, I2 = /* @__PURE__ */ Te({
  __name: "SidebarNav",
  setup(e) {
    const {
      resolvedItems: n,
      isCollapsed: t,
      expandedItems: a,
      activeItemId: s
    } = ns();
    return (r, l) => (b(), M("nav", {
      class: ne([{ "sidebar-nav--collapsed": p(t) }, "sidebar-nav"])
    }, [
      E("div", E2, [
        (b(!0), M(Se, null, Pe(p(n), (i, o, u, c) => {
          const f = [p(s), p(a).size, p(t), i.id];
          if (c && c.key === i.id && df(c, f)) return c;
          const h = (b(), fe(ef, {
            key: i.id,
            item: i,
            level: 0
          }, null, 8, ["item"]));
          return h.memo = f, h;
        }, l, 0), 128))
      ])
    ], 2));
  }
});
function tf(e, n = []) {
  var a;
  const t = [];
  for (const s of e) {
    const r = [...n, s.id];
    if (s.to) {
      const l = { itemId: s.id, ancestorIds: r };
      typeof s.to == "string" ? l.path = s.to : typeof s.to == "object" && "name" in s.to && s.to.name ? l.routeName = s.to.name : typeof s.to == "object" && "path" in s.to && s.to.path && (l.path = s.to.path), t.push(l);
    }
    (a = s.children) != null && a.length && t.push(...tf(s.children, r));
  }
  return t;
}
function P2(e) {
  const n = ei(), t = C(() => tf(e.value)), a = Wt(null), s = Wt(/* @__PURE__ */ new Set());
  He(
    () => ({ path: n.path, name: n.name }),
    ({ path: u, name: c }) => {
      let f;
      for (const h of t.value) {
        if (h.path && h.path === u) {
          f = h;
          break;
        }
        if (h.routeName && h.routeName === c) {
          f = h;
          break;
        }
      }
      f ? (a.value = f.itemId, s.value = new Set(f.ancestorIds)) : (a.value = null, s.value = /* @__PURE__ */ new Set());
    },
    { immediate: !0 }
  );
  const r = C(() => a.value), l = C(() => s.value);
  return { activeItemId: r, activePathIds: l, isActive: (u) => a.value === u, isOnActivePath: (u) => s.value.has(u) };
}
const DC = /* @__PURE__ */ Te({
  __name: "NavigationSidebar",
  props: {
    sidebar: {}
  },
  emits: ["prefetch", "collapse", "item-click"],
  setup(e, { emit: n }) {
    const t = n, a = ff(
      () => import("./NavigationSidebarMobile-DpH28xET.js")
    ), s = t2(e.sidebar), { activeItemId: r, activePathIds: l, isActive: i, isOnActivePath: o } = P2(
      s.resolvedItems
    );
    Va(Jd, {
      ...s,
      activeItemId: r,
      activePathIds: l,
      isActive: i,
      isOnActivePath: o,
      onPrefetch: (c) => t("prefetch", c)
    });
    const u = C(() => e.sidebar.isCollapsed.value);
    return (c, f) => (b(), M("div", null, [
      E("aside", {
        class: ne([{ "sidebar--collapsed": u.value }, "sidebar sidebar--flat"]),
        "aria-label": "Main navigation"
      }, [
        oe(_2, null, ft({ _: 2 }, [
          c.$slots["header-title"] ? {
            name: "start",
            fn: de(() => [
              U(c.$slots, "header-title")
            ]),
            key: "0"
          } : void 0,
          c.$slots["header-end"] ? {
            name: "end",
            fn: de(() => [
              U(c.$slots, "header-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024),
        U(c.$slots, "subtitle-block"),
        oe(I2),
        oe(k2, null, ft({ _: 2 }, [
          c.$slots["footer-start"] ? {
            name: "start",
            fn: de(() => [
              U(c.$slots, "footer-start")
            ]),
            key: "0"
          } : void 0,
          c.$slots["footer-end"] ? {
            name: "end",
            fn: de(() => [
              U(c.$slots, "footer-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024)
      ], 2),
      oe(p(a), null, ft({ _: 2 }, [
        c.$slots["footer-start"] ? {
          name: "start",
          fn: de(() => [
            U(c.$slots, "footer-start")
          ]),
          key: "0"
        } : void 0,
        c.$slots["footer-end"] ? {
          name: "end",
          fn: de(() => [
            U(c.$slots, "footer-end")
          ]),
          key: "1"
        } : void 0
      ]), 1024)
    ]));
  }
}), A2 = "ui-sidebar";
function R2(e) {
  try {
    return localStorage.getItem(`${e}:collapsed`) === "true";
  } catch {
    return !1;
  }
}
function V2(e, n) {
  try {
    localStorage.setItem(`${e}:collapsed`, String(n));
  } catch {
  }
}
function F2(e) {
  try {
    const n = localStorage.getItem(`${e}:expanded`);
    if (!n) return /* @__PURE__ */ new Set();
    const t = JSON.parse(n);
    return Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function L2(e, n) {
  try {
    localStorage.setItem(`${e}:expanded`, JSON.stringify([...n]));
  } catch {
  }
}
function OC(e) {
  const n = {
    brandName: e.brandName ?? "",
    logoUrl: e.logoUrl ?? "",
    storageKey: e.storageKey ?? A2,
    persistCollapse: e.persistCollapse ?? !0,
    persistentQueryParams: e.persistentQueryParams ?? []
  }, t = te(!1), a = te(!1), s = te(/* @__PURE__ */ new Set());
  return n.persistCollapse && typeof window < "u" && (t.value = R2(n.storageKey), s.value = F2(n.storageKey), Ut(() => {
    V2(n.storageKey, t.value);
  }), Ut(() => {
    L2(n.storageKey, s.value);
  })), {
    items: e.items,
    isCollapsed: t,
    isMobileOpen: a,
    expandedItems: s,
    options: n,
    toggleCollapse: () => {
      t.value = !t.value;
    },
    toggleMobile: () => {
      a.value = !a.value;
    }
  };
}
function N2(e, n, t, a, s) {
  let r = e.find((l) => l.id === n);
  return r || (r = { id: n, label: t, icon: a, order: s ?? 999, children: [] }, e.push(r)), r;
}
function B2(e, n, t) {
  if (!t.menuGroup) {
    e.push(n);
    return;
  }
  const a = t.menuGroup.split("/");
  let s = e;
  a.forEach((r, l) => {
    var c;
    const i = `group:${a.slice(0, l + 1).join("/")}`, o = (c = t.menuGroupMeta) == null ? void 0 : c[r];
    s = N2(
      s,
      i,
      r,
      (o == null ? void 0 : o.icon) ?? (l === 0 ? t.menuGroupIcon : void 0),
      (o == null ? void 0 : o.order) ?? (l === 0 ? t.menuGroupOrder : void 0)
    ).children;
  }), s.push(n);
}
function nf(e) {
  return e.sort((n, t) => (n.order ?? 999) - (t.order ?? 999)).map((n) => {
    var t;
    return {
      ...n,
      children: (t = n.children) != null && t.length ? nf(n.children) : void 0
    };
  });
}
function _C(e) {
  const n = [];
  for (const { item: t, meta: a } of e)
    B2(n, t, a);
  return nf(n);
}
export {
  v$ as $,
  rC as A,
  it as B,
  fw as C,
  Z2 as D,
  dC as E,
  eC as F,
  vk as G,
  tC as H,
  yC as I,
  XM as J,
  fC as K,
  Vu as L,
  pC as M,
  lC as N,
  iC as O,
  T1 as P,
  Cs as Q,
  Kd as R,
  Gk as S,
  yM as T,
  _C as U,
  xe as V,
  OC as W,
  sa as X,
  Ed as Y,
  xs as Z,
  Ge as _,
  Qd as a,
  Ss as a0,
  Id as a1,
  Pd as a2,
  K2 as a3,
  Wa as a4,
  $i as a5,
  Ud as a6,
  _d as a7,
  MC as a8,
  $C as a9,
  p$ as aA,
  gC as aB,
  J$ as aC,
  Cc as aD,
  CC as aE,
  Oi as aF,
  wl as aa,
  hC as ab,
  Gd as ac,
  Ii as ad,
  Gr as ae,
  i$ as af,
  G2 as ag,
  mC as ah,
  o$ as ai,
  qd as aj,
  Ei as ak,
  l$ as al,
  Ws as am,
  _i as an,
  jr as ao,
  u$ as ap,
  vC as aq,
  jd as ar,
  k1 as as,
  Ka as at,
  J2 as au,
  Od as av,
  TC as aw,
  Di as ax,
  P2 as ay,
  Lk as az,
  Gl as b,
  wC as c,
  bC as d,
  sC as e,
  DC as f,
  SC as g,
  xC as h,
  kC as i,
  oC as j,
  uC as k,
  U2 as l,
  qt as m,
  TS as n,
  Fu as o,
  q2 as p,
  j2 as q,
  nC as r,
  X2 as s,
  Mr as t,
  ns as u,
  cC as v,
  Tr as w,
  Q2 as x,
  Ur as y,
  aC as z
};
//# sourceMappingURL=index-90OMiUb1.js.map
